import { IReadingsForDay } from "./interfaces";const Data: { [dateKey: string]: IReadingsForDay } = {
    "2025/11/30": {
        "datePretty": "Sunday, November 30, 2025",
        "calendar": "1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 122",
                        "readQS": "Psalm+122",
                        "audioQS": "Ps.122"
                    },
                    {
                        "pretty": "Isaiah 2:1\u20135",
                        "readQS": "Isaiah+2:1-5",
                        "audioQS": "Isa.2"
                    },
                    {
                        "pretty": "Romans 13:11\u201314",
                        "readQS": "Romans+13:11-14",
                        "audioQS": "Rom.13"
                    },
                    {
                        "pretty": "Matthew 24:36\u201344",
                        "readQS": "Matthew+24:36-44",
                        "audioQS": "Matt.24"
                    }
                ],
                "readQS": "Psalm+122%3B+Isaiah+2:1-5%3B+Romans+13:11-14%3B+Matthew+24:36-44",
                "audioQS": "Ps.122,Isa.2,Rom.13,Matt.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Micah 4:1\u20137",
                        "readQS": "Micah+4:1-7",
                        "audioQS": "Mic.4"
                    },
                    {
                        "pretty": "1 Thessalonians 5:1\u201311",
                        "readQS": "1+Thessalonians+5:1-11",
                        "audioQS": "1Thess.5"
                    }
                ],
                "readQS": "Psalm+44%3B+Micah+4:1-7%3B+1+Thessalonians+5:1-11",
                "audioQS": "Ps.44,Mic.4,1Thess.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Isaiah 52:1\u201312",
                        "readQS": "Isaiah+52:1-12",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Matthew 24:15\u201328",
                        "readQS": "Matthew+24:15-28",
                        "audioQS": "Matt.24"
                    }
                ],
                "readQS": "Psalm+9%3B+Isaiah+52:1-12%3B+Matthew+24:15-28",
                "audioQS": "Ps.9,Isa.52,Matt.24",
                "note": null
            }
        ]
    },
    "2025/12/01": {
        "datePretty": "Monday, December 1, 2025",
        "calendar": "St Andrew the Apostle",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 47,147:1\u201311",
                        "readQS": "Psalm+47,147:1-11",
                        "audioQS": "Ps.47,147"
                    },
                    {
                        "pretty": "Ezekiel 47:1\u201312",
                        "readQS": "Ezekiel+47:1-12",
                        "audioQS": "Ezek.47"
                    },
                    {
                        "pretty": "John 12:20\u201332",
                        "readQS": "John+12:20-32",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+47,147:1-11%3B+Ezekiel+47:1-12%3B+John+12:20-32",
                "audioQS": "Ps.47,147,Ezek.47,John.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 87,96",
                        "readQS": "Psalm+87,96",
                        "audioQS": "Ps.87,96"
                    },
                    {
                        "pretty": "Zechariah 8:20\u201323",
                        "readQS": "Zechariah+8:20-23",
                        "audioQS": "Zech.8"
                    },
                    {
                        "pretty": "John 1:35\u201342",
                        "readQS": "John+1:35-42",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+87,96%3B+Zechariah+8:20-23%3B+John+1:35-42",
                "audioQS": "Ps.87,96,Zech.8,John.1",
                "note": null
            }
        ]
    },
    "2025/12/02": {
        "datePretty": "Tuesday, December 2, 2025",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 26:1\u201313",
                        "readQS": "Isaiah+26:1-13",
                        "audioQS": "Isa.26"
                    },
                    {
                        "pretty": "Matthew 12:22\u201337",
                        "readQS": "Matthew+12:22-37",
                        "audioQS": "Matt.12"
                    }
                ],
                "readQS": "Psalm+80%3B+Isaiah+26:1-13%3B+Matthew+12:22-37",
                "audioQS": "Ps.80,Isa.26,Matt.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 74",
                        "readQS": "Psalm+74",
                        "audioQS": "Ps.74"
                    },
                    {
                        "pretty": "Isaiah 43:1\u201313",
                        "readQS": "Isaiah+43:1-13",
                        "audioQS": "Isa.43"
                    },
                    {
                        "pretty": "Revelation 20",
                        "readQS": "Revelation+20",
                        "audioQS": "Rev.20"
                    }
                ],
                "readQS": "Psalm+74%3B+Isaiah+43:1-13%3B+Revelation+20",
                "audioQS": "Ps.74,Isa.43,Rev.20",
                "note": null
            }
        ]
    },
    "2025/12/03": {
        "datePretty": "Wednesday, December 3, 2025",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 7",
                        "readQS": "Psalm+7",
                        "audioQS": "Ps.7"
                    },
                    {
                        "pretty": "Isaiah 28:1\u201313",
                        "readQS": "Isaiah+28:1-13",
                        "audioQS": "Isa.28"
                    },
                    {
                        "pretty": "Matthew 12:38\u2013end",
                        "readQS": "Matthew+12:38-",
                        "audioQS": "Matt.12"
                    }
                ],
                "readQS": "Psalm+7%3B+Isaiah+28:1-13%3B+Matthew+12:38-",
                "audioQS": "Ps.7,Isa.28,Matt.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Isaiah 43:14\u2013end",
                        "readQS": "Isaiah+43:14-",
                        "audioQS": "Isa.43"
                    },
                    {
                        "pretty": "Revelation 21:1\u20138",
                        "readQS": "Revelation+21:1-8",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+77%3B+Isaiah+43:14-%3B+Revelation+21:1-8",
                "audioQS": "Ps.77,Isa.43,Rev.21",
                "note": null
            }
        ]
    },
    "2025/12/04": {
        "datePretty": "Thursday, December 4, 2025",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "Isaiah 28:14\u2013end",
                        "readQS": "Isaiah+28:14-",
                        "audioQS": "Isa.28"
                    },
                    {
                        "pretty": "Matthew 13:1\u201323",
                        "readQS": "Matthew+13:1-23",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+42%3B+Isaiah+28:14-%3B+Matthew+13:1-23",
                "audioQS": "Ps.42,Isa.28,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 44:1\u20138",
                        "readQS": "Isaiah+44:1-8",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 21:9\u201321",
                        "readQS": "Revelation+21:9-21",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+40%3B+Isaiah+44:1-8%3B+Revelation+21:9-21",
                "audioQS": "Ps.40,Isa.44,Rev.21",
                "note": null
            }
        ]
    },
    "2025/12/05": {
        "datePretty": "Friday, December 5, 2025",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 25",
                        "readQS": "Psalm+25",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Isaiah 29:1\u201314",
                        "readQS": "Isaiah+29:1-14",
                        "audioQS": "Isa.29"
                    },
                    {
                        "pretty": "Matthew 13:24\u201343",
                        "readQS": "Matthew+13:24-43",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+25%3B+Isaiah+29:1-14%3B+Matthew+13:24-43",
                "audioQS": "Ps.25,Isa.29,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 17",
                        "readQS": "Psalm+17",
                        "audioQS": "Ps.17"
                    },
                    {
                        "pretty": "Isaiah 44:9\u201323",
                        "readQS": "Isaiah+44:9-23",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 21:22\u201322:5",
                        "readQS": "Revelation+21:22-22:5",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+17%3B+Isaiah+44:9-23%3B+Revelation+21:22-22:5",
                "audioQS": "Ps.17,Isa.44,Rev.21",
                "note": null
            }
        ]
    },
    "2025/12/06": {
        "datePretty": "Saturday, December 6, 2025",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Isaiah 29:15\u2013end",
                        "readQS": "Isaiah+29:15-",
                        "audioQS": "Isa.29"
                    },
                    {
                        "pretty": "Matthew 13:44\u2013end",
                        "readQS": "Matthew+13:44-",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+9%3B+Isaiah+29:15-%3B+Matthew+13:44-",
                "audioQS": "Ps.9,Isa.29,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 27",
                        "readQS": "Psalm+27",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Isaiah 44:24\u201345:13",
                        "readQS": "Isaiah+44:24-45:13",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 22:6\u2013end",
                        "readQS": "Revelation+22:6-",
                        "audioQS": "Rev.22"
                    }
                ],
                "readQS": "Psalm+27%3B+Isaiah+44:24-45:13%3B+Revelation+22:6-",
                "audioQS": "Ps.27,Isa.44,Rev.22",
                "note": null
            }
        ]
    },
    "2025/12/07": {
        "datePretty": "Sunday, December 7, 2025",
        "calendar": "2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 72:1\u20137,18,19",
                        "readQS": "Psalm+72:1-7,18,19",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Isaiah 11:1\u201310",
                        "readQS": "Isaiah+11:1-10",
                        "audioQS": "Isa.11"
                    },
                    {
                        "pretty": "Romans 15:4\u201313",
                        "readQS": "Romans+15:4-13",
                        "audioQS": "Rom.15"
                    },
                    {
                        "pretty": "Matthew 3:1\u201312",
                        "readQS": "Matthew+3:1-12",
                        "audioQS": "Matt.3"
                    }
                ],
                "readQS": "Psalm+72:1-7,18,19%3B+Isaiah+11:1-10%3B+Romans+15:4-13%3B+Matthew+3:1-12",
                "audioQS": "Ps.72,Isa.11,Rom.15,Matt.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Amos 7",
                        "readQS": "Amos+7",
                        "audioQS": "Amos.7"
                    },
                    {
                        "pretty": "Luke 1:5\u201320",
                        "readQS": "Luke+1:5-20",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+80%3B+Amos+7%3B+Luke+1:5-20",
                "audioQS": "Ps.80,Amos.7,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "1 Kings 18:17\u201339",
                        "readQS": "1+Kings+18:17-39",
                        "audioQS": "1Kgs.18"
                    },
                    {
                        "pretty": "John 1:19\u201328",
                        "readQS": "John+1:19-28",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+11%3B+1+Kings+18:17-39%3B+John+1:19-28",
                "audioQS": "Ps.11,1Kgs.18,John.1",
                "note": null
            }
        ]
    },
    "2025/12/08": {
        "datePretty": "Monday, December 8, 2025",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Isaiah 30:1\u201318",
                        "readQS": "Isaiah+30:1-18",
                        "audioQS": "Isa.30"
                    },
                    {
                        "pretty": "Matthew 14:1\u201312",
                        "readQS": "Matthew+14:1-12",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+44%3B+Isaiah+30:1-18%3B+Matthew+14:1-12",
                "audioQS": "Ps.44,Isa.30,Matt.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "Isaiah 45:14\u2013end",
                        "readQS": "Isaiah+45:14-",
                        "audioQS": "Isa.45"
                    },
                    {
                        "pretty": "1 Thessalonians 1",
                        "readQS": "1+Thessalonians+1",
                        "audioQS": "1Thess.1"
                    }
                ],
                "readQS": "Psalm+144%3B+Isaiah+45:14-%3B+1+Thessalonians+1",
                "audioQS": "Ps.144,Isa.45,1Thess.1",
                "note": null
            }
        ]
    },
    "2025/12/09": {
        "datePretty": "Tuesday, December 9, 2025",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 56",
                        "readQS": "Psalm+56",
                        "audioQS": "Ps.56"
                    },
                    {
                        "pretty": "Isaiah 30:19\u2013end",
                        "readQS": "Isaiah+30:19-",
                        "audioQS": "Isa.30"
                    },
                    {
                        "pretty": "Matthew 14:13\u2013end",
                        "readQS": "Matthew+14:13-",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+56%3B+Isaiah+30:19-%3B+Matthew+14:13-",
                "audioQS": "Ps.56,Isa.30,Matt.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "Isaiah 46",
                        "readQS": "Isaiah+46",
                        "audioQS": "Isa.46"
                    },
                    {
                        "pretty": "1 Thessalonians 2:1\u201312",
                        "readQS": "1+Thessalonians+2:1-12",
                        "audioQS": "1Thess.2"
                    }
                ],
                "readQS": "Psalm+11%3B+Isaiah+46%3B+1+Thessalonians+2:1-12",
                "audioQS": "Ps.11,Isa.46,1Thess.2",
                "note": null
            }
        ]
    },
    "2025/12/10": {
        "datePretty": "Wednesday, December 10, 2025",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 62",
                        "readQS": "Psalm+62",
                        "audioQS": "Ps.62"
                    },
                    {
                        "pretty": "Isaiah 31",
                        "readQS": "Isaiah+31",
                        "audioQS": "Isa.31"
                    },
                    {
                        "pretty": "Matthew 15:1\u201320",
                        "readQS": "Matthew+15:1-20",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+62%3B+Isaiah+31%3B+Matthew+15:1-20",
                "audioQS": "Ps.62,Isa.31,Matt.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 10",
                        "readQS": "Psalm+10",
                        "audioQS": "Ps.10"
                    },
                    {
                        "pretty": "Isaiah 47",
                        "readQS": "Isaiah+47",
                        "audioQS": "Isa.47"
                    },
                    {
                        "pretty": "1 Thessalonians 2:13\u2013end",
                        "readQS": "1+Thessalonians+2:13-",
                        "audioQS": "1Thess.2"
                    }
                ],
                "readQS": "Psalm+10%3B+Isaiah+47%3B+1+Thessalonians+2:13-",
                "audioQS": "Ps.10,Isa.47,1Thess.2",
                "note": null
            }
        ]
    },
    "2025/12/11": {
        "datePretty": "Thursday, December 11, 2025",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 54",
                        "readQS": "Psalm+54",
                        "audioQS": "Ps.54"
                    },
                    {
                        "pretty": "Isaiah 32",
                        "readQS": "Isaiah+32",
                        "audioQS": "Isa.32"
                    },
                    {
                        "pretty": "Matthew 15:21\u201328",
                        "readQS": "Matthew+15:21-28",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+54%3B+Isaiah+32%3B+Matthew+15:21-28",
                "audioQS": "Ps.54,Isa.32,Matt.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Isaiah 48:1\u201311",
                        "readQS": "Isaiah+48:1-11",
                        "audioQS": "Isa.48"
                    },
                    {
                        "pretty": "1 Thessalonians 3",
                        "readQS": "1+Thessalonians+3",
                        "audioQS": "1Thess.3"
                    }
                ],
                "readQS": "Psalm+73%3B+Isaiah+48:1-11%3B+1+Thessalonians+3",
                "audioQS": "Ps.73,Isa.48,1Thess.3",
                "note": null
            }
        ]
    },
    "2025/12/12": {
        "datePretty": "Friday, December 12, 2025",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 86",
                        "readQS": "Psalm+86",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Isaiah 33:1\u201322",
                        "readQS": "Isaiah+33:1-22",
                        "audioQS": "Isa.33"
                    },
                    {
                        "pretty": "Matthew 15:29\u2013end",
                        "readQS": "Matthew+15:29-",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+86%3B+Isaiah+33:1-22%3B+Matthew+15:29-",
                "audioQS": "Ps.86,Isa.33,Matt.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 90",
                        "readQS": "Psalm+90",
                        "audioQS": "Ps.90"
                    },
                    {
                        "pretty": "Isaiah 48:12\u2013end",
                        "readQS": "Isaiah+48:12-",
                        "audioQS": "Isa.48"
                    },
                    {
                        "pretty": "1 Thessalonians 4:1\u201312",
                        "readQS": "1+Thessalonians+4:1-12",
                        "audioQS": "1Thess.4"
                    }
                ],
                "readQS": "Psalm+90%3B+Isaiah+48:12-%3B+1+Thessalonians+4:1-12",
                "audioQS": "Ps.90,Isa.48,1Thess.4",
                "note": null
            }
        ]
    },
    "2025/12/13": {
        "datePretty": "Saturday, December 13, 2025",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Isaiah 35",
                        "readQS": "Isaiah+35",
                        "audioQS": "Isa.35"
                    },
                    {
                        "pretty": "Matthew 16:1\u201312",
                        "readQS": "Matthew+16:1-12",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+145%3B+Isaiah+35%3B+Matthew+16:1-12",
                "audioQS": "Ps.145,Isa.35,Matt.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 94",
                        "readQS": "Psalm+94",
                        "audioQS": "Ps.94"
                    },
                    {
                        "pretty": "Isaiah 49:1\u201313",
                        "readQS": "Isaiah+49:1-13",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Thessalonians 4:13\u2013end",
                        "readQS": "1+Thessalonians+4:13-",
                        "audioQS": "1Thess.4"
                    }
                ],
                "readQS": "Psalm+94%3B+Isaiah+49:1-13%3B+1+Thessalonians+4:13-",
                "audioQS": "Ps.94,Isa.49,1Thess.4",
                "note": null
            }
        ]
    },
    "2025/12/14": {
        "datePretty": "Sunday, December 14, 2025",
        "calendar": "3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 146:4\u201310",
                        "readQS": "Psalm+146:4-10",
                        "audioQS": "Ps.146"
                    },
                    {
                        "pretty": "Canticle: Luke 1:46\u201355 (Magnificat)",
                        "readQS": "Luke+1:46-55",
                        "audioQS": "Luke.1"
                    },
                    {
                        "pretty": "Isaiah 35:1\u201310",
                        "readQS": "Isaiah+35:1-10",
                        "audioQS": "Isa.35"
                    },
                    {
                        "pretty": "James 5:7\u201310",
                        "readQS": "James+5:7-10",
                        "audioQS": "Jas.5"
                    },
                    {
                        "pretty": "Matthew 11:2\u201311",
                        "readQS": "Matthew+11:2-11",
                        "audioQS": "Matt.11"
                    }
                ],
                "readQS": "Psalm+146:4-10%3B+Canticle:+Luke+1:46-55+%28Magnificat%29%3B+Isaiah+35:1-10%3B+James+5:7-10%3B+Matthew+11:2-11",
                "audioQS": "Ps.146,Canticle,Isa.35,Jas.5,Matt.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 68:1\u201319",
                        "readQS": "Psalm+68:1-19",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Zephaniah 3:14\u201320",
                        "readQS": "Zephaniah+3:14-20",
                        "audioQS": "Zeph.3"
                    },
                    {
                        "pretty": "Philippians 4:4\u20137",
                        "readQS": "Philippians+4:4-7",
                        "audioQS": "Phil.4"
                    }
                ],
                "readQS": "Psalm+68:1-19%3B+Zephaniah+3:14-20%3B+Philippians+4:4-7",
                "audioQS": "Ps.68,Zeph.3,Phil.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 12",
                        "readQS": "Psalm+12",
                        "audioQS": "Ps.12"
                    },
                    {
                        "pretty": "Isaiah 5:8\u201330",
                        "readQS": "Isaiah+5:8-30",
                        "audioQS": "Isa.5"
                    },
                    {
                        "pretty": "Acts 13:13\u201341",
                        "readQS": "Acts+13:13-41",
                        "audioQS": "Acts.13"
                    }
                ],
                "readQS": "Psalm+12%3B+Isaiah+5:8-30%3B+Acts+13:13-41",
                "audioQS": "Ps.12,Isa.5,Acts.13",
                "note": null
            }
        ]
    },
    "2025/12/15": {
        "datePretty": "Monday, December 15, 2025",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 38:1\u20138,38:21\u201322",
                        "readQS": "Isaiah+38:1-8,38:21-22",
                        "audioQS": "Isa.38"
                    },
                    {
                        "pretty": "Matthew 16:13\u2013end",
                        "readQS": "Matthew+16:13-",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+40%3B+Isaiah+38:1-8,38:21-22%3B+Matthew+16:13-",
                "audioQS": "Ps.40,Isa.38,Matt.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 26",
                        "readQS": "Psalm+26",
                        "audioQS": "Ps.26"
                    },
                    {
                        "pretty": "Isaiah 49:14\u201325",
                        "readQS": "Isaiah+49:14-25",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Thessalonians 5:1\u201311",
                        "readQS": "1+Thessalonians+5:1-11",
                        "audioQS": "1Thess.5"
                    }
                ],
                "readQS": "Psalm+26%3B+Isaiah+49:14-25%3B+1+Thessalonians+5:1-11",
                "audioQS": "Ps.26,Isa.49,1Thess.5",
                "note": null
            }
        ]
    },
    "2025/12/16": {
        "datePretty": "Tuesday, December 16, 2025",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 70",
                        "readQS": "Psalm+70",
                        "audioQS": "Ps.70"
                    },
                    {
                        "pretty": "Isaiah 38:9\u201320",
                        "readQS": "Isaiah+38:9-20",
                        "audioQS": "Isa.38"
                    },
                    {
                        "pretty": "Matthew 17:1\u201313",
                        "readQS": "Matthew+17:1-13",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+70%3B+Isaiah+38:9-20%3B+Matthew+17:1-13",
                "audioQS": "Ps.70,Isa.38,Matt.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Isaiah 50",
                        "readQS": "Isaiah+50",
                        "audioQS": "Isa.50"
                    },
                    {
                        "pretty": "1 Thessalonians 5:12\u2013end",
                        "readQS": "1+Thessalonians+5:12-",
                        "audioQS": "1Thess.5"
                    }
                ],
                "readQS": "Psalm+50%3B+Isaiah+50%3B+1+Thessalonians+5:12-",
                "audioQS": "Ps.50,Isa.50,1Thess.5",
                "note": null
            }
        ]
    },
    "2025/12/17": {
        "datePretty": "Wednesday, December 17, 2025",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 75",
                        "readQS": "Psalm+75",
                        "audioQS": "Ps.75"
                    },
                    {
                        "pretty": "Isaiah 39",
                        "readQS": "Isaiah+39",
                        "audioQS": "Isa.39"
                    },
                    {
                        "pretty": "Matthew 17:14\u201321",
                        "readQS": "Matthew+17:14-21",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+75%3B+Isaiah+39%3B+Matthew+17:14-21",
                "audioQS": "Ps.75,Isa.39,Matt.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 82",
                        "readQS": "Psalm+82",
                        "audioQS": "Ps.82"
                    },
                    {
                        "pretty": "Isaiah 51:1\u20138",
                        "readQS": "Isaiah+51:1-8",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "2 Thessalonians 1",
                        "readQS": "2+Thessalonians+1",
                        "audioQS": "2Thess.1"
                    }
                ],
                "readQS": "Psalm+82%3B+Isaiah+51:1-8%3B+2+Thessalonians+1",
                "audioQS": "Ps.82,Isa.51,2Thess.1",
                "note": null
            }
        ]
    },
    "2025/12/18": {
        "datePretty": "Thursday, December 18, 2025",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 76",
                        "readQS": "Psalm+76",
                        "audioQS": "Ps.76"
                    },
                    {
                        "pretty": "Zephaniah 1:1\u20132:3",
                        "readQS": "Zephaniah+1:1-2:3",
                        "audioQS": "Zeph.1"
                    },
                    {
                        "pretty": "Matthew 17:22\u2013end",
                        "readQS": "Matthew+17:22-",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+76%3B+Zephaniah+1:1-2:3%3B+Matthew+17:22-",
                "audioQS": "Ps.76,Zeph.1,Matt.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Isaiah 51:9\u201316",
                        "readQS": "Isaiah+51:9-16",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "2 Thessalonians 2",
                        "readQS": "2+Thessalonians+2",
                        "audioQS": "2Thess.2"
                    }
                ],
                "readQS": "Psalm+44%3B+Isaiah+51:9-16%3B+2+Thessalonians+2",
                "audioQS": "Ps.44,Isa.51,2Thess.2",
                "note": null
            }
        ]
    },
    "2025/12/19": {
        "datePretty": "Friday, December 19, 2025",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 146",
                        "readQS": "Psalm+146",
                        "audioQS": "Ps.146"
                    },
                    {
                        "pretty": "Zephaniah 3:1\u201313",
                        "readQS": "Zephaniah+3:1-13",
                        "audioQS": "Zeph.3"
                    },
                    {
                        "pretty": "Matthew 18:1\u201320",
                        "readQS": "Matthew+18:1-20",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+146%3B+Zephaniah+3:1-13%3B+Matthew+18:1-20",
                "audioQS": "Ps.146,Zeph.3,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 57",
                        "readQS": "Psalm+57",
                        "audioQS": "Ps.57"
                    },
                    {
                        "pretty": "Isaiah 51:17\u2013end",
                        "readQS": "Isaiah+51:17-",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "2 Thessalonians 3",
                        "readQS": "2+Thessalonians+3",
                        "audioQS": "2Thess.3"
                    }
                ],
                "readQS": "Psalm+57%3B+Isaiah+51:17-%3B+2+Thessalonians+3",
                "audioQS": "Ps.57,Isa.51,2Thess.3",
                "note": null
            }
        ]
    },
    "2025/12/20": {
        "datePretty": "Saturday, December 20, 2025",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Zephaniah 3:14\u2013end",
                        "readQS": "Zephaniah+3:14-",
                        "audioQS": "Zeph.3"
                    },
                    {
                        "pretty": "Matthew 18:21\u2013end",
                        "readQS": "Matthew+18:21-",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+46%3B+Zephaniah+3:14-%3B+Matthew+18:21-",
                "audioQS": "Ps.46,Zeph.3,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 4",
                        "readQS": "Psalm+4",
                        "audioQS": "Ps.4"
                    },
                    {
                        "pretty": "Isaiah 52:1\u201312",
                        "readQS": "Isaiah+52:1-12",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Jude",
                        "readQS": "Jude",
                        "audioQS": "Jude"
                    }
                ],
                "readQS": "Psalm+4%3B+Isaiah+52:1-12%3B+Jude",
                "audioQS": "Ps.4,Isa.52,Jude",
                "note": null
            }
        ]
    },
    "2025/12/21": {
        "datePretty": "Sunday, December 21, 2025",
        "calendar": "4th Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 80:1\u20138,18\u201320",
                        "readQS": "Psalm+80:1-8,18-20",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 7:10\u201316",
                        "readQS": "Isaiah+7:10-16",
                        "audioQS": "Isa.7"
                    },
                    {
                        "pretty": "Romans 1:1\u20137",
                        "readQS": "Romans+1:1-7",
                        "audioQS": "Rom.1"
                    },
                    {
                        "pretty": "Matthew 1:18\u201325",
                        "readQS": "Matthew+1:18-25",
                        "audioQS": "Matt.1"
                    }
                ],
                "readQS": "Psalm+80:1-8,18-20%3B+Isaiah+7:10-16%3B+Romans+1:1-7%3B+Matthew+1:18-25",
                "audioQS": "Ps.80,Isa.7,Rom.1,Matt.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "Micah 5:2\u20135a",
                        "readQS": "Micah+5:2-5a",
                        "audioQS": "Mic.5"
                    },
                    {
                        "pretty": "Luke 1:26\u201338",
                        "readQS": "Luke+1:26-38",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+144%3B+Micah+5:2-5a%3B+Luke+1:26-38",
                "audioQS": "Ps.144,Mic.5,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 113",
                        "readQS": "Psalm+113",
                        "audioQS": "Ps.113"
                    },
                    {
                        "pretty": "1 Samuel 1:1\u201320",
                        "readQS": "1+Samuel+1:1-20",
                        "audioQS": "1Sam.1"
                    },
                    {
                        "pretty": "Revelation 22:6\u201321",
                        "readQS": "Revelation+22:6-21",
                        "audioQS": "Rev.22"
                    }
                ],
                "readQS": "Psalm+113%3B+1+Samuel+1:1-20%3B+Revelation+22:6-21",
                "audioQS": "Ps.113,1Sam.1,Rev.22",
                "note": null
            }
        ]
    },
    "2025/12/22": {
        "datePretty": "Monday, December 22, 2025",
        "calendar": "Week of 4th Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 124",
                        "readQS": "Psalm+124",
                        "audioQS": "Ps.124"
                    },
                    {
                        "pretty": "Malachi 1:1,1:6\u2013end",
                        "readQS": "Malachi+1:1,1:6-",
                        "audioQS": "Mal.1"
                    },
                    {
                        "pretty": "Matthew 19:1\u201312",
                        "readQS": "Matthew+19:1-12",
                        "audioQS": "Matt.19"
                    }
                ],
                "readQS": "Psalm+124%3B+Malachi+1:1,1:6-%3B+Matthew+19:1-12",
                "audioQS": "Ps.124,Mal.1,Matt.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 24",
                        "readQS": "Psalm+24",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "Isaiah 52:13\u2013end",
                        "readQS": "Isaiah+52:13-",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Isaiah 53",
                        "readQS": "Isaiah+53",
                        "audioQS": "Isa.53"
                    },
                    {
                        "pretty": "2 Peter 1:1\u201315",
                        "readQS": "2+Peter+1:1-15",
                        "audioQS": "2Pet.1"
                    }
                ],
                "readQS": "Psalm+24%3B+Isaiah+52:13-%3B+Isaiah+53%3B+2+Peter+1:1-15",
                "audioQS": "Ps.24,Isa.52,Isa.53,2Pet.1",
                "note": null
            }
        ]
    },
    "2025/12/23": {
        "datePretty": "Tuesday, December 23, 2025",
        "calendar": "Week of 4th Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 130",
                        "readQS": "Psalm+130",
                        "audioQS": "Ps.130"
                    },
                    {
                        "pretty": "Malachi 2:1\u201316",
                        "readQS": "Malachi+2:1-16",
                        "audioQS": "Mal.2"
                    },
                    {
                        "pretty": "Matthew 19:13\u201315",
                        "readQS": "Matthew+19:13-15",
                        "audioQS": "Matt.19"
                    }
                ],
                "readQS": "Psalm+130%3B+Malachi+2:1-16%3B+Matthew+19:13-15",
                "audioQS": "Ps.130,Mal.2,Matt.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 89:1\u201337",
                        "readQS": "Psalm+89:1-37",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Isaiah 54",
                        "readQS": "Isaiah+54",
                        "audioQS": "Isa.54"
                    },
                    {
                        "pretty": "2 Peter 1:16\u20132:3",
                        "readQS": "2+Peter+1:16-2:3",
                        "audioQS": "2Pet.1"
                    }
                ],
                "readQS": "Psalm+89:1-37%3B+Isaiah+54%3B+2+Peter+1:16-2:3",
                "audioQS": "Ps.89,Isa.54,2Pet.1",
                "note": null
            }
        ]
    },
    "2025/12/24": {
        "datePretty": "Wednesday, December 24, 2025",
        "calendar": "Christmas Eve",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 45",
                        "readQS": "Psalm+45",
                        "audioQS": "Ps.45"
                    },
                    {
                        "pretty": "Malachi 2:17\u20133:12",
                        "readQS": "Malachi+2:17-3:12",
                        "audioQS": "Mal.2"
                    },
                    {
                        "pretty": "Matthew 19:16\u2013end",
                        "readQS": "Matthew+19:16-",
                        "audioQS": "Matt.19"
                    }
                ],
                "readQS": "Psalm+45%3B+Malachi+2:17-3:12%3B+Matthew+19:16-",
                "audioQS": "Ps.45,Mal.2,Matt.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Christmas Eve)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Zechariah 2",
                        "readQS": "Zechariah+2",
                        "audioQS": "Zech.2"
                    },
                    {
                        "pretty": "Revelation 1:1\u20138",
                        "readQS": "Revelation+1:1-8",
                        "audioQS": "Rev.1"
                    }
                ],
                "readQS": "Psalm+85%3B+Zechariah+2%3B+Revelation+1:1-8",
                "audioQS": "Ps.85,Zech.2,Rev.1",
                "note": null
            }
        ]
    },
    "2025/12/25": {
        "datePretty": "Thursday, December 25, 2025",
        "calendar": "Christmas Day",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (I)",
                "readingSetSubtitle": "Revised Common Lectionary (Proper I)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 96",
                        "readQS": "Psalm+96",
                        "audioQS": "Ps.96"
                    },
                    {
                        "pretty": "",
                        "readQS": "",
                        "audioQS": ""
                    },
                    {
                        "pretty": "Titus 2:11\u201314",
                        "readQS": "Titus+2:11-14",
                        "audioQS": "Titus.2"
                    },
                    {
                        "pretty": "Luke 2:1\u201314,(15\u201320)",
                        "readQS": "Luke+2:1-14,%2815-20%29",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+96%3B+%3B+Titus+2:11-14%3B+Luke+2:1-14,%2815-20%29",
                "audioQS": "Ps.96,,Titus.2,Luke.2",
                "note": "Any of the three sets of readings (I, II, and III) may be used on Christmas Night and on Christmas Day. Set III should be used at some service during the celebration."
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (II)",
                "readingSetSubtitle": "Revised Common Lectionary (Proper II)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Isaiah 62:6\u201312",
                        "readQS": "Isaiah+62:6-12",
                        "audioQS": "Isa.62"
                    },
                    {
                        "pretty": "Titus 3:4\u20137",
                        "readQS": "Titus+3:4-7",
                        "audioQS": "Titus.3"
                    },
                    {
                        "pretty": "Luke 2:(1\u20137),8\u201320",
                        "readQS": "Luke+2:%281-7%29,8-20",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+97%3B+Isaiah+62:6-12%3B+Titus+3:4-7%3B+Luke+2:%281-7%29,8-20",
                "audioQS": "Ps.97,Isa.62,Titus.3,Luke.2",
                "note": "Any of the three sets of readings (I, II, and III) may be used on Christmas Night and on Christmas Day. Set III should be used at some service during the celebration."
            },
            {
                "readingSetTab": "rclTrack3",
                "readingSetTabName": "RCL (III)",
                "readingSetSubtitle": "Revised Common Lectionary (Proper III)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 98",
                        "readQS": "Psalm+98",
                        "audioQS": "Ps.98"
                    },
                    {
                        "pretty": "Isaiah 52:7\u201310",
                        "readQS": "Isaiah+52:7-10",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Hebrews 1:1\u20134,(5\u201312)",
                        "readQS": "Hebrews+1:1-4,%285-12%29",
                        "audioQS": "Heb.1"
                    },
                    {
                        "pretty": "John 1:1\u201314",
                        "readQS": "John+1:1-14",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+98%3B+Isaiah+52:7-10%3B+Hebrews+1:1-4,%285-12%29%3B+John+1:1-14",
                "audioQS": "Ps.98,Isa.52,Heb.1,John.1",
                "note": "Any of the three sets of readings (I, II, and III) may be used on Christmas Night and on Christmas Day. Set III should be used at some service during the celebration."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 110",
                        "readQS": "Psalm+110",
                        "audioQS": "Ps.110"
                    },
                    {
                        "pretty": "Isaiah 62:1\u20135",
                        "readQS": "Isaiah+62:1-5",
                        "audioQS": "Isa.62"
                    },
                    {
                        "pretty": "Matthew 1:18\u201325",
                        "readQS": "Matthew+1:18-25",
                        "audioQS": "Matt.1"
                    }
                ],
                "readQS": "Psalm+110%3B+Isaiah+62:1-5%3B+Matthew+1:18-25",
                "audioQS": "Ps.110,Isa.62,Matt.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 8",
                        "readQS": "Psalm+8",
                        "audioQS": "Ps.8"
                    },
                    {
                        "pretty": "Isaiah 65:17\u201325",
                        "readQS": "Isaiah+65:17-25",
                        "audioQS": "Isa.65"
                    },
                    {
                        "pretty": "Philippians 2:5\u201311",
                        "readQS": "Philippians+2:5-11",
                        "audioQS": "Phil.2"
                    }
                ],
                "readQS": "Psalm+8%3B+Isaiah+65:17-25%3B+Philippians+2:5-11",
                "audioQS": "Ps.8,Isa.65,Phil.2",
                "note": null
            }
        ]
    },
    "2025/12/26": {
        "datePretty": "Friday, December 26, 2025",
        "calendar": "St Stephen, the first Christian Martyr",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 13",
                        "readQS": "Psalm+13",
                        "audioQS": "Ps.13"
                    },
                    {
                        "pretty": "Jeremiah 26:12\u201315",
                        "readQS": "Jeremiah+26:12-15",
                        "audioQS": "Jer.26"
                    },
                    {
                        "pretty": "Acts 6",
                        "readQS": "Acts+6",
                        "audioQS": "Acts.6"
                    }
                ],
                "readQS": "Psalm+13%3B+Jeremiah+26:12-15%3B+Acts+6",
                "audioQS": "Ps.13,Jer.26,Acts.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 86",
                        "readQS": "Psalm+86",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Genesis 4:1\u201310",
                        "readQS": "Genesis+4:1-10",
                        "audioQS": "Gen.4"
                    },
                    {
                        "pretty": "Matthew 23:34\u201339",
                        "readQS": "Matthew+23:34-39",
                        "audioQS": "Matt.23"
                    }
                ],
                "readQS": "Psalm+86%3B+Genesis+4:1-10%3B+Matthew+23:34-39",
                "audioQS": "Ps.86,Gen.4,Matt.23",
                "note": null
            }
        ]
    },
    "2025/12/27": {
        "datePretty": "Saturday, December 27, 2025",
        "calendar": "St John the Evangelist",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 21",
                        "readQS": "Psalm+21",
                        "audioQS": "Ps.21"
                    },
                    {
                        "pretty": "Exodus 33:12\u201323",
                        "readQS": "Exodus+33:12-23",
                        "audioQS": "Exod.33"
                    },
                    {
                        "pretty": "1 John 2:1\u201311",
                        "readQS": "1+John+2:1-11",
                        "audioQS": "1John.2"
                    }
                ],
                "readQS": "Psalm+21%3B+Exodus+33:12-23%3B+1+John+2:1-11",
                "audioQS": "Ps.21,Exod.33,1John.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Isaiah 6:1\u20138",
                        "readQS": "Isaiah+6:1-8",
                        "audioQS": "Isa.6"
                    },
                    {
                        "pretty": "1 John 5:1\u201312",
                        "readQS": "1+John+5:1-12",
                        "audioQS": "1John.5"
                    }
                ],
                "readQS": "Psalm+97%3B+Isaiah+6:1-8%3B+1+John+5:1-12",
                "audioQS": "Ps.97,Isa.6,1John.5",
                "note": null
            }
        ]
    },
    "2025/12/28": {
        "datePretty": "Sunday, December 28, 2025",
        "calendar": "Holy Innocents",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Isaiah 63:7\u20139",
                        "readQS": "Isaiah+63:7-9",
                        "audioQS": "Isa.63"
                    },
                    {
                        "pretty": "Hebrews 2:10\u201318",
                        "readQS": "Hebrews+2:10-18",
                        "audioQS": "Heb.2"
                    },
                    {
                        "pretty": "Matthew 2:13\u201323",
                        "readQS": "Matthew+2:13-23",
                        "audioQS": "Matt.2"
                    }
                ],
                "readQS": "Psalm+148%3B+Isaiah+63:7-9%3B+Hebrews+2:10-18%3B+Matthew+2:13-23",
                "audioQS": "Ps.148,Isa.63,Heb.2,Matt.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "Genesis 37:13\u201320",
                        "readQS": "Genesis+37:13-20",
                        "audioQS": "Gen.37"
                    },
                    {
                        "pretty": "Matthew 18:1\u201310",
                        "readQS": "Matthew+18:1-10",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+36%3B+Genesis+37:13-20%3B+Matthew+18:1-10",
                "audioQS": "Ps.36,Gen.37,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 128",
                        "readQS": "Psalm+128",
                        "audioQS": "Ps.128"
                    },
                    {
                        "pretty": "Isaiah 49:14\u201325",
                        "readQS": "Isaiah+49:14-25",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "Mark 10:13\u201316",
                        "readQS": "Mark+10:13-16",
                        "audioQS": "Mark.10"
                    }
                ],
                "readQS": "Psalm+128%3B+Isaiah+49:14-25%3B+Mark+10:13-16",
                "audioQS": "Ps.128,Isa.49,Mark.10",
                "note": null
            }
        ]
    },
    "2025/12/29": {
        "datePretty": "Monday, December 29, 2025",
        "calendar": "Week of 1st Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Jonah 1",
                        "readQS": "Jonah+1",
                        "audioQS": "Jonah.1"
                    },
                    {
                        "pretty": "Colossians 1:1\u201314",
                        "readQS": "Colossians+1:1-14",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+19%3B+Jonah+1%3B+Colossians+1:1-14",
                "audioQS": "Ps.19,Jonah.1,Col.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Isaiah 57:15\u2013end",
                        "readQS": "Isaiah+57:15-",
                        "audioQS": "Isa.57"
                    },
                    {
                        "pretty": "John 1:1\u201318",
                        "readQS": "John+1:1-18",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+132%3B+Isaiah+57:15-%3B+John+1:1-18",
                "audioQS": "Ps.132,Isa.57,John.1",
                "note": null
            }
        ]
    },
    "2025/12/30": {
        "datePretty": "Tuesday, December 30, 2025",
        "calendar": "Week of 1st Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 113",
                        "readQS": "Psalm+113",
                        "audioQS": "Ps.113"
                    },
                    {
                        "pretty": "Jonah 2",
                        "readQS": "Jonah+2",
                        "audioQS": "Jonah.2"
                    },
                    {
                        "pretty": "Colossians 1:15\u201323",
                        "readQS": "Colossians+1:15-23",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+113%3B+Jonah+2%3B+Colossians+1:15-23",
                "audioQS": "Ps.113,Jonah.2,Col.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 65",
                        "readQS": "Psalm+65",
                        "audioQS": "Ps.65"
                    },
                    {
                        "pretty": "Isaiah 59:1\u201315a",
                        "readQS": "Isaiah+59:1-15a",
                        "audioQS": "Isa.59"
                    },
                    {
                        "pretty": "John 1:19\u201328",
                        "readQS": "John+1:19-28",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+65%3B+Isaiah+59:1-15a%3B+John+1:19-28",
                "audioQS": "Ps.65,Isa.59,John.1",
                "note": null
            }
        ]
    },
    "2025/12/31": {
        "datePretty": "Wednesday, December 31, 2025",
        "calendar": "Week of 1st Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 102",
                        "readQS": "Psalm+102",
                        "audioQS": "Ps.102"
                    },
                    {
                        "pretty": "Jonah 3",
                        "readQS": "Jonah+3",
                        "audioQS": "Jonah.3"
                    },
                    {
                        "pretty": "Jonah 4",
                        "readQS": "Jonah+4",
                        "audioQS": "Jonah.4"
                    },
                    {
                        "pretty": "Colossians 1:24\u20132:7",
                        "readQS": "Colossians+1:24-2:7",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+102%3B+Jonah+3%3B+Jonah+4%3B+Colossians+1:24-2:7",
                "audioQS": "Ps.102,Jonah.3,Jonah.4,Col.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Naming of Jesus)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Jeremiah 23:1\u20136",
                        "readQS": "Jeremiah+23:1-6",
                        "audioQS": "Jer.23"
                    },
                    {
                        "pretty": "Colossians 2:8\u201315",
                        "readQS": "Colossians+2:8-15",
                        "audioQS": "Col.2"
                    }
                ],
                "readQS": "Psalm+148%3B+Jeremiah+23:1-6%3B+Colossians+2:8-15",
                "audioQS": "Ps.148,Jer.23,Col.2",
                "note": null
            }
        ]
    },
    "2026/01/01": {
        "datePretty": "Thursday, January 1, 2026",
        "calendar": "The naming of Jesus",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 8",
                        "readQS": "Psalm+8",
                        "audioQS": "Ps.8"
                    },
                    {
                        "pretty": "Numbers 6:22\u201327",
                        "readQS": "Numbers+6:22-27",
                        "audioQS": "Num.6"
                    },
                    {
                        "pretty": "Galatians 4:4\u20137",
                        "readQS": "Galatians+4:4-7",
                        "audioQS": "Gal.4"
                    },
                    {
                        "pretty": "Luke 2: 15\u201321",
                        "readQS": "Luke+2:+15-21",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+8%3B+Numbers+6:22-27%3B+Galatians+4:4-7%3B+Luke+2:+15-21",
                "audioQS": "Ps.8,Num.6,Gal.4,Luke.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 103",
                        "readQS": "Psalm+103",
                        "audioQS": "Ps.103"
                    },
                    {
                        "pretty": "Genesis 17:1\u201313",
                        "readQS": "Genesis+17:1-13",
                        "audioQS": "Gen.17"
                    },
                    {
                        "pretty": "Romans 2:17\u201329",
                        "readQS": "Romans+2:17-29",
                        "audioQS": "Rom.2"
                    }
                ],
                "readQS": "Psalm+103%3B+Genesis+17:1-13%3B+Romans+2:17-29",
                "audioQS": "Ps.103,Gen.17,Rom.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 115",
                        "readQS": "Psalm+115",
                        "audioQS": "Ps.115"
                    },
                    {
                        "pretty": "Deuteronomy 30:11\u201320",
                        "readQS": "Deuteronomy+30:11-20",
                        "audioQS": "Deut.30"
                    },
                    {
                        "pretty": "Acts 3:1\u201316",
                        "readQS": "Acts+3:1-16",
                        "audioQS": "Acts.3"
                    }
                ],
                "readQS": "Psalm+115%3B+Deuteronomy+30:11-20%3B+Acts+3:1-16",
                "audioQS": "Ps.115,Deut.30,Acts.3",
                "note": null
            }
        ]
    },
    "2026/01/02": {
        "datePretty": "Friday, January 2, 2026",
        "calendar": "Week of 1st Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 18:1\u201330",
                        "readQS": "Psalm+18:1-30",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "Ruth 1",
                        "readQS": "Ruth+1",
                        "audioQS": "Ruth.1"
                    },
                    {
                        "pretty": "Colossians 2:8\u2013end",
                        "readQS": "Colossians+2:8-",
                        "audioQS": "Col.2"
                    }
                ],
                "readQS": "Psalm+18:1-30%3B+Ruth+1%3B+Colossians+2:8-",
                "audioQS": "Ps.18,Ruth.1,Col.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Isaiah 60:1\u201312",
                        "readQS": "Isaiah+60:1-12",
                        "audioQS": "Isa.60"
                    },
                    {
                        "pretty": "John 1:35\u201342",
                        "readQS": "John+1:35-42",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+46%3B+Isaiah+60:1-12%3B+John+1:35-42",
                "audioQS": "Ps.46,Isa.60,John.1",
                "note": null
            }
        ]
    },
    "2026/01/03": {
        "datePretty": "Saturday, January 3, 2026",
        "calendar": "Week of 1st Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 127",
                        "readQS": "Psalm+127",
                        "audioQS": "Ps.127"
                    },
                    {
                        "pretty": "Ruth 2",
                        "readQS": "Ruth+2",
                        "audioQS": "Ruth.2"
                    },
                    {
                        "pretty": "Colossians 3:1\u201311",
                        "readQS": "Colossians+3:1-11",
                        "audioQS": "Col.3"
                    }
                ],
                "readQS": "Psalm+127%3B+Ruth+2%3B+Colossians+3:1-11",
                "audioQS": "Ps.127,Ruth.2,Col.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 2",
                        "readQS": "Psalm+2",
                        "audioQS": "Ps.2"
                    },
                    {
                        "pretty": "Isaiah 60:13\u2013end",
                        "readQS": "Isaiah+60:13-",
                        "audioQS": "Isa.60"
                    },
                    {
                        "pretty": "John 1:43\u2013end",
                        "readQS": "John+1:43-",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+2%3B+Isaiah+60:13-%3B+John+1:43-",
                "audioQS": "Ps.2,Isa.60,John.1",
                "note": null
            }
        ]
    },
    "2026/01/04": {
        "datePretty": "Sunday, January 4, 2026",
        "calendar": "2nd Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 147:13\u201321",
                        "readQS": "Psalm+147:13-21",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "Jeremiah 31:7\u201314",
                        "readQS": "Jeremiah+31:7-14",
                        "audioQS": "Jer.31"
                    },
                    {
                        "pretty": "Ephesians 1:3\u201314",
                        "readQS": "Ephesians+1:3-14",
                        "audioQS": "Eph.1"
                    },
                    {
                        "pretty": "John 1:(1\u20139),10\u201318",
                        "readQS": "John+1:%281-9%29,10-18",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+147:13-21%3B+Jeremiah+31:7-14%3B+Ephesians+1:3-14%3B+John+1:%281-9%29,10-18",
                "audioQS": "Ps.147,Jer.31,Eph.1,John.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 87",
                        "readQS": "Psalm+87",
                        "audioQS": "Ps.87"
                    },
                    {
                        "pretty": "Jeremiah 31:15\u201317",
                        "readQS": "Jeremiah+31:15-17",
                        "audioQS": "Jer.31"
                    },
                    {
                        "pretty": "2 Corinthians 1:3\u201312",
                        "readQS": "2+Corinthians+1:3-12",
                        "audioQS": "2Cor.1"
                    }
                ],
                "readQS": "Psalm+87%3B+Jeremiah+31:15-17%3B+2+Corinthians+1:3-12",
                "audioQS": "Ps.87,Jer.31,2Cor.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Isaiah 41:21 \u2013 42:4",
                        "readQS": "Isaiah+41:21+-+42:4",
                        "audioQS": "Isa.41"
                    },
                    {
                        "pretty": "Colossians 1:1\u201314",
                        "readQS": "Colossians+1:1-14",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+135%3B+Isaiah+41:21+-+42:4%3B+Colossians+1:1-14",
                "audioQS": "Ps.135,Isa.41,Col.1",
                "note": null
            }
        ]
    },
    "2026/01/05": {
        "datePretty": "Monday, January 5, 2026",
        "calendar": "Week of 2nd Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "Ruth 4:1\u201317",
                        "readQS": "Ruth+4:1-17",
                        "audioQS": "Ruth.4"
                    },
                    {
                        "pretty": "Colossians 4:2\u2013end",
                        "readQS": "Colossians+4:2-",
                        "audioQS": "Col.4"
                    }
                ],
                "readQS": "Psalm+48%3B+Ruth+4:1-17%3B+Colossians+4:2-",
                "audioQS": "Ps.48,Ruth.4,Col.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Epiphany)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Isaiah 49:1\u201313",
                        "readQS": "Isaiah+49:1-13",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "John 4:7\u201326",
                        "readQS": "John+4:7-26",
                        "audioQS": "John.4"
                    }
                ],
                "readQS": "Psalm+97%3B+Isaiah+49:1-13%3B+John+4:7-26",
                "audioQS": "Ps.97,Isa.49,John.4",
                "note": null
            }
        ]
    },
    "2026/01/06": {
        "datePretty": "Tuesday, January 6, 2026",
        "calendar": "The Epiphany",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 72:(1\u20139),10\u201315",
                        "readQS": "Psalm+72:%281-9%29,10-15",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Isaiah 60.1\u20136",
                        "readQS": "Isaiah+60.1-6",
                        "audioQS": "Isa.60.1\u20136"
                    },
                    {
                        "pretty": "Ephesians 3:1\u201312",
                        "readQS": "Ephesians+3:1-12",
                        "audioQS": "Eph.3"
                    },
                    {
                        "pretty": "Matthew 2:1\u201312",
                        "readQS": "Matthew+2:1-12",
                        "audioQS": "Matt.2"
                    }
                ],
                "readQS": "Psalm+72:%281-9%29,10-15%3B+Isaiah+60.1-6%3B+Ephesians+3:1-12%3B+Matthew+2:1-12",
                "audioQS": "Ps.72,Isa.60.1\u20136,Eph.3,Matt.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Jeremiah 31:7\u201314",
                        "readQS": "Jeremiah+31:7-14",
                        "audioQS": "Jer.31"
                    },
                    {
                        "pretty": "John 1:29\u201334",
                        "readQS": "John+1:29-34",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+132%3B+Jeremiah+31:7-14%3B+John+1:29-34",
                "audioQS": "Ps.132,Jer.31,John.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 98,100",
                        "readQS": "Psalm+98,100",
                        "audioQS": "Ps.98,100"
                    },
                    {
                        "pretty": "Isaiah 60:1\u20139",
                        "readQS": "Isaiah+60:1-9",
                        "audioQS": "Isa.60"
                    },
                    {
                        "pretty": "John 2:1\u201311",
                        "readQS": "John+2:1-11",
                        "audioQS": "John.2"
                    }
                ],
                "readQS": "Psalm+98,100%3B+Isaiah+60:1-9%3B+John+2:1-11",
                "audioQS": "Ps.98,100,Isa.60,John.2",
                "note": null
            }
        ]
    },
    "2026/01/07": {
        "datePretty": "Wednesday, January 7, 2026",
        "calendar": "Week of 2nd Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 99",
                        "readQS": "Psalm+99",
                        "audioQS": "Ps.99"
                    },
                    {
                        "pretty": "Jeremiah 23:1\u20138",
                        "readQS": "Jeremiah+23:1-8",
                        "audioQS": "Jer.23"
                    },
                    {
                        "pretty": "Matthew 20:1\u201316",
                        "readQS": "Matthew+20:1-16",
                        "audioQS": "Matt.20"
                    }
                ],
                "readQS": "Psalm+99%3B+Jeremiah+23:1-8%3B+Matthew+20:1-16",
                "audioQS": "Ps.99,Jer.23,Matt.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Isaiah 63:7\u2013end",
                        "readQS": "Isaiah+63:7-",
                        "audioQS": "Isa.63"
                    },
                    {
                        "pretty": "1 John 3",
                        "readQS": "1+John+3",
                        "audioQS": "1John.3"
                    }
                ],
                "readQS": "Psalm+118%3B+Isaiah+63:7-%3B+1+John+3",
                "audioQS": "Ps.118,Isa.63,1John.3",
                "note": null
            }
        ]
    },
    "2026/01/08": {
        "datePretty": "Thursday, January 8, 2026",
        "calendar": "Week of 2nd Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Jeremiah 30:1\u201317",
                        "readQS": "Jeremiah+30:1-17",
                        "audioQS": "Jer.30"
                    },
                    {
                        "pretty": "Matthew 20:17\u201328",
                        "readQS": "Matthew+20:17-28",
                        "audioQS": "Matt.20"
                    }
                ],
                "readQS": "Psalm+46%3B+Jeremiah+30:1-17%3B+Matthew+20:17-28",
                "audioQS": "Ps.46,Jer.30,Matt.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Isaiah 64",
                        "readQS": "Isaiah+64",
                        "audioQS": "Isa.64"
                    },
                    {
                        "pretty": "1 John 4:7\u2013end",
                        "readQS": "1+John+4:7-",
                        "audioQS": "1John.4"
                    }
                ],
                "readQS": "Psalm+145%3B+Isaiah+64%3B+1+John+4:7-",
                "audioQS": "Ps.145,Isa.64,1John.4",
                "note": null
            }
        ]
    },
    "2026/01/09": {
        "datePretty": "Friday, January 9, 2026",
        "calendar": "Week of 2nd Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Jeremiah 30:18\u201331:9",
                        "readQS": "Jeremiah+30:18-31:9",
                        "audioQS": "Jer.30"
                    },
                    {
                        "pretty": "Matthew 20:29\u2013end",
                        "readQS": "Matthew+20:29-",
                        "audioQS": "Matt.20"
                    }
                ],
                "readQS": "Psalm+148%3B+Jeremiah+30:18-31:9%3B+Matthew+20:29-",
                "audioQS": "Ps.148,Jer.30,Matt.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 67",
                        "readQS": "Psalm+67",
                        "audioQS": "Ps.67"
                    },
                    {
                        "pretty": "Isaiah 65:1\u201316",
                        "readQS": "Isaiah+65:1-16",
                        "audioQS": "Isa.65"
                    },
                    {
                        "pretty": "1 John 5:1\u201312",
                        "readQS": "1+John+5:1-12",
                        "audioQS": "1John.5"
                    }
                ],
                "readQS": "Psalm+67%3B+Isaiah+65:1-16%3B+1+John+5:1-12",
                "audioQS": "Ps.67,Isa.65,1John.5",
                "note": null
            }
        ]
    },
    "2026/01/10": {
        "datePretty": "Saturday, January 10, 2026",
        "calendar": "Week of 2nd Sunday of Christmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 149",
                        "readQS": "Psalm+149",
                        "audioQS": "Ps.149"
                    },
                    {
                        "pretty": "Jeremiah 31:10\u201317",
                        "readQS": "Jeremiah+31:10-17",
                        "audioQS": "Jer.31"
                    },
                    {
                        "pretty": "Matthew 23:1\u201312",
                        "readQS": "Matthew+23:1-12",
                        "audioQS": "Matt.23"
                    }
                ],
                "readQS": "Psalm+149%3B+Jeremiah+31:10-17%3B+Matthew+23:1-12",
                "audioQS": "Ps.149,Jer.31,Matt.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Baptism of the Lord)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "Isaiah 61",
                        "readQS": "Isaiah+61",
                        "audioQS": "Isa.61"
                    },
                    {
                        "pretty": "Titus 2:11\u201314",
                        "readQS": "Titus+2:11-14",
                        "audioQS": "Titus.2"
                    },
                    {
                        "pretty": "Titus 3:4\u20137",
                        "readQS": "Titus+3:4-7",
                        "audioQS": "Titus.3"
                    }
                ],
                "readQS": "Psalm+36%3B+Isaiah+61%3B+Titus+2:11-14%3B+Titus+3:4-7",
                "audioQS": "Ps.36,Isa.61,Titus.2,Titus.3",
                "note": null
            }
        ]
    },
    "2026/01/11": {
        "datePretty": "Sunday, January 11, 2026",
        "calendar": "The Baptism of the Lord",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 29",
                        "readQS": "Psalm+29",
                        "audioQS": "Ps.29"
                    },
                    {
                        "pretty": "Isaiah 42:1\u20139",
                        "readQS": "Isaiah+42:1-9",
                        "audioQS": "Isa.42"
                    },
                    {
                        "pretty": "Acts 10:34\u201343",
                        "readQS": "Acts+10:34-43",
                        "audioQS": "Acts.10"
                    },
                    {
                        "pretty": "Matthew 3:13\u201317",
                        "readQS": "Matthew+3:13-17",
                        "audioQS": "Matt.3"
                    }
                ],
                "readQS": "Psalm+29%3B+Isaiah+42:1-9%3B+Acts+10:34-43%3B+Matthew+3:13-17",
                "audioQS": "Ps.29,Isa.42,Acts.10,Matt.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 89:19\u201329",
                        "readQS": "Psalm+89:19-29",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Exodus 14:15\u201322",
                        "readQS": "Exodus+14:15-22",
                        "audioQS": "Exod.14"
                    },
                    {
                        "pretty": "1 John 5:6\u20139",
                        "readQS": "1+John+5:6-9",
                        "audioQS": "1John.5"
                    }
                ],
                "readQS": "Psalm+89:19-29%3B+Exodus+14:15-22%3B+1+John+5:6-9",
                "audioQS": "Ps.89,Exod.14,1John.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46,47",
                        "readQS": "Psalm+46,47",
                        "audioQS": "Ps.46,47"
                    },
                    {
                        "pretty": "Joshua 3:1\u20138,14\u201317",
                        "readQS": "Joshua+3:1-8,14-17",
                        "audioQS": "Josh.3"
                    },
                    {
                        "pretty": "Hebrews 1:1\u201312",
                        "readQS": "Hebrews+1:1-12",
                        "audioQS": "Heb.1"
                    }
                ],
                "readQS": "Psalm+46,47%3B+Joshua+3:1-8,14-17%3B+Hebrews+1:1-12",
                "audioQS": "Ps.46,47,Josh.3,Heb.1",
                "note": null
            }
        ]
    },
    "2026/01/12": {
        "datePretty": "Monday, January 12, 2026",
        "calendar": "Week of 1st Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 2",
                        "readQS": "Psalm+2",
                        "audioQS": "Ps.2"
                    },
                    {
                        "pretty": "Genesis 1:1\u201319",
                        "readQS": "Genesis+1:1-19",
                        "audioQS": "Gen.1"
                    },
                    {
                        "pretty": "Matthew 21:1\u201317",
                        "readQS": "Matthew+21:1-17",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+2%3B+Genesis+1:1-19%3B+Matthew+21:1-17",
                "audioQS": "Ps.2,Gen.1,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Amos 1",
                        "readQS": "Amos+1",
                        "audioQS": "Amos.1"
                    },
                    {
                        "pretty": "1 Corinthians 1:1\u201317",
                        "readQS": "1+Corinthians+1:1-17",
                        "audioQS": "1Cor.1"
                    }
                ],
                "readQS": "Psalm+34%3B+Amos+1%3B+1+Corinthians+1:1-17",
                "audioQS": "Ps.34,Amos.1,1Cor.1",
                "note": null
            }
        ]
    },
    "2026/01/13": {
        "datePretty": "Tuesday, January 13, 2026",
        "calendar": "Week of 1st Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Genesis 1:20\u20132:3",
                        "readQS": "Genesis+1:20-2:3",
                        "audioQS": "Gen.1"
                    },
                    {
                        "pretty": "Matthew 21:18\u201332",
                        "readQS": "Matthew+21:18-32",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+9%3B+Genesis+1:20-2:3%3B+Matthew+21:18-32",
                "audioQS": "Ps.9,Gen.1,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 45",
                        "readQS": "Psalm+45",
                        "audioQS": "Ps.45"
                    },
                    {
                        "pretty": "Amos 2",
                        "readQS": "Amos+2",
                        "audioQS": "Amos.2"
                    },
                    {
                        "pretty": "1 Corinthians 1:18\u2013end",
                        "readQS": "1+Corinthians+1:18-",
                        "audioQS": "1Cor.1"
                    }
                ],
                "readQS": "Psalm+45%3B+Amos+2%3B+1+Corinthians+1:18-",
                "audioQS": "Ps.45,Amos.2,1Cor.1",
                "note": null
            }
        ]
    },
    "2026/01/14": {
        "datePretty": "Wednesday, January 14, 2026",
        "calendar": "Week of 1st Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 20",
                        "readQS": "Psalm+20",
                        "audioQS": "Ps.20"
                    },
                    {
                        "pretty": "Genesis 2:4\u2013end",
                        "readQS": "Genesis+2:4-",
                        "audioQS": "Gen.2"
                    },
                    {
                        "pretty": "Matthew 21:33\u2013end",
                        "readQS": "Matthew+21:33-",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+20%3B+Genesis+2:4-%3B+Matthew+21:33-",
                "audioQS": "Ps.20,Gen.2,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Amos 3",
                        "readQS": "Amos+3",
                        "audioQS": "Amos.3"
                    },
                    {
                        "pretty": "1 Corinthians 2",
                        "readQS": "1+Corinthians+2",
                        "audioQS": "1Cor.2"
                    }
                ],
                "readQS": "Psalm+47%3B+Amos+3%3B+1+Corinthians+2",
                "audioQS": "Ps.47,Amos.3,1Cor.2",
                "note": null
            }
        ]
    },
    "2026/01/15": {
        "datePretty": "Thursday, January 15, 2026",
        "calendar": "Week of 1st Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 21",
                        "readQS": "Psalm+21",
                        "audioQS": "Ps.21"
                    },
                    {
                        "pretty": "Genesis 3",
                        "readQS": "Genesis+3",
                        "audioQS": "Gen.3"
                    },
                    {
                        "pretty": "Matthew 22:1\u201314",
                        "readQS": "Matthew+22:1-14",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+21%3B+Genesis+3%3B+Matthew+22:1-14",
                "audioQS": "Ps.21,Gen.3,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 61",
                        "readQS": "Psalm+61",
                        "audioQS": "Ps.61"
                    },
                    {
                        "pretty": "Amos 4",
                        "readQS": "Amos+4",
                        "audioQS": "Amos.4"
                    },
                    {
                        "pretty": "1 Corinthians 3",
                        "readQS": "1+Corinthians+3",
                        "audioQS": "1Cor.3"
                    }
                ],
                "readQS": "Psalm+61%3B+Amos+4%3B+1+Corinthians+3",
                "audioQS": "Ps.61,Amos.4,1Cor.3",
                "note": null
            }
        ]
    },
    "2026/01/16": {
        "datePretty": "Friday, January 16, 2026",
        "calendar": "Week of 1st Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 67",
                        "readQS": "Psalm+67",
                        "audioQS": "Ps.67"
                    },
                    {
                        "pretty": "Genesis 4:1\u201316,4:25\u201326",
                        "readQS": "Genesis+4:1-16,4:25-26",
                        "audioQS": "Gen.4"
                    },
                    {
                        "pretty": "Matthew 22:15\u201333",
                        "readQS": "Matthew+22:15-33",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+67%3B+Genesis+4:1-16,4:25-26%3B+Matthew+22:15-33",
                "audioQS": "Ps.67,Gen.4,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 68",
                        "readQS": "Psalm+68",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Amos 5:1\u201317",
                        "readQS": "Amos+5:1-17",
                        "audioQS": "Amos.5"
                    },
                    {
                        "pretty": "1 Corinthians 4",
                        "readQS": "1+Corinthians+4",
                        "audioQS": "1Cor.4"
                    }
                ],
                "readQS": "Psalm+68%3B+Amos+5:1-17%3B+1+Corinthians+4",
                "audioQS": "Ps.68,Amos.5,1Cor.4",
                "note": null
            }
        ]
    },
    "2026/01/17": {
        "datePretty": "Saturday, January 17, 2026",
        "calendar": "Week of 1st Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Genesis 6:1\u201310",
                        "readQS": "Genesis+6:1-10",
                        "audioQS": "Gen.6"
                    },
                    {
                        "pretty": "Matthew 22:34\u2013end",
                        "readQS": "Matthew+22:34-",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+33%3B+Genesis+6:1-10%3B+Matthew+22:34-",
                "audioQS": "Ps.33,Gen.6,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Amos 5:18\u2013end",
                        "readQS": "Amos+5:18-",
                        "audioQS": "Amos.5"
                    },
                    {
                        "pretty": "1 Corinthians 5",
                        "readQS": "1+Corinthians+5",
                        "audioQS": "1Cor.5"
                    }
                ],
                "readQS": "Psalm+85%3B+Amos+5:18-%3B+1+Corinthians+5",
                "audioQS": "Ps.85,Amos.5,1Cor.5",
                "note": null
            }
        ]
    },
    "2026/01/18": {
        "datePretty": "Sunday, January 18, 2026",
        "calendar": "2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 40:1\u201312",
                        "readQS": "Psalm+40:1-12",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 49:1\u20137",
                        "readQS": "Isaiah+49:1-7",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Corinthians 1:1\u20139",
                        "readQS": "1+Corinthians+1:1-9",
                        "audioQS": "1Cor.1"
                    },
                    {
                        "pretty": "John 1:29\u201342",
                        "readQS": "John+1:29-42",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+40:1-12%3B+Isaiah+49:1-7%3B+1+Corinthians+1:1-9%3B+John+1:29-42",
                "audioQS": "Ps.40,Isa.49,1Cor.1,John.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 145:1\u201312",
                        "readQS": "Psalm+145:1-12",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Jeremiah 1:4\u201310",
                        "readQS": "Jeremiah+1:4-10",
                        "audioQS": "Jer.1"
                    },
                    {
                        "pretty": "Mark 1:14\u201320",
                        "readQS": "Mark+1:14-20",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+145:1-12%3B+Jeremiah+1:4-10%3B+Mark+1:14-20",
                "audioQS": "Ps.145,Jer.1,Mark.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 96",
                        "readQS": "Psalm+96",
                        "audioQS": "Ps.96"
                    },
                    {
                        "pretty": "Ezekiel 2:1\u20133:4",
                        "readQS": "Ezekiel+2:1-3:4",
                        "audioQS": "Ezek.2"
                    },
                    {
                        "pretty": "Galatians 1:11\u201324",
                        "readQS": "Galatians+1:11-24",
                        "audioQS": "Gal.1"
                    }
                ],
                "readQS": "Psalm+96%3B+Ezekiel+2:1-3:4%3B+Galatians+1:11-24",
                "audioQS": "Ps.96,Ezek.2,Gal.1",
                "note": null
            }
        ]
    },
    "2026/01/19": {
        "datePretty": "Monday, January 19, 2026",
        "calendar": "Week of 2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 146",
                        "readQS": "Psalm+146",
                        "audioQS": "Ps.146"
                    },
                    {
                        "pretty": "Genesis 6:11\u20137:10",
                        "readQS": "Genesis+6:11-7:10",
                        "audioQS": "Gen.6"
                    },
                    {
                        "pretty": "Matthew 24:1\u201314",
                        "readQS": "Matthew+24:1-14",
                        "audioQS": "Matt.24"
                    }
                ],
                "readQS": "Psalm+146%3B+Genesis+6:11-7:10%3B+Matthew+24:1-14",
                "audioQS": "Ps.146,Gen.6,Matt.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Amos 6",
                        "readQS": "Amos+6",
                        "audioQS": "Amos.6"
                    },
                    {
                        "pretty": "1 Corinthians 6:1\u201311",
                        "readQS": "1+Corinthians+6:1-11",
                        "audioQS": "1Cor.6"
                    }
                ],
                "readQS": "Psalm+71%3B+Amos+6%3B+1+Corinthians+6:1-11",
                "audioQS": "Ps.71,Amos.6,1Cor.6",
                "note": null
            }
        ]
    },
    "2026/01/20": {
        "datePretty": "Tuesday, January 20, 2026",
        "calendar": "Week of 2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Genesis 7:11\u2013end",
                        "readQS": "Genesis+7:11-",
                        "audioQS": "Gen.7"
                    },
                    {
                        "pretty": "Matthew 24:15\u201328",
                        "readQS": "Matthew+24:15-28",
                        "audioQS": "Matt.24"
                    }
                ],
                "readQS": "Psalm+132%3B+Genesis+7:11-%3B+Matthew+24:15-28",
                "audioQS": "Ps.132,Gen.7,Matt.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 89:1\u201337",
                        "readQS": "Psalm+89:1-37",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Amos 7",
                        "readQS": "Amos+7",
                        "audioQS": "Amos.7"
                    },
                    {
                        "pretty": "1 Corinthians 6:12\u2013end",
                        "readQS": "1+Corinthians+6:12-",
                        "audioQS": "1Cor.6"
                    }
                ],
                "readQS": "Psalm+89:1-37%3B+Amos+7%3B+1+Corinthians+6:12-",
                "audioQS": "Ps.89,Amos.7,1Cor.6",
                "note": null
            }
        ]
    },
    "2026/01/21": {
        "datePretty": "Wednesday, January 21, 2026",
        "calendar": "Week of 2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 81",
                        "readQS": "Psalm+81",
                        "audioQS": "Ps.81"
                    },
                    {
                        "pretty": "Genesis 8:1\u201314",
                        "readQS": "Genesis+8:1-14",
                        "audioQS": "Gen.8"
                    },
                    {
                        "pretty": "Matthew 24:29\u2013end",
                        "readQS": "Matthew+24:29-",
                        "audioQS": "Matt.24"
                    }
                ],
                "readQS": "Psalm+81%3B+Genesis+8:1-14%3B+Matthew+24:29-",
                "audioQS": "Ps.81,Gen.8,Matt.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Amos 8",
                        "readQS": "Amos+8",
                        "audioQS": "Amos.8"
                    },
                    {
                        "pretty": "1 Corinthians 7:1\u201324",
                        "readQS": "1+Corinthians+7:1-24",
                        "audioQS": "1Cor.7"
                    }
                ],
                "readQS": "Psalm+97%3B+Amos+8%3B+1+Corinthians+7:1-24",
                "audioQS": "Ps.97,Amos.8,1Cor.7",
                "note": null
            }
        ]
    },
    "2026/01/22": {
        "datePretty": "Thursday, January 22, 2026",
        "calendar": "Week of 2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 76",
                        "readQS": "Psalm+76",
                        "audioQS": "Ps.76"
                    },
                    {
                        "pretty": "Genesis 8:15\u20139:7",
                        "readQS": "Genesis+8:15-9:7",
                        "audioQS": "Gen.8"
                    },
                    {
                        "pretty": "Matthew 25:1\u201313",
                        "readQS": "Matthew+25:1-13",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+76%3B+Genesis+8:15-9:7%3B+Matthew+25:1-13",
                "audioQS": "Ps.76,Gen.8,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 111",
                        "readQS": "Psalm+111",
                        "audioQS": "Ps.111"
                    },
                    {
                        "pretty": "Amos 9",
                        "readQS": "Amos+9",
                        "audioQS": "Amos.9"
                    },
                    {
                        "pretty": "1 Corinthians 7:25\u2013end",
                        "readQS": "1+Corinthians+7:25-",
                        "audioQS": "1Cor.7"
                    }
                ],
                "readQS": "Psalm+111%3B+Amos+9%3B+1+Corinthians+7:25-",
                "audioQS": "Ps.111,Amos.9,1Cor.7",
                "note": null
            }
        ]
    },
    "2026/01/23": {
        "datePretty": "Friday, January 23, 2026",
        "calendar": "Week of 2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 27",
                        "readQS": "Psalm+27",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Genesis 9:8\u201319",
                        "readQS": "Genesis+9:8-19",
                        "audioQS": "Gen.9"
                    },
                    {
                        "pretty": "Matthew 25:14\u201330",
                        "readQS": "Matthew+25:14-30",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+27%3B+Genesis+9:8-19%3B+Matthew+25:14-30",
                "audioQS": "Ps.27,Gen.9,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Hosea 1:1\u20132:1",
                        "readQS": "Hosea+1:1-2:1",
                        "audioQS": "Hos.1"
                    },
                    {
                        "pretty": "1 Corinthians 8",
                        "readQS": "1+Corinthians+8",
                        "audioQS": "1Cor.8"
                    }
                ],
                "readQS": "Psalm+73%3B+Hosea+1:1-2:1%3B+1+Corinthians+8",
                "audioQS": "Ps.73,Hos.1,1Cor.8",
                "note": null
            }
        ]
    },
    "2026/01/24": {
        "datePretty": "Saturday, January 24, 2026",
        "calendar": "Week of 2nd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 122",
                        "readQS": "Psalm+122",
                        "audioQS": "Ps.122"
                    },
                    {
                        "pretty": "Genesis 11:1\u20139",
                        "readQS": "Genesis+11:1-9",
                        "audioQS": "Gen.11"
                    },
                    {
                        "pretty": "Matthew 25:31\u2013end",
                        "readQS": "Matthew+25:31-",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+122%3B+Genesis+11:1-9%3B+Matthew+25:31-",
                "audioQS": "Ps.122,Gen.11,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Conversion of St Paul)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 149",
                        "readQS": "Psalm+149",
                        "audioQS": "Ps.149"
                    },
                    {
                        "pretty": "Isaiah 49:1\u201313",
                        "readQS": "Isaiah+49:1-13",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "Acts 22:3\u201316",
                        "readQS": "Acts+22:3-16",
                        "audioQS": "Acts.22"
                    }
                ],
                "readQS": "Psalm+149%3B+Isaiah+49:1-13%3B+Acts+22:3-16",
                "audioQS": "Ps.149,Isa.49,Acts.22",
                "note": null
            }
        ]
    },
    "2026/01/25": {
        "datePretty": "Sunday, January 25, 2026",
        "calendar": "The Conversion of Saint Paul",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 27:1,4\u201312",
                        "readQS": "Psalm+27:1,4-12",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Isaiah 9:1\u20134",
                        "readQS": "Isaiah+9:1-4",
                        "audioQS": "Isa.9"
                    },
                    {
                        "pretty": "1 Corinthians 1:10\u201318",
                        "readQS": "1+Corinthians+1:10-18",
                        "audioQS": "1Cor.1"
                    },
                    {
                        "pretty": "Matthew 4:12\u201323",
                        "readQS": "Matthew+4:12-23",
                        "audioQS": "Matt.4"
                    }
                ],
                "readQS": "Psalm+27:1,4-12%3B+Isaiah+9:1-4%3B+1+Corinthians+1:10-18%3B+Matthew+4:12-23",
                "audioQS": "Ps.27,Isa.9,1Cor.1,Matt.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 66,147:12\u201320",
                        "readQS": "Psalm+66,147:12-20",
                        "audioQS": "Ps.66,147"
                    },
                    {
                        "pretty": "Ezekiel 3:22\u201327",
                        "readQS": "Ezekiel+3:22-27",
                        "audioQS": "Ezek.3"
                    },
                    {
                        "pretty": "Philippians 3:1\u201314",
                        "readQS": "Philippians+3:1-14",
                        "audioQS": "Phil.3"
                    }
                ],
                "readQS": "Psalm+66,147:12-20%3B+Ezekiel+3:22-27%3B+Philippians+3:1-14",
                "audioQS": "Ps.66,147,Ezek.3,Phil.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:41\u201356",
                        "readQS": "Psalm+119:41-56",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Isaiah 56:1\u20138",
                        "readQS": "Isaiah+56:1-8",
                        "audioQS": "Isa.56"
                    },
                    {
                        "pretty": "Colossians 1:24\u2013end,2:1\u20137",
                        "readQS": "Colossians+1:24-,2:1-7",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+119:41-56%3B+Isaiah+56:1-8%3B+Colossians+1:24-,2:1-7",
                "audioQS": "Ps.119,Isa.56,Col.1",
                "note": null
            }
        ]
    },
    "2026/01/26": {
        "datePretty": "Monday, January 26, 2026",
        "calendar": "Week of 3rd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 108",
                        "readQS": "Psalm+108",
                        "audioQS": "Ps.108"
                    },
                    {
                        "pretty": "Genesis 11:27\u201312:9",
                        "readQS": "Genesis+11:27-12:9",
                        "audioQS": "Gen.11"
                    },
                    {
                        "pretty": "Matthew 26:1\u201316",
                        "readQS": "Matthew+26:1-16",
                        "audioQS": "Matt.26"
                    }
                ],
                "readQS": "Psalm+108%3B+Genesis+11:27-12:9%3B+Matthew+26:1-16",
                "audioQS": "Ps.108,Gen.11,Matt.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "Hosea 2:18\u2013end",
                        "readQS": "Hosea+2:18-",
                        "audioQS": "Hos.2"
                    },
                    {
                        "pretty": "Hosea 3",
                        "readQS": "Hosea+3",
                        "audioQS": "Hos.3"
                    },
                    {
                        "pretty": "1 Corinthians 9:15\u2013end",
                        "readQS": "1+Corinthians+9:15-",
                        "audioQS": "1Cor.9"
                    }
                ],
                "readQS": "Psalm+138%3B+Hosea+2:18-%3B+Hosea+3%3B+1+Corinthians+9:15-",
                "audioQS": "Ps.138,Hos.2,Hos.3,1Cor.9",
                "note": null
            }
        ]
    },
    "2026/01/27": {
        "datePretty": "Tuesday, January 27, 2026",
        "calendar": "Week of 3rd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "Genesis 13:2\u2013end",
                        "readQS": "Genesis+13:2-",
                        "audioQS": "Gen.13"
                    },
                    {
                        "pretty": "Matthew 26:17\u201335",
                        "readQS": "Matthew+26:17-35",
                        "audioQS": "Matt.26"
                    }
                ],
                "readQS": "Psalm+36%3B+Genesis+13:2-%3B+Matthew+26:17-35",
                "audioQS": "Ps.36,Gen.13,Matt.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Hosea 4:1\u201316",
                        "readQS": "Hosea+4:1-16",
                        "audioQS": "Hos.4"
                    },
                    {
                        "pretty": "1 Corinthians 10:1\u201313",
                        "readQS": "1+Corinthians+10:1-13",
                        "audioQS": "1Cor.10"
                    }
                ],
                "readQS": "Psalm+145%3B+Hosea+4:1-16%3B+1+Corinthians+10:1-13",
                "audioQS": "Ps.145,Hos.4,1Cor.10",
                "note": null
            }
        ]
    },
    "2026/01/28": {
        "datePretty": "Wednesday, January 28, 2026",
        "calendar": "Week of 3rd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Genesis 14",
                        "readQS": "Genesis+14",
                        "audioQS": "Gen.14"
                    },
                    {
                        "pretty": "Matthew 26:36\u201346",
                        "readQS": "Matthew+26:36-46",
                        "audioQS": "Matt.26"
                    }
                ],
                "readQS": "Psalm+46%3B+Genesis+14%3B+Matthew+26:36-46",
                "audioQS": "Ps.46,Gen.14,Matt.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 29",
                        "readQS": "Psalm+29",
                        "audioQS": "Ps.29"
                    },
                    {
                        "pretty": "Hosea 5:1\u20137",
                        "readQS": "Hosea+5:1-7",
                        "audioQS": "Hos.5"
                    },
                    {
                        "pretty": "1 Corinthians 10:14\u201311:1",
                        "readQS": "1+Corinthians+10:14-11:1",
                        "audioQS": "1Cor.10"
                    }
                ],
                "readQS": "Psalm+29%3B+Hosea+5:1-7%3B+1+Corinthians+10:14-11:1",
                "audioQS": "Ps.29,Hos.5,1Cor.10",
                "note": null
            }
        ]
    },
    "2026/01/29": {
        "datePretty": "Thursday, January 29, 2026",
        "calendar": "Week of 3rd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Genesis 15",
                        "readQS": "Genesis+15",
                        "audioQS": "Gen.15"
                    },
                    {
                        "pretty": "Matthew 26:47\u201356",
                        "readQS": "Matthew+26:47-56",
                        "audioQS": "Matt.26"
                    }
                ],
                "readQS": "Psalm+47%3B+Genesis+15%3B+Matthew+26:47-56",
                "audioQS": "Ps.47,Gen.15,Matt.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 24",
                        "readQS": "Psalm+24",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "Hosea 5:8\u20136:6",
                        "readQS": "Hosea+5:8-6:6",
                        "audioQS": "Hos.5"
                    },
                    {
                        "pretty": "1 Corinthians 11:2\u201316",
                        "readQS": "1+Corinthians+11:2-16",
                        "audioQS": "1Cor.11"
                    }
                ],
                "readQS": "Psalm+24%3B+Hosea+5:8-6:6%3B+1+Corinthians+11:2-16",
                "audioQS": "Ps.24,Hos.5,1Cor.11",
                "note": null
            }
        ]
    },
    "2026/01/30": {
        "datePretty": "Friday, January 30, 2026",
        "calendar": "Week of 3rd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 65",
                        "readQS": "Psalm+65",
                        "audioQS": "Ps.65"
                    },
                    {
                        "pretty": "Genesis 16",
                        "readQS": "Genesis+16",
                        "audioQS": "Gen.16"
                    },
                    {
                        "pretty": "Matthew 26:57\u2013end",
                        "readQS": "Matthew+26:57-",
                        "audioQS": "Matt.26"
                    }
                ],
                "readQS": "Psalm+65%3B+Genesis+16%3B+Matthew+26:57-",
                "audioQS": "Ps.65,Gen.16,Matt.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 67",
                        "readQS": "Psalm+67",
                        "audioQS": "Ps.67"
                    },
                    {
                        "pretty": "Hosea 6:7\u20137:2",
                        "readQS": "Hosea+6:7-7:2",
                        "audioQS": "Hos.6"
                    },
                    {
                        "pretty": "1 Corinthians 11:17\u2013end",
                        "readQS": "1+Corinthians+11:17-",
                        "audioQS": "1Cor.11"
                    }
                ],
                "readQS": "Psalm+67%3B+Hosea+6:7-7:2%3B+1+Corinthians+11:17-",
                "audioQS": "Ps.67,Hos.6,1Cor.11",
                "note": null
            }
        ]
    },
    "2026/01/31": {
        "datePretty": "Saturday, January 31, 2026",
        "calendar": "Week of 3rd Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 68",
                        "readQS": "Psalm+68",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Genesis 17:1\u201322",
                        "readQS": "Genesis+17:1-22",
                        "audioQS": "Gen.17"
                    },
                    {
                        "pretty": "Matthew 27:1\u201310",
                        "readQS": "Matthew+27:1-10",
                        "audioQS": "Matt.27"
                    }
                ],
                "readQS": "Psalm+68%3B+Genesis+17:1-22%3B+Matthew+27:1-10",
                "audioQS": "Ps.68,Gen.17,Matt.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Hosea 8",
                        "readQS": "Hosea+8",
                        "audioQS": "Hos.8"
                    },
                    {
                        "pretty": "1 Corinthians 12:1\u201311",
                        "readQS": "1+Corinthians+12:1-11",
                        "audioQS": "1Cor.12"
                    }
                ],
                "readQS": "Psalm+72%3B+Hosea+8%3B+1+Corinthians+12:1-11",
                "audioQS": "Ps.72,Hos.8,1Cor.12",
                "note": null
            }
        ]
    },
    "2026/02/01": {
        "datePretty": "Sunday, February 1, 2026",
        "calendar": "4th Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 36:5\u201310",
                        "readQS": "Psalm+36:5-10",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "1 Kings 17:8\u201316",
                        "readQS": "1+Kings+17:8-16",
                        "audioQS": "1Kgs.17"
                    },
                    {
                        "pretty": "1 Corinthians 1:18\u201331",
                        "readQS": "1+Corinthians+1:18-31",
                        "audioQS": "1Cor.1"
                    },
                    {
                        "pretty": "John 2:1\u201311",
                        "readQS": "John+2:1-11",
                        "audioQS": "John.2"
                    }
                ],
                "readQS": "Psalm+36:5-10%3B+1+Kings+17:8-16%3B+1+Corinthians+1:18-31%3B+John+2:1-11",
                "audioQS": "Ps.36,1Kgs.17,1Cor.1,John.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71:1\u20136,15\u201317",
                        "readQS": "Psalm+71:1-6,15-17",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Haggai 2:1\u20139",
                        "readQS": "Haggai+2:1-9",
                        "audioQS": "Hag.2"
                    },
                    {
                        "pretty": "1 Corinthians 3:10\u201317",
                        "readQS": "1+Corinthians+3:10-17",
                        "audioQS": "1Cor.3"
                    }
                ],
                "readQS": "Psalm+71:1-6,15-17%3B+Haggai+2:1-9%3B+1+Corinthians+3:10-17",
                "audioQS": "Ps.71,Hag.2,1Cor.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Presentation)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "1 Samuel 1:19b\u201328",
                        "readQS": "1+Samuel+1:19b-28",
                        "audioQS": "1Sam.1"
                    },
                    {
                        "pretty": "Hebrews 4:11\u201316",
                        "readQS": "Hebrews+4:11-16",
                        "audioQS": "Heb.4"
                    }
                ],
                "readQS": "Psalm+118%3B+1+Samuel+1:19b-28%3B+Hebrews+4:11-16",
                "audioQS": "Ps.118,1Sam.1,Heb.4",
                "note": null
            }
        ]
    },
    "2026/02/02": {
        "datePretty": "Monday, February 2, 2026",
        "calendar": "Presentation of Jesus at the Temple",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 24:(1\u20136),7\u201310",
                        "readQS": "Psalm+24:%281-6%29,7-10",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "Malachi 3.1\u20135",
                        "readQS": "Malachi+3.1-5",
                        "audioQS": "Mal.3.1\u20135"
                    },
                    {
                        "pretty": "Hebrews 2:14\u201318",
                        "readQS": "Hebrews+2:14-18",
                        "audioQS": "Heb.2"
                    },
                    {
                        "pretty": "Luke 2:22\u201340",
                        "readQS": "Luke+2:22-40",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+24:%281-6%29,7-10%3B+Malachi+3.1-5%3B+Hebrews+2:14-18%3B+Luke+2:22-40",
                "audioQS": "Ps.24,Mal.3.1\u20135,Heb.2,Luke.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 48,146",
                        "readQS": "Psalm+48,146",
                        "audioQS": "Ps.48,146"
                    },
                    {
                        "pretty": "Exodus 13:1\u201316",
                        "readQS": "Exodus+13:1-16",
                        "audioQS": "Exod.13"
                    },
                    {
                        "pretty": "Romans 12:1\u20135",
                        "readQS": "Romans+12:1-5",
                        "audioQS": "Rom.12"
                    }
                ],
                "readQS": "Psalm+48,146%3B+Exodus+13:1-16%3B+Romans+12:1-5",
                "audioQS": "Ps.48,146,Exod.13,Rom.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 122,132",
                        "readQS": "Psalm+122,132",
                        "audioQS": "Ps.122,132"
                    },
                    {
                        "pretty": "Haggai 2:1\u20139",
                        "readQS": "Haggai+2:1-9",
                        "audioQS": "Hag.2"
                    },
                    {
                        "pretty": "John 2:18\u201322",
                        "readQS": "John+2:18-22",
                        "audioQS": "John.2"
                    }
                ],
                "readQS": "Psalm+122,132%3B+Haggai+2:1-9%3B+John+2:18-22",
                "audioQS": "Ps.122,132,Hag.2,John.2",
                "note": null
            }
        ]
    },
    "2026/02/03": {
        "datePretty": "Tuesday, February 3, 2026",
        "calendar": "Week of 4th Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "Genesis 18:16\u2013end",
                        "readQS": "Genesis+18:16-",
                        "audioQS": "Gen.18"
                    },
                    {
                        "pretty": "Matthew 27:27\u201344",
                        "readQS": "Matthew+27:27-44",
                        "audioQS": "Matt.27"
                    }
                ],
                "readQS": "Psalm+5%3B+Genesis+18:16-%3B+Matthew+27:27-44",
                "audioQS": "Ps.5,Gen.18,Matt.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Hosea 10",
                        "readQS": "Hosea+10",
                        "audioQS": "Hos.10"
                    },
                    {
                        "pretty": "1 Corinthians 13",
                        "readQS": "1+Corinthians+13",
                        "audioQS": "1Cor.13"
                    }
                ],
                "readQS": "Psalm+9%3B+Hosea+10%3B+1+Corinthians+13",
                "audioQS": "Ps.9,Hos.10,1Cor.13",
                "note": null
            }
        ]
    },
    "2026/02/04": {
        "datePretty": "Wednesday, February 4, 2026",
        "calendar": "Week of 4th Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:1\u201332",
                        "readQS": "Psalm+119:1-32",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Genesis 19:1\u20133,19:12\u201329",
                        "readQS": "Genesis+19:1-3,19:12-29",
                        "audioQS": "Gen.19"
                    },
                    {
                        "pretty": "Matthew 27:45\u201356",
                        "readQS": "Matthew+27:45-56",
                        "audioQS": "Matt.27"
                    }
                ],
                "readQS": "Psalm+119:1-32%3B+Genesis+19:1-3,19:12-29%3B+Matthew+27:45-56",
                "audioQS": "Ps.119,Gen.19,Matt.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "Hosea 11:1\u201311",
                        "readQS": "Hosea+11:1-11",
                        "audioQS": "Hos.11"
                    },
                    {
                        "pretty": "1 Corinthians 14:1\u201319",
                        "readQS": "1+Corinthians+14:1-19",
                        "audioQS": "1Cor.14"
                    }
                ],
                "readQS": "Psalm+11%3B+Hosea+11:1-11%3B+1+Corinthians+14:1-19",
                "audioQS": "Ps.11,Hos.11,1Cor.14",
                "note": null
            }
        ]
    },
    "2026/02/05": {
        "datePretty": "Thursday, February 5, 2026",
        "calendar": "Week of 4th Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15",
                        "readQS": "Psalm+15",
                        "audioQS": "Ps.15"
                    },
                    {
                        "pretty": "Genesis 21:1\u201321",
                        "readQS": "Genesis+21:1-21",
                        "audioQS": "Gen.21"
                    },
                    {
                        "pretty": "Matthew 27:57\u2013end",
                        "readQS": "Matthew+27:57-",
                        "audioQS": "Matt.27"
                    }
                ],
                "readQS": "Psalm+15%3B+Genesis+21:1-21%3B+Matthew+27:57-",
                "audioQS": "Ps.15,Gen.21,Matt.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 18",
                        "readQS": "Psalm+18",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "Hosea 11:12\u2013end",
                        "readQS": "Hosea+11:12-",
                        "audioQS": "Hos.11"
                    },
                    {
                        "pretty": "Hosea 12",
                        "readQS": "Hosea+12",
                        "audioQS": "Hos.12"
                    },
                    {
                        "pretty": "1 Corinthians 14:20\u2013end",
                        "readQS": "1+Corinthians+14:20-",
                        "audioQS": "1Cor.14"
                    }
                ],
                "readQS": "Psalm+18%3B+Hosea+11:12-%3B+Hosea+12%3B+1+Corinthians+14:20-",
                "audioQS": "Ps.18,Hos.11,Hos.12,1Cor.14",
                "note": null
            }
        ]
    },
    "2026/02/06": {
        "datePretty": "Friday, February 6, 2026",
        "calendar": "Week of 4th Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Genesis 22:1\u201319",
                        "readQS": "Genesis+22:1-19",
                        "audioQS": "Gen.22"
                    },
                    {
                        "pretty": "Matthew 28:1\u201315",
                        "readQS": "Matthew+28:1-15",
                        "audioQS": "Matt.28"
                    }
                ],
                "readQS": "Psalm+19%3B+Genesis+22:1-19%3B+Matthew+28:1-15",
                "audioQS": "Ps.19,Gen.22,Matt.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Hosea 13:1\u201314",
                        "readQS": "Hosea+13:1-14",
                        "audioQS": "Hos.13"
                    },
                    {
                        "pretty": "1 Corinthians 16:1\u20139",
                        "readQS": "1+Corinthians+16:1-9",
                        "audioQS": "1Cor.16"
                    }
                ],
                "readQS": "Psalm+22%3B+Hosea+13:1-14%3B+1+Corinthians+16:1-9",
                "audioQS": "Ps.22,Hos.13,1Cor.16",
                "note": null
            }
        ]
    },
    "2026/02/07": {
        "datePretty": "Saturday, February 7, 2026",
        "calendar": "Week of 4th Sunday after the Epiphany",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Genesis 23",
                        "readQS": "Genesis+23",
                        "audioQS": "Gen.23"
                    },
                    {
                        "pretty": "Matthew 28:16\u2013end",
                        "readQS": "Matthew+28:16-",
                        "audioQS": "Matt.28"
                    }
                ],
                "readQS": "Psalm+23%3B+Genesis+23%3B+Matthew+28:16-",
                "audioQS": "Ps.23,Gen.23,Matt.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 24",
                        "readQS": "Psalm+24",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "Hosea 14",
                        "readQS": "Hosea+14",
                        "audioQS": "Hos.14"
                    },
                    {
                        "pretty": "1 Corinthians 16:10\u2013end",
                        "readQS": "1+Corinthians+16:10-",
                        "audioQS": "1Cor.16"
                    }
                ],
                "readQS": "Psalm+24%3B+Hosea+14%3B+1+Corinthians+16:10-",
                "audioQS": "Ps.24,Hos.14,1Cor.16",
                "note": null
            }
        ]
    },
    "2026/02/08": {
        "datePretty": "Sunday, February 8, 2026",
        "calendar": "2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 136:1\u20139,(10\u201322),23\u201326",
                        "readQS": "Psalm+136:1-9,%2810-22%29,23-26",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Genesis 1:1\u20132:3",
                        "readQS": "Genesis+1:1-2:3",
                        "audioQS": "Gen.1"
                    },
                    {
                        "pretty": "Romans 8:18\u201325",
                        "readQS": "Romans+8:18-25",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 6:25\u201334",
                        "readQS": "Matthew+6:25-34",
                        "audioQS": "Matt.6"
                    }
                ],
                "readQS": "Psalm+136:1-9,%2810-22%29,23-26%3B+Genesis+1:1-2:3%3B+Romans+8:18-25%3B+Matthew+6:25-34",
                "audioQS": "Ps.136,Gen.1,Rom.8,Matt.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 100,150",
                        "readQS": "Psalm+100,150",
                        "audioQS": "Ps.100,150"
                    },
                    {
                        "pretty": "Job 38:1\u201321",
                        "readQS": "Job+38:1-21",
                        "audioQS": "Job.38"
                    },
                    {
                        "pretty": "Colossians 1:15\u201320",
                        "readQS": "Colossians+1:15-20",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+100,150%3B+Job+38:1-21%3B+Colossians+1:15-20",
                "audioQS": "Ps.100,150,Job.38,Col.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Proverbs 8:1,22\u201331",
                        "readQS": "Proverbs+8:1,22-31",
                        "audioQS": "Prov.8"
                    },
                    {
                        "pretty": "Revelation 4",
                        "readQS": "Revelation+4",
                        "audioQS": "Rev.4"
                    }
                ],
                "readQS": "Psalm+148%3B+Proverbs+8:1,22-31%3B+Revelation+4",
                "audioQS": "Ps.148,Prov.8,Rev.4",
                "note": null
            }
        ]
    },
    "2026/02/09": {
        "datePretty": "Monday, February 9, 2026",
        "calendar": "Week of 2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Genesis 29:31\u201330:24",
                        "readQS": "Genesis+29:31-30:24",
                        "audioQS": "Gen.29"
                    },
                    {
                        "pretty": "2 Timothy 4:1\u20138",
                        "readQS": "2+Timothy+4:1-8",
                        "audioQS": "2Tim.4"
                    }
                ],
                "readQS": "Psalm+30%3B+Genesis+29:31-30:24%3B+2+Timothy+4:1-8",
                "audioQS": "Ps.30,Gen.29,2Tim.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 28",
                        "readQS": "Psalm+28",
                        "audioQS": "Ps.28"
                    },
                    {
                        "pretty": "2 Chronicles 9:1\u201312",
                        "readQS": "2+Chronicles+9:1-12",
                        "audioQS": "2Chr.9"
                    },
                    {
                        "pretty": "John 19:1\u201316",
                        "readQS": "John+19:1-16",
                        "audioQS": "John.19"
                    }
                ],
                "readQS": "Psalm+28%3B+2+Chronicles+9:1-12%3B+John+19:1-16",
                "audioQS": "Ps.28,2Chr.9,John.19",
                "note": null
            }
        ]
    },
    "2026/02/10": {
        "datePretty": "Tuesday, February 10, 2026",
        "calendar": "Week of 2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "Genesis 31:1\u201324",
                        "readQS": "Genesis+31:1-24",
                        "audioQS": "Gen.31"
                    },
                    {
                        "pretty": "2 Timothy 4:9\u2013end",
                        "readQS": "2+Timothy+4:9-",
                        "audioQS": "2Tim.4"
                    }
                ],
                "readQS": "Psalm+36%3B+Genesis+31:1-24%3B+2+Timothy+4:9-",
                "audioQS": "Ps.36,Gen.31,2Tim.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "2 Chronicles 10:1\u201311:4",
                        "readQS": "2+Chronicles+10:1-11:4",
                        "audioQS": "2Chr.10"
                    },
                    {
                        "pretty": "John 19:17\u201330",
                        "readQS": "John+19:17-30",
                        "audioQS": "John.19"
                    }
                ],
                "readQS": "Psalm+33%3B+2+Chronicles+10:1-11:4%3B+John+19:17-30",
                "audioQS": "Ps.33,2Chr.10,John.19",
                "note": null
            }
        ]
    },
    "2026/02/11": {
        "datePretty": "Wednesday, February 11, 2026",
        "calendar": "Week of 2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Genesis 31:25\u201332:2",
                        "readQS": "Genesis+31:25-32:2",
                        "audioQS": "Gen.31"
                    },
                    {
                        "pretty": "Titus 1",
                        "readQS": "Titus+1",
                        "audioQS": "Titus.1"
                    }
                ],
                "readQS": "Psalm+34%3B+Genesis+31:25-32:2%3B+Titus+1",
                "audioQS": "Ps.34,Gen.31,Titus.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:33\u201356",
                        "readQS": "Psalm+119:33-56",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "2 Chronicles 12",
                        "readQS": "2+Chronicles+12",
                        "audioQS": "2Chr.12"
                    },
                    {
                        "pretty": "John 19:31\u2013end",
                        "readQS": "John+19:31-",
                        "audioQS": "John.19"
                    }
                ],
                "readQS": "Psalm+119:33-56%3B+2+Chronicles+12%3B+John+19:31-",
                "audioQS": "Ps.119,2Chr.12,John.19",
                "note": null
            }
        ]
    },
    "2026/02/12": {
        "datePretty": "Thursday, February 12, 2026",
        "calendar": "Week of 2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 37",
                        "readQS": "Psalm+37",
                        "audioQS": "Ps.37"
                    },
                    {
                        "pretty": "Genesis 32:3\u201330",
                        "readQS": "Genesis+32:3-30",
                        "audioQS": "Gen.32"
                    },
                    {
                        "pretty": "Titus 2",
                        "readQS": "Titus+2",
                        "audioQS": "Titus.2"
                    }
                ],
                "readQS": "Psalm+37%3B+Genesis+32:3-30%3B+Titus+2",
                "audioQS": "Ps.37,Gen.32,Titus.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "2 Chronicles 13:1\u201314:1",
                        "readQS": "2+Chronicles+13:1-14:1",
                        "audioQS": "2Chr.13"
                    },
                    {
                        "pretty": "John 20:1\u201310",
                        "readQS": "John+20:1-10",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+40%3B+2+Chronicles+13:1-14:1%3B+John+20:1-10",
                "audioQS": "Ps.40,2Chr.13,John.20",
                "note": null
            }
        ]
    },
    "2026/02/13": {
        "datePretty": "Friday, February 13, 2026",
        "calendar": "Week of 2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Genesis 33:1\u201317",
                        "readQS": "Genesis+33:1-17",
                        "audioQS": "Gen.33"
                    },
                    {
                        "pretty": "Titus 3",
                        "readQS": "Titus+3",
                        "audioQS": "Titus.3"
                    }
                ],
                "readQS": "Psalm+31%3B+Genesis+33:1-17%3B+Titus+3",
                "audioQS": "Ps.31,Gen.33,Titus.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 35",
                        "readQS": "Psalm+35",
                        "audioQS": "Ps.35"
                    },
                    {
                        "pretty": "2 Chronicles 14:2\u2013end",
                        "readQS": "2+Chronicles+14:2-",
                        "audioQS": "2Chr.14"
                    },
                    {
                        "pretty": "John 20:11\u201318",
                        "readQS": "John+20:11-18",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+35%3B+2+Chronicles+14:2-%3B+John+20:11-18",
                "audioQS": "Ps.35,2Chr.14,John.20",
                "note": null
            }
        ]
    },
    "2026/02/14": {
        "datePretty": "Saturday, February 14, 2026",
        "calendar": "Week of 2nd Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "Genesis 35",
                        "readQS": "Genesis+35",
                        "audioQS": "Gen.35"
                    },
                    {
                        "pretty": "Philemon",
                        "readQS": "Philemon",
                        "audioQS": "Phlm"
                    }
                ],
                "readQS": "Psalm+42%3B+Genesis+35%3B+Philemon",
                "audioQS": "Ps.42,Gen.35,Phlm",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "2 Chronicles 15:1\u201315",
                        "readQS": "2+Chronicles+15:1-15",
                        "audioQS": "2Chr.15"
                    },
                    {
                        "pretty": "John 20:19\u2013end",
                        "readQS": "John+20:19-",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+46%3B+2+Chronicles+15:1-15%3B+John+20:19-",
                "audioQS": "Ps.46,2Chr.15,John.20",
                "note": null
            }
        ]
    },
    "2026/02/15": {
        "datePretty": "Sunday, February 15, 2026",
        "calendar": "The Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 2",
                        "readQS": "Psalm+2",
                        "audioQS": "Ps.2"
                    },
                    {
                        "pretty": "Exodus 24:12\u201318",
                        "readQS": "Exodus+24:12-18",
                        "audioQS": "Exod.24"
                    },
                    {
                        "pretty": "2 Peter 1:16\u201321",
                        "readQS": "2+Peter+1:16-21",
                        "audioQS": "2Pet.1"
                    },
                    {
                        "pretty": "Matthew 17:1\u20139",
                        "readQS": "Matthew+17:1-9",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+2%3B+Exodus+24:12-18%3B+2+Peter+1:16-21%3B+Matthew+17:1-9",
                "audioQS": "Ps.2,Exod.24,2Pet.1,Matt.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Exodus 34:29\u201335",
                        "readQS": "Exodus+34:29-35",
                        "audioQS": "Exod.34"
                    },
                    {
                        "pretty": "2 Corinthians 4:3\u20136",
                        "readQS": "2+Corinthians+4:3-6",
                        "audioQS": "2Cor.4"
                    }
                ],
                "readQS": "Psalm+72%3B+Exodus+34:29-35%3B+2+Corinthians+4:3-6",
                "audioQS": "Ps.72,Exod.34,2Cor.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 84",
                        "readQS": "Psalm+84",
                        "audioQS": "Ps.84"
                    },
                    {
                        "pretty": "2 Kings 2:1\u201312",
                        "readQS": "2+Kings+2:1-12",
                        "audioQS": "2Kgs.2"
                    },
                    {
                        "pretty": "Matthew 17:9\u201323",
                        "readQS": "Matthew+17:9-23",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+84%3B+2+Kings+2:1-12%3B+Matthew+17:9-23",
                "audioQS": "Ps.84,2Kgs.2,Matt.17",
                "note": null
            }
        ]
    },
    "2026/02/16": {
        "datePretty": "Monday, February 16, 2026",
        "calendar": "Week of the Sunday before Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Genesis 37:1\u201311",
                        "readQS": "Genesis+37:1-11",
                        "audioQS": "Gen.37"
                    },
                    {
                        "pretty": "Galatians 1",
                        "readQS": "Galatians+1",
                        "audioQS": "Gal.1"
                    }
                ],
                "readQS": "Psalm+44%3B+Genesis+37:1-11%3B+Galatians+1",
                "audioQS": "Ps.44,Gen.37,Gal.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Jeremiah 1",
                        "readQS": "Jeremiah+1",
                        "audioQS": "Jer.1"
                    },
                    {
                        "pretty": "John 3:1\u201321",
                        "readQS": "John+3:1-21",
                        "audioQS": "John.3"
                    }
                ],
                "readQS": "Psalm+47%3B+Jeremiah+1%3B+John+3:1-21",
                "audioQS": "Ps.47,Jer.1,John.3",
                "note": null
            }
        ]
    },
    "2026/02/17": {
        "datePretty": "Tuesday, February 17, 2026",
        "calendar": "Shrove Tuesday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "Genesis 37:12\u2013end",
                        "readQS": "Genesis+37:12-",
                        "audioQS": "Gen.37"
                    },
                    {
                        "pretty": "Galatians 2:1\u201310",
                        "readQS": "Galatians+2:1-10",
                        "audioQS": "Gal.2"
                    }
                ],
                "readQS": "Psalm+48%3B+Genesis+37:12-%3B+Galatians+2:1-10",
                "audioQS": "Ps.48,Gen.37,Gal.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Jeremiah 2:1\u201313",
                        "readQS": "Jeremiah+2:1-13",
                        "audioQS": "Jer.2"
                    },
                    {
                        "pretty": "John 3:22\u2013end",
                        "readQS": "John+3:22-",
                        "audioQS": "John.3"
                    }
                ],
                "readQS": "Psalm+50%3B+Jeremiah+2:1-13%3B+John+3:22-",
                "audioQS": "Ps.50,Jer.2,John.3",
                "note": null
            }
        ]
    },
    "2026/02/18": {
        "datePretty": "Wednesday, February 18, 2026",
        "calendar": "Ash Wednesday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 51:1\u201318",
                        "readQS": "Psalm+51:1-18",
                        "audioQS": "Ps.51"
                    },
                    {
                        "pretty": "Joel 2:1\u20132,12\u201317",
                        "readQS": "Joel+2:1-2,12-17",
                        "audioQS": "Joel.2"
                    },
                    {
                        "pretty": "2 Corinthians 5:20b\u20136.10",
                        "readQS": "2+Corinthians+5:20b-6.10",
                        "audioQS": "2Cor.5"
                    },
                    {
                        "pretty": "Matthew 6:1\u20136,16\u201321",
                        "readQS": "Matthew+6:1-6,16-21",
                        "audioQS": "Matt.6"
                    }
                ],
                "readQS": "Psalm+51:1-18%3B+Joel+2:1-2,12-17%3B+2+Corinthians+5:20b-6.10%3B+Matthew+6:1-6,16-21",
                "audioQS": "Ps.51,Joel.2,2Cor.5,Matt.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 38",
                        "readQS": "Psalm+38",
                        "audioQS": "Ps.38"
                    },
                    {
                        "pretty": "Daniel 9:3\u20136,17\u201319",
                        "readQS": "Daniel+9:3-6,17-19",
                        "audioQS": "Dan.9"
                    },
                    {
                        "pretty": "1 Timothy 6:6\u201319",
                        "readQS": "1+Timothy+6:6-19",
                        "audioQS": "1Tim.6"
                    }
                ],
                "readQS": "Psalm+38%3B+Daniel+9:3-6,17-19%3B+1+Timothy+6:6-19",
                "audioQS": "Ps.38,Dan.9,1Tim.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 51",
                        "readQS": "Psalm+51",
                        "audioQS": "Ps.51"
                    },
                    {
                        "pretty": "Isaiah 1:10\u201318",
                        "readQS": "Isaiah+1:10-18",
                        "audioQS": "Isa.1"
                    },
                    {
                        "pretty": "Luke 15:11\u201332",
                        "readQS": "Luke+15:11-32",
                        "audioQS": "Luke.15"
                    }
                ],
                "readQS": "Psalm+51%3B+Isaiah+1:10-18%3B+Luke+15:11-32",
                "audioQS": "Ps.51,Isa.1,Luke.15",
                "note": null
            }
        ]
    },
    "2026/02/19": {
        "datePretty": "Thursday, February 19, 2026",
        "calendar": "1st day of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Genesis 39",
                        "readQS": "Genesis+39",
                        "audioQS": "Gen.39"
                    },
                    {
                        "pretty": "Galatians 2:11\u2013end",
                        "readQS": "Galatians+2:11-",
                        "audioQS": "Gal.2"
                    }
                ],
                "readQS": "Psalm+77%3B+Genesis+39%3B+Galatians+2:11-",
                "audioQS": "Ps.77,Gen.39,Gal.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 74",
                        "readQS": "Psalm+74",
                        "audioQS": "Ps.74"
                    },
                    {
                        "pretty": "Jeremiah 2:14\u201332",
                        "readQS": "Jeremiah+2:14-32",
                        "audioQS": "Jer.2"
                    },
                    {
                        "pretty": "John 4:1\u201326",
                        "readQS": "John+4:1-26",
                        "audioQS": "John.4"
                    }
                ],
                "readQS": "Psalm+74%3B+Jeremiah+2:14-32%3B+John+4:1-26",
                "audioQS": "Ps.74,Jer.2,John.4",
                "note": null
            }
        ]
    },
    "2026/02/20": {
        "datePretty": "Friday, February 20, 2026",
        "calendar": "2nd day of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 3",
                        "readQS": "Psalm+3",
                        "audioQS": "Ps.3"
                    },
                    {
                        "pretty": "Genesis 40",
                        "readQS": "Genesis+40",
                        "audioQS": "Gen.40"
                    },
                    {
                        "pretty": "Galatians 3:1\u201314",
                        "readQS": "Galatians+3:1-14",
                        "audioQS": "Gal.3"
                    }
                ],
                "readQS": "Psalm+3%3B+Genesis+40%3B+Galatians+3:1-14",
                "audioQS": "Ps.3,Gen.40,Gal.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Jeremiah 3:6\u201322",
                        "readQS": "Jeremiah+3:6-22",
                        "audioQS": "Jer.3"
                    },
                    {
                        "pretty": "John 4:27\u201342",
                        "readQS": "John+4:27-42",
                        "audioQS": "John.4"
                    }
                ],
                "readQS": "Psalm+31%3B+Jeremiah+3:6-22%3B+John+4:27-42",
                "audioQS": "Ps.31,Jer.3,John.4",
                "note": null
            }
        ]
    },
    "2026/02/21": {
        "datePretty": "Saturday, February 21, 2026",
        "calendar": "3rd day of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Genesis 41:1\u201324",
                        "readQS": "Genesis+41:1-24",
                        "audioQS": "Gen.41"
                    },
                    {
                        "pretty": "Galatians 3:15\u201322",
                        "readQS": "Galatians+3:15-22",
                        "audioQS": "Gal.3"
                    }
                ],
                "readQS": "Psalm+71%3B+Genesis+41:1-24%3B+Galatians+3:15-22",
                "audioQS": "Ps.71,Gen.41,Gal.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Jeremiah 4:1\u201318",
                        "readQS": "Jeremiah+4:1-18",
                        "audioQS": "Jer.4"
                    },
                    {
                        "pretty": "John 4:43\u2013end",
                        "readQS": "John+4:43-",
                        "audioQS": "John.4"
                    }
                ],
                "readQS": "Psalm+73%3B+Jeremiah+4:1-18%3B+John+4:43-",
                "audioQS": "Ps.73,Jer.4,John.4",
                "note": null
            }
        ]
    },
    "2026/02/22": {
        "datePretty": "Sunday, February 22, 2026",
        "calendar": "1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 32",
                        "readQS": "Psalm+32",
                        "audioQS": "Ps.32"
                    },
                    {
                        "pretty": "Genesis 2:15\u201317,3:1\u20137",
                        "readQS": "Genesis+2:15-17,3:1-7",
                        "audioQS": "Gen.2"
                    },
                    {
                        "pretty": "Romans 5:12\u201319",
                        "readQS": "Romans+5:12-19",
                        "audioQS": "Rom.5"
                    },
                    {
                        "pretty": "Matthew 4:1\u201311",
                        "readQS": "Matthew+4:1-11",
                        "audioQS": "Matt.4"
                    }
                ],
                "readQS": "Psalm+32%3B+Genesis+2:15-17,3:1-7%3B+Romans+5:12-19%3B+Matthew+4:1-11",
                "audioQS": "Ps.32,Gen.2,Rom.5,Matt.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:1\u201316",
                        "readQS": "Psalm+119:1-16",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Jeremiah 18:1\u201311",
                        "readQS": "Jeremiah+18:1-11",
                        "audioQS": "Jer.18"
                    },
                    {
                        "pretty": "Luke 18:9\u201314",
                        "readQS": "Luke+18:9-14",
                        "audioQS": "Luke.18"
                    }
                ],
                "readQS": "Psalm+119:1-16%3B+Jeremiah+18:1-11%3B+Luke+18:9-14",
                "audioQS": "Ps.119,Jer.18,Luke.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50:1\u201315",
                        "readQS": "Psalm+50:1-15",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Deuteronomy 6:4\u20139,16\u201325",
                        "readQS": "Deuteronomy+6:4-9,16-25",
                        "audioQS": "Deut.6"
                    },
                    {
                        "pretty": "Luke 15:1\u201310",
                        "readQS": "Luke+15:1-10",
                        "audioQS": "Luke.15"
                    }
                ],
                "readQS": "Psalm+50:1-15%3B+Deuteronomy+6:4-9,16-25%3B+Luke+15:1-10",
                "audioQS": "Ps.50,Deut.6,Luke.15",
                "note": null
            }
        ]
    },
    "2026/02/23": {
        "datePretty": "Monday, February 23, 2026",
        "calendar": "Week of 1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "Genesis 41:25\u201345",
                        "readQS": "Genesis+41:25-45",
                        "audioQS": "Gen.41"
                    },
                    {
                        "pretty": "Galatians 3:23\u20134:7",
                        "readQS": "Galatians+3:23-4:7",
                        "audioQS": "Gal.3"
                    }
                ],
                "readQS": "Psalm+11%3B+Genesis+41:25-45%3B+Galatians+3:23-4:7",
                "audioQS": "Ps.11,Gen.41,Gal.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 13",
                        "readQS": "Psalm+13",
                        "audioQS": "Ps.13"
                    },
                    {
                        "pretty": "Jeremiah 4:19\u2013end",
                        "readQS": "Jeremiah+4:19-",
                        "audioQS": "Jer.4"
                    },
                    {
                        "pretty": "John 5:1\u201318",
                        "readQS": "John+5:1-18",
                        "audioQS": "John.5"
                    }
                ],
                "readQS": "Psalm+13%3B+Jeremiah+4:19-%3B+John+5:1-18",
                "audioQS": "Ps.13,Jer.4,John.5",
                "note": null
            }
        ]
    },
    "2026/02/24": {
        "datePretty": "Tuesday, February 24, 2026",
        "calendar": "Week of 1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Genesis 41:46\u201342:5",
                        "readQS": "Genesis+41:46-42:5",
                        "audioQS": "Gen.41"
                    },
                    {
                        "pretty": "Galatians 4:8\u201320",
                        "readQS": "Galatians+4:8-20",
                        "audioQS": "Gal.4"
                    }
                ],
                "readQS": "Psalm+44%3B+Genesis+41:46-42:5%3B+Galatians+4:8-20",
                "audioQS": "Ps.44,Gen.41,Gal.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 49",
                        "readQS": "Psalm+49",
                        "audioQS": "Ps.49"
                    },
                    {
                        "pretty": "Jeremiah 5:1\u201319",
                        "readQS": "Jeremiah+5:1-19",
                        "audioQS": "Jer.5"
                    },
                    {
                        "pretty": "John 5:19\u201329",
                        "readQS": "John+5:19-29",
                        "audioQS": "John.5"
                    }
                ],
                "readQS": "Psalm+49%3B+Jeremiah+5:1-19%3B+John+5:19-29",
                "audioQS": "Ps.49,Jer.5,John.5",
                "note": null
            }
        ]
    },
    "2026/02/25": {
        "datePretty": "Wednesday, February 25, 2026",
        "calendar": "Week of 1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 6",
                        "readQS": "Psalm+6",
                        "audioQS": "Ps.6"
                    },
                    {
                        "pretty": "Genesis 42:6\u201317",
                        "readQS": "Genesis+42:6-17",
                        "audioQS": "Gen.42"
                    },
                    {
                        "pretty": "Galatians 4:21\u20135:1",
                        "readQS": "Galatians+4:21-5:1",
                        "audioQS": "Gal.4"
                    }
                ],
                "readQS": "Psalm+6%3B+Genesis+42:6-17%3B+Galatians+4:21-5:1",
                "audioQS": "Ps.6,Gen.42,Gal.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 28",
                        "readQS": "Psalm+28",
                        "audioQS": "Ps.28"
                    },
                    {
                        "pretty": "Jeremiah 5:20\u2013end",
                        "readQS": "Jeremiah+5:20-",
                        "audioQS": "Jer.5"
                    },
                    {
                        "pretty": "John 5:30\u2013end",
                        "readQS": "John+5:30-",
                        "audioQS": "John.5"
                    }
                ],
                "readQS": "Psalm+28%3B+Jeremiah+5:20-%3B+John+5:30-",
                "audioQS": "Ps.28,Jer.5,John.5",
                "note": null
            }
        ]
    },
    "2026/02/26": {
        "datePretty": "Thursday, February 26, 2026",
        "calendar": "Week of 1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "Genesis 42:18\u201328",
                        "readQS": "Genesis+42:18-28",
                        "audioQS": "Gen.42"
                    },
                    {
                        "pretty": "Galatians 5:2\u201315",
                        "readQS": "Galatians+5:2-15",
                        "audioQS": "Gal.5"
                    }
                ],
                "readQS": "Psalm+42%3B+Genesis+42:18-28%3B+Galatians+5:2-15",
                "audioQS": "Ps.42,Gen.42,Gal.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 142",
                        "readQS": "Psalm+142",
                        "audioQS": "Ps.142"
                    },
                    {
                        "pretty": "Jeremiah 6:9\u201321",
                        "readQS": "Jeremiah+6:9-21",
                        "audioQS": "Jer.6"
                    },
                    {
                        "pretty": "John 6:1\u201315",
                        "readQS": "John+6:1-15",
                        "audioQS": "John.6"
                    }
                ],
                "readQS": "Psalm+142%3B+Jeremiah+6:9-21%3B+John+6:1-15",
                "audioQS": "Ps.142,Jer.6,John.6",
                "note": null
            }
        ]
    },
    "2026/02/27": {
        "datePretty": "Friday, February 27, 2026",
        "calendar": "Week of 1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Genesis 42:29\u2013end",
                        "readQS": "Genesis+42:29-",
                        "audioQS": "Gen.42"
                    },
                    {
                        "pretty": "Galatians 5:16\u2013end",
                        "readQS": "Galatians+5:16-",
                        "audioQS": "Gal.5"
                    }
                ],
                "readQS": "Psalm+22%3B+Genesis+42:29-%3B+Galatians+5:16-",
                "audioQS": "Ps.22,Gen.42,Gal.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 55",
                        "readQS": "Psalm+55",
                        "audioQS": "Ps.55"
                    },
                    {
                        "pretty": "Jeremiah 6:22\u2013end",
                        "readQS": "Jeremiah+6:22-",
                        "audioQS": "Jer.6"
                    },
                    {
                        "pretty": "John 6:16\u201327",
                        "readQS": "John+6:16-27",
                        "audioQS": "John.6"
                    }
                ],
                "readQS": "Psalm+55%3B+Jeremiah+6:22-%3B+John+6:16-27",
                "audioQS": "Ps.55,Jer.6,John.6",
                "note": null
            }
        ]
    },
    "2026/02/28": {
        "datePretty": "Saturday, February 28, 2026",
        "calendar": "Week of 1st Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 63",
                        "readQS": "Psalm+63",
                        "audioQS": "Ps.63"
                    },
                    {
                        "pretty": "Genesis 43:1\u201315",
                        "readQS": "Genesis+43:1-15",
                        "audioQS": "Gen.43"
                    },
                    {
                        "pretty": "Galatians 6",
                        "readQS": "Galatians+6",
                        "audioQS": "Gal.6"
                    }
                ],
                "readQS": "Psalm+63%3B+Genesis+43:1-15%3B+Galatians+6",
                "audioQS": "Ps.63,Gen.43,Gal.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 4",
                        "readQS": "Psalm+4",
                        "audioQS": "Ps.4"
                    },
                    {
                        "pretty": "Jeremiah 7:1\u201320",
                        "readQS": "Jeremiah+7:1-20",
                        "audioQS": "Jer.7"
                    },
                    {
                        "pretty": "John 6:27\u201340",
                        "readQS": "John+6:27-40",
                        "audioQS": "John.6"
                    }
                ],
                "readQS": "Psalm+4%3B+Jeremiah+7:1-20%3B+John+6:27-40",
                "audioQS": "Ps.4,Jer.7,John.6",
                "note": null
            }
        ]
    },
    "2026/03/01": {
        "datePretty": "Sunday, March 1, 2026",
        "calendar": "2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 121",
                        "readQS": "Psalm+121",
                        "audioQS": "Ps.121"
                    },
                    {
                        "pretty": "Genesis 12:1\u20134a",
                        "readQS": "Genesis+12:1-4a",
                        "audioQS": "Gen.12"
                    },
                    {
                        "pretty": "Romans 4:1\u20135,13\u201317",
                        "readQS": "Romans+4:1-5,13-17",
                        "audioQS": "Rom.4"
                    },
                    {
                        "pretty": "John 3:1\u201317",
                        "readQS": "John+3:1-17",
                        "audioQS": "John.3"
                    }
                ],
                "readQS": "Psalm+121%3B+Genesis+12:1-4a%3B+Romans+4:1-5,13-17%3B+John+3:1-17",
                "audioQS": "Ps.121,Gen.12,Rom.4,John.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 74",
                        "readQS": "Psalm+74",
                        "audioQS": "Ps.74"
                    },
                    {
                        "pretty": "Jeremiah 22:1\u20139",
                        "readQS": "Jeremiah+22:1-9",
                        "audioQS": "Jer.22"
                    },
                    {
                        "pretty": "Matthew 8:1\u201313",
                        "readQS": "Matthew+8:1-13",
                        "audioQS": "Matt.8"
                    }
                ],
                "readQS": "Psalm+74%3B+Jeremiah+22:1-9%3B+Matthew+8:1-13",
                "audioQS": "Ps.74,Jer.22,Matt.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Numbers 21:4\u20139",
                        "readQS": "Numbers+21:4-9",
                        "audioQS": "Num.21"
                    },
                    {
                        "pretty": "Luke 14:27\u201333",
                        "readQS": "Luke+14:27-33",
                        "audioQS": "Luke.14"
                    }
                ],
                "readQS": "Psalm+135%3B+Numbers+21:4-9%3B+Luke+14:27-33",
                "audioQS": "Ps.135,Num.21,Luke.14",
                "note": null
            }
        ]
    },
    "2026/03/02": {
        "datePretty": "Monday, March 2, 2026",
        "calendar": "Week of 2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 32",
                        "readQS": "Psalm+32",
                        "audioQS": "Ps.32"
                    },
                    {
                        "pretty": "Genesis 43:16\u2013end",
                        "readQS": "Genesis+43:16-",
                        "audioQS": "Gen.43"
                    },
                    {
                        "pretty": "Hebrews 1",
                        "readQS": "Hebrews+1",
                        "audioQS": "Heb.1"
                    }
                ],
                "readQS": "Psalm+32%3B+Genesis+43:16-%3B+Hebrews+1",
                "audioQS": "Ps.32,Gen.43,Heb.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 74",
                        "readQS": "Psalm+74",
                        "audioQS": "Ps.74"
                    },
                    {
                        "pretty": "Jeremiah 7:21\u2013end",
                        "readQS": "Jeremiah+7:21-",
                        "audioQS": "Jer.7"
                    },
                    {
                        "pretty": "John 6:41\u201351",
                        "readQS": "John+6:41-51",
                        "audioQS": "John.6"
                    }
                ],
                "readQS": "Psalm+74%3B+Jeremiah+7:21-%3B+John+6:41-51",
                "audioQS": "Ps.74,Jer.7,John.6",
                "note": null
            }
        ]
    },
    "2026/03/03": {
        "datePretty": "Tuesday, March 3, 2026",
        "calendar": "Week of 2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Genesis 44:1\u201317",
                        "readQS": "Genesis+44:1-17",
                        "audioQS": "Gen.44"
                    },
                    {
                        "pretty": "Hebrews 2:1\u20139",
                        "readQS": "Hebrews+2:1-9",
                        "audioQS": "Heb.2"
                    }
                ],
                "readQS": "Psalm+50%3B+Genesis+44:1-17%3B+Hebrews+2:1-9",
                "audioQS": "Ps.50,Gen.44,Heb.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 52",
                        "readQS": "Psalm+52",
                        "audioQS": "Ps.52"
                    },
                    {
                        "pretty": "Jeremiah 8:1\u201315",
                        "readQS": "Jeremiah+8:1-15",
                        "audioQS": "Jer.8"
                    },
                    {
                        "pretty": "John 6:52\u201359",
                        "readQS": "John+6:52-59",
                        "audioQS": "John.6"
                    }
                ],
                "readQS": "Psalm+52%3B+Jeremiah+8:1-15%3B+John+6:52-59",
                "audioQS": "Ps.52,Jer.8,John.6",
                "note": null
            }
        ]
    },
    "2026/03/04": {
        "datePretty": "Wednesday, March 4, 2026",
        "calendar": "Week of 2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 35",
                        "readQS": "Psalm+35",
                        "audioQS": "Ps.35"
                    },
                    {
                        "pretty": "Genesis 44:18\u2013end",
                        "readQS": "Genesis+44:18-",
                        "audioQS": "Gen.44"
                    },
                    {
                        "pretty": "Hebrews 2:10\u2013end",
                        "readQS": "Hebrews+2:10-",
                        "audioQS": "Heb.2"
                    }
                ],
                "readQS": "Psalm+35%3B+Genesis+44:18-%3B+Hebrews+2:10-",
                "audioQS": "Ps.35,Gen.44,Heb.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 3",
                        "readQS": "Psalm+3",
                        "audioQS": "Ps.3"
                    },
                    {
                        "pretty": "Jeremiah 8:18\u20139:11",
                        "readQS": "Jeremiah+8:18-9:11",
                        "audioQS": "Jer.8"
                    },
                    {
                        "pretty": "John 6:60\u2013end",
                        "readQS": "John+6:60-",
                        "audioQS": "John.6"
                    }
                ],
                "readQS": "Psalm+3%3B+Jeremiah+8:18-9:11%3B+John+6:60-",
                "audioQS": "Ps.3,Jer.8,John.6",
                "note": null
            }
        ]
    },
    "2026/03/05": {
        "datePretty": "Thursday, March 5, 2026",
        "calendar": "Week of 2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Genesis 45:1\u201315",
                        "readQS": "Genesis+45:1-15",
                        "audioQS": "Gen.45"
                    },
                    {
                        "pretty": "Hebrews 3:1\u20136",
                        "readQS": "Hebrews+3:1-6",
                        "audioQS": "Heb.3"
                    }
                ],
                "readQS": "Psalm+34%3B+Genesis+45:1-15%3B+Hebrews+3:1-6",
                "audioQS": "Ps.34,Gen.45,Heb.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Jeremiah 9:12\u201324",
                        "readQS": "Jeremiah+9:12-24",
                        "audioQS": "Jer.9"
                    },
                    {
                        "pretty": "John 7:1\u201313",
                        "readQS": "John+7:1-13",
                        "audioQS": "John.7"
                    }
                ],
                "readQS": "Psalm+71%3B+Jeremiah+9:12-24%3B+John+7:1-13",
                "audioQS": "Ps.71,Jer.9,John.7",
                "note": null
            }
        ]
    },
    "2026/03/06": {
        "datePretty": "Friday, March 6, 2026",
        "calendar": "Week of 2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 41",
                        "readQS": "Psalm+41",
                        "audioQS": "Ps.41"
                    },
                    {
                        "pretty": "Genesis 45:16\u2013end",
                        "readQS": "Genesis+45:16-",
                        "audioQS": "Gen.45"
                    },
                    {
                        "pretty": "Hebrews 3:7\u2013end",
                        "readQS": "Hebrews+3:7-",
                        "audioQS": "Heb.3"
                    }
                ],
                "readQS": "Psalm+41%3B+Genesis+45:16-%3B+Hebrews+3:7-",
                "audioQS": "Ps.41,Gen.45,Heb.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 6",
                        "readQS": "Psalm+6",
                        "audioQS": "Ps.6"
                    },
                    {
                        "pretty": "Jeremiah 10:1\u201316",
                        "readQS": "Jeremiah+10:1-16",
                        "audioQS": "Jer.10"
                    },
                    {
                        "pretty": "John 7:14\u201324",
                        "readQS": "John+7:14-24",
                        "audioQS": "John.7"
                    }
                ],
                "readQS": "Psalm+6%3B+Jeremiah+10:1-16%3B+John+7:14-24",
                "audioQS": "Ps.6,Jer.10,John.7",
                "note": null
            }
        ]
    },
    "2026/03/07": {
        "datePretty": "Saturday, March 7, 2026",
        "calendar": "Week of 2nd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 25",
                        "readQS": "Psalm+25",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Genesis 46:1\u20137,46:28\u2013end",
                        "readQS": "Genesis+46:1-7,46:28-",
                        "audioQS": "Gen.46"
                    },
                    {
                        "pretty": "Hebrews 4:1\u201313",
                        "readQS": "Hebrews+4:1-13",
                        "audioQS": "Heb.4"
                    }
                ],
                "readQS": "Psalm+25%3B+Genesis+46:1-7,46:28-%3B+Hebrews+4:1-13",
                "audioQS": "Ps.25,Gen.46,Heb.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Jeremiah 10:17\u201324",
                        "readQS": "Jeremiah+10:17-24",
                        "audioQS": "Jer.10"
                    },
                    {
                        "pretty": "John 7:25\u201336",
                        "readQS": "John+7:25-36",
                        "audioQS": "John.7"
                    }
                ],
                "readQS": "Psalm+23%3B+Jeremiah+10:17-24%3B+John+7:25-36",
                "audioQS": "Ps.23,Jer.10,John.7",
                "note": null
            }
        ]
    },
    "2026/03/08": {
        "datePretty": "Sunday, March 8, 2026",
        "calendar": "3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 95",
                        "readQS": "Psalm+95",
                        "audioQS": "Ps.95"
                    },
                    {
                        "pretty": "Exodus 17:1\u20137",
                        "readQS": "Exodus+17:1-7",
                        "audioQS": "Exod.17"
                    },
                    {
                        "pretty": "Romans 5:1\u201311",
                        "readQS": "Romans+5:1-11",
                        "audioQS": "Rom.5"
                    },
                    {
                        "pretty": "John 4:5\u201342",
                        "readQS": "John+4:5-42",
                        "audioQS": "John.4"
                    }
                ],
                "readQS": "Psalm+95%3B+Exodus+17:1-7%3B+Romans+5:1-11%3B+John+4:5-42",
                "audioQS": "Ps.95,Exod.17,Rom.5,John.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Amos 7:10\u201317",
                        "readQS": "Amos+7:10-17",
                        "audioQS": "Amos.7"
                    },
                    {
                        "pretty": "2 Corinthians 1:1\u201311",
                        "readQS": "2+Corinthians+1:1-11",
                        "audioQS": "2Cor.1"
                    }
                ],
                "readQS": "Psalm+46%3B+Amos+7:10-17%3B+2+Corinthians+1:1-11",
                "audioQS": "Ps.46,Amos.7,2Cor.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Joshua 1:1\u20139",
                        "readQS": "Joshua+1:1-9",
                        "audioQS": "Josh.1"
                    },
                    {
                        "pretty": "Ephesians 6:10\u201320",
                        "readQS": "Ephesians+6:10-20",
                        "audioQS": "Eph.6"
                    }
                ],
                "readQS": "Psalm+40%3B+Joshua+1:1-9%3B+Ephesians+6:10-20",
                "audioQS": "Ps.40,Josh.1,Eph.6",
                "note": null
            }
        ]
    },
    "2026/03/09": {
        "datePretty": "Monday, March 9, 2026",
        "calendar": "Week of 3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "Genesis 47:1\u201327",
                        "readQS": "Genesis+47:1-27",
                        "audioQS": "Gen.47"
                    },
                    {
                        "pretty": "Hebrews 4:14\u20135:10",
                        "readQS": "Hebrews+4:14-5:10",
                        "audioQS": "Heb.4"
                    }
                ],
                "readQS": "Psalm+5%3B+Genesis+47:1-27%3B+Hebrews+4:14-5:10",
                "audioQS": "Ps.5,Gen.47,Heb.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 17",
                        "readQS": "Psalm+17",
                        "audioQS": "Ps.17"
                    },
                    {
                        "pretty": "Jeremiah 11:1\u201317",
                        "readQS": "Jeremiah+11:1-17",
                        "audioQS": "Jer.11"
                    },
                    {
                        "pretty": "John 7:37\u201352",
                        "readQS": "John+7:37-52",
                        "audioQS": "John.7"
                    }
                ],
                "readQS": "Psalm+17%3B+Jeremiah+11:1-17%3B+John+7:37-52",
                "audioQS": "Ps.17,Jer.11,John.7",
                "note": null
            }
        ]
    },
    "2026/03/10": {
        "datePretty": "Tuesday, March 10, 2026",
        "calendar": "Week of 3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Genesis 47:28\u2013end",
                        "readQS": "Genesis+47:28-",
                        "audioQS": "Gen.47"
                    },
                    {
                        "pretty": "Genesis 48",
                        "readQS": "Genesis+48",
                        "audioQS": "Gen.48"
                    },
                    {
                        "pretty": "Hebrews 5:11\u20136:12",
                        "readQS": "Hebrews+5:11-6:12",
                        "audioQS": "Heb.5"
                    }
                ],
                "readQS": "Psalm+9%3B+Genesis+47:28-%3B+Genesis+48%3B+Hebrews+5:11-6:12",
                "audioQS": "Ps.9,Gen.47,Gen.48,Heb.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 64",
                        "readQS": "Psalm+64",
                        "audioQS": "Ps.64"
                    },
                    {
                        "pretty": "Jeremiah 11:18\u201312:6",
                        "readQS": "Jeremiah+11:18-12:6",
                        "audioQS": "Jer.11"
                    },
                    {
                        "pretty": "John 7:53\u20138:11",
                        "readQS": "John+7:53-8:11",
                        "audioQS": "John.7"
                    }
                ],
                "readQS": "Psalm+64%3B+Jeremiah+11:18-12:6%3B+John+7:53-8:11",
                "audioQS": "Ps.64,Jer.11,John.7",
                "note": null
            }
        ]
    },
    "2026/03/11": {
        "datePretty": "Wednesday, March 11, 2026",
        "calendar": "Week of 3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 38",
                        "readQS": "Psalm+38",
                        "audioQS": "Ps.38"
                    },
                    {
                        "pretty": "Genesis 49:1\u201332",
                        "readQS": "Genesis+49:1-32",
                        "audioQS": "Gen.49"
                    },
                    {
                        "pretty": "Hebrews 6:13\u2013end",
                        "readQS": "Hebrews+6:13-",
                        "audioQS": "Heb.6"
                    }
                ],
                "readQS": "Psalm+38%3B+Genesis+49:1-32%3B+Hebrews+6:13-",
                "audioQS": "Ps.38,Gen.49,Heb.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 39",
                        "readQS": "Psalm+39",
                        "audioQS": "Ps.39"
                    },
                    {
                        "pretty": "Jeremiah 13:1\u201311",
                        "readQS": "Jeremiah+13:1-11",
                        "audioQS": "Jer.13"
                    },
                    {
                        "pretty": "John 8:12\u201330",
                        "readQS": "John+8:12-30",
                        "audioQS": "John.8"
                    }
                ],
                "readQS": "Psalm+39%3B+Jeremiah+13:1-11%3B+John+8:12-30",
                "audioQS": "Ps.39,Jer.13,John.8",
                "note": null
            }
        ]
    },
    "2026/03/12": {
        "datePretty": "Thursday, March 12, 2026",
        "calendar": "Week of 3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 56",
                        "readQS": "Psalm+56",
                        "audioQS": "Ps.56"
                    },
                    {
                        "pretty": "Genesis 49:33\u2013end",
                        "readQS": "Genesis+49:33-",
                        "audioQS": "Gen.49"
                    },
                    {
                        "pretty": "Genesis 50",
                        "readQS": "Genesis+50",
                        "audioQS": "Gen.50"
                    },
                    {
                        "pretty": "Hebrews 7:1\u201310",
                        "readQS": "Hebrews+7:1-10",
                        "audioQS": "Heb.7"
                    }
                ],
                "readQS": "Psalm+56%3B+Genesis+49:33-%3B+Genesis+50%3B+Hebrews+7:1-10",
                "audioQS": "Ps.56,Gen.49,Gen.50,Heb.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 59",
                        "readQS": "Psalm+59",
                        "audioQS": "Ps.59"
                    },
                    {
                        "pretty": "Jeremiah 14",
                        "readQS": "Jeremiah+14",
                        "audioQS": "Jer.14"
                    },
                    {
                        "pretty": "John 8:31\u201347",
                        "readQS": "John+8:31-47",
                        "audioQS": "John.8"
                    }
                ],
                "readQS": "Psalm+59%3B+Jeremiah+14%3B+John+8:31-47",
                "audioQS": "Ps.59,Jer.14,John.8",
                "note": null
            }
        ]
    },
    "2026/03/13": {
        "datePretty": "Friday, March 13, 2026",
        "calendar": "Week of 3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Exodus 1:1\u201314",
                        "readQS": "Exodus+1:1-14",
                        "audioQS": "Exod.1"
                    },
                    {
                        "pretty": "Hebrews 7:11\u2013end",
                        "readQS": "Hebrews+7:11-",
                        "audioQS": "Heb.7"
                    }
                ],
                "readQS": "Psalm+22%3B+Exodus+1:1-14%3B+Hebrews+7:11-",
                "audioQS": "Ps.22,Exod.1,Heb.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 69",
                        "readQS": "Psalm+69",
                        "audioQS": "Ps.69"
                    },
                    {
                        "pretty": "Jeremiah 15:10\u2013end",
                        "readQS": "Jeremiah+15:10-",
                        "audioQS": "Jer.15"
                    },
                    {
                        "pretty": "John 8:48\u2013end",
                        "readQS": "John+8:48-",
                        "audioQS": "John.8"
                    }
                ],
                "readQS": "Psalm+69%3B+Jeremiah+15:10-%3B+John+8:48-",
                "audioQS": "Ps.69,Jer.15,John.8",
                "note": null
            }
        ]
    },
    "2026/03/14": {
        "datePretty": "Saturday, March 14, 2026",
        "calendar": "Week of 3rd Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Exodus 1:22\u20132:10",
                        "readQS": "Exodus+1:22-2:10",
                        "audioQS": "Exod.1"
                    },
                    {
                        "pretty": "Hebrews 8",
                        "readQS": "Hebrews+8",
                        "audioQS": "Heb.8"
                    }
                ],
                "readQS": "Psalm+31%3B+Exodus+1:22-2:10%3B+Hebrews+8",
                "audioQS": "Ps.31,Exod.1,Heb.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Jeremiah 16:10\u201317:4",
                        "readQS": "Jeremiah+16:10-17:4",
                        "audioQS": "Jer.16"
                    },
                    {
                        "pretty": "John 9:1\u201317",
                        "readQS": "John+9:1-17",
                        "audioQS": "John.9"
                    }
                ],
                "readQS": "Psalm+116%3B+Jeremiah+16:10-17:4%3B+John+9:1-17",
                "audioQS": "Ps.116,Jer.16,John.9",
                "note": null
            }
        ]
    },
    "2026/03/15": {
        "datePretty": "Sunday, March 15, 2026",
        "calendar": "4th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "1 Samuel 16:1\u201313",
                        "readQS": "1+Samuel+16:1-13",
                        "audioQS": "1Sam.16"
                    },
                    {
                        "pretty": "Ephesians 5:8\u201314",
                        "readQS": "Ephesians+5:8-14",
                        "audioQS": "Eph.5"
                    },
                    {
                        "pretty": "John 9:1\u201341",
                        "readQS": "John+9:1-41",
                        "audioQS": "John.9"
                    }
                ],
                "readQS": "Psalm+23%3B+1+Samuel+16:1-13%3B+Ephesians+5:8-14%3B+John+9:1-41",
                "audioQS": "Ps.23,1Sam.16,Eph.5,John.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Isaiah 43:1\u20137",
                        "readQS": "Isaiah+43:1-7",
                        "audioQS": "Isa.43"
                    },
                    {
                        "pretty": "Ephesians 2:8\u201314",
                        "readQS": "Ephesians+2:8-14",
                        "audioQS": "Eph.2"
                    }
                ],
                "readQS": "Psalm+19%3B+Isaiah+43:1-7%3B+Ephesians+2:8-14",
                "audioQS": "Ps.19,Isa.43,Eph.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 31:1\u201316",
                        "readQS": "Psalm+31:1-16",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Micah 7",
                        "readQS": "Micah+7",
                        "audioQS": "Mic.7"
                    },
                    {
                        "pretty": "James 5",
                        "readQS": "James+5",
                        "audioQS": "Jas.5"
                    }
                ],
                "readQS": "Psalm+31:1-16%3B+Micah+7%3B+James+5",
                "audioQS": "Ps.31,Mic.7,Jas.5",
                "note": null
            }
        ]
    },
    "2026/03/16": {
        "datePretty": "Monday, March 16, 2026",
        "calendar": "Week of 4th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Exodus 2:11\u201322",
                        "readQS": "Exodus+2:11-22",
                        "audioQS": "Exod.2"
                    },
                    {
                        "pretty": "Hebrews 9:1\u201314",
                        "readQS": "Hebrews+9:1-14",
                        "audioQS": "Heb.9"
                    }
                ],
                "readQS": "Psalm+77%3B+Exodus+2:11-22%3B+Hebrews+9:1-14",
                "audioQS": "Ps.77,Exod.2,Heb.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 25",
                        "readQS": "Psalm+25",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Jeremiah 17:5\u201318",
                        "readQS": "Jeremiah+17:5-18",
                        "audioQS": "Jer.17"
                    },
                    {
                        "pretty": "John 9:18\u2013end",
                        "readQS": "John+9:18-",
                        "audioQS": "John.9"
                    }
                ],
                "readQS": "Psalm+25%3B+Jeremiah+17:5-18%3B+John+9:18-",
                "audioQS": "Ps.25,Jer.17,John.9",
                "note": null
            }
        ]
    },
    "2026/03/17": {
        "datePretty": "Tuesday, March 17, 2026",
        "calendar": "Week of 4th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 79",
                        "readQS": "Psalm+79",
                        "audioQS": "Ps.79"
                    },
                    {
                        "pretty": "Exodus 2:23\u20133:20",
                        "readQS": "Exodus+2:23-3:20",
                        "audioQS": "Exod.2"
                    },
                    {
                        "pretty": "Hebrews 9:15\u2013end",
                        "readQS": "Hebrews+9:15-",
                        "audioQS": "Heb.9"
                    }
                ],
                "readQS": "Psalm+79%3B+Exodus+2:23-3:20%3B+Hebrews+9:15-",
                "audioQS": "Ps.79,Exod.2,Heb.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Jeremiah 18:1\u201312",
                        "readQS": "Jeremiah+18:1-12",
                        "audioQS": "Jer.18"
                    },
                    {
                        "pretty": "John 10:1\u201310",
                        "readQS": "John+10:1-10",
                        "audioQS": "John.10"
                    }
                ],
                "readQS": "Psalm+80%3B+Jeremiah+18:1-12%3B+John+10:1-10",
                "audioQS": "Ps.80,Jer.18,John.10",
                "note": null
            }
        ]
    },
    "2026/03/18": {
        "datePretty": "Wednesday, March 18, 2026",
        "calendar": "Week of 4th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 90",
                        "readQS": "Psalm+90",
                        "audioQS": "Ps.90"
                    },
                    {
                        "pretty": "Exodus 4:1\u201323",
                        "readQS": "Exodus+4:1-23",
                        "audioQS": "Exod.4"
                    },
                    {
                        "pretty": "Hebrews 10:1\u201318",
                        "readQS": "Hebrews+10:1-18",
                        "audioQS": "Heb.10"
                    }
                ],
                "readQS": "Psalm+90%3B+Exodus+4:1-23%3B+Hebrews+10:1-18",
                "audioQS": "Ps.90,Exod.4,Heb.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Joseph)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Hosea 11:1\u20139",
                        "readQS": "Hosea+11:1-9",
                        "audioQS": "Hos.11"
                    },
                    {
                        "pretty": "Luke 2:41\u201352",
                        "readQS": "Luke+2:41-52",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+132%3B+Hosea+11:1-9%3B+Luke+2:41-52",
                "audioQS": "Ps.132,Hos.11,Luke.2",
                "note": null
            }
        ]
    },
    "2026/03/19": {
        "datePretty": "Thursday, March 19, 2026",
        "calendar": "St Joseph of Nazereth",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 25,147:1\u201312",
                        "readQS": "Psalm+25,147:1-12",
                        "audioQS": "Ps.25,147"
                    },
                    {
                        "pretty": "Isaiah 11:1\u201310",
                        "readQS": "Isaiah+11:1-10",
                        "audioQS": "Isa.11"
                    },
                    {
                        "pretty": "Matthew 13:54\u201358",
                        "readQS": "Matthew+13:54-58",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+25,147:1-12%3B+Isaiah+11:1-10%3B+Matthew+13:54-58",
                "audioQS": "Ps.25,147,Isa.11,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 1,112",
                        "readQS": "Psalm+1,112",
                        "audioQS": "Ps.1,112"
                    },
                    {
                        "pretty": "Genesis 50:22\u201326",
                        "readQS": "Genesis+50:22-26",
                        "audioQS": "Gen.50"
                    },
                    {
                        "pretty": "Matthew 2:13\u201323",
                        "readQS": "Matthew+2:13-23",
                        "audioQS": "Matt.2"
                    }
                ],
                "readQS": "Psalm+1,112%3B+Genesis+50:22-26%3B+Matthew+2:13-23",
                "audioQS": "Ps.1,112,Gen.50,Matt.2",
                "note": null
            }
        ]
    },
    "2026/03/20": {
        "datePretty": "Friday, March 20, 2026",
        "calendar": "Week of 4th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 102",
                        "readQS": "Psalm+102",
                        "audioQS": "Ps.102"
                    },
                    {
                        "pretty": "Exodus 6:2\u201313",
                        "readQS": "Exodus+6:2-13",
                        "audioQS": "Exod.6"
                    },
                    {
                        "pretty": "Hebrews 10:26\u2013end",
                        "readQS": "Hebrews+10:26-",
                        "audioQS": "Heb.10"
                    }
                ],
                "readQS": "Psalm+102%3B+Exodus+6:2-13%3B+Hebrews+10:26-",
                "audioQS": "Ps.102,Exod.6,Heb.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 16",
                        "readQS": "Psalm+16",
                        "audioQS": "Ps.16"
                    },
                    {
                        "pretty": "Jeremiah 19:14\u201320:6",
                        "readQS": "Jeremiah+19:14-20:6",
                        "audioQS": "Jer.19"
                    },
                    {
                        "pretty": "John 11:1\u201316",
                        "readQS": "John+11:1-16",
                        "audioQS": "John.11"
                    }
                ],
                "readQS": "Psalm+16%3B+Jeremiah+19:14-20:6%3B+John+11:1-16",
                "audioQS": "Ps.16,Jer.19,John.11",
                "note": null
            }
        ]
    },
    "2026/03/21": {
        "datePretty": "Saturday, March 21, 2026",
        "calendar": "Week of 4th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 32",
                        "readQS": "Psalm+32",
                        "audioQS": "Ps.32"
                    },
                    {
                        "pretty": "Exodus 7:8\u2013end",
                        "readQS": "Exodus+7:8-",
                        "audioQS": "Exod.7"
                    },
                    {
                        "pretty": "Hebrews 11:1\u201316",
                        "readQS": "Hebrews+11:1-16",
                        "audioQS": "Heb.11"
                    }
                ],
                "readQS": "Psalm+32%3B+Exodus+7:8-%3B+Hebrews+11:1-16",
                "audioQS": "Ps.32,Exod.7,Heb.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 140",
                        "readQS": "Psalm+140",
                        "audioQS": "Ps.140"
                    },
                    {
                        "pretty": "Jeremiah 20:7\u2013end",
                        "readQS": "Jeremiah+20:7-",
                        "audioQS": "Jer.20"
                    },
                    {
                        "pretty": "John 11:17\u201327",
                        "readQS": "John+11:17-27",
                        "audioQS": "John.11"
                    }
                ],
                "readQS": "Psalm+140%3B+Jeremiah+20:7-%3B+John+11:17-27",
                "audioQS": "Ps.140,Jer.20,John.11",
                "note": null
            }
        ]
    },
    "2026/03/22": {
        "datePretty": "Sunday, March 22, 2026",
        "calendar": "5th Sunday of Lent - Passion Sunday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 130",
                        "readQS": "Psalm+130",
                        "audioQS": "Ps.130"
                    },
                    {
                        "pretty": "Ezekiel 37:1\u201314",
                        "readQS": "Ezekiel+37:1-14",
                        "audioQS": "Ezek.37"
                    },
                    {
                        "pretty": "Romans 8:6\u201311",
                        "readQS": "Romans+8:6-11",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "John 11:1\u201345",
                        "readQS": "John+11:1-45",
                        "audioQS": "John.11"
                    }
                ],
                "readQS": "Psalm+130%3B+Ezekiel+37:1-14%3B+Romans+8:6-11%3B+John+11:1-45",
                "audioQS": "Ps.130,Ezek.37,Rom.8,John.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 86",
                        "readQS": "Psalm+86",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Jeremiah 31:27\u201337",
                        "readQS": "Jeremiah+31:27-37",
                        "audioQS": "Jer.31"
                    },
                    {
                        "pretty": "John 12:20\u201333",
                        "readQS": "John+12:20-33",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+86%3B+Jeremiah+31:27-37%3B+John+12:20-33",
                "audioQS": "Ps.86,Jer.31,John.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Lamentations 3:19\u201333",
                        "readQS": "Lamentations+3:19-33",
                        "audioQS": "Lam.3"
                    },
                    {
                        "pretty": "Matthew 20:17\u201334",
                        "readQS": "Matthew+20:17-34",
                        "audioQS": "Matt.20"
                    }
                ],
                "readQS": "Psalm+30%3B+Lamentations+3:19-33%3B+Matthew+20:17-34",
                "audioQS": "Ps.30,Lam.3,Matt.20",
                "note": null
            }
        ]
    },
    "2026/03/23": {
        "datePretty": "Monday, March 23, 2026",
        "calendar": "Week of 5th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Exodus 8:1\u201319",
                        "readQS": "Exodus+8:1-19",
                        "audioQS": "Exod.8"
                    },
                    {
                        "pretty": "Hebrews 11:17\u201331",
                        "readQS": "Hebrews+11:17-31",
                        "audioQS": "Heb.11"
                    }
                ],
                "readQS": "Psalm+73%3B+Exodus+8:1-19%3B+Hebrews+11:17-31",
                "audioQS": "Ps.73,Exod.8,Heb.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 26",
                        "readQS": "Psalm+26",
                        "audioQS": "Ps.26"
                    },
                    {
                        "pretty": "Jeremiah 21:1\u201310",
                        "readQS": "Jeremiah+21:1-10",
                        "audioQS": "Jer.21"
                    },
                    {
                        "pretty": "John 11:28\u201344",
                        "readQS": "John+11:28-44",
                        "audioQS": "John.11"
                    }
                ],
                "readQS": "Psalm+26%3B+Jeremiah+21:1-10%3B+John+11:28-44",
                "audioQS": "Ps.26,Jer.21,John.11",
                "note": null
            }
        ]
    },
    "2026/03/24": {
        "datePretty": "Tuesday, March 24, 2026",
        "calendar": "Week of 5th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 35",
                        "readQS": "Psalm+35",
                        "audioQS": "Ps.35"
                    },
                    {
                        "pretty": "Exodus 8:20\u2013end",
                        "readQS": "Exodus+8:20-",
                        "audioQS": "Exod.8"
                    },
                    {
                        "pretty": "Hebrews 11:32\u201312:2",
                        "readQS": "Hebrews+11:32-12:2",
                        "audioQS": "Heb.11"
                    }
                ],
                "readQS": "Psalm+35%3B+Exodus+8:20-%3B+Hebrews+11:32-12:2",
                "audioQS": "Ps.35,Exod.8,Heb.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Annunciation)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Genesis 3:8\u201315",
                        "readQS": "Genesis+3:8-15",
                        "audioQS": "Gen.3"
                    },
                    {
                        "pretty": "Galatians 4:1\u20135",
                        "readQS": "Galatians+4:1-5",
                        "audioQS": "Gal.4"
                    }
                ],
                "readQS": "Psalm+85%3B+Genesis+3:8-15%3B+Galatians+4:1-5",
                "audioQS": "Ps.85,Gen.3,Gal.4",
                "note": null
            }
        ]
    },
    "2026/03/25": {
        "datePretty": "Wednesday, March 25, 2026",
        "calendar": "The Annunciation",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 40:5\u201311",
                        "readQS": "Psalm+40:5-11",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 7:10\u201314",
                        "readQS": "Isaiah+7:10-14",
                        "audioQS": "Isa.7"
                    },
                    {
                        "pretty": "Hebrews 10:4\u201310",
                        "readQS": "Hebrews+10:4-10",
                        "audioQS": "Heb.10"
                    },
                    {
                        "pretty": "Luke 1:26\u201338",
                        "readQS": "Luke+1:26-38",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+40:5-11%3B+Isaiah+7:10-14%3B+Hebrews+10:4-10%3B+Luke+1:26-38",
                "audioQS": "Ps.40,Isa.7,Heb.10,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 111,113",
                        "readQS": "Psalm+111,113",
                        "audioQS": "Ps.111,113"
                    },
                    {
                        "pretty": "1 Samuel 2:1\u201310",
                        "readQS": "1+Samuel+2:1-10",
                        "audioQS": "1Sam.2"
                    },
                    {
                        "pretty": "Romans 5:12\u201321",
                        "readQS": "Romans+5:12-21",
                        "audioQS": "Rom.5"
                    }
                ],
                "readQS": "Psalm+111,113%3B+1+Samuel+2:1-10%3B+Romans+5:12-21",
                "audioQS": "Ps.111,113,1Sam.2,Rom.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 131,146",
                        "readQS": "Psalm+131,146",
                        "audioQS": "Ps.131,146"
                    },
                    {
                        "pretty": "Isaiah 52:1\u201312",
                        "readQS": "Isaiah+52:1-12",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Hebrews 2:5\u201318",
                        "readQS": "Hebrews+2:5-18",
                        "audioQS": "Heb.2"
                    }
                ],
                "readQS": "Psalm+131,146%3B+Isaiah+52:1-12%3B+Hebrews+2:5-18",
                "audioQS": "Ps.131,146,Isa.52,Heb.2",
                "note": null
            }
        ]
    },
    "2026/03/26": {
        "datePretty": "Thursday, March 26, 2026",
        "calendar": "Week of 5th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Exodus 9:13\u2013end",
                        "readQS": "Exodus+9:13-",
                        "audioQS": "Exod.9"
                    },
                    {
                        "pretty": "Hebrews 12:14\u2013end",
                        "readQS": "Hebrews+12:14-",
                        "audioQS": "Heb.12"
                    }
                ],
                "readQS": "Psalm+40%3B+Exodus+9:13-%3B+Hebrews+12:14-",
                "audioQS": "Ps.40,Exod.9,Heb.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 43",
                        "readQS": "Psalm+43",
                        "audioQS": "Ps.43"
                    },
                    {
                        "pretty": "Jeremiah 23:9\u201332",
                        "readQS": "Jeremiah+23:9-32",
                        "audioQS": "Jer.23"
                    },
                    {
                        "pretty": "John 12:12\u201319",
                        "readQS": "John+12:12-19",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+43%3B+Jeremiah+23:9-32%3B+John+12:12-19",
                "audioQS": "Ps.43,Jer.23,John.12",
                "note": null
            }
        ]
    },
    "2026/03/27": {
        "datePretty": "Friday, March 27, 2026",
        "calendar": "Week of 5th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Exodus 10",
                        "readQS": "Exodus+10",
                        "audioQS": "Exod.10"
                    },
                    {
                        "pretty": "Hebrews 13:1\u201316",
                        "readQS": "Hebrews+13:1-16",
                        "audioQS": "Heb.13"
                    }
                ],
                "readQS": "Psalm+22%3B+Exodus+10%3B+Hebrews+13:1-16",
                "audioQS": "Ps.22,Exod.10,Heb.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Jeremiah 24",
                        "readQS": "Jeremiah+24",
                        "audioQS": "Jer.24"
                    },
                    {
                        "pretty": "John 12:20\u201336a",
                        "readQS": "John+12:20-36a",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+31%3B+Jeremiah+24%3B+John+12:20-36a",
                "audioQS": "Ps.31,Jer.24,John.12",
                "note": null
            }
        ]
    },
    "2026/03/28": {
        "datePretty": "Saturday, March 28, 2026",
        "calendar": "Week of 5th Sunday of Lent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Exodus 11",
                        "readQS": "Exodus+11",
                        "audioQS": "Exod.11"
                    },
                    {
                        "pretty": "Hebrews 13:17\u2013end",
                        "readQS": "Hebrews+13:17-",
                        "audioQS": "Heb.13"
                    }
                ],
                "readQS": "Psalm+23%3B+Exodus+11%3B+Hebrews+13:17-",
                "audioQS": "Ps.23,Exod.11,Heb.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 130",
                        "readQS": "Psalm+130",
                        "audioQS": "Ps.130"
                    },
                    {
                        "pretty": "Jeremiah 25:1\u201314",
                        "readQS": "Jeremiah+25:1-14",
                        "audioQS": "Jer.25"
                    },
                    {
                        "pretty": "John 12:36b\u2013end",
                        "readQS": "John+12:36b-",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+130%3B+Jeremiah+25:1-14%3B+John+12:36b-",
                "audioQS": "Ps.130,Jer.25,John.12",
                "note": null
            }
        ]
    },
    "2026/03/29": {
        "datePretty": "Sunday, March 29, 2026",
        "calendar": "6th Sunday of Lent - Palm Sunday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "Passion",
                "readingSetSubtitle": "RCL (Liturgy of the Passion)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 31:9\u201316",
                        "readQS": "Psalm+31:9-16",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Isaiah 50:4\u20139a",
                        "readQS": "Isaiah+50:4-9a",
                        "audioQS": "Isa.50"
                    },
                    {
                        "pretty": "Philippians 2:5\u201311",
                        "readQS": "Philippians+2:5-11",
                        "audioQS": "Phil.2"
                    },
                    {
                        "pretty": "Matthew 26:14\u201327:66",
                        "readQS": "Matthew+26:14-27:66",
                        "audioQS": "Matt.26"
                    }
                ],
                "readQS": "Psalm+31:9-16%3B+Isaiah+50:4-9a%3B+Philippians+2:5-11%3B+Matthew+26:14-27:66",
                "audioQS": "Ps.31,Isa.50,Phil.2,Matt.26",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "Palms",
                "readingSetSubtitle": "RCL (Liturgy of the Palms)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 118:1\u20132,19\u201329",
                        "readQS": "Psalm+118:1-2,19-29",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "",
                        "readQS": "",
                        "audioQS": ""
                    },
                    {
                        "pretty": "",
                        "readQS": "",
                        "audioQS": ""
                    },
                    {
                        "pretty": "Matthew 21:1\u201311",
                        "readQS": "Matthew+21:1-11",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+118:1-2,19-29%3B+%3B+%3B+Matthew+21:1-11",
                "audioQS": "Ps.118,,,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 61,62",
                        "readQS": "Psalm+61,62",
                        "audioQS": "Ps.61,62"
                    },
                    {
                        "pretty": "Zechariah 9:9\u201312",
                        "readQS": "Zechariah+9:9-12",
                        "audioQS": "Zech.9"
                    },
                    {
                        "pretty": "Luke 16:19\u201331",
                        "readQS": "Luke+16:19-31",
                        "audioQS": "Luke.16"
                    }
                ],
                "readQS": "Psalm+61,62%3B+Zechariah+9:9-12%3B+Luke+16:19-31",
                "audioQS": "Ps.61,62,Zech.9,Luke.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 5:1\u20137",
                        "readQS": "Isaiah+5:1-7",
                        "audioQS": "Isa.5"
                    },
                    {
                        "pretty": "Matthew 21:33\u201346",
                        "readQS": "Matthew+21:33-46",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+80%3B+Isaiah+5:1-7%3B+Matthew+21:33-46",
                "audioQS": "Ps.80,Isa.5,Matt.21",
                "note": null
            }
        ]
    },
    "2026/03/30": {
        "datePretty": "Monday, March 30, 2026",
        "calendar": "Monday in Holy Week",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 36:5\u201311",
                        "readQS": "Psalm+36:5-11",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "Isaiah 42:1\u20139",
                        "readQS": "Isaiah+42:1-9",
                        "audioQS": "Isa.42"
                    },
                    {
                        "pretty": "Hebrews 9:11\u201315",
                        "readQS": "Hebrews+9:11-15",
                        "audioQS": "Heb.9"
                    },
                    {
                        "pretty": "John 12:1\u201311",
                        "readQS": "John+12:1-11",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+36:5-11%3B+Isaiah+42:1-9%3B+Hebrews+9:11-15%3B+John+12:1-11",
                "audioQS": "Ps.36,Isa.42,Heb.9,John.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 41",
                        "readQS": "Psalm+41",
                        "audioQS": "Ps.41"
                    },
                    {
                        "pretty": "Lamentations 1:1\u201312a",
                        "readQS": "Lamentations+1:1-12a",
                        "audioQS": "Lam.1"
                    },
                    {
                        "pretty": "Luke 22:1\u201323",
                        "readQS": "Luke+22:1-23",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+41%3B+Lamentations+1:1-12a%3B+Luke+22:1-23",
                "audioQS": "Ps.41,Lam.1,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 25",
                        "readQS": "Psalm+25",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Lamentations 2:8\u201319",
                        "readQS": "Lamentations+2:8-19",
                        "audioQS": "Lam.2"
                    },
                    {
                        "pretty": "Colossians 1:18\u201323",
                        "readQS": "Colossians+1:18-23",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+25%3B+Lamentations+2:8-19%3B+Colossians+1:18-23",
                "audioQS": "Ps.25,Lam.2,Col.1",
                "note": null
            }
        ]
    },
    "2026/03/31": {
        "datePretty": "Tuesday, March 31, 2026",
        "calendar": "Tuesday in Holy Week",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 71:(1\u20138),9\u201314",
                        "readQS": "Psalm+71:%281-8%29,9-14",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Isaiah 49:1\u20137",
                        "readQS": "Isaiah+49:1-7",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Corinthians 1:18\u201331",
                        "readQS": "1+Corinthians+1:18-31",
                        "audioQS": "1Cor.1"
                    },
                    {
                        "pretty": "John 12:20\u201336",
                        "readQS": "John+12:20-36",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+71:%281-8%29,9-14%3B+Isaiah+49:1-7%3B+1+Corinthians+1:18-31%3B+John+12:20-36",
                "audioQS": "Ps.71,Isa.49,1Cor.1,John.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 27",
                        "readQS": "Psalm+27",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Lamentations 3:1\u201318",
                        "readQS": "Lamentations+3:1-18",
                        "audioQS": "Lam.3"
                    },
                    {
                        "pretty": "Luke 22:(24\u201338),39\u201353",
                        "readQS": "Luke+22:%2824-38%29,39-53",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+27%3B+Lamentations+3:1-18%3B+Luke+22:%2824-38%29,39-53",
                "audioQS": "Ps.27,Lam.3,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 55:13\u201324",
                        "readQS": "Psalm+55:13-24",
                        "audioQS": "Ps.55"
                    },
                    {
                        "pretty": "Lamentations 3:40\u201351",
                        "readQS": "Lamentations+3:40-51",
                        "audioQS": "Lam.3"
                    },
                    {
                        "pretty": "Galatians 6:11\u2013end",
                        "readQS": "Galatians+6:11-",
                        "audioQS": "Gal.6"
                    }
                ],
                "readQS": "Psalm+55:13-24%3B+Lamentations+3:40-51%3B+Galatians+6:11-",
                "audioQS": "Ps.55,Lam.3,Gal.6",
                "note": null
            }
        ]
    },
    "2026/04/01": {
        "datePretty": "Wednesday, April 1, 2026",
        "calendar": "Wednesday in Holy Week",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 70",
                        "readQS": "Psalm+70",
                        "audioQS": "Ps.70"
                    },
                    {
                        "pretty": "Isaiah 50:4\u20139a",
                        "readQS": "Isaiah+50:4-9a",
                        "audioQS": "Isa.50"
                    },
                    {
                        "pretty": "Hebrews 12:1\u20133",
                        "readQS": "Hebrews+12:1-3",
                        "audioQS": "Heb.12"
                    },
                    {
                        "pretty": "John 13:21\u201332",
                        "readQS": "John+13:21-32",
                        "audioQS": "John.13"
                    }
                ],
                "readQS": "Psalm+70%3B+Isaiah+50:4-9a%3B+Hebrews+12:1-3%3B+John+13:21-32",
                "audioQS": "Ps.70,Isa.50,Heb.12,John.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 102",
                        "readQS": "Psalm+102",
                        "audioQS": "Ps.102"
                    },
                    {
                        "pretty": "Jeremiah 11:18\u201320",
                        "readQS": "Jeremiah+11:18-20",
                        "audioQS": "Jer.11"
                    },
                    {
                        "pretty": "Luke 22:54\u201371",
                        "readQS": "Luke+22:54-71",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+102%3B+Jeremiah+11:18-20%3B+Luke+22:54-71",
                "audioQS": "Ps.102,Jer.11,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 88",
                        "readQS": "Psalm+88",
                        "audioQS": "Ps.88"
                    },
                    {
                        "pretty": "Isaiah 63:1\u20139",
                        "readQS": "Isaiah+63:1-9",
                        "audioQS": "Isa.63"
                    },
                    {
                        "pretty": "Revelation 14:18\u201315:4",
                        "readQS": "Revelation+14:18-15:4",
                        "audioQS": "Rev.14"
                    }
                ],
                "readQS": "Psalm+88%3B+Isaiah+63:1-9%3B+Revelation+14:18-15:4",
                "audioQS": "Ps.88,Isa.63,Rev.14",
                "note": null
            }
        ]
    },
    "2026/04/02": {
        "datePretty": "Thursday, April 2, 2026",
        "calendar": "Maundy Thursday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 116:1,10\u201317",
                        "readQS": "Psalm+116:1,10-17",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Exodus 12:1\u20134,(5\u201310),11\u201314",
                        "readQS": "Exodus+12:1-4,%285-10%29,11-14",
                        "audioQS": "Exod.12"
                    },
                    {
                        "pretty": "1 Corinthians 11:23\u201326",
                        "readQS": "1+Corinthians+11:23-26",
                        "audioQS": "1Cor.11"
                    },
                    {
                        "pretty": "John 13:1\u201317,31b\u201335",
                        "readQS": "John+13:1-17,31b-35",
                        "audioQS": "John.13"
                    }
                ],
                "readQS": "Psalm+116:1,10-17%3B+Exodus+12:1-4,%285-10%29,11-14%3B+1+Corinthians+11:23-26%3B+John+13:1-17,31b-35",
                "audioQS": "Ps.116,Exod.12,1Cor.11,John.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42,43",
                        "readQS": "Psalm+42,43",
                        "audioQS": "Ps.42,43"
                    },
                    {
                        "pretty": "Leviticus 16:2\u201324",
                        "readQS": "Leviticus+16:2-24",
                        "audioQS": "Lev.16"
                    },
                    {
                        "pretty": "Luke 23:1\u201325",
                        "readQS": "Luke+23:1-25",
                        "audioQS": "Luke.23"
                    }
                ],
                "readQS": "Psalm+42,43%3B+Leviticus+16:2-24%3B+Luke+23:1-25",
                "audioQS": "Ps.42,43,Lev.16,Luke.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 39",
                        "readQS": "Psalm+39",
                        "audioQS": "Ps.39"
                    },
                    {
                        "pretty": "Exodus 11",
                        "readQS": "Exodus+11",
                        "audioQS": "Exod.11"
                    },
                    {
                        "pretty": "Ephesians 2:11\u201318",
                        "readQS": "Ephesians+2:11-18",
                        "audioQS": "Eph.2"
                    }
                ],
                "readQS": "Psalm+39%3B+Exodus+11%3B+Ephesians+2:11-18",
                "audioQS": "Ps.39,Exod.11,Eph.2",
                "note": null
            }
        ]
    },
    "2026/04/03": {
        "datePretty": "Friday, April 3, 2026",
        "calendar": "Good Friday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Isaiah 52:13\u201353:12",
                        "readQS": "Isaiah+52:13-53:12",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Hebrews 10:16\u201325",
                        "readQS": "Hebrews+10:16-25",
                        "audioQS": "Heb.10"
                    },
                    {
                        "pretty": "John 18:1\u201319:42",
                        "readQS": "John+18:1-19:42",
                        "audioQS": "John.18"
                    }
                ],
                "readQS": "Psalm+22%3B+Isaiah+52:13-53:12%3B+Hebrews+10:16-25%3B+John+18:1-19:42",
                "audioQS": "Ps.22,Isa.52,Heb.10,John.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 69",
                        "readQS": "Psalm+69",
                        "audioQS": "Ps.69"
                    },
                    {
                        "pretty": "Genesis 22:1\u201318",
                        "readQS": "Genesis+22:1-18",
                        "audioQS": "Gen.22"
                    },
                    {
                        "pretty": "Hebrews 10:1\u201310",
                        "readQS": "Hebrews+10:1-10",
                        "audioQS": "Heb.10"
                    }
                ],
                "readQS": "Psalm+69%3B+Genesis+22:1-18%3B+Hebrews+10:1-10",
                "audioQS": "Ps.69,Gen.22,Heb.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 130,143",
                        "readQS": "Psalm+130,143",
                        "audioQS": "Ps.130,143"
                    },
                    {
                        "pretty": "Lamentations 5:15\u201322",
                        "readQS": "Lamentations+5:15-22",
                        "audioQS": "Lam.5"
                    },
                    {
                        "pretty": "John 19:38\u201342",
                        "readQS": "John+19:38-42",
                        "audioQS": "John.19"
                    }
                ],
                "readQS": "Psalm+130,143%3B+Lamentations+5:15-22%3B+John+19:38-42",
                "audioQS": "Ps.130,143,Lam.5,John.19",
                "note": null
            }
        ]
    },
    "2026/04/04": {
        "datePretty": "Saturday, April 4, 2026",
        "calendar": "Holy Saturday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "Holy Sat.",
                "readingSetSubtitle": "RCL (Holy Saturday)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 31:1\u20134,15,16",
                        "readQS": "Psalm+31:1-4,15,16",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Job 14:1\u201314",
                        "readQS": "Job+14:1-14",
                        "audioQS": "Job.14"
                    },
                    {
                        "pretty": "1 Peter 4:1\u20138",
                        "readQS": "1+Peter+4:1-8",
                        "audioQS": "1Pet.4"
                    },
                    {
                        "pretty": "Matthew 27:57\u201366",
                        "readQS": "Matthew+27:57-66",
                        "audioQS": "Matt.27"
                    }
                ],
                "readQS": "Psalm+31:1-4,15,16%3B+Job+14:1-14%3B+1+Peter+4:1-8%3B+Matthew+27:57-66",
                "audioQS": "Ps.31,Job.14,1Pet.4,Matt.27",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "Vigil",
                "readingSetSubtitle": "RCL (Easter Vigil)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 114",
                        "readQS": "Psalm+114",
                        "audioQS": "Ps.114"
                    },
                    {
                        "pretty": "Canticle: Exodus 15:1b\u201313,17\u201318",
                        "readQS": "Exodus+15:1b-13,17-18",
                        "audioQS": "Exod.15"
                    },
                    {
                        "pretty": "Exodus 14:10\u201331,15:20\u201321",
                        "readQS": "Exodus+14:10-31,15:20-21",
                        "audioQS": "Exod.14"
                    },
                    {
                        "pretty": "",
                        "readQS": "",
                        "audioQS": ""
                    },
                    {
                        "pretty": "Romans 6:3\u201311",
                        "readQS": "Romans+6:3-11",
                        "audioQS": "Rom.6"
                    },
                    {
                        "pretty": "Matthew 28:1\u201310",
                        "readQS": "Matthew+28:1-10",
                        "audioQS": "Matt.28"
                    }
                ],
                "readQS": "Psalm+114%3B+Canticle:+Exodus+15:1b-13,17-18%3B+Exodus+14:10-31,15:20-21%3B+%3B+Romans+6:3-11%3B+Matthew+28:1-10",
                "audioQS": "Ps.114,Canticle,Exod.14,,Rom.6,Matt.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 142",
                        "readQS": "Psalm+142",
                        "audioQS": "Ps.142"
                    },
                    {
                        "pretty": "Hosea 6:1\u20136",
                        "readQS": "Hosea+6:1-6",
                        "audioQS": "Hos.6"
                    },
                    {
                        "pretty": "John 2:18\u201322",
                        "readQS": "John+2:18-22",
                        "audioQS": "John.2"
                    }
                ],
                "readQS": "Psalm+142%3B+Hosea+6:1-6%3B+John+2:18-22",
                "audioQS": "Ps.142,Hos.6,John.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Job 19:21\u201327",
                        "readQS": "Job+19:21-27",
                        "audioQS": "Job.19"
                    },
                    {
                        "pretty": "1 John 5:5\u201312",
                        "readQS": "1+John+5:5-12",
                        "audioQS": "1John.5"
                    }
                ],
                "readQS": "Psalm+116%3B+Job+19:21-27%3B+1+John+5:5-12",
                "audioQS": "Ps.116,Job.19,1John.5",
                "note": null
            }
        ]
    },
    "2026/04/05": {
        "datePretty": "Sunday, April 5, 2026",
        "calendar": "Easter Sunday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 118:1\u20132,14\u201324",
                        "readQS": "Psalm+118:1-2,14-24",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Acts 10:34\u201343",
                        "readQS": "Acts+10:34-43",
                        "audioQS": "Acts.10"
                    },
                    {
                        "pretty": "Colossians 3:1\u20134",
                        "readQS": "Colossians+3:1-4",
                        "audioQS": "Col.3"
                    },
                    {
                        "pretty": "John 20:1\u201318",
                        "readQS": "John+20:1-18",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+118:1-2,14-24%3B+Acts+10:34-43%3B+Colossians+3:1-4%3B+John+20:1-18",
                "audioQS": "Ps.118,Acts.10,Col.3,John.20",
                "note": "The reading from Acts should be used as the 1st or 2nd reading."
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (late)",
                "readingSetSubtitle": "RCL (late in the day)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 114",
                        "readQS": "Psalm+114",
                        "audioQS": "Ps.114"
                    },
                    {
                        "pretty": "Isaiah 25:6\u20139",
                        "readQS": "Isaiah+25:6-9",
                        "audioQS": "Isa.25"
                    },
                    {
                        "pretty": "1 Corinthians 5:6b\u20138",
                        "readQS": "1+Corinthians+5:6b-8",
                        "audioQS": "1Cor.5"
                    },
                    {
                        "pretty": "Luke 24:13\u201349",
                        "readQS": "Luke+24:13-49",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+114%3B+Isaiah+25:6-9%3B+1+Corinthians+5:6b-8%3B+Luke+24:13-49",
                "audioQS": "Ps.114,Isa.25,1Cor.5,Luke.24",
                "note": "When the main Eucharistic service must be late in the day"
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 114,117",
                        "readQS": "Psalm+114,117",
                        "audioQS": "Ps.114,117"
                    },
                    {
                        "pretty": "Exodus 14:10\u201318,14:26\u201315:2",
                        "readQS": "Exodus+14:10-18,14:26-15:2",
                        "audioQS": "Exod.14"
                    },
                    {
                        "pretty": "Revelation 15:2\u20134",
                        "readQS": "Revelation+15:2-4",
                        "audioQS": "Rev.15"
                    }
                ],
                "readQS": "Psalm+114,117%3B+Exodus+14:10-18,14:26-15:2%3B+Revelation+15:2-4",
                "audioQS": "Ps.114,117,Exod.14,Rev.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 105",
                        "readQS": "Psalm+105",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Song of Solomon 3:2\u20135,8:6\u20137",
                        "readQS": "Song+of+Solomon+3:2-5,8:6-7",
                        "audioQS": "Song.3"
                    },
                    {
                        "pretty": "John 20:11\u201318 (if not used at the Principal Service)",
                        "readQS": "John+20:11-18+%28if+not+used+at+the+Principal+Service%29",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+105%3B+Song+of+Solomon+3:2-5,8:6-7%3B+John+20:11-18+%28if+not+used+at+the+Principal+Service%29",
                "audioQS": "Ps.105,Song.3,John.20",
                "note": null
            }
        ]
    },
    "2026/04/06": {
        "datePretty": "Monday, April 6, 2026",
        "calendar": "Monday in Easter Week",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 111",
                        "readQS": "Psalm+111",
                        "audioQS": "Ps.111"
                    },
                    {
                        "pretty": "Exodus 12:1\u201314",
                        "readQS": "Exodus+12:1-14",
                        "audioQS": "Exod.12"
                    },
                    {
                        "pretty": "1 Corinthians 15:1\u201311",
                        "readQS": "1+Corinthians+15:1-11",
                        "audioQS": "1Cor.15"
                    }
                ],
                "readQS": "Psalm+111%3B+Exodus+12:1-14%3B+1+Corinthians+15:1-11",
                "audioQS": "Ps.111,Exod.12,1Cor.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Song of Solomon 1:9\u20132:7",
                        "readQS": "Song+of+Solomon+1:9-2:7",
                        "audioQS": "Song.1"
                    },
                    {
                        "pretty": "Mark 16:1\u20138",
                        "readQS": "Mark+16:1-8",
                        "audioQS": "Mark.16"
                    }
                ],
                "readQS": "Psalm+135%3B+Song+of+Solomon+1:9-2:7%3B+Mark+16:1-8",
                "audioQS": "Ps.135,Song.1,Mark.16",
                "note": null
            }
        ]
    },
    "2026/04/07": {
        "datePretty": "Tuesday, April 7, 2026",
        "calendar": "Tuesday in Easter Week",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 112",
                        "readQS": "Psalm+112",
                        "audioQS": "Ps.112"
                    },
                    {
                        "pretty": "Exodus 12:14\u201336",
                        "readQS": "Exodus+12:14-36",
                        "audioQS": "Exod.12"
                    },
                    {
                        "pretty": "1 Corinthians 15:12\u201319",
                        "readQS": "1+Corinthians+15:12-19",
                        "audioQS": "1Cor.15"
                    }
                ],
                "readQS": "Psalm+112%3B+Exodus+12:14-36%3B+1+Corinthians+15:12-19",
                "audioQS": "Ps.112,Exod.12,1Cor.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Song of Solomon 2:8\u2013end",
                        "readQS": "Song+of+Solomon+2:8-",
                        "audioQS": "Song.2"
                    },
                    {
                        "pretty": "Luke 24:1\u201312",
                        "readQS": "Luke+24:1-12",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+136%3B+Song+of+Solomon+2:8-%3B+Luke+24:1-12",
                "audioQS": "Ps.136,Song.2,Luke.24",
                "note": null
            }
        ]
    },
    "2026/04/08": {
        "datePretty": "Wednesday, April 8, 2026",
        "calendar": "Wednesday in Easter Week",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 113",
                        "readQS": "Psalm+113",
                        "audioQS": "Ps.113"
                    },
                    {
                        "pretty": "Exodus 12:37\u2013end",
                        "readQS": "Exodus+12:37-",
                        "audioQS": "Exod.12"
                    },
                    {
                        "pretty": "1 Corinthians 15:20\u201328",
                        "readQS": "1+Corinthians+15:20-28",
                        "audioQS": "1Cor.15"
                    }
                ],
                "readQS": "Psalm+113%3B+Exodus+12:37-%3B+1+Corinthians+15:20-28",
                "audioQS": "Ps.113,Exod.12,1Cor.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 105",
                        "readQS": "Psalm+105",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Song of Solomon 3",
                        "readQS": "Song+of+Solomon+3",
                        "audioQS": "Song.3"
                    },
                    {
                        "pretty": "Matthew 28:16\u2013end",
                        "readQS": "Matthew+28:16-",
                        "audioQS": "Matt.28"
                    }
                ],
                "readQS": "Psalm+105%3B+Song+of+Solomon+3%3B+Matthew+28:16-",
                "audioQS": "Ps.105,Song.3,Matt.28",
                "note": null
            }
        ]
    },
    "2026/04/09": {
        "datePretty": "Thursday, April 9, 2026",
        "calendar": "Thursday in Easter Week",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 114",
                        "readQS": "Psalm+114",
                        "audioQS": "Ps.114"
                    },
                    {
                        "pretty": "Exodus 13:1\u201316",
                        "readQS": "Exodus+13:1-16",
                        "audioQS": "Exod.13"
                    },
                    {
                        "pretty": "1 Corinthians 15:29\u201334",
                        "readQS": "1+Corinthians+15:29-34",
                        "audioQS": "1Cor.15"
                    }
                ],
                "readQS": "Psalm+114%3B+Exodus+13:1-16%3B+1+Corinthians+15:29-34",
                "audioQS": "Ps.114,Exod.13,1Cor.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 106",
                        "readQS": "Psalm+106",
                        "audioQS": "Ps.106"
                    },
                    {
                        "pretty": "Song of Solomon 5:2\u20136:3",
                        "readQS": "Song+of+Solomon+5:2-6:3",
                        "audioQS": "Song.5"
                    },
                    {
                        "pretty": "Luke 7:11\u201317",
                        "readQS": "Luke+7:11-17",
                        "audioQS": "Luke.7"
                    }
                ],
                "readQS": "Psalm+106%3B+Song+of+Solomon+5:2-6:3%3B+Luke+7:11-17",
                "audioQS": "Ps.106,Song.5,Luke.7",
                "note": null
            }
        ]
    },
    "2026/04/10": {
        "datePretty": "Friday, April 10, 2026",
        "calendar": "Friday in Easter Week",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 115",
                        "readQS": "Psalm+115",
                        "audioQS": "Ps.115"
                    },
                    {
                        "pretty": "Exodus 13:17\u201314:14",
                        "readQS": "Exodus+13:17-14:14",
                        "audioQS": "Exod.13"
                    },
                    {
                        "pretty": "1 Corinthians 15:35\u201350",
                        "readQS": "1+Corinthians+15:35-50",
                        "audioQS": "1Cor.15"
                    }
                ],
                "readQS": "Psalm+115%3B+Exodus+13:17-14:14%3B+1+Corinthians+15:35-50",
                "audioQS": "Ps.115,Exod.13,1Cor.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 107",
                        "readQS": "Psalm+107",
                        "audioQS": "Ps.107"
                    },
                    {
                        "pretty": "Song of Solomon 7:10\u20138:4",
                        "readQS": "Song+of+Solomon+7:10-8:4",
                        "audioQS": "Song.7"
                    },
                    {
                        "pretty": "Luke 8:41\u2013end",
                        "readQS": "Luke+8:41-",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+107%3B+Song+of+Solomon+7:10-8:4%3B+Luke+8:41-",
                "audioQS": "Ps.107,Song.7,Luke.8",
                "note": null
            }
        ]
    },
    "2026/04/11": {
        "datePretty": "Saturday, April 11, 2026",
        "calendar": "Saturday in Easter Week",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Exodus 14:15\u2013end",
                        "readQS": "Exodus+14:15-",
                        "audioQS": "Exod.14"
                    },
                    {
                        "pretty": "1 Corinthians 15:51\u2013end",
                        "readQS": "1+Corinthians+15:51-",
                        "audioQS": "1Cor.15"
                    }
                ],
                "readQS": "Psalm+116%3B+Exodus+14:15-%3B+1+Corinthians+15:51-",
                "audioQS": "Ps.116,Exod.14,1Cor.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Song of Solomon 8:5\u20137",
                        "readQS": "Song+of+Solomon+8:5-7",
                        "audioQS": "Song.8"
                    },
                    {
                        "pretty": "John 11:17\u201344",
                        "readQS": "John+11:17-44",
                        "audioQS": "John.11"
                    }
                ],
                "readQS": "Psalm+145%3B+Song+of+Solomon+8:5-7%3B+John+11:17-44",
                "audioQS": "Ps.145,Song.8,John.11",
                "note": null
            }
        ]
    },
    "2026/04/12": {
        "datePretty": "Sunday, April 12, 2026",
        "calendar": "2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 16",
                        "readQS": "Psalm+16",
                        "audioQS": "Ps.16"
                    },
                    {
                        "pretty": "Acts 2:14a,22\u201332",
                        "readQS": "Acts+2:14a,22-32",
                        "audioQS": "Acts.2"
                    },
                    {
                        "pretty": "1 Peter 1:3\u20139",
                        "readQS": "1+Peter+1:3-9",
                        "audioQS": "1Pet.1"
                    },
                    {
                        "pretty": "John 20:19\u201331",
                        "readQS": "John+20:19-31",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+16%3B+Acts+2:14a,22-32%3B+1+Peter+1:3-9%3B+John+20:19-31",
                "audioQS": "Ps.16,Acts.2,1Pet.1,John.20",
                "note": "The reading from Acts must be used as either the first or second reading."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 81:1\u201310",
                        "readQS": "Psalm+81:1-10",
                        "audioQS": "Ps.81"
                    },
                    {
                        "pretty": "Exodus 12:1\u201317",
                        "readQS": "Exodus+12:1-17",
                        "audioQS": "Exod.12"
                    },
                    {
                        "pretty": "1 Corinthians 5:6b\u20138",
                        "readQS": "1+Corinthians+5:6b-8",
                        "audioQS": "1Cor.5"
                    }
                ],
                "readQS": "Psalm+81:1-10%3B+Exodus+12:1-17%3B+1+Corinthians+5:6b-8",
                "audioQS": "Ps.81,Exod.12,1Cor.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 30:1\u20135",
                        "readQS": "Psalm+30:1-5",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Daniel 6:(1\u20135),6\u201323",
                        "readQS": "Daniel+6:%281-5%29,6-23",
                        "audioQS": "Dan.6"
                    },
                    {
                        "pretty": "Mark 15:46\u201316:8",
                        "readQS": "Mark+15:46-16:8",
                        "audioQS": "Mark.15"
                    }
                ],
                "readQS": "Psalm+30:1-5%3B+Daniel+6:%281-5%29,6-23%3B+Mark+15:46-16:8",
                "audioQS": "Ps.30,Dan.6,Mark.15",
                "note": null
            }
        ]
    },
    "2026/04/13": {
        "datePretty": "Monday, April 13, 2026",
        "calendar": "Week of 2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Exodus 15:1\u201321",
                        "readQS": "Exodus+15:1-21",
                        "audioQS": "Exod.15"
                    },
                    {
                        "pretty": "Colossians 1:1\u201314",
                        "readQS": "Colossians+1:1-14",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+19%3B+Exodus+15:1-21%3B+Colossians+1:1-14",
                "audioQS": "Ps.19,Exod.15,Col.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Deuteronomy 1:3\u201318",
                        "readQS": "Deuteronomy+1:3-18",
                        "audioQS": "Deut.1"
                    },
                    {
                        "pretty": "John 20:1\u201310",
                        "readQS": "John+20:1-10",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+139%3B+Deuteronomy+1:3-18%3B+John+20:1-10",
                "audioQS": "Ps.139,Deut.1,John.20",
                "note": null
            }
        ]
    },
    "2026/04/14": {
        "datePretty": "Tuesday, April 14, 2026",
        "calendar": "Week of 2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 8",
                        "readQS": "Psalm+8",
                        "audioQS": "Ps.8"
                    },
                    {
                        "pretty": "Exodus 15:22\u201316:10",
                        "readQS": "Exodus+15:22-16:10",
                        "audioQS": "Exod.15"
                    },
                    {
                        "pretty": "Colossians 1:15\u2013end",
                        "readQS": "Colossians+1:15-",
                        "audioQS": "Col.1"
                    }
                ],
                "readQS": "Psalm+8%3B+Exodus+15:22-16:10%3B+Colossians+1:15-",
                "audioQS": "Ps.8,Exod.15,Col.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 104",
                        "readQS": "Psalm+104",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Deuteronomy 1:19\u201340",
                        "readQS": "Deuteronomy+1:19-40",
                        "audioQS": "Deut.1"
                    },
                    {
                        "pretty": "John 20:11\u201318",
                        "readQS": "John+20:11-18",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+104%3B+Deuteronomy+1:19-40%3B+John+20:11-18",
                "audioQS": "Ps.104,Deut.1,John.20",
                "note": null
            }
        ]
    },
    "2026/04/15": {
        "datePretty": "Wednesday, April 15, 2026",
        "calendar": "Week of 2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Exodus 16:11\u2013end",
                        "readQS": "Exodus+16:11-",
                        "audioQS": "Exod.16"
                    },
                    {
                        "pretty": "Colossians 2:1\u201315",
                        "readQS": "Colossians+2:1-15",
                        "audioQS": "Col.2"
                    }
                ],
                "readQS": "Psalm+30%3B+Exodus+16:11-%3B+Colossians+2:1-15",
                "audioQS": "Ps.30,Exod.16,Col.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Deuteronomy 3:18\u2013end",
                        "readQS": "Deuteronomy+3:18-",
                        "audioQS": "Deut.3"
                    },
                    {
                        "pretty": "John 20:19\u2013end",
                        "readQS": "John+20:19-",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+33%3B+Deuteronomy+3:18-%3B+John+20:19-",
                "audioQS": "Ps.33,Deut.3,John.20",
                "note": null
            }
        ]
    },
    "2026/04/16": {
        "datePretty": "Thursday, April 16, 2026",
        "calendar": "Week of 2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 28",
                        "readQS": "Psalm+28",
                        "audioQS": "Ps.28"
                    },
                    {
                        "pretty": "Exodus 17",
                        "readQS": "Exodus+17",
                        "audioQS": "Exod.17"
                    },
                    {
                        "pretty": "Colossians 2:16\u20133:11",
                        "readQS": "Colossians+2:16-3:11",
                        "audioQS": "Col.2"
                    }
                ],
                "readQS": "Psalm+28%3B+Exodus+17%3B+Colossians+2:16-3:11",
                "audioQS": "Ps.28,Exod.17,Col.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Deuteronomy 4:1\u201314",
                        "readQS": "Deuteronomy+4:1-14",
                        "audioQS": "Deut.4"
                    },
                    {
                        "pretty": "John 21:1\u201314",
                        "readQS": "John+21:1-14",
                        "audioQS": "John.21"
                    }
                ],
                "readQS": "Psalm+34%3B+Deuteronomy+4:1-14%3B+John+21:1-14",
                "audioQS": "Ps.34,Deut.4,John.21",
                "note": null
            }
        ]
    },
    "2026/04/17": {
        "datePretty": "Friday, April 17, 2026",
        "calendar": "Week of 2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 61",
                        "readQS": "Psalm+61",
                        "audioQS": "Ps.61"
                    },
                    {
                        "pretty": "Exodus 18:1\u201312",
                        "readQS": "Exodus+18:1-12",
                        "audioQS": "Exod.18"
                    },
                    {
                        "pretty": "Colossians 3:12\u20134:1",
                        "readQS": "Colossians+3:12-4:1",
                        "audioQS": "Col.3"
                    }
                ],
                "readQS": "Psalm+61%3B+Exodus+18:1-12%3B+Colossians+3:12-4:1",
                "audioQS": "Ps.61,Exod.18,Col.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Deuteronomy 4:15\u201331",
                        "readQS": "Deuteronomy+4:15-31",
                        "audioQS": "Deut.4"
                    },
                    {
                        "pretty": "John 21:15\u201319",
                        "readQS": "John+21:15-19",
                        "audioQS": "John.21"
                    }
                ],
                "readQS": "Psalm+118%3B+Deuteronomy+4:15-31%3B+John+21:15-19",
                "audioQS": "Ps.118,Deut.4,John.21",
                "note": null
            }
        ]
    },
    "2026/04/18": {
        "datePretty": "Saturday, April 18, 2026",
        "calendar": "Week of 2nd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 84",
                        "readQS": "Psalm+84",
                        "audioQS": "Ps.84"
                    },
                    {
                        "pretty": "Exodus 18:13\u2013end",
                        "readQS": "Exodus+18:13-",
                        "audioQS": "Exod.18"
                    },
                    {
                        "pretty": "Colossians 4:2\u2013end",
                        "readQS": "Colossians+4:2-",
                        "audioQS": "Col.4"
                    }
                ],
                "readQS": "Psalm+84%3B+Exodus+18:13-%3B+Colossians+4:2-",
                "audioQS": "Ps.84,Exod.18,Col.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66",
                        "readQS": "Psalm+66",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Deuteronomy 4:32\u201340",
                        "readQS": "Deuteronomy+4:32-40",
                        "audioQS": "Deut.4"
                    },
                    {
                        "pretty": "John 21:20\u2013end",
                        "readQS": "John+21:20-",
                        "audioQS": "John.21"
                    }
                ],
                "readQS": "Psalm+66%3B+Deuteronomy+4:32-40%3B+John+21:20-",
                "audioQS": "Ps.66,Deut.4,John.21",
                "note": null
            }
        ]
    },
    "2026/04/19": {
        "datePretty": "Sunday, April 19, 2026",
        "calendar": "3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 116:1\u20133,10\u201317",
                        "readQS": "Psalm+116:1-3,10-17",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Acts 2:14a,36\u201341",
                        "readQS": "Acts+2:14a,36-41",
                        "audioQS": "Acts.2"
                    },
                    {
                        "pretty": "1 Peter 1:17\u201323",
                        "readQS": "1+Peter+1:17-23",
                        "audioQS": "1Pet.1"
                    },
                    {
                        "pretty": "Luke 24:13\u201335",
                        "readQS": "Luke+24:13-35",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+116:1-3,10-17%3B+Acts+2:14a,36-41%3B+1+Peter+1:17-23%3B+Luke+24:13-35",
                "audioQS": "Ps.116,Acts.2,1Pet.1,Luke.24",
                "note": "The reading from Acts must be used as either the first or second reading."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Isaiah 40:1\u201311",
                        "readQS": "Isaiah+40:1-11",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "1 Peter 5:1\u201311",
                        "readQS": "1+Peter+5:1-11",
                        "audioQS": "1Pet.5"
                    }
                ],
                "readQS": "Psalm+23%3B+Isaiah+40:1-11%3B+1+Peter+5:1-11",
                "audioQS": "Ps.23,Isa.40,1Pet.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "Haggai 1:13\u20132:9",
                        "readQS": "Haggai+1:13-2:9",
                        "audioQS": "Hag.1"
                    },
                    {
                        "pretty": "1 Corinthians 3:10\u201317",
                        "readQS": "1+Corinthians+3:10-17",
                        "audioQS": "1Cor.3"
                    }
                ],
                "readQS": "Psalm+48%3B+Haggai+1:13-2:9%3B+1+Corinthians+3:10-17",
                "audioQS": "Ps.48,Hag.1,1Cor.3",
                "note": null
            }
        ]
    },
    "2026/04/20": {
        "datePretty": "Monday, April 20, 2026",
        "calendar": "Week of 3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 96",
                        "readQS": "Psalm+96",
                        "audioQS": "Ps.96"
                    },
                    {
                        "pretty": "Exodus 19",
                        "readQS": "Exodus+19",
                        "audioQS": "Exod.19"
                    },
                    {
                        "pretty": "Luke 1:1\u201325",
                        "readQS": "Luke+1:1-25",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+96%3B+Exodus+19%3B+Luke+1:1-25",
                "audioQS": "Ps.96,Exod.19,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 61",
                        "readQS": "Psalm+61",
                        "audioQS": "Ps.61"
                    },
                    {
                        "pretty": "Deuteronomy 5:1\u201322",
                        "readQS": "Deuteronomy+5:1-22",
                        "audioQS": "Deut.5"
                    },
                    {
                        "pretty": "Ephesians 1:1\u201314",
                        "readQS": "Ephesians+1:1-14",
                        "audioQS": "Eph.1"
                    }
                ],
                "readQS": "Psalm+61%3B+Deuteronomy+5:1-22%3B+Ephesians+1:1-14",
                "audioQS": "Ps.61,Deut.5,Eph.1",
                "note": null
            }
        ]
    },
    "2026/04/21": {
        "datePretty": "Tuesday, April 21, 2026",
        "calendar": "Week of 3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 98",
                        "readQS": "Psalm+98",
                        "audioQS": "Ps.98"
                    },
                    {
                        "pretty": "Exodus 20:1\u201321",
                        "readQS": "Exodus+20:1-21",
                        "audioQS": "Exod.20"
                    },
                    {
                        "pretty": "Luke 1:26\u201338",
                        "readQS": "Luke+1:26-38",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+98%3B+Exodus+20:1-21%3B+Luke+1:26-38",
                "audioQS": "Ps.98,Exod.20,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Deuteronomy 5:22\u2013end",
                        "readQS": "Deuteronomy+5:22-",
                        "audioQS": "Deut.5"
                    },
                    {
                        "pretty": "Ephesians 1:15\u2013end",
                        "readQS": "Ephesians+1:15-",
                        "audioQS": "Eph.1"
                    }
                ],
                "readQS": "Psalm+71%3B+Deuteronomy+5:22-%3B+Ephesians+1:15-",
                "audioQS": "Ps.71,Deut.5,Eph.1",
                "note": null
            }
        ]
    },
    "2026/04/22": {
        "datePretty": "Wednesday, April 22, 2026",
        "calendar": "Week of 3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 105",
                        "readQS": "Psalm+105",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Exodus 24",
                        "readQS": "Exodus+24",
                        "audioQS": "Exod.24"
                    },
                    {
                        "pretty": "Luke 1:39\u201356",
                        "readQS": "Luke+1:39-56",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+105%3B+Exodus+24%3B+Luke+1:39-56",
                "audioQS": "Ps.105,Exod.24,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Deuteronomy 6",
                        "readQS": "Deuteronomy+6",
                        "audioQS": "Deut.6"
                    },
                    {
                        "pretty": "Ephesians 2:1\u201310",
                        "readQS": "Ephesians+2:1-10",
                        "audioQS": "Eph.2"
                    }
                ],
                "readQS": "Psalm+72%3B+Deuteronomy+6%3B+Ephesians+2:1-10",
                "audioQS": "Ps.72,Deut.6,Eph.2",
                "note": null
            }
        ]
    },
    "2026/04/23": {
        "datePretty": "Thursday, April 23, 2026",
        "calendar": "Week of 3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Exodus 25:1\u201322",
                        "readQS": "Exodus+25:1-22",
                        "audioQS": "Exod.25"
                    },
                    {
                        "pretty": "Luke 1:57\u2013end",
                        "readQS": "Luke+1:57-",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+136%3B+Exodus+25:1-22%3B+Luke+1:57-",
                "audioQS": "Ps.136,Exod.25,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Deuteronomy 7:1\u201311",
                        "readQS": "Deuteronomy+7:1-11",
                        "audioQS": "Deut.7"
                    },
                    {
                        "pretty": "Ephesians 2:11\u2013end",
                        "readQS": "Ephesians+2:11-",
                        "audioQS": "Eph.2"
                    }
                ],
                "readQS": "Psalm+73%3B+Deuteronomy+7:1-11%3B+Ephesians+2:11-",
                "audioQS": "Ps.73,Deut.7,Eph.2",
                "note": null
            }
        ]
    },
    "2026/04/24": {
        "datePretty": "Friday, April 24, 2026",
        "calendar": "Week of 3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 107",
                        "readQS": "Psalm+107",
                        "audioQS": "Ps.107"
                    },
                    {
                        "pretty": "Exodus 28:1\u20134a,28:29\u201338",
                        "readQS": "Exodus+28:1-4a,28:29-38",
                        "audioQS": "Exod.28"
                    },
                    {
                        "pretty": "Luke 2:1\u201320",
                        "readQS": "Luke+2:1-20",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+107%3B+Exodus+28:1-4a,28:29-38%3B+Luke+2:1-20",
                "audioQS": "Ps.107,Exod.28,Luke.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Deuteronomy 7:12\u2013end",
                        "readQS": "Deuteronomy+7:12-",
                        "audioQS": "Deut.7"
                    },
                    {
                        "pretty": "Ephesians 3:1\u201313",
                        "readQS": "Ephesians+3:1-13",
                        "audioQS": "Eph.3"
                    }
                ],
                "readQS": "Psalm+77%3B+Deuteronomy+7:12-%3B+Ephesians+3:1-13",
                "audioQS": "Ps.77,Deut.7,Eph.3",
                "note": null
            }
        ]
    },
    "2026/04/25": {
        "datePretty": "Saturday, April 25, 2026",
        "calendar": "Week of 3rd Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 110",
                        "readQS": "Psalm+110",
                        "audioQS": "Ps.110"
                    },
                    {
                        "pretty": "Exodus 29:1\u20139",
                        "readQS": "Exodus+29:1-9",
                        "audioQS": "Exod.29"
                    },
                    {
                        "pretty": "Luke 2:21\u201340",
                        "readQS": "Luke+2:21-40",
                        "audioQS": "Luke.2"
                    }
                ],
                "readQS": "Psalm+110%3B+Exodus+29:1-9%3B+Luke+2:21-40",
                "audioQS": "Ps.110,Exod.29,Luke.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 27",
                        "readQS": "Psalm+27",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Deuteronomy 8",
                        "readQS": "Deuteronomy+8",
                        "audioQS": "Deut.8"
                    },
                    {
                        "pretty": "Ephesians 3:14\u2013end",
                        "readQS": "Ephesians+3:14-",
                        "audioQS": "Eph.3"
                    }
                ],
                "readQS": "Psalm+27%3B+Deuteronomy+8%3B+Ephesians+3:14-",
                "audioQS": "Ps.27,Deut.8,Eph.3",
                "note": null
            }
        ]
    },
    "2026/04/26": {
        "datePretty": "Sunday, April 26, 2026",
        "calendar": "4th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Acts 2:42\u201347",
                        "readQS": "Acts+2:42-47",
                        "audioQS": "Acts.2"
                    },
                    {
                        "pretty": "1 Peter 2:19\u201325",
                        "readQS": "1+Peter+2:19-25",
                        "audioQS": "1Pet.2"
                    },
                    {
                        "pretty": "John 10:1\u201310",
                        "readQS": "John+10:1-10",
                        "audioQS": "John.10"
                    }
                ],
                "readQS": "Psalm+23%3B+Acts+2:42-47%3B+1+Peter+2:19-25%3B+John+10:1-10",
                "audioQS": "Ps.23,Acts.2,1Pet.2,John.10",
                "note": "The reading from Acts must be used as either the first or second reading."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 106:6\u201324",
                        "readQS": "Psalm+106:6-24",
                        "audioQS": "Ps.106"
                    },
                    {
                        "pretty": "Nehemiah 9:6\u201315",
                        "readQS": "Nehemiah+9:6-15",
                        "audioQS": "Neh.9"
                    },
                    {
                        "pretty": "1 Corinthians 10:1\u201313",
                        "readQS": "1+Corinthians+10:1-13",
                        "audioQS": "1Cor.10"
                    }
                ],
                "readQS": "Psalm+106:6-24%3B+Nehemiah+9:6-15%3B+1+Corinthians+10:1-13",
                "audioQS": "Ps.106,Neh.9,1Cor.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Mark)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Isaiah 52:7\u201310",
                        "readQS": "Isaiah+52:7-10",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Mark 1:1\u201315",
                        "readQS": "Mark+1:1-15",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+19%3B+Isaiah+52:7-10%3B+Mark+1:1-15",
                "audioQS": "Ps.19,Isa.52,Mark.1",
                "note": null
            }
        ]
    },
    "2026/04/27": {
        "datePretty": "Monday, April 27, 2026",
        "calendar": "St Mark the Evangelist",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 37:23\u201341,148",
                        "readQS": "Psalm+37:23-41,148",
                        "audioQS": "Ps.37"
                    },
                    {
                        "pretty": "Isaiah 62:6\u201310",
                        "readQS": "Isaiah+62:6-10",
                        "audioQS": "Isa.62"
                    },
                    {
                        "pretty": "Acts 12:25\u2013end,13:1\u201313",
                        "readQS": "Acts+12:25-,13:1-13",
                        "audioQS": "Acts.12"
                    }
                ],
                "readQS": "Psalm+37:23-41,148%3B+Isaiah+62:6-10%3B+Acts+12:25-,13:1-13",
                "audioQS": "Ps.37,Isa.62,Acts.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 45",
                        "readQS": "Psalm+45",
                        "audioQS": "Ps.45"
                    },
                    {
                        "pretty": "Ezekiel 1:4\u201314",
                        "readQS": "Ezekiel+1:4-14",
                        "audioQS": "Ezek.1"
                    },
                    {
                        "pretty": "2 Timothy 4:1\u201311",
                        "readQS": "2+Timothy+4:1-11",
                        "audioQS": "2Tim.4"
                    }
                ],
                "readQS": "Psalm+45%3B+Ezekiel+1:4-14%3B+2+Timothy+4:1-11",
                "audioQS": "Ps.45,Ezek.1,2Tim.4",
                "note": null
            }
        ]
    },
    "2026/04/28": {
        "datePretty": "Tuesday, April 28, 2026",
        "calendar": "Week of 4th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Exodus 32:15\u201334",
                        "readQS": "Exodus+32:15-34",
                        "audioQS": "Exod.32"
                    },
                    {
                        "pretty": "Luke 3:1\u201314",
                        "readQS": "Luke+3:1-14",
                        "audioQS": "Luke.3"
                    }
                ],
                "readQS": "Psalm+139%3B+Exodus+32:15-34%3B+Luke+3:1-14",
                "audioQS": "Ps.139,Exod.32,Luke.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Deuteronomy 9:23\u201310:5",
                        "readQS": "Deuteronomy+9:23-10:5",
                        "audioQS": "Deut.9"
                    },
                    {
                        "pretty": "Ephesians 4:17\u2013end",
                        "readQS": "Ephesians+4:17-",
                        "audioQS": "Eph.4"
                    }
                ],
                "readQS": "Psalm+116%3B+Deuteronomy+9:23-10:5%3B+Ephesians+4:17-",
                "audioQS": "Ps.116,Deut.9,Eph.4",
                "note": null
            }
        ]
    },
    "2026/04/29": {
        "datePretty": "Wednesday, April 29, 2026",
        "calendar": "Week of 4th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Exodus 33",
                        "readQS": "Exodus+33",
                        "audioQS": "Exod.33"
                    },
                    {
                        "pretty": "Luke 3:15\u201322",
                        "readQS": "Luke+3:15-22",
                        "audioQS": "Luke.3"
                    }
                ],
                "readQS": "Psalm+135%3B+Exodus+33%3B+Luke+3:15-22",
                "audioQS": "Ps.135,Exod.33,Luke.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Deuteronomy 10:12\u2013end",
                        "readQS": "Deuteronomy+10:12-",
                        "audioQS": "Deut.10"
                    },
                    {
                        "pretty": "Ephesians 5:1\u201314",
                        "readQS": "Ephesians+5:1-14",
                        "audioQS": "Eph.5"
                    }
                ],
                "readQS": "Psalm+47%3B+Deuteronomy+10:12-%3B+Ephesians+5:1-14",
                "audioQS": "Ps.47,Deut.10,Eph.5",
                "note": null
            }
        ]
    },
    "2026/04/30": {
        "datePretty": "Thursday, April 30, 2026",
        "calendar": "Week of 4th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Exodus 34:1\u201310,34:27\u2013end",
                        "readQS": "Exodus+34:1-10,34:27-",
                        "audioQS": "Exod.34"
                    },
                    {
                        "pretty": "Luke 4:1\u201313",
                        "readQS": "Luke+4:1-13",
                        "audioQS": "Luke.4"
                    }
                ],
                "readQS": "Psalm+118%3B+Exodus+34:1-10,34:27-%3B+Luke+4:1-13",
                "audioQS": "Ps.118,Exod.34,Luke.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Phillip and St James)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 25",
                        "readQS": "Psalm+25",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Isaiah 40:27\u201331",
                        "readQS": "Isaiah+40:27-31",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "John 12:20\u201326",
                        "readQS": "John+12:20-26",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+25%3B+Isaiah+40:27-31%3B+John+12:20-26",
                "audioQS": "Ps.25,Isa.40,John.12",
                "note": null
            }
        ]
    },
    "2026/05/01": {
        "datePretty": "Friday, May 1, 2026",
        "calendar": "St Phillip and St James, Apostles",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 139,146",
                        "readQS": "Psalm+139,146",
                        "audioQS": "Ps.139,146"
                    },
                    {
                        "pretty": "Proverbs 4:10\u201318",
                        "readQS": "Proverbs+4:10-18",
                        "audioQS": "Prov.4"
                    },
                    {
                        "pretty": "James 1:1\u201312",
                        "readQS": "James+1:1-12",
                        "audioQS": "Jas.1"
                    }
                ],
                "readQS": "Psalm+139,146%3B+Proverbs+4:10-18%3B+James+1:1-12",
                "audioQS": "Ps.139,146,Prov.4,Jas.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 149",
                        "readQS": "Psalm+149",
                        "audioQS": "Ps.149"
                    },
                    {
                        "pretty": "Job 23:1\u201312",
                        "readQS": "Job+23:1-12",
                        "audioQS": "Job.23"
                    },
                    {
                        "pretty": "John 1:43\u201351",
                        "readQS": "John+1:43-51",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+149%3B+Job+23:1-12%3B+John+1:43-51",
                "audioQS": "Ps.149,Job.23,John.1",
                "note": null
            }
        ]
    },
    "2026/05/02": {
        "datePretty": "Saturday, May 2, 2026",
        "calendar": "Week of 4th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Exodus 40:17\u2013end",
                        "readQS": "Exodus+40:17-",
                        "audioQS": "Exod.40"
                    },
                    {
                        "pretty": "Luke 4:31\u201337",
                        "readQS": "Luke+4:31-37",
                        "audioQS": "Luke.4"
                    }
                ],
                "readQS": "Psalm+34%3B+Exodus+40:17-%3B+Luke+4:31-37",
                "audioQS": "Ps.34,Exod.40,Luke.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 84",
                        "readQS": "Psalm+84",
                        "audioQS": "Ps.84"
                    },
                    {
                        "pretty": "Deuteronomy 15:1\u201318",
                        "readQS": "Deuteronomy+15:1-18",
                        "audioQS": "Deut.15"
                    },
                    {
                        "pretty": "Ephesians 6:10\u2013end",
                        "readQS": "Ephesians+6:10-",
                        "audioQS": "Eph.6"
                    }
                ],
                "readQS": "Psalm+84%3B+Deuteronomy+15:1-18%3B+Ephesians+6:10-",
                "audioQS": "Ps.84,Deut.15,Eph.6",
                "note": null
            }
        ]
    },
    "2026/05/03": {
        "datePretty": "Sunday, May 3, 2026",
        "calendar": "5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 31:1\u20135,15\u201316",
                        "readQS": "Psalm+31:1-5,15-16",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Acts 7:55\u201360",
                        "readQS": "Acts+7:55-60",
                        "audioQS": "Acts.7"
                    },
                    {
                        "pretty": "1 Peter 2:2\u201310",
                        "readQS": "1+Peter+2:2-10",
                        "audioQS": "1Pet.2"
                    },
                    {
                        "pretty": "John 14:1\u201314",
                        "readQS": "John+14:1-14",
                        "audioQS": "John.14"
                    }
                ],
                "readQS": "Psalm+31:1-5,15-16%3B+Acts+7:55-60%3B+1+Peter+2:2-10%3B+John+14:1-14",
                "audioQS": "Ps.31,Acts.7,1Pet.2,John.14",
                "note": "The reading from Acts must be used as either the first or second reading."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Ezekiel 37:1\u201312",
                        "readQS": "Ezekiel+37:1-12",
                        "audioQS": "Ezek.37"
                    },
                    {
                        "pretty": "John 5:19\u201329",
                        "readQS": "John+5:19-29",
                        "audioQS": "John.5"
                    }
                ],
                "readQS": "Psalm+30%3B+Ezekiel+37:1-12%3B+John+5:19-29",
                "audioQS": "Ps.30,Ezek.37,John.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 147:1\u201312",
                        "readQS": "Psalm+147:1-12",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "Zechariah 4:1\u201310",
                        "readQS": "Zechariah+4:1-10",
                        "audioQS": "Zech.4"
                    },
                    {
                        "pretty": "Revelation 21:1\u201314",
                        "readQS": "Revelation+21:1-14",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+147:1-12%3B+Zechariah+4:1-10%3B+Revelation+21:1-14",
                "audioQS": "Ps.147,Zech.4,Rev.21",
                "note": null
            }
        ]
    },
    "2026/05/04": {
        "datePretty": "Monday, May 4, 2026",
        "calendar": "Week of 5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Numbers 9:15\u2013end,10:33\u2013end",
                        "readQS": "Numbers+9:15-,10:33-",
                        "audioQS": "Num.9"
                    },
                    {
                        "pretty": "Luke 4:38\u2013end",
                        "readQS": "Luke+4:38-",
                        "audioQS": "Luke.4"
                    }
                ],
                "readQS": "Psalm+145%3B+Numbers+9:15-,10:33-%3B+Luke+4:38-",
                "audioQS": "Ps.145,Num.9,Luke.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 105",
                        "readQS": "Psalm+105",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Deuteronomy 16:1\u201320",
                        "readQS": "Deuteronomy+16:1-20",
                        "audioQS": "Deut.16"
                    },
                    {
                        "pretty": "1 Peter 1:1\u201312",
                        "readQS": "1+Peter+1:1-12",
                        "audioQS": "1Pet.1"
                    }
                ],
                "readQS": "Psalm+105%3B+Deuteronomy+16:1-20%3B+1+Peter+1:1-12",
                "audioQS": "Ps.105,Deut.16,1Pet.1",
                "note": null
            }
        ]
    },
    "2026/05/05": {
        "datePretty": "Tuesday, May 5, 2026",
        "calendar": "Week of 5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Numbers 11:1\u201333",
                        "readQS": "Numbers+11:1-33",
                        "audioQS": "Num.11"
                    },
                    {
                        "pretty": "Luke 5:1\u201311",
                        "readQS": "Luke+5:1-11",
                        "audioQS": "Luke.5"
                    }
                ],
                "readQS": "Psalm+19%3B+Numbers+11:1-33%3B+Luke+5:1-11",
                "audioQS": "Ps.19,Num.11,Luke.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Deuteronomy 17:8\u2013end",
                        "readQS": "Deuteronomy+17:8-",
                        "audioQS": "Deut.17"
                    },
                    {
                        "pretty": "1 Peter 1:13\u2013end",
                        "readQS": "1+Peter+1:13-",
                        "audioQS": "1Pet.1"
                    }
                ],
                "readQS": "Psalm+97%3B+Deuteronomy+17:8-%3B+1+Peter+1:13-",
                "audioQS": "Ps.97,Deut.17,1Pet.1",
                "note": null
            }
        ]
    },
    "2026/05/06": {
        "datePretty": "Wednesday, May 6, 2026",
        "calendar": "Week of 5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Numbers 12",
                        "readQS": "Numbers+12",
                        "audioQS": "Num.12"
                    },
                    {
                        "pretty": "Luke 5:12\u201326",
                        "readQS": "Luke+5:12-26",
                        "audioQS": "Luke.5"
                    }
                ],
                "readQS": "Psalm+30%3B+Numbers+12%3B+Luke+5:12-26",
                "audioQS": "Ps.30,Num.12,Luke.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 99",
                        "readQS": "Psalm+99",
                        "audioQS": "Ps.99"
                    },
                    {
                        "pretty": "Deuteronomy 18:9\u2013end",
                        "readQS": "Deuteronomy+18:9-",
                        "audioQS": "Deut.18"
                    },
                    {
                        "pretty": "1 Peter 2:1\u201310",
                        "readQS": "1+Peter+2:1-10",
                        "audioQS": "1Pet.2"
                    }
                ],
                "readQS": "Psalm+99%3B+Deuteronomy+18:9-%3B+1+Peter+2:1-10",
                "audioQS": "Ps.99,Deut.18,1Pet.2",
                "note": null
            }
        ]
    },
    "2026/05/07": {
        "datePretty": "Thursday, May 7, 2026",
        "calendar": "Week of 5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 57",
                        "readQS": "Psalm+57",
                        "audioQS": "Ps.57"
                    },
                    {
                        "pretty": "Numbers 13:1\u20133,13:17\u2013end",
                        "readQS": "Numbers+13:1-3,13:17-",
                        "audioQS": "Num.13"
                    },
                    {
                        "pretty": "Luke 5:27\u2013end",
                        "readQS": "Luke+5:27-",
                        "audioQS": "Luke.5"
                    }
                ],
                "readQS": "Psalm+57%3B+Numbers+13:1-3,13:17-%3B+Luke+5:27-",
                "audioQS": "Ps.57,Num.13,Luke.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 104",
                        "readQS": "Psalm+104",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Deuteronomy 19",
                        "readQS": "Deuteronomy+19",
                        "audioQS": "Deut.19"
                    },
                    {
                        "pretty": "1 Peter 2:11\u2013end",
                        "readQS": "1+Peter+2:11-",
                        "audioQS": "1Pet.2"
                    }
                ],
                "readQS": "Psalm+104%3B+Deuteronomy+19%3B+1+Peter+2:11-",
                "audioQS": "Ps.104,Deut.19,1Pet.2",
                "note": null
            }
        ]
    },
    "2026/05/08": {
        "datePretty": "Friday, May 8, 2026",
        "calendar": "Week of 5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "Numbers 14:1\u201325",
                        "readQS": "Numbers+14:1-25",
                        "audioQS": "Num.14"
                    },
                    {
                        "pretty": "Luke 6:1\u201311",
                        "readQS": "Luke+6:1-11",
                        "audioQS": "Luke.6"
                    }
                ],
                "readQS": "Psalm+138%3B+Numbers+14:1-25%3B+Luke+6:1-11",
                "audioQS": "Ps.138,Num.14,Luke.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66",
                        "readQS": "Psalm+66",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Deuteronomy 21:22\u201322:8",
                        "readQS": "Deuteronomy+21:22-22:8",
                        "audioQS": "Deut.21"
                    },
                    {
                        "pretty": "1 Peter 3:1\u201312",
                        "readQS": "1+Peter+3:1-12",
                        "audioQS": "1Pet.3"
                    }
                ],
                "readQS": "Psalm+66%3B+Deuteronomy+21:22-22:8%3B+1+Peter+3:1-12",
                "audioQS": "Ps.66,Deut.21,1Pet.3",
                "note": null
            }
        ]
    },
    "2026/05/09": {
        "datePretty": "Saturday, May 9, 2026",
        "calendar": "Week of 5th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 146",
                        "readQS": "Psalm+146",
                        "audioQS": "Ps.146"
                    },
                    {
                        "pretty": "Numbers 14:26\u2013end",
                        "readQS": "Numbers+14:26-",
                        "audioQS": "Num.14"
                    },
                    {
                        "pretty": "Luke 6:12\u201326",
                        "readQS": "Luke+6:12-26",
                        "audioQS": "Luke.6"
                    }
                ],
                "readQS": "Psalm+146%3B+Numbers+14:26-%3B+Luke+6:12-26",
                "audioQS": "Ps.146,Num.14,Luke.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Deuteronomy 24:5\u2013end",
                        "readQS": "Deuteronomy+24:5-",
                        "audioQS": "Deut.24"
                    },
                    {
                        "pretty": "1 Peter 3:13\u2013end",
                        "readQS": "1+Peter+3:13-",
                        "audioQS": "1Pet.3"
                    }
                ],
                "readQS": "Psalm+118%3B+Deuteronomy+24:5-%3B+1+Peter+3:13-",
                "audioQS": "Ps.118,Deut.24,1Pet.3",
                "note": null
            }
        ]
    },
    "2026/05/10": {
        "datePretty": "Sunday, May 10, 2026",
        "calendar": "6th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 66:7\u201318",
                        "readQS": "Psalm+66:7-18",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Acts 17:22\u201331",
                        "readQS": "Acts+17:22-31",
                        "audioQS": "Acts.17"
                    },
                    {
                        "pretty": "1 Peter 3:13\u201322",
                        "readQS": "1+Peter+3:13-22",
                        "audioQS": "1Pet.3"
                    },
                    {
                        "pretty": "John 14:15\u201321",
                        "readQS": "John+14:15-21",
                        "audioQS": "John.14"
                    }
                ],
                "readQS": "Psalm+66:7-18%3B+Acts+17:22-31%3B+1+Peter+3:13-22%3B+John+14:15-21",
                "audioQS": "Ps.66,Acts.17,1Pet.3,John.14",
                "note": "The reading from Acts must be used as either the first or second reading."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 73:21\u201328",
                        "readQS": "Psalm+73:21-28",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Job 14:1\u20132,7\u201315,19:23\u201327a",
                        "readQS": "Job+14:1-2,7-15,19:23-27a",
                        "audioQS": "Job.14"
                    },
                    {
                        "pretty": "1 Thessalonians 4:13\u201318",
                        "readQS": "1+Thessalonians+4:13-18",
                        "audioQS": "1Thess.4"
                    }
                ],
                "readQS": "Psalm+73:21-28%3B+Job+14:1-2,7-15,19:23-27a%3B+1+Thessalonians+4:13-18",
                "audioQS": "Ps.73,Job.14,1Thess.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 87,36:5\u201310",
                        "readQS": "Psalm+87,36:5-10",
                        "audioQS": "Ps.87,36"
                    },
                    {
                        "pretty": "Zechariah 8:1\u201313",
                        "readQS": "Zechariah+8:1-13",
                        "audioQS": "Zech.8"
                    },
                    {
                        "pretty": "Revelation 21:22\u201322:5",
                        "readQS": "Revelation+21:22-22:5",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+87,36:5-10%3B+Zechariah+8:1-13%3B+Revelation+21:22-22:5",
                "audioQS": "Ps.87,36,Zech.8,Rev.21",
                "note": null
            }
        ]
    },
    "2026/05/11": {
        "datePretty": "Monday, May 11, 2026",
        "calendar": "Week of 6th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 65",
                        "readQS": "Psalm+65",
                        "audioQS": "Ps.65"
                    },
                    {
                        "pretty": "Numbers 16:1\u201335",
                        "readQS": "Numbers+16:1-35",
                        "audioQS": "Num.16"
                    },
                    {
                        "pretty": "Luke 6:27\u201338",
                        "readQS": "Luke+6:27-38",
                        "audioQS": "Luke.6"
                    }
                ],
                "readQS": "Psalm+65%3B+Numbers+16:1-35%3B+Luke+6:27-38",
                "audioQS": "Ps.65,Num.16,Luke.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 121",
                        "readQS": "Psalm+121",
                        "audioQS": "Ps.121"
                    },
                    {
                        "pretty": "Deuteronomy 26",
                        "readQS": "Deuteronomy+26",
                        "audioQS": "Deut.26"
                    },
                    {
                        "pretty": "1 Peter 4:1\u201311",
                        "readQS": "1+Peter+4:1-11",
                        "audioQS": "1Pet.4"
                    }
                ],
                "readQS": "Psalm+121%3B+Deuteronomy+26%3B+1+Peter+4:1-11",
                "audioQS": "Ps.121,Deut.26,1Pet.4",
                "note": null
            }
        ]
    },
    "2026/05/12": {
        "datePretty": "Tuesday, May 12, 2026",
        "calendar": "Week of 6th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 126",
                        "readQS": "Psalm+126",
                        "audioQS": "Ps.126"
                    },
                    {
                        "pretty": "Numbers 16:36\u2013end",
                        "readQS": "Numbers+16:36-",
                        "audioQS": "Num.16"
                    },
                    {
                        "pretty": "Luke 6:39\u2013end",
                        "readQS": "Luke+6:39-",
                        "audioQS": "Luke.6"
                    }
                ],
                "readQS": "Psalm+126%3B+Numbers+16:36-%3B+Luke+6:39-",
                "audioQS": "Ps.126,Num.16,Luke.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 128",
                        "readQS": "Psalm+128",
                        "audioQS": "Ps.128"
                    },
                    {
                        "pretty": "Deuteronomy 28:1\u201314",
                        "readQS": "Deuteronomy+28:1-14",
                        "audioQS": "Deut.28"
                    },
                    {
                        "pretty": "1 Peter 4:12\u2013end",
                        "readQS": "1+Peter+4:12-",
                        "audioQS": "1Pet.4"
                    }
                ],
                "readQS": "Psalm+128%3B+Deuteronomy+28:1-14%3B+1+Peter+4:12-",
                "audioQS": "Ps.128,Deut.28,1Pet.4",
                "note": null
            }
        ]
    },
    "2026/05/13": {
        "datePretty": "Wednesday, May 13, 2026",
        "calendar": "Week of 6th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Numbers 17:1\u201311",
                        "readQS": "Numbers+17:1-11",
                        "audioQS": "Num.17"
                    },
                    {
                        "pretty": "Luke 7:1\u201310",
                        "readQS": "Luke+7:1-10",
                        "audioQS": "Luke.7"
                    }
                ],
                "readQS": "Psalm+132%3B+Numbers+17:1-11%3B+Luke+7:1-10",
                "audioQS": "Ps.132,Num.17,Luke.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Ascension Day)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 15,24",
                        "readQS": "Psalm+15,24",
                        "audioQS": "Ps.15,24"
                    },
                    {
                        "pretty": "2 Samuel 23:1\u20135",
                        "readQS": "2+Samuel+23:1-5",
                        "audioQS": "2Sam.23"
                    },
                    {
                        "pretty": "Colossians 2:20\u2013end,3:1\u20134",
                        "readQS": "Colossians+2:20-,3:1-4",
                        "audioQS": "Col.2"
                    }
                ],
                "readQS": "Psalm+15,24%3B+2+Samuel+23:1-5%3B+Colossians+2:20-,3:1-4",
                "audioQS": "Ps.15,24,2Sam.23,Col.2",
                "note": null
            }
        ]
    },
    "2026/05/14": {
        "datePretty": "Thursday, May 14, 2026",
        "calendar": "Ascension Day",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Acts 1:1\u201311",
                        "readQS": "Acts+1:1-11",
                        "audioQS": "Acts.1"
                    },
                    {
                        "pretty": "Ephesians 1:15\u201323",
                        "readQS": "Ephesians+1:15-23",
                        "audioQS": "Eph.1"
                    },
                    {
                        "pretty": "Luke 24:44\u201353",
                        "readQS": "Luke+24:44-53",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+47%3B+Acts+1:1-11%3B+Ephesians+1:15-23%3B+Luke+24:44-53",
                "audioQS": "Ps.47,Acts.1,Eph.1,Luke.24",
                "note": "These readings can be used on the Sunday after Ascension day."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 110",
                        "readQS": "Psalm+110",
                        "audioQS": "Ps.110"
                    },
                    {
                        "pretty": "Isaiah 52:7\u201315",
                        "readQS": "Isaiah+52:7-15",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Hebrews 7:(11\u201325),26\u201328",
                        "readQS": "Hebrews+7:%2811-25%29,26-28",
                        "audioQS": "Heb.7"
                    }
                ],
                "readQS": "Psalm+110%3B+Isaiah+52:7-15%3B+Hebrews+7:%2811-25%29,26-28",
                "audioQS": "Ps.110,Isa.52,Heb.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 8",
                        "readQS": "Psalm+8",
                        "audioQS": "Ps.8"
                    },
                    {
                        "pretty": "2 Kings 2:1\u201315",
                        "readQS": "2+Kings+2:1-15",
                        "audioQS": "2Kgs.2"
                    },
                    {
                        "pretty": "Revelation 5",
                        "readQS": "Revelation+5",
                        "audioQS": "Rev.5"
                    }
                ],
                "readQS": "Psalm+8%3B+2+Kings+2:1-15%3B+Revelation+5",
                "audioQS": "Ps.8,2Kgs.2,Rev.5",
                "note": null
            }
        ]
    },
    "2026/05/15": {
        "datePretty": "Friday, May 15, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 81",
                        "readQS": "Psalm+81",
                        "audioQS": "Ps.81"
                    },
                    {
                        "pretty": "Numbers 20:1\u201313",
                        "readQS": "Numbers+20:1-13",
                        "audioQS": "Num.20"
                    },
                    {
                        "pretty": "Luke 7:11\u201317",
                        "readQS": "Luke+7:11-17",
                        "audioQS": "Luke.7"
                    }
                ],
                "readQS": "Psalm+81%3B+Numbers+20:1-13%3B+Luke+7:11-17",
                "audioQS": "Ps.81,Num.20,Luke.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Deuteronomy 29:2\u201315",
                        "readQS": "Deuteronomy+29:2-15",
                        "audioQS": "Deut.29"
                    },
                    {
                        "pretty": "1 John 1:1\u20132:6",
                        "readQS": "1+John+1:1-2:6",
                        "audioQS": "1John.1"
                    }
                ],
                "readQS": "Psalm+145%3B+Deuteronomy+29:2-15%3B+1+John+1:1-2:6",
                "audioQS": "Ps.145,Deut.29,1John.1",
                "note": null
            }
        ]
    },
    "2026/05/16": {
        "datePretty": "Saturday, May 16, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Numbers 21:4\u20139",
                        "readQS": "Numbers+21:4-9",
                        "audioQS": "Num.21"
                    },
                    {
                        "pretty": "Luke 7:18\u201335",
                        "readQS": "Luke+7:18-35",
                        "audioQS": "Luke.7"
                    }
                ],
                "readQS": "Psalm+47%3B+Numbers+21:4-9%3B+Luke+7:18-35",
                "audioQS": "Ps.47,Num.21,Luke.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Deuteronomy 30",
                        "readQS": "Deuteronomy+30",
                        "audioQS": "Deut.30"
                    },
                    {
                        "pretty": "1 John 2:7\u201317",
                        "readQS": "1+John+2:7-17",
                        "audioQS": "1John.2"
                    }
                ],
                "readQS": "Psalm+85%3B+Deuteronomy+30%3B+1+John+2:7-17",
                "audioQS": "Ps.85,Deut.30,1John.2",
                "note": null
            }
        ]
    },
    "2026/05/17": {
        "datePretty": "Sunday, May 17, 2026",
        "calendar": "7th Sunday of Easter",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 68:1\u201310,32\u201335",
                        "readQS": "Psalm+68:1-10,32-35",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Acts 1:6\u201314",
                        "readQS": "Acts+1:6-14",
                        "audioQS": "Acts.1"
                    },
                    {
                        "pretty": "1 Peter 4:12\u201314,5:6\u201311",
                        "readQS": "1+Peter+4:12-14,5:6-11",
                        "audioQS": "1Pet.4"
                    },
                    {
                        "pretty": "John 17:1\u201311",
                        "readQS": "John+17:1-11",
                        "audioQS": "John.17"
                    }
                ],
                "readQS": "Psalm+68:1-10,32-35%3B+Acts+1:6-14%3B+1+Peter+4:12-14,5:6-11%3B+John+17:1-11",
                "audioQS": "Ps.68,Acts.1,1Pet.4,John.17",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "Ascension",
                "readingSetSubtitle": "RCL (Readings from Ascension Day)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Acts 1:1\u201311",
                        "readQS": "Acts+1:1-11",
                        "audioQS": "Acts.1"
                    },
                    {
                        "pretty": "Ephesians 1:15\u201323",
                        "readQS": "Ephesians+1:15-23",
                        "audioQS": "Eph.1"
                    },
                    {
                        "pretty": "Luke 24:44\u201353",
                        "readQS": "Luke+24:44-53",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+47%3B+Acts+1:1-11%3B+Ephesians+1:15-23%3B+Luke+24:44-53",
                "audioQS": "Ps.47,Acts.1,Eph.1,Luke.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 104:26\u201335",
                        "readQS": "Psalm+104:26-35",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Isaiah 65:17\u201325",
                        "readQS": "Isaiah+65:17-25",
                        "audioQS": "Isa.65"
                    },
                    {
                        "pretty": "Revelation 21:1\u20138",
                        "readQS": "Revelation+21:1-8",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+104:26-35%3B+Isaiah+65:17-25%3B+Revelation+21:1-8",
                "audioQS": "Ps.104,Isa.65,Rev.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "2 Samuel 23:1\u20135",
                        "readQS": "2+Samuel+23:1-5",
                        "audioQS": "2Sam.23"
                    },
                    {
                        "pretty": "Ephesians 1:15\u201323",
                        "readQS": "Ephesians+1:15-23",
                        "audioQS": "Eph.1"
                    }
                ],
                "readQS": "Psalm+47%3B+2+Samuel+23:1-5%3B+Ephesians+1:15-23",
                "audioQS": "Ps.47,2Sam.23,Eph.1",
                "note": null
            }
        ]
    },
    "2026/05/18": {
        "datePretty": "Monday, May 18, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 93",
                        "readQS": "Psalm+93",
                        "audioQS": "Ps.93"
                    },
                    {
                        "pretty": "Numbers 22:1\u201335",
                        "readQS": "Numbers+22:1-35",
                        "audioQS": "Num.22"
                    },
                    {
                        "pretty": "Luke 7:36\u2013end",
                        "readQS": "Luke+7:36-",
                        "audioQS": "Luke.7"
                    }
                ],
                "readQS": "Psalm+93%3B+Numbers+22:1-35%3B+Luke+7:36-",
                "audioQS": "Ps.93,Num.22,Luke.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 18",
                        "readQS": "Psalm+18",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "Deuteronomy 31:1\u201313",
                        "readQS": "Deuteronomy+31:1-13",
                        "audioQS": "Deut.31"
                    },
                    {
                        "pretty": "1 John 2:18\u2013end",
                        "readQS": "1+John+2:18-",
                        "audioQS": "1John.2"
                    }
                ],
                "readQS": "Psalm+18%3B+Deuteronomy+31:1-13%3B+1+John+2:18-",
                "audioQS": "Ps.18,Deut.31,1John.2",
                "note": null
            }
        ]
    },
    "2026/05/19": {
        "datePretty": "Tuesday, May 19, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 99",
                        "readQS": "Psalm+99",
                        "audioQS": "Ps.99"
                    },
                    {
                        "pretty": "Numbers 22:36\u201323:12",
                        "readQS": "Numbers+22:36-23:12",
                        "audioQS": "Num.22"
                    },
                    {
                        "pretty": "Luke 8:1\u201315",
                        "readQS": "Luke+8:1-15",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+99%3B+Numbers+22:36-23:12%3B+Luke+8:1-15",
                "audioQS": "Ps.99,Num.22,Luke.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 68",
                        "readQS": "Psalm+68",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Deuteronomy 31:14\u201329",
                        "readQS": "Deuteronomy+31:14-29",
                        "audioQS": "Deut.31"
                    },
                    {
                        "pretty": "1 John 3:1\u201310",
                        "readQS": "1+John+3:1-10",
                        "audioQS": "1John.3"
                    }
                ],
                "readQS": "Psalm+68%3B+Deuteronomy+31:14-29%3B+1+John+3:1-10",
                "audioQS": "Ps.68,Deut.31,1John.3",
                "note": null
            }
        ]
    },
    "2026/05/20": {
        "datePretty": "Wednesday, May 20, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 29",
                        "readQS": "Psalm+29",
                        "audioQS": "Ps.29"
                    },
                    {
                        "pretty": "Numbers 23:13\u2013end",
                        "readQS": "Numbers+23:13-",
                        "audioQS": "Num.23"
                    },
                    {
                        "pretty": "Luke 8:16\u201325",
                        "readQS": "Luke+8:16-25",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+29%3B+Numbers+23:13-%3B+Luke+8:16-25",
                "audioQS": "Ps.29,Num.23,Luke.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Deuteronomy 31:30\u201332:14",
                        "readQS": "Deuteronomy+31:30-32:14",
                        "audioQS": "Deut.31"
                    },
                    {
                        "pretty": "1 John 3:11\u2013end",
                        "readQS": "1+John+3:11-",
                        "audioQS": "1John.3"
                    }
                ],
                "readQS": "Psalm+46%3B+Deuteronomy+31:30-32:14%3B+1+John+3:11-",
                "audioQS": "Ps.46,Deut.31,1John.3",
                "note": null
            }
        ]
    },
    "2026/05/21": {
        "datePretty": "Thursday, May 21, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 24",
                        "readQS": "Psalm+24",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "Numbers 24",
                        "readQS": "Numbers+24",
                        "audioQS": "Num.24"
                    },
                    {
                        "pretty": "Luke 8:26\u201339",
                        "readQS": "Luke+8:26-39",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+24%3B+Numbers+24%3B+Luke+8:26-39",
                "audioQS": "Ps.24,Num.24,Luke.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Deuteronomy 32:15\u201347",
                        "readQS": "Deuteronomy+32:15-47",
                        "audioQS": "Deut.32"
                    },
                    {
                        "pretty": "1 John 4:1\u20136",
                        "readQS": "1+John+4:1-6",
                        "audioQS": "1John.4"
                    }
                ],
                "readQS": "Psalm+139%3B+Deuteronomy+32:15-47%3B+1+John+4:1-6",
                "audioQS": "Ps.139,Deut.32,1John.4",
                "note": null
            }
        ]
    },
    "2026/05/22": {
        "datePretty": "Friday, May 22, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 28",
                        "readQS": "Psalm+28",
                        "audioQS": "Ps.28"
                    },
                    {
                        "pretty": "Numbers 27:12\u2013end",
                        "readQS": "Numbers+27:12-",
                        "audioQS": "Num.27"
                    },
                    {
                        "pretty": "Luke 8:40\u2013end",
                        "readQS": "Luke+8:40-",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+28%3B+Numbers+27:12-%3B+Luke+8:40-",
                "audioQS": "Ps.28,Num.27,Luke.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 147",
                        "readQS": "Psalm+147",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "Deuteronomy 33",
                        "readQS": "Deuteronomy+33",
                        "audioQS": "Deut.33"
                    },
                    {
                        "pretty": "1 John 4:7\u2013end",
                        "readQS": "1+John+4:7-",
                        "audioQS": "1John.4"
                    }
                ],
                "readQS": "Psalm+147%3B+Deuteronomy+33%3B+1+John+4:7-",
                "audioQS": "Ps.147,Deut.33,1John.4",
                "note": null
            }
        ]
    },
    "2026/05/23": {
        "datePretty": "Saturday, May 23, 2026",
        "calendar": "10 days between Ascension Day and Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 43",
                        "readQS": "Psalm+43",
                        "audioQS": "Ps.43"
                    },
                    {
                        "pretty": "Numbers 32:1\u201327",
                        "readQS": "Numbers+32:1-27",
                        "audioQS": "Num.32"
                    },
                    {
                        "pretty": "Luke 9:1\u201317",
                        "readQS": "Luke+9:1-17",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+43%3B+Numbers+32:1-27%3B+Luke+9:1-17",
                "audioQS": "Ps.43,Num.32,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Pentecost)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "Deuteronomy 16:9\u201315",
                        "readQS": "Deuteronomy+16:9-15",
                        "audioQS": "Deut.16"
                    },
                    {
                        "pretty": "John 15:26\u201316:15",
                        "readQS": "John+15:26-16:15",
                        "audioQS": "John.15"
                    }
                ],
                "readQS": "Psalm+48%3B+Deuteronomy+16:9-15%3B+John+15:26-16:15",
                "audioQS": "Ps.48,Deut.16,John.15",
                "note": null
            }
        ]
    },
    "2026/05/24": {
        "datePretty": "Sunday, May 24, 2026",
        "calendar": "Day of Pentecost",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 104:26\u201336,37b",
                        "readQS": "Psalm+104:26-36,37b",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Acts 2:1\u201321",
                        "readQS": "Acts+2:1-21",
                        "audioQS": "Acts.2"
                    },
                    {
                        "pretty": "1 Corinthians 12:3b\u201313",
                        "readQS": "1+Corinthians+12:3b-13",
                        "audioQS": "1Cor.12"
                    },
                    {
                        "pretty": "John 20:19\u201323",
                        "readQS": "John+20:19-23",
                        "audioQS": "John.20"
                    }
                ],
                "readQS": "Psalm+104:26-36,37b%3B+Acts+2:1-21%3B+1+Corinthians+12:3b-13%3B+John+20:19-23",
                "audioQS": "Ps.104,Acts.2,1Cor.12,John.20",
                "note": "The reading from Acts must be used as either the first or second reading."
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 87",
                        "readQS": "Psalm+87",
                        "audioQS": "Ps.87"
                    },
                    {
                        "pretty": "Genesis 11:1\u20139",
                        "readQS": "Genesis+11:1-9",
                        "audioQS": "Gen.11"
                    },
                    {
                        "pretty": "Acts 10:34\u201348",
                        "readQS": "Acts+10:34-48",
                        "audioQS": "Acts.10"
                    }
                ],
                "readQS": "Psalm+87%3B+Genesis+11:1-9%3B+Acts+10:34-48",
                "audioQS": "Ps.87,Gen.11,Acts.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 67,133",
                        "readQS": "Psalm+67,133",
                        "audioQS": "Ps.67,133"
                    },
                    {
                        "pretty": "Joel 2:21\u201332",
                        "readQS": "Joel+2:21-32",
                        "audioQS": "Joel.2"
                    },
                    {
                        "pretty": "Acts 2:14\u201321,(22\u201338)",
                        "readQS": "Acts+2:14-21,%2822-38%29",
                        "audioQS": "Acts.2"
                    }
                ],
                "readQS": "Psalm+67,133%3B+Joel+2:21-32%3B+Acts+2:14-21,%2822-38%29",
                "audioQS": "Ps.67,133,Joel.2,Acts.2",
                "note": null
            }
        ]
    },
    "2026/05/25": {
        "datePretty": "Monday, May 25, 2026",
        "calendar": "Week after Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 126",
                        "readQS": "Psalm+126",
                        "audioQS": "Ps.126"
                    },
                    {
                        "pretty": "Joshua 1",
                        "readQS": "Joshua+1",
                        "audioQS": "Josh.1"
                    },
                    {
                        "pretty": "Luke 9:18\u201327",
                        "readQS": "Luke+9:18-27",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+126%3B+Joshua+1%3B+Luke+9:18-27",
                "audioQS": "Ps.126,Josh.1,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 127",
                        "readQS": "Psalm+127",
                        "audioQS": "Ps.127"
                    },
                    {
                        "pretty": "2 Chronicles 17:1\u201312",
                        "readQS": "2+Chronicles+17:1-12",
                        "audioQS": "2Chr.17"
                    },
                    {
                        "pretty": "Romans 1:1\u201317",
                        "readQS": "Romans+1:1-17",
                        "audioQS": "Rom.1"
                    }
                ],
                "readQS": "Psalm+127%3B+2+Chronicles+17:1-12%3B+Romans+1:1-17",
                "audioQS": "Ps.127,2Chr.17,Rom.1",
                "note": null
            }
        ]
    },
    "2026/05/26": {
        "datePretty": "Tuesday, May 26, 2026",
        "calendar": "Week after Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Joshua 2",
                        "readQS": "Joshua+2",
                        "audioQS": "Josh.2"
                    },
                    {
                        "pretty": "Luke 9:28\u201336",
                        "readQS": "Luke+9:28-36",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+132%3B+Joshua+2%3B+Luke+9:28-36",
                "audioQS": "Ps.132,Josh.2,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "2 Chronicles 18:1\u201327",
                        "readQS": "2+Chronicles+18:1-27",
                        "audioQS": "2Chr.18"
                    },
                    {
                        "pretty": "Romans 1:18\u2013end",
                        "readQS": "Romans+1:18-",
                        "audioQS": "Rom.1"
                    }
                ],
                "readQS": "Psalm+135%3B+2+Chronicles+18:1-27%3B+Romans+1:18-",
                "audioQS": "Ps.135,2Chr.18,Rom.1",
                "note": null
            }
        ]
    },
    "2026/05/27": {
        "datePretty": "Wednesday, May 27, 2026",
        "calendar": "Week after Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:153\u2013end",
                        "readQS": "Psalm+119:153-",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Joshua 3",
                        "readQS": "Joshua+3",
                        "audioQS": "Josh.3"
                    },
                    {
                        "pretty": "Luke 9:37\u201350",
                        "readQS": "Luke+9:37-50",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+119:153-%3B+Joshua+3%3B+Luke+9:37-50",
                "audioQS": "Ps.119,Josh.3,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "2 Chronicles 18:28\u2013end",
                        "readQS": "2+Chronicles+18:28-",
                        "audioQS": "2Chr.18"
                    },
                    {
                        "pretty": "2 Chronicles 19",
                        "readQS": "2+Chronicles+19",
                        "audioQS": "2Chr.19"
                    },
                    {
                        "pretty": "Romans 2:1\u201316",
                        "readQS": "Romans+2:1-16",
                        "audioQS": "Rom.2"
                    }
                ],
                "readQS": "Psalm+136%3B+2+Chronicles+18:28-%3B+2+Chronicles+19%3B+Romans+2:1-16",
                "audioQS": "Ps.136,2Chr.18,2Chr.19,Rom.2",
                "note": null
            }
        ]
    },
    "2026/05/28": {
        "datePretty": "Thursday, May 28, 2026",
        "calendar": "Week after Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 143",
                        "readQS": "Psalm+143",
                        "audioQS": "Ps.143"
                    },
                    {
                        "pretty": "Joshua 4:1\u20135:1",
                        "readQS": "Joshua+4:1-5:1",
                        "audioQS": "Josh.4"
                    },
                    {
                        "pretty": "Luke 9:51\u2013end",
                        "readQS": "Luke+9:51-",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+143%3B+Joshua+4:1-5:1%3B+Luke+9:51-",
                "audioQS": "Ps.143,Josh.4,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "2 Chronicles 20:1\u201323",
                        "readQS": "2+Chronicles+20:1-23",
                        "audioQS": "2Chr.20"
                    },
                    {
                        "pretty": "Romans 2:17\u2013end",
                        "readQS": "Romans+2:17-",
                        "audioQS": "Rom.2"
                    }
                ],
                "readQS": "Psalm+138%3B+2+Chronicles+20:1-23%3B+Romans+2:17-",
                "audioQS": "Ps.138,2Chr.20,Rom.2",
                "note": null
            }
        ]
    },
    "2026/05/29": {
        "datePretty": "Friday, May 29, 2026",
        "calendar": "Week after Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "Joshua 5:2\u2013end",
                        "readQS": "Joshua+5:2-",
                        "audioQS": "Josh.5"
                    },
                    {
                        "pretty": "Luke 10:1\u201316",
                        "readQS": "Luke+10:1-16",
                        "audioQS": "Luke.10"
                    }
                ],
                "readQS": "Psalm+144%3B+Joshua+5:2-%3B+Luke+10:1-16",
                "audioQS": "Ps.144,Josh.5,Luke.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "2 Chronicles 22:10\u2013end",
                        "readQS": "2+Chronicles+22:10-",
                        "audioQS": "2Chr.22"
                    },
                    {
                        "pretty": "2 Chronicles 23",
                        "readQS": "2+Chronicles+23",
                        "audioQS": "2Chr.23"
                    },
                    {
                        "pretty": "Romans 3:1\u201320",
                        "readQS": "Romans+3:1-20",
                        "audioQS": "Rom.3"
                    }
                ],
                "readQS": "Psalm+145%3B+2+Chronicles+22:10-%3B+2+Chronicles+23%3B+Romans+3:1-20",
                "audioQS": "Ps.145,2Chr.22,2Chr.23,Rom.3",
                "note": null
            }
        ]
    },
    "2026/05/30": {
        "datePretty": "Saturday, May 30, 2026",
        "calendar": "Week after Pentecost",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 147",
                        "readQS": "Psalm+147",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "Joshua 6:1\u201320",
                        "readQS": "Joshua+6:1-20",
                        "audioQS": "Josh.6"
                    },
                    {
                        "pretty": "Luke 10:17\u201324",
                        "readQS": "Luke+10:17-24",
                        "audioQS": "Luke.10"
                    }
                ],
                "readQS": "Psalm+147%3B+Joshua+6:1-20%3B+Luke+10:17-24",
                "audioQS": "Ps.147,Josh.6,Luke.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Trinity Sunday)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 97,98",
                        "readQS": "Psalm+97,98",
                        "audioQS": "Ps.97,98"
                    },
                    {
                        "pretty": "Exodus 34:1\u201310",
                        "readQS": "Exodus+34:1-10",
                        "audioQS": "Exod.34"
                    },
                    {
                        "pretty": "Mark 1:1\u201313",
                        "readQS": "Mark+1:1-13",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+97,98%3B+Exodus+34:1-10%3B+Mark+1:1-13",
                "audioQS": "Ps.97,98,Exod.34,Mark.1",
                "note": null
            }
        ]
    },
    "2026/05/31": {
        "datePretty": "Sunday, May 31, 2026",
        "calendar": "Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 8",
                        "readQS": "Psalm+8",
                        "audioQS": "Ps.8"
                    },
                    {
                        "pretty": "Isaiah 40:12\u201317,27\u201331",
                        "readQS": "Isaiah+40:12-17,27-31",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "2 Corinthians 13:11\u201313",
                        "readQS": "2+Corinthians+13:11-13",
                        "audioQS": "2Cor.13"
                    },
                    {
                        "pretty": "Matthew 28:16\u201320",
                        "readQS": "Matthew+28:16-20",
                        "audioQS": "Matt.28"
                    }
                ],
                "readQS": "Psalm+8%3B+Isaiah+40:12-17,27-31%3B+2+Corinthians+13:11-13%3B+Matthew+28:16-20",
                "audioQS": "Ps.8,Isa.40,2Cor.13,Matt.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 86:8\u201313",
                        "readQS": "Psalm+86:8-13",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Exodus 3:1\u20136,13\u201315",
                        "readQS": "Exodus+3:1-6,13-15",
                        "audioQS": "Exod.3"
                    },
                    {
                        "pretty": "John 17:1\u201311",
                        "readQS": "John+17:1-11",
                        "audioQS": "John.17"
                    }
                ],
                "readQS": "Psalm+86:8-13%3B+Exodus+3:1-6,13-15%3B+John+17:1-11",
                "audioQS": "Ps.86,Exod.3,John.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 93,150",
                        "readQS": "Psalm+93,150",
                        "audioQS": "Ps.93,150"
                    },
                    {
                        "pretty": "Isaiah 6:1\u20138",
                        "readQS": "Isaiah+6:1-8",
                        "audioQS": "Isa.6"
                    },
                    {
                        "pretty": "John 16:5\u201315",
                        "readQS": "John+16:5-15",
                        "audioQS": "John.16"
                    }
                ],
                "readQS": "Psalm+93,150%3B+Isaiah+6:1-8%3B+John+16:5-15",
                "audioQS": "Ps.93,150,Isa.6,John.16",
                "note": null
            }
        ]
    },
    "2026/06/01": {
        "datePretty": "Monday, June 1, 2026",
        "calendar": "Week of Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 1",
                        "readQS": "Psalm+1",
                        "audioQS": "Ps.1"
                    },
                    {
                        "pretty": "Joshua 7:1\u201315",
                        "readQS": "Joshua+7:1-15",
                        "audioQS": "Josh.7"
                    },
                    {
                        "pretty": "Luke 10:25\u201337",
                        "readQS": "Luke+10:25-37",
                        "audioQS": "Luke.10"
                    }
                ],
                "readQS": "Psalm+1%3B+Joshua+7:1-15%3B+Luke+10:25-37",
                "audioQS": "Ps.1,Josh.7,Luke.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 4",
                        "readQS": "Psalm+4",
                        "audioQS": "Ps.4"
                    },
                    {
                        "pretty": "2 Chronicles 26:1\u201321",
                        "readQS": "2+Chronicles+26:1-21",
                        "audioQS": "2Chr.26"
                    },
                    {
                        "pretty": "Romans 4:1\u201312",
                        "readQS": "Romans+4:1-12",
                        "audioQS": "Rom.4"
                    }
                ],
                "readQS": "Psalm+4%3B+2+Chronicles+26:1-21%3B+Romans+4:1-12",
                "audioQS": "Ps.4,2Chr.26,Rom.4",
                "note": null
            }
        ]
    },
    "2026/06/02": {
        "datePretty": "Tuesday, June 2, 2026",
        "calendar": "Week of Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "Joshua 7:16\u2013end",
                        "readQS": "Joshua+7:16-",
                        "audioQS": "Josh.7"
                    },
                    {
                        "pretty": "Luke 10:38\u2013end",
                        "readQS": "Luke+10:38-",
                        "audioQS": "Luke.10"
                    }
                ],
                "readQS": "Psalm+5%3B+Joshua+7:16-%3B+Luke+10:38-",
                "audioQS": "Ps.5,Josh.7,Luke.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "2 Chronicles 28",
                        "readQS": "2+Chronicles+28",
                        "audioQS": "2Chr.28"
                    },
                    {
                        "pretty": "Romans 4:13\u2013end",
                        "readQS": "Romans+4:13-",
                        "audioQS": "Rom.4"
                    }
                ],
                "readQS": "Psalm+9%3B+2+Chronicles+28%3B+Romans+4:13-",
                "audioQS": "Ps.9,2Chr.28,Rom.4",
                "note": null
            }
        ]
    },
    "2026/06/03": {
        "datePretty": "Wednesday, June 3, 2026",
        "calendar": "Week of Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:1\u201332",
                        "readQS": "Psalm+119:1-32",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Joshua 8:1\u201329",
                        "readQS": "Joshua+8:1-29",
                        "audioQS": "Josh.8"
                    },
                    {
                        "pretty": "Luke 11:1\u201313",
                        "readQS": "Luke+11:1-13",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+119:1-32%3B+Joshua+8:1-29%3B+Luke+11:1-13",
                "audioQS": "Ps.119,Josh.8,Luke.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "2 Chronicles 29:1\u201319",
                        "readQS": "2+Chronicles+29:1-19",
                        "audioQS": "2Chr.29"
                    },
                    {
                        "pretty": "Romans 5:1\u201311",
                        "readQS": "Romans+5:1-11",
                        "audioQS": "Rom.5"
                    }
                ],
                "readQS": "Psalm+11%3B+2+Chronicles+29:1-19%3B+Romans+5:1-11",
                "audioQS": "Ps.11,2Chr.29,Rom.5",
                "note": null
            }
        ]
    },
    "2026/06/04": {
        "datePretty": "Thursday, June 4, 2026",
        "calendar": "Week of Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15",
                        "readQS": "Psalm+15",
                        "audioQS": "Ps.15"
                    },
                    {
                        "pretty": "Joshua 8:30\u2013end",
                        "readQS": "Joshua+8:30-",
                        "audioQS": "Josh.8"
                    },
                    {
                        "pretty": "Luke 11:14\u201328",
                        "readQS": "Luke+11:14-28",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+15%3B+Joshua+8:30-%3B+Luke+11:14-28",
                "audioQS": "Ps.15,Josh.8,Luke.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 18",
                        "readQS": "Psalm+18",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "2 Chronicles 29:20\u2013end",
                        "readQS": "2+Chronicles+29:20-",
                        "audioQS": "2Chr.29"
                    },
                    {
                        "pretty": "Romans 5:12\u2013end",
                        "readQS": "Romans+5:12-",
                        "audioQS": "Rom.5"
                    }
                ],
                "readQS": "Psalm+18%3B+2+Chronicles+29:20-%3B+Romans+5:12-",
                "audioQS": "Ps.18,2Chr.29,Rom.5",
                "note": null
            }
        ]
    },
    "2026/06/05": {
        "datePretty": "Friday, June 5, 2026",
        "calendar": "Week of Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Joshua 9:3\u201326",
                        "readQS": "Joshua+9:3-26",
                        "audioQS": "Josh.9"
                    },
                    {
                        "pretty": "Luke 11:29\u201336",
                        "readQS": "Luke+11:29-36",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+19%3B+Joshua+9:3-26%3B+Luke+11:29-36",
                "audioQS": "Ps.19,Josh.9,Luke.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "2 Chronicles 30",
                        "readQS": "2+Chronicles+30",
                        "audioQS": "2Chr.30"
                    },
                    {
                        "pretty": "Romans 6:1\u201314",
                        "readQS": "Romans+6:1-14",
                        "audioQS": "Rom.6"
                    }
                ],
                "readQS": "Psalm+22%3B+2+Chronicles+30%3B+Romans+6:1-14",
                "audioQS": "Ps.22,2Chr.30,Rom.6",
                "note": null
            }
        ]
    },
    "2026/06/06": {
        "datePretty": "Saturday, June 6, 2026",
        "calendar": "Week of Trinity Sunday",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Joshua 10:1\u201315",
                        "readQS": "Joshua+10:1-15",
                        "audioQS": "Josh.10"
                    },
                    {
                        "pretty": "Luke 11:37\u2013end",
                        "readQS": "Luke+11:37-",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+23%3B+Joshua+10:1-15%3B+Luke+11:37-",
                "audioQS": "Ps.23,Josh.10,Luke.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 24",
                        "readQS": "Psalm+24",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "2 Chronicles 32:1\u201322",
                        "readQS": "2+Chronicles+32:1-22",
                        "audioQS": "2Chr.32"
                    },
                    {
                        "pretty": "Romans 6:15\u2013end",
                        "readQS": "Romans+6:15-",
                        "audioQS": "Rom.6"
                    }
                ],
                "readQS": "Psalm+24%3B+2+Chronicles+32:1-22%3B+Romans+6:15-",
                "audioQS": "Ps.24,2Chr.32,Rom.6",
                "note": null
            }
        ]
    },
    "2026/06/07": {
        "datePretty": "Sunday, June 7, 2026",
        "calendar": "10th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 50:7\u201315",
                        "readQS": "Psalm+50:7-15",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Hosea 5:15\u20136:6",
                        "readQS": "Hosea+5:15-6:6",
                        "audioQS": "Hos.5"
                    },
                    {
                        "pretty": "Romans 4:13\u201325",
                        "readQS": "Romans+4:13-25",
                        "audioQS": "Rom.4"
                    },
                    {
                        "pretty": "Matthew 9:9\u201313,18\u201326",
                        "readQS": "Matthew+9:9-13,18-26",
                        "audioQS": "Matt.9"
                    }
                ],
                "readQS": "Psalm+50:7-15%3B+Hosea+5:15-6:6%3B+Romans+4:13-25%3B+Matthew+9:9-13,18-26",
                "audioQS": "Ps.50,Hos.5,Rom.4,Matt.9",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 33:1\u201312",
                        "readQS": "Psalm+33:1-12",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Genesis 12:1\u20139",
                        "readQS": "Genesis+12:1-9",
                        "audioQS": "Gen.12"
                    },
                    {
                        "pretty": "Romans 4:13\u201325",
                        "readQS": "Romans+4:13-25",
                        "audioQS": "Rom.4"
                    },
                    {
                        "pretty": "Matthew 9:9\u201313,18\u201326",
                        "readQS": "Matthew+9:9-13,18-26",
                        "audioQS": "Matt.9"
                    }
                ],
                "readQS": "Psalm+33:1-12%3B+Genesis+12:1-9%3B+Romans+4:13-25%3B+Matthew+9:9-13,18-26",
                "audioQS": "Ps.33,Gen.12,Rom.4,Matt.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 38",
                        "readQS": "Psalm+38",
                        "audioQS": "Ps.38"
                    },
                    {
                        "pretty": "Deuteronomy 6:10\u201325",
                        "readQS": "Deuteronomy+6:10-25",
                        "audioQS": "Deut.6"
                    },
                    {
                        "pretty": "Acts 22:22\u201323:11",
                        "readQS": "Acts+22:22-23:11",
                        "audioQS": "Acts.22"
                    }
                ],
                "readQS": "Psalm+38%3B+Deuteronomy+6:10-25%3B+Acts+22:22-23:11",
                "audioQS": "Ps.38,Deut.6,Acts.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 41",
                        "readQS": "Psalm+41",
                        "audioQS": "Ps.41"
                    },
                    {
                        "pretty": "1 Samuel 18:1\u201316",
                        "readQS": "1+Samuel+18:1-16",
                        "audioQS": "1Sam.18"
                    },
                    {
                        "pretty": "Luke 8:41\u201356",
                        "readQS": "Luke+8:41-56",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+41%3B+1+Samuel+18:1-16%3B+Luke+8:41-56",
                "audioQS": "Ps.41,1Sam.18,Luke.8",
                "note": null
            }
        ]
    },
    "2026/06/08": {
        "datePretty": "Monday, June 8, 2026",
        "calendar": "Week of 10th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "Joshua 14",
                        "readQS": "Joshua+14",
                        "audioQS": "Josh.14"
                    },
                    {
                        "pretty": "Luke 12:1\u201312",
                        "readQS": "Luke+12:1-12",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+30%3B+Joshua+14%3B+Luke+12:1-12",
                "audioQS": "Ps.30,Josh.14,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 28",
                        "readQS": "Psalm+28",
                        "audioQS": "Ps.28"
                    },
                    {
                        "pretty": "2 Chronicles 33:1\u201313",
                        "readQS": "2+Chronicles+33:1-13",
                        "audioQS": "2Chr.33"
                    },
                    {
                        "pretty": "Romans 7:1\u20136",
                        "readQS": "Romans+7:1-6",
                        "audioQS": "Rom.7"
                    }
                ],
                "readQS": "Psalm+28%3B+2+Chronicles+33:1-13%3B+Romans+7:1-6",
                "audioQS": "Ps.28,2Chr.33,Rom.7",
                "note": null
            }
        ]
    },
    "2026/06/09": {
        "datePretty": "Tuesday, June 9, 2026",
        "calendar": "Week of 10th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "Joshua 21:43\u201322:8",
                        "readQS": "Joshua+21:43-22:8",
                        "audioQS": "Josh.21"
                    },
                    {
                        "pretty": "Luke 12:13\u201321",
                        "readQS": "Luke+12:13-21",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+36%3B+Joshua+21:43-22:8%3B+Luke+12:13-21",
                "audioQS": "Ps.36,Josh.21,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "2 Chronicles 34:1\u201318",
                        "readQS": "2+Chronicles+34:1-18",
                        "audioQS": "2Chr.34"
                    },
                    {
                        "pretty": "Romans 7:7\u2013end",
                        "readQS": "Romans+7:7-",
                        "audioQS": "Rom.7"
                    }
                ],
                "readQS": "Psalm+33%3B+2+Chronicles+34:1-18%3B+Romans+7:7-",
                "audioQS": "Ps.33,2Chr.34,Rom.7",
                "note": null
            }
        ]
    },
    "2026/06/10": {
        "datePretty": "Wednesday, June 10, 2026",
        "calendar": "Week of 10th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Joshua 22:9\u2013end",
                        "readQS": "Joshua+22:9-",
                        "audioQS": "Josh.22"
                    },
                    {
                        "pretty": "Luke 12:22\u201331",
                        "readQS": "Luke+12:22-31",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+34%3B+Joshua+22:9-%3B+Luke+12:22-31",
                "audioQS": "Ps.34,Josh.22,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Barnabas)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 1,15",
                        "readQS": "Psalm+1,15",
                        "audioQS": "Ps.1,15"
                    },
                    {
                        "pretty": "Isaiah 42:5\u201312",
                        "readQS": "Isaiah+42:5-12",
                        "audioQS": "Isa.42"
                    },
                    {
                        "pretty": "Acts 14:8\u201328",
                        "readQS": "Acts+14:8-28",
                        "audioQS": "Acts.14"
                    }
                ],
                "readQS": "Psalm+1,15%3B+Isaiah+42:5-12%3B+Acts+14:8-28",
                "audioQS": "Ps.1,15,Isa.42,Acts.14",
                "note": null
            }
        ]
    },
    "2026/06/11": {
        "datePretty": "Thursday, June 11, 2026",
        "calendar": "Barnabas the Apostle",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 100,101,117",
                        "readQS": "Psalm+100,101,117",
                        "audioQS": "Ps.100,101,117"
                    },
                    {
                        "pretty": "Jeremaiah 9:23\u201324",
                        "readQS": "Jeremaiah+9:23-24",
                        "audioQS": "Jeremaiah 9"
                    },
                    {
                        "pretty": "Acts 4:32\u201337",
                        "readQS": "Acts+4:32-37",
                        "audioQS": "Acts.4"
                    }
                ],
                "readQS": "Psalm+100,101,117%3B+Jeremaiah+9:23-24%3B+Acts+4:32-37",
                "audioQS": "Ps.100,101,117,Jeremaiah 9,Acts.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 147",
                        "readQS": "Psalm+147",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "Ecclesiastes 12:9\u201324",
                        "readQS": "Ecclesiastes+12:9-24",
                        "audioQS": "Eccl.12"
                    },
                    {
                        "pretty": "Acts 9:26\u201331",
                        "readQS": "Acts+9:26-31",
                        "audioQS": "Acts.9"
                    }
                ],
                "readQS": "Psalm+147%3B+Ecclesiastes+12:9-24%3B+Acts+9:26-31",
                "audioQS": "Ps.147,Eccl.12,Acts.9",
                "note": null
            }
        ]
    },
    "2026/06/12": {
        "datePretty": "Friday, June 12, 2026",
        "calendar": "Week of 10th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Joshua 24:1\u201328",
                        "readQS": "Joshua+24:1-28",
                        "audioQS": "Josh.24"
                    },
                    {
                        "pretty": "Luke 12:41\u201348",
                        "readQS": "Luke+12:41-48",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+31%3B+Joshua+24:1-28%3B+Luke+12:41-48",
                "audioQS": "Ps.31,Josh.24,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 35",
                        "readQS": "Psalm+35",
                        "audioQS": "Ps.35"
                    },
                    {
                        "pretty": "2 Chronicles 35:20\u201336:10",
                        "readQS": "2+Chronicles+35:20-36:10",
                        "audioQS": "2Chr.35"
                    },
                    {
                        "pretty": "Romans 8:18\u201330",
                        "readQS": "Romans+8:18-30",
                        "audioQS": "Rom.8"
                    }
                ],
                "readQS": "Psalm+35%3B+2+Chronicles+35:20-36:10%3B+Romans+8:18-30",
                "audioQS": "Ps.35,2Chr.35,Rom.8",
                "note": null
            }
        ]
    },
    "2026/06/13": {
        "datePretty": "Saturday, June 13, 2026",
        "calendar": "Week of 10th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "Joshua 24:29\u2013end",
                        "readQS": "Joshua+24:29-",
                        "audioQS": "Josh.24"
                    },
                    {
                        "pretty": "Luke 12:49\u2013end",
                        "readQS": "Luke+12:49-",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+42%3B+Joshua+24:29-%3B+Luke+12:49-",
                "audioQS": "Ps.42,Josh.24,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "2 Chronicles 36:11\u2013end",
                        "readQS": "2+Chronicles+36:11-",
                        "audioQS": "2Chr.36"
                    },
                    {
                        "pretty": "Romans 8:31\u2013end",
                        "readQS": "Romans+8:31-",
                        "audioQS": "Rom.8"
                    }
                ],
                "readQS": "Psalm+46%3B+2+Chronicles+36:11-%3B+Romans+8:31-",
                "audioQS": "Ps.46,2Chr.36,Rom.8",
                "note": null
            }
        ]
    },
    "2026/06/14": {
        "datePretty": "Sunday, June 14, 2026",
        "calendar": "11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 100",
                        "readQS": "Psalm+100",
                        "audioQS": "Ps.100"
                    },
                    {
                        "pretty": "Exodus 19:2\u20138a",
                        "readQS": "Exodus+19:2-8a",
                        "audioQS": "Exod.19"
                    },
                    {
                        "pretty": "Romans 5:1\u20138",
                        "readQS": "Romans+5:1-8",
                        "audioQS": "Rom.5"
                    },
                    {
                        "pretty": "Matthew 9:35\u201310:8,(9\u201323)",
                        "readQS": "Matthew+9:35-10:8,%289-23%29",
                        "audioQS": "Matt.9"
                    }
                ],
                "readQS": "Psalm+100%3B+Exodus+19:2-8a%3B+Romans+5:1-8%3B+Matthew+9:35-10:8,%289-23%29",
                "audioQS": "Ps.100,Exod.19,Rom.5,Matt.9",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 116:1,10\u201317",
                        "readQS": "Psalm+116:1,10-17",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Genesis 18:1\u201315,(21:1\u20137)",
                        "readQS": "Genesis+18:1-15,%2821:1-7%29",
                        "audioQS": "Gen.18"
                    },
                    {
                        "pretty": "Romans 5:1\u20138",
                        "readQS": "Romans+5:1-8",
                        "audioQS": "Rom.5"
                    },
                    {
                        "pretty": "Matthew 9:35\u201310:8,(9\u201323)",
                        "readQS": "Matthew+9:35-10:8,%289-23%29",
                        "audioQS": "Matt.9"
                    }
                ],
                "readQS": "Psalm+116:1,10-17%3B+Genesis+18:1-15,%2821:1-7%29%3B+Romans+5:1-8%3B+Matthew+9:35-10:8,%289-23%29",
                "audioQS": "Ps.116,Gen.18,Rom.5,Matt.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 45",
                        "readQS": "Psalm+45",
                        "audioQS": "Ps.45"
                    },
                    {
                        "pretty": "Deuteronomy 10:12\u201311:1",
                        "readQS": "Deuteronomy+10:12-11:1",
                        "audioQS": "Deut.10"
                    },
                    {
                        "pretty": "Acts 23:12\u201335",
                        "readQS": "Acts+23:12-35",
                        "audioQS": "Acts.23"
                    }
                ],
                "readQS": "Psalm+45%3B+Deuteronomy+10:12-11:1%3B+Acts+23:12-35",
                "audioQS": "Ps.45,Deut.10,Acts.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 43",
                        "readQS": "Psalm+43",
                        "audioQS": "Ps.43"
                    },
                    {
                        "pretty": "1 Samuel 21:1\u201315",
                        "readQS": "1+Samuel+21:1-15",
                        "audioQS": "1Sam.21"
                    },
                    {
                        "pretty": "Luke 11:14\u201328",
                        "readQS": "Luke+11:14-28",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+43%3B+1+Samuel+21:1-15%3B+Luke+11:14-28",
                "audioQS": "Ps.43,1Sam.21,Luke.11",
                "note": null
            }
        ]
    },
    "2026/06/15": {
        "datePretty": "Monday, June 15, 2026",
        "calendar": "Week of 11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Judges 2",
                        "readQS": "Judges+2",
                        "audioQS": "Judg.2"
                    },
                    {
                        "pretty": "Luke 13:1\u20139",
                        "readQS": "Luke+13:1-9",
                        "audioQS": "Luke.13"
                    }
                ],
                "readQS": "Psalm+44%3B+Judges+2%3B+Luke+13:1-9",
                "audioQS": "Ps.44,Judg.2,Luke.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Ezra 1",
                        "readQS": "Ezra+1",
                        "audioQS": "Ezra.1"
                    },
                    {
                        "pretty": "Romans 9:1\u201318",
                        "readQS": "Romans+9:1-18",
                        "audioQS": "Rom.9"
                    }
                ],
                "readQS": "Psalm+47%3B+Ezra+1%3B+Romans+9:1-18",
                "audioQS": "Ps.47,Ezra.1,Rom.9",
                "note": null
            }
        ]
    },
    "2026/06/16": {
        "datePretty": "Tuesday, June 16, 2026",
        "calendar": "Week of 11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "Judges 4:1\u201323",
                        "readQS": "Judges+4:1-23",
                        "audioQS": "Judg.4"
                    },
                    {
                        "pretty": "Luke 13:10\u201321",
                        "readQS": "Luke+13:10-21",
                        "audioQS": "Luke.13"
                    }
                ],
                "readQS": "Psalm+48%3B+Judges+4:1-23%3B+Luke+13:10-21",
                "audioQS": "Ps.48,Judg.4,Luke.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Ezra 3",
                        "readQS": "Ezra+3",
                        "audioQS": "Ezra.3"
                    },
                    {
                        "pretty": "Romans 9:19\u2013end",
                        "readQS": "Romans+9:19-",
                        "audioQS": "Rom.9"
                    }
                ],
                "readQS": "Psalm+50%3B+Ezra+3%3B+Romans+9:19-",
                "audioQS": "Ps.50,Ezra.3,Rom.9",
                "note": null
            }
        ]
    },
    "2026/06/17": {
        "datePretty": "Wednesday, June 17, 2026",
        "calendar": "Week of 11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:57\u201380",
                        "readQS": "Psalm+119:57-80",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Judges 5",
                        "readQS": "Judges+5",
                        "audioQS": "Judg.5"
                    },
                    {
                        "pretty": "Luke 13:22\u2013end",
                        "readQS": "Luke+13:22-",
                        "audioQS": "Luke.13"
                    }
                ],
                "readQS": "Psalm+119:57-80%3B+Judges+5%3B+Luke+13:22-",
                "audioQS": "Ps.119,Judg.5,Luke.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 59",
                        "readQS": "Psalm+59",
                        "audioQS": "Ps.59"
                    },
                    {
                        "pretty": "Ezra 4:1\u20135",
                        "readQS": "Ezra+4:1-5",
                        "audioQS": "Ezra.4"
                    },
                    {
                        "pretty": "Romans 10:1\u201310",
                        "readQS": "Romans+10:1-10",
                        "audioQS": "Rom.10"
                    }
                ],
                "readQS": "Psalm+59%3B+Ezra+4:1-5%3B+Romans+10:1-10",
                "audioQS": "Ps.59,Ezra.4,Rom.10",
                "note": null
            }
        ]
    },
    "2026/06/18": {
        "datePretty": "Thursday, June 18, 2026",
        "calendar": "Week of 11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 57",
                        "readQS": "Psalm+57",
                        "audioQS": "Ps.57"
                    },
                    {
                        "pretty": "Judges 6:1\u201324",
                        "readQS": "Judges+6:1-24",
                        "audioQS": "Judg.6"
                    },
                    {
                        "pretty": "Luke 14:1\u201311",
                        "readQS": "Luke+14:1-11",
                        "audioQS": "Luke.14"
                    }
                ],
                "readQS": "Psalm+57%3B+Judges+6:1-24%3B+Luke+14:1-11",
                "audioQS": "Ps.57,Judg.6,Luke.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 62",
                        "readQS": "Psalm+62",
                        "audioQS": "Ps.62"
                    },
                    {
                        "pretty": "Ezra 4:7\u2013end",
                        "readQS": "Ezra+4:7-",
                        "audioQS": "Ezra.4"
                    },
                    {
                        "pretty": "Romans 10:11\u2013end",
                        "readQS": "Romans+10:11-",
                        "audioQS": "Rom.10"
                    }
                ],
                "readQS": "Psalm+62%3B+Ezra+4:7-%3B+Romans+10:11-",
                "audioQS": "Ps.62,Ezra.4,Rom.10",
                "note": null
            }
        ]
    },
    "2026/06/19": {
        "datePretty": "Friday, June 19, 2026",
        "calendar": "Week of 11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 51",
                        "readQS": "Psalm+51",
                        "audioQS": "Ps.51"
                    },
                    {
                        "pretty": "Judges 6:25\u2013end",
                        "readQS": "Judges+6:25-",
                        "audioQS": "Judg.6"
                    },
                    {
                        "pretty": "Luke 14:12\u201324",
                        "readQS": "Luke+14:12-24",
                        "audioQS": "Luke.14"
                    }
                ],
                "readQS": "Psalm+51%3B+Judges+6:25-%3B+Luke+14:12-24",
                "audioQS": "Ps.51,Judg.6,Luke.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 38",
                        "readQS": "Psalm+38",
                        "audioQS": "Ps.38"
                    },
                    {
                        "pretty": "Ezra 5",
                        "readQS": "Ezra+5",
                        "audioQS": "Ezra.5"
                    },
                    {
                        "pretty": "Romans 11:1\u201312",
                        "readQS": "Romans+11:1-12",
                        "audioQS": "Rom.11"
                    }
                ],
                "readQS": "Psalm+38%3B+Ezra+5%3B+Romans+11:1-12",
                "audioQS": "Ps.38,Ezra.5,Rom.11",
                "note": null
            }
        ]
    },
    "2026/06/20": {
        "datePretty": "Saturday, June 20, 2026",
        "calendar": "Week of 11th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 68",
                        "readQS": "Psalm+68",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Judges 7",
                        "readQS": "Judges+7",
                        "audioQS": "Judg.7"
                    },
                    {
                        "pretty": "Luke 14:25\u2013end",
                        "readQS": "Luke+14:25-",
                        "audioQS": "Luke.14"
                    }
                ],
                "readQS": "Psalm+68%3B+Judges+7%3B+Luke+14:25-",
                "audioQS": "Ps.68,Judg.7,Luke.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66",
                        "readQS": "Psalm+66",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Ezra 6",
                        "readQS": "Ezra+6",
                        "audioQS": "Ezra.6"
                    },
                    {
                        "pretty": "Romans 11:13\u201324",
                        "readQS": "Romans+11:13-24",
                        "audioQS": "Rom.11"
                    }
                ],
                "readQS": "Psalm+66%3B+Ezra+6%3B+Romans+11:13-24",
                "audioQS": "Ps.66,Ezra.6,Rom.11",
                "note": null
            }
        ]
    },
    "2026/06/21": {
        "datePretty": "Sunday, June 21, 2026",
        "calendar": "12th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 69:8\u201311,(12\u201317),18\u201320",
                        "readQS": "Psalm+69:8-11,%2812-17%29,18-20",
                        "audioQS": "Ps.69"
                    },
                    {
                        "pretty": "Jeremiah 20:7\u201313",
                        "readQS": "Jeremiah+20:7-13",
                        "audioQS": "Jer.20"
                    },
                    {
                        "pretty": "Romans 6:1b\u201311",
                        "readQS": "Romans+6:1b-11",
                        "audioQS": "Rom.6"
                    },
                    {
                        "pretty": "Matthew 10:24\u201339",
                        "readQS": "Matthew+10:24-39",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+69:8-11,%2812-17%29,18-20%3B+Jeremiah+20:7-13%3B+Romans+6:1b-11%3B+Matthew+10:24-39",
                "audioQS": "Ps.69,Jer.20,Rom.6,Matt.10",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 86:1\u201310,16\u201317",
                        "readQS": "Psalm+86:1-10,16-17",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Genesis 21:8\u201321",
                        "readQS": "Genesis+21:8-21",
                        "audioQS": "Gen.21"
                    },
                    {
                        "pretty": "Romans 6:1b\u201311",
                        "readQS": "Romans+6:1b-11",
                        "audioQS": "Rom.6"
                    },
                    {
                        "pretty": "Matthew 10:24\u201339",
                        "readQS": "Matthew+10:24-39",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+86:1-10,16-17%3B+Genesis+21:8-21%3B+Romans+6:1b-11%3B+Matthew+10:24-39",
                "audioQS": "Ps.86,Gen.21,Rom.6,Matt.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 49",
                        "readQS": "Psalm+49",
                        "audioQS": "Ps.49"
                    },
                    {
                        "pretty": "Deuteronomy 11:1\u201315",
                        "readQS": "Deuteronomy+11:1-15",
                        "audioQS": "Deut.11"
                    },
                    {
                        "pretty": "Acts 27:1\u201312",
                        "readQS": "Acts+27:1-12",
                        "audioQS": "Acts.27"
                    }
                ],
                "readQS": "Psalm+49%3B+Deuteronomy+11:1-15%3B+Acts+27:1-12",
                "audioQS": "Ps.49,Deut.11,Acts.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "1 Samuel 24:1\u201317",
                        "readQS": "1+Samuel+24:1-17",
                        "audioQS": "1Sam.24"
                    },
                    {
                        "pretty": "Luke 14:12\u201324",
                        "readQS": "Luke+14:12-24",
                        "audioQS": "Luke.14"
                    }
                ],
                "readQS": "Psalm+46%3B+1+Samuel+24:1-17%3B+Luke+14:12-24",
                "audioQS": "Ps.46,1Sam.24,Luke.14",
                "note": null
            }
        ]
    },
    "2026/06/22": {
        "datePretty": "Monday, June 22, 2026",
        "calendar": "Week of 12th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Judges 8:22\u2013end",
                        "readQS": "Judges+8:22-",
                        "audioQS": "Judg.8"
                    },
                    {
                        "pretty": "Luke 15:1\u201310",
                        "readQS": "Luke+15:1-10",
                        "audioQS": "Luke.15"
                    }
                ],
                "readQS": "Psalm+71%3B+Judges+8:22-%3B+Luke+15:1-10",
                "audioQS": "Ps.71,Judg.8,Luke.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Ezra 7",
                        "readQS": "Ezra+7",
                        "audioQS": "Ezra.7"
                    },
                    {
                        "pretty": "Romans 11:25\u2013end",
                        "readQS": "Romans+11:25-",
                        "audioQS": "Rom.11"
                    }
                ],
                "readQS": "Psalm+72%3B+Ezra+7%3B+Romans+11:25-",
                "audioQS": "Ps.72,Ezra.7,Rom.11",
                "note": null
            }
        ]
    },
    "2026/06/23": {
        "datePretty": "Tuesday, June 23, 2026",
        "calendar": "Week of 12th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Judges 9:1\u201321",
                        "readQS": "Judges+9:1-21",
                        "audioQS": "Judg.9"
                    },
                    {
                        "pretty": "Luke 15:11\u2013end",
                        "readQS": "Luke+15:11-",
                        "audioQS": "Luke.15"
                    }
                ],
                "readQS": "Psalm+73%3B+Judges+9:1-21%3B+Luke+15:11-",
                "audioQS": "Ps.73,Judg.9,Luke.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St John the Baptist)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Judges 13:2\u20137,13:24\u201325",
                        "readQS": "Judges+13:2-7,13:24-25",
                        "audioQS": "Judg.13"
                    },
                    {
                        "pretty": "Luke 1:5\u201325",
                        "readQS": "Luke+1:5-25",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+71%3B+Judges+13:2-7,13:24-25%3B+Luke+1:5-25",
                "audioQS": "Ps.71,Judg.13,Luke.1",
                "note": null
            }
        ]
    },
    "2026/06/24": {
        "datePretty": "Wednesday, June 24, 2026",
        "calendar": "St John the Baptist",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 50,149",
                        "readQS": "Psalm+50,149",
                        "audioQS": "Ps.50,149"
                    },
                    {
                        "pretty": "Malachi 3:1\u20136",
                        "readQS": "Malachi+3:1-6",
                        "audioQS": "Mal.3"
                    },
                    {
                        "pretty": "Luke 3:1\u201317",
                        "readQS": "Luke+3:1-17",
                        "audioQS": "Luke.3"
                    }
                ],
                "readQS": "Psalm+50,149%3B+Malachi+3:1-6%3B+Luke+3:1-17",
                "audioQS": "Ps.50,149,Mal.3,Luke.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 80,82",
                        "readQS": "Psalm+80,82",
                        "audioQS": "Ps.80,82"
                    },
                    {
                        "pretty": "Malachi 4",
                        "readQS": "Malachi+4",
                        "audioQS": "Mal.4"
                    },
                    {
                        "pretty": "Matthew 11:2\u201319",
                        "readQS": "Matthew+11:2-19",
                        "audioQS": "Matt.11"
                    }
                ],
                "readQS": "Psalm+80,82%3B+Malachi+4%3B+Matthew+11:2-19",
                "audioQS": "Ps.80,82,Mal.4,Matt.11",
                "note": null
            }
        ]
    },
    "2026/06/25": {
        "datePretty": "Thursday, June 25, 2026",
        "calendar": "Week of 12th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 78:1\u201339",
                        "readQS": "Psalm+78:1-39",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "Judges 11:1\u201311",
                        "readQS": "Judges+11:1-11",
                        "audioQS": "Judg.11"
                    },
                    {
                        "pretty": "Luke 16:19\u2013end",
                        "readQS": "Luke+16:19-",
                        "audioQS": "Luke.16"
                    }
                ],
                "readQS": "Psalm+78:1-39%3B+Judges+11:1-11%3B+Luke+16:19-",
                "audioQS": "Ps.78,Judg.11,Luke.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 78:40\u2013end",
                        "readQS": "Psalm+78:40-",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "Ezra 10:1\u201317",
                        "readQS": "Ezra+10:1-17",
                        "audioQS": "Ezra.10"
                    },
                    {
                        "pretty": "Romans 13:1\u20137",
                        "readQS": "Romans+13:1-7",
                        "audioQS": "Rom.13"
                    }
                ],
                "readQS": "Psalm+78:40-%3B+Ezra+10:1-17%3B+Romans+13:1-7",
                "audioQS": "Ps.78,Ezra.10,Rom.13",
                "note": null
            }
        ]
    },
    "2026/06/26": {
        "datePretty": "Friday, June 26, 2026",
        "calendar": "Week of 12th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 55",
                        "readQS": "Psalm+55",
                        "audioQS": "Ps.55"
                    },
                    {
                        "pretty": "Judges 11:29\u2013end",
                        "readQS": "Judges+11:29-",
                        "audioQS": "Judg.11"
                    },
                    {
                        "pretty": "Luke 17:1\u201310",
                        "readQS": "Luke+17:1-10",
                        "audioQS": "Luke.17"
                    }
                ],
                "readQS": "Psalm+55%3B+Judges+11:29-%3B+Luke+17:1-10",
                "audioQS": "Ps.55,Judg.11,Luke.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 69",
                        "readQS": "Psalm+69",
                        "audioQS": "Ps.69"
                    },
                    {
                        "pretty": "Nehemiah 1",
                        "readQS": "Nehemiah+1",
                        "audioQS": "Neh.1"
                    },
                    {
                        "pretty": "Romans 13:8\u2013end",
                        "readQS": "Romans+13:8-",
                        "audioQS": "Rom.13"
                    }
                ],
                "readQS": "Psalm+69%3B+Nehemiah+1%3B+Romans+13:8-",
                "audioQS": "Ps.69,Neh.1,Rom.13",
                "note": null
            }
        ]
    },
    "2026/06/27": {
        "datePretty": "Saturday, June 27, 2026",
        "calendar": "Week of 12th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 76",
                        "readQS": "Psalm+76",
                        "audioQS": "Ps.76"
                    },
                    {
                        "pretty": "Judges 12:1\u20137",
                        "readQS": "Judges+12:1-7",
                        "audioQS": "Judg.12"
                    },
                    {
                        "pretty": "Luke 17:11\u201319",
                        "readQS": "Luke+17:11-19",
                        "audioQS": "Luke.17"
                    }
                ],
                "readQS": "Psalm+76%3B+Judges+12:1-7%3B+Luke+17:11-19",
                "audioQS": "Ps.76,Judg.12,Luke.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 84",
                        "readQS": "Psalm+84",
                        "audioQS": "Ps.84"
                    },
                    {
                        "pretty": "Nehemiah 2",
                        "readQS": "Nehemiah+2",
                        "audioQS": "Neh.2"
                    },
                    {
                        "pretty": "Romans 14:1\u201312",
                        "readQS": "Romans+14:1-12",
                        "audioQS": "Rom.14"
                    }
                ],
                "readQS": "Psalm+84%3B+Nehemiah+2%3B+Romans+14:1-12",
                "audioQS": "Ps.84,Neh.2,Rom.14",
                "note": null
            }
        ]
    },
    "2026/06/28": {
        "datePretty": "Sunday, June 28, 2026",
        "calendar": "13th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 89:1\u20134,15\u201318",
                        "readQS": "Psalm+89:1-4,15-18",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Jeremiah 28:5\u20139",
                        "readQS": "Jeremiah+28:5-9",
                        "audioQS": "Jer.28"
                    },
                    {
                        "pretty": "Romans 6:12\u201323",
                        "readQS": "Romans+6:12-23",
                        "audioQS": "Rom.6"
                    },
                    {
                        "pretty": "Matthew 10:40\u201342",
                        "readQS": "Matthew+10:40-42",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+89:1-4,15-18%3B+Jeremiah+28:5-9%3B+Romans+6:12-23%3B+Matthew+10:40-42",
                "audioQS": "Ps.89,Jer.28,Rom.6,Matt.10",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 13",
                        "readQS": "Psalm+13",
                        "audioQS": "Ps.13"
                    },
                    {
                        "pretty": "Genesis 22:1\u201314",
                        "readQS": "Genesis+22:1-14",
                        "audioQS": "Gen.22"
                    },
                    {
                        "pretty": "Romans 6:12\u201323",
                        "readQS": "Romans+6:12-23",
                        "audioQS": "Rom.6"
                    },
                    {
                        "pretty": "Matthew 10:40\u201342",
                        "readQS": "Matthew+10:40-42",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+13%3B+Genesis+22:1-14%3B+Romans+6:12-23%3B+Matthew+10:40-42",
                "audioQS": "Ps.13,Gen.22,Rom.6,Matt.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 52,53",
                        "readQS": "Psalm+52,53",
                        "audioQS": "Ps.52,53"
                    },
                    {
                        "pretty": "Deuteronomy 15:1\u201311",
                        "readQS": "Deuteronomy+15:1-11",
                        "audioQS": "Deut.15"
                    },
                    {
                        "pretty": "Acts 27:(13\u201332),33\u201344",
                        "readQS": "Acts+27:%2813-32%29,33-44",
                        "audioQS": "Acts.27"
                    }
                ],
                "readQS": "Psalm+52,53%3B+Deuteronomy+15:1-11%3B+Acts+27:%2813-32%29,33-44",
                "audioQS": "Ps.52,53,Deut.15,Acts.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Peter and St Paul)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66,67",
                        "readQS": "Psalm+66,67",
                        "audioQS": "Ps.66,67"
                    },
                    {
                        "pretty": "Ezekiel 3:4\u201311",
                        "readQS": "Ezekiel+3:4-11",
                        "audioQS": "Ezek.3"
                    },
                    {
                        "pretty": "Galatians 1:13\u2013end,2:1\u20138",
                        "readQS": "Galatians+1:13-,2:1-8",
                        "audioQS": "Gal.1"
                    }
                ],
                "readQS": "Psalm+66,67%3B+Ezekiel+3:4-11%3B+Galatians+1:13-,2:1-8",
                "audioQS": "Ps.66,67,Ezek.3,Gal.1",
                "note": null
            }
        ]
    },
    "2026/06/29": {
        "datePretty": "Monday, June 29, 2026",
        "calendar": "St Peter and St Paul, Apostles, Martyrs",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71,113",
                        "readQS": "Psalm+71,113",
                        "audioQS": "Ps.71,113"
                    },
                    {
                        "pretty": "Isaiah 49:1\u20136",
                        "readQS": "Isaiah+49:1-6",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "Acts 11:1\u201318",
                        "readQS": "Acts+11:1-18",
                        "audioQS": "Acts.11"
                    }
                ],
                "readQS": "Psalm+71,113%3B+Isaiah+49:1-6%3B+Acts+11:1-18",
                "audioQS": "Ps.71,113,Isa.49,Acts.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 124,138",
                        "readQS": "Psalm+124,138",
                        "audioQS": "Ps.124,138"
                    },
                    {
                        "pretty": "Ezekiel 34:11\u201316",
                        "readQS": "Ezekiel+34:11-16",
                        "audioQS": "Ezek.34"
                    },
                    {
                        "pretty": "John 21:15\u201322",
                        "readQS": "John+21:15-22",
                        "audioQS": "John.21"
                    }
                ],
                "readQS": "Psalm+124,138%3B+Ezekiel+34:11-16%3B+John+21:15-22",
                "audioQS": "Ps.124,138,Ezek.34,John.21",
                "note": null
            }
        ]
    },
    "2026/06/30": {
        "datePretty": "Tuesday, June 30, 2026",
        "calendar": "Week of 13th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 89:1\u201318",
                        "readQS": "Psalm+89:1-18",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Judges 14",
                        "readQS": "Judges+14",
                        "audioQS": "Judg.14"
                    },
                    {
                        "pretty": "Luke 18:1\u201314",
                        "readQS": "Luke+18:1-14",
                        "audioQS": "Luke.18"
                    }
                ],
                "readQS": "Psalm+89:1-18%3B+Judges+14%3B+Luke+18:1-14",
                "audioQS": "Ps.89,Judg.14,Luke.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 89:19\u2013end",
                        "readQS": "Psalm+89:19-",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Nehemiah 5",
                        "readQS": "Nehemiah+5",
                        "audioQS": "Neh.5"
                    },
                    {
                        "pretty": "Romans 15:1\u201313",
                        "readQS": "Romans+15:1-13",
                        "audioQS": "Rom.15"
                    }
                ],
                "readQS": "Psalm+89:19-%3B+Nehemiah+5%3B+Romans+15:1-13",
                "audioQS": "Ps.89,Neh.5,Rom.15",
                "note": null
            }
        ]
    },
    "2026/07/01": {
        "datePretty": "Wednesday, July 1, 2026",
        "calendar": "Week of 13th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:105\u2013128",
                        "readQS": "Psalm+119:105-128",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Judges 15:1\u201316:3",
                        "readQS": "Judges+15:1-16:3",
                        "audioQS": "Judg.15"
                    },
                    {
                        "pretty": "Luke 18:15\u201330",
                        "readQS": "Luke+18:15-30",
                        "audioQS": "Luke.18"
                    }
                ],
                "readQS": "Psalm+119:105-128%3B+Judges+15:1-16:3%3B+Luke+18:15-30",
                "audioQS": "Ps.119,Judg.15,Luke.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 91",
                        "readQS": "Psalm+91",
                        "audioQS": "Ps.91"
                    },
                    {
                        "pretty": "Nehemiah 6:1\u20137:4",
                        "readQS": "Nehemiah+6:1-7:4",
                        "audioQS": "Neh.6"
                    },
                    {
                        "pretty": "Romans 15:14\u201321",
                        "readQS": "Romans+15:14-21",
                        "audioQS": "Rom.15"
                    }
                ],
                "readQS": "Psalm+91%3B+Nehemiah+6:1-7:4%3B+Romans+15:14-21",
                "audioQS": "Ps.91,Neh.6,Rom.15",
                "note": null
            }
        ]
    },
    "2026/07/02": {
        "datePretty": "Thursday, July 2, 2026",
        "calendar": "Week of 13th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 92",
                        "readQS": "Psalm+92",
                        "audioQS": "Ps.92"
                    },
                    {
                        "pretty": "Judges 16:4\u2013end",
                        "readQS": "Judges+16:4-",
                        "audioQS": "Judg.16"
                    },
                    {
                        "pretty": "Luke 18:31\u2013end",
                        "readQS": "Luke+18:31-",
                        "audioQS": "Luke.18"
                    }
                ],
                "readQS": "Psalm+92%3B+Judges+16:4-%3B+Luke+18:31-",
                "audioQS": "Ps.92,Judg.16,Luke.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Annunciation)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 27",
                        "readQS": "Psalm+27",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Isaiah 35",
                        "readQS": "Isaiah+35",
                        "audioQS": "Isa.35"
                    },
                    {
                        "pretty": "Hebrews 10:35\u2013end,11:1",
                        "readQS": "Hebrews+10:35-,11:1",
                        "audioQS": "Heb.10"
                    }
                ],
                "readQS": "Psalm+27%3B+Isaiah+35%3B+Hebrews+10:35-,11:1",
                "audioQS": "Ps.27,Isa.35,Heb.10",
                "note": null
            }
        ]
    },
    "2026/07/03": {
        "datePretty": "Friday, July 3, 2026",
        "calendar": "Thomas the Apostle",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 92,146",
                        "readQS": "Psalm+92,146",
                        "audioQS": "Ps.92,146"
                    },
                    {
                        "pretty": "2 Samuel 15:17\u201321",
                        "readQS": "2+Samuel+15:17-21",
                        "audioQS": "2Sam.15"
                    },
                    {
                        "pretty": "John 11:1\u201316",
                        "readQS": "John+11:1-16",
                        "audioQS": "John.11"
                    }
                ],
                "readQS": "Psalm+92,146%3B+2+Samuel+15:17-21%3B+John+11:1-16",
                "audioQS": "Ps.92,146,2Sam.15,John.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Job 42:1\u20136",
                        "readQS": "Job+42:1-6",
                        "audioQS": "Job.42"
                    },
                    {
                        "pretty": "1 Peter 1:3\u201312",
                        "readQS": "1+Peter+1:3-12",
                        "audioQS": "1Pet.1"
                    }
                ],
                "readQS": "Psalm+139%3B+Job+42:1-6%3B+1+Peter+1:3-12",
                "audioQS": "Ps.139,Job.42,1Pet.1",
                "note": null
            }
        ]
    },
    "2026/07/04": {
        "datePretty": "Saturday, July 4, 2026",
        "calendar": "Week of 13th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Judges 18:1\u201320,18:27\u2013end",
                        "readQS": "Judges+18:1-20,18:27-",
                        "audioQS": "Judg.18"
                    },
                    {
                        "pretty": "Luke 19:11\u201327",
                        "readQS": "Luke+19:11-27",
                        "audioQS": "Luke.19"
                    }
                ],
                "readQS": "Psalm+97%3B+Judges+18:1-20,18:27-%3B+Luke+19:11-27",
                "audioQS": "Ps.97,Judg.18,Luke.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 104",
                        "readQS": "Psalm+104",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Nehemiah 9:24\u2013end",
                        "readQS": "Nehemiah+9:24-",
                        "audioQS": "Neh.9"
                    },
                    {
                        "pretty": "Romans 16:17\u2013end",
                        "readQS": "Romans+16:17-",
                        "audioQS": "Rom.16"
                    }
                ],
                "readQS": "Psalm+104%3B+Nehemiah+9:24-%3B+Romans+16:17-",
                "audioQS": "Ps.104,Neh.9,Rom.16",
                "note": null
            }
        ]
    },
    "2026/07/05": {
        "datePretty": "Sunday, July 5, 2026",
        "calendar": "14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 145:8\u201315",
                        "readQS": "Psalm+145:8-15",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Zechariah 9:9\u201312",
                        "readQS": "Zechariah+9:9-12",
                        "audioQS": "Zech.9"
                    },
                    {
                        "pretty": "Romans 7:15\u201325a",
                        "readQS": "Romans+7:15-25a",
                        "audioQS": "Rom.7"
                    },
                    {
                        "pretty": "Matthew 11:16\u201319,25\u201330",
                        "readQS": "Matthew+11:16-19,25-30",
                        "audioQS": "Matt.11"
                    }
                ],
                "readQS": "Psalm+145:8-15%3B+Zechariah+9:9-12%3B+Romans+7:15-25a%3B+Matthew+11:16-19,25-30",
                "audioQS": "Ps.145,Zech.9,Rom.7,Matt.11",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 45:10\u201317",
                        "readQS": "Psalm+45:10-17",
                        "audioQS": "Ps.45"
                    },
                    {
                        "pretty": "Canticle: Song of Solomon 2:8\u201313",
                        "readQS": "Song+of+Solomon+2:8-13",
                        "audioQS": "Song.2"
                    },
                    {
                        "pretty": "Genesis 24:34\u201338,42\u201349,58\u201367",
                        "readQS": "Genesis+24:34-38,42-49,58-67",
                        "audioQS": "Gen.24"
                    },
                    {
                        "pretty": "Romans 7:15\u201325a",
                        "readQS": "Romans+7:15-25a",
                        "audioQS": "Rom.7"
                    },
                    {
                        "pretty": "Matthew 11:16\u201319",
                        "readQS": "Matthew+11:16-19",
                        "audioQS": "Matt.11"
                    }
                ],
                "readQS": "Psalm+45:10-17%3B+Canticle:+Song+of+Solomon+2:8-13%3B+Genesis+24:34-38,42-49,58-67%3B+Romans+7:15-25a%3B+Matthew+11:16-19",
                "audioQS": "Ps.45,Canticle,Gen.24,Rom.7,Matt.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 55:1\u201315,18\u201322",
                        "readQS": "Psalm+55:1-15,18-22",
                        "audioQS": "Ps.55"
                    },
                    {
                        "pretty": "Deuteronomy 24:10\u201322",
                        "readQS": "Deuteronomy+24:10-22",
                        "audioQS": "Deut.24"
                    },
                    {
                        "pretty": "Acts 28:1\u201316",
                        "readQS": "Acts+28:1-16",
                        "audioQS": "Acts.28"
                    }
                ],
                "readQS": "Psalm+55:1-15,18-22%3B+Deuteronomy+24:10-22%3B+Acts+28:1-16",
                "audioQS": "Ps.55,Deut.24,Acts.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 56",
                        "readQS": "Psalm+56",
                        "audioQS": "Ps.56"
                    },
                    {
                        "pretty": "2 Samuel 2:1\u201311,3:1",
                        "readQS": "2+Samuel+2:1-11,3:1",
                        "audioQS": "2Sam.2"
                    },
                    {
                        "pretty": "Luke 18:31\u201319:10",
                        "readQS": "Luke+18:31-19:10",
                        "audioQS": "Luke.18"
                    }
                ],
                "readQS": "Psalm+56%3B+2+Samuel+2:1-11,3:1%3B+Luke+18:31-19:10",
                "audioQS": "Ps.56,2Sam.2,Luke.18",
                "note": null
            }
        ]
    },
    "2026/07/06": {
        "datePretty": "Monday, July 6, 2026",
        "calendar": "Week of 14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 98",
                        "readQS": "Psalm+98",
                        "audioQS": "Ps.98"
                    },
                    {
                        "pretty": "1 Samuel 1:1\u201320",
                        "readQS": "1+Samuel+1:1-20",
                        "audioQS": "1Sam.1"
                    },
                    {
                        "pretty": "Luke 19:28\u201340",
                        "readQS": "Luke+19:28-40",
                        "audioQS": "Luke.19"
                    }
                ],
                "readQS": "Psalm+98%3B+1+Samuel+1:1-20%3B+Luke+19:28-40",
                "audioQS": "Ps.98,1Sam.1,Luke.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 105",
                        "readQS": "Psalm+105",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Nehemiah 12:27\u201347",
                        "readQS": "Nehemiah+12:27-47",
                        "audioQS": "Neh.12"
                    },
                    {
                        "pretty": "2 Corinthians 1:1\u201314",
                        "readQS": "2+Corinthians+1:1-14",
                        "audioQS": "2Cor.1"
                    }
                ],
                "readQS": "Psalm+105%3B+Nehemiah+12:27-47%3B+2+Corinthians+1:1-14",
                "audioQS": "Ps.105,Neh.12,2Cor.1",
                "note": null
            }
        ]
    },
    "2026/07/07": {
        "datePretty": "Tuesday, July 7, 2026",
        "calendar": "Week of 14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 106",
                        "readQS": "Psalm+106",
                        "audioQS": "Ps.106"
                    },
                    {
                        "pretty": "1 Samuel 1:21\u20132:11",
                        "readQS": "1+Samuel+1:21-2:11",
                        "audioQS": "1Sam.1"
                    },
                    {
                        "pretty": "Luke 19:41\u2013end",
                        "readQS": "Luke+19:41-",
                        "audioQS": "Luke.19"
                    }
                ],
                "readQS": "Psalm+106%3B+1+Samuel+1:21-2:11%3B+Luke+19:41-",
                "audioQS": "Ps.106,1Sam.1,Luke.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 107",
                        "readQS": "Psalm+107",
                        "audioQS": "Ps.107"
                    },
                    {
                        "pretty": "Nehemiah 13:1\u201314",
                        "readQS": "Nehemiah+13:1-14",
                        "audioQS": "Neh.13"
                    },
                    {
                        "pretty": "2 Corinthians 1:15\u20132:4",
                        "readQS": "2+Corinthians+1:15-2:4",
                        "audioQS": "2Cor.1"
                    }
                ],
                "readQS": "Psalm+107%3B+Nehemiah+13:1-14%3B+2+Corinthians+1:15-2:4",
                "audioQS": "Ps.107,Neh.13,2Cor.1",
                "note": null
            }
        ]
    },
    "2026/07/08": {
        "datePretty": "Wednesday, July 8, 2026",
        "calendar": "Week of 14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 111",
                        "readQS": "Psalm+111",
                        "audioQS": "Ps.111"
                    },
                    {
                        "pretty": "1 Samuel 2:12\u201326",
                        "readQS": "1+Samuel+2:12-26",
                        "audioQS": "1Sam.2"
                    },
                    {
                        "pretty": "Luke 20:1\u20138",
                        "readQS": "Luke+20:1-8",
                        "audioQS": "Luke.20"
                    }
                ],
                "readQS": "Psalm+111%3B+1+Samuel+2:12-26%3B+Luke+20:1-8",
                "audioQS": "Ps.111,1Sam.2,Luke.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:129\u2013152",
                        "readQS": "Psalm+119:129-152",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Nehemiah 13:15\u2013end",
                        "readQS": "Nehemiah+13:15-",
                        "audioQS": "Neh.13"
                    },
                    {
                        "pretty": "2 Corinthians 2:5\u2013end",
                        "readQS": "2+Corinthians+2:5-",
                        "audioQS": "2Cor.2"
                    }
                ],
                "readQS": "Psalm+119:129-152%3B+Nehemiah+13:15-%3B+2+Corinthians+2:5-",
                "audioQS": "Ps.119,Neh.13,2Cor.2",
                "note": null
            }
        ]
    },
    "2026/07/09": {
        "datePretty": "Thursday, July 9, 2026",
        "calendar": "Week of 14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 115",
                        "readQS": "Psalm+115",
                        "audioQS": "Ps.115"
                    },
                    {
                        "pretty": "1 Samuel 2:27\u2013end",
                        "readQS": "1+Samuel+2:27-",
                        "audioQS": "1Sam.2"
                    },
                    {
                        "pretty": "Luke 20:9\u201319",
                        "readQS": "Luke+20:9-19",
                        "audioQS": "Luke.20"
                    }
                ],
                "readQS": "Psalm+115%3B+1+Samuel+2:27-%3B+Luke+20:9-19",
                "audioQS": "Ps.115,1Sam.2,Luke.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Esther 1",
                        "readQS": "Esther+1",
                        "audioQS": "Esth.1"
                    },
                    {
                        "pretty": "2 Corinthians 3",
                        "readQS": "2+Corinthians+3",
                        "audioQS": "2Cor.3"
                    }
                ],
                "readQS": "Psalm+116%3B+Esther+1%3B+2+Corinthians+3",
                "audioQS": "Ps.116,Esth.1,2Cor.3",
                "note": null
            }
        ]
    },
    "2026/07/10": {
        "datePretty": "Friday, July 10, 2026",
        "calendar": "Week of 14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "1 Samuel 3:1\u20134:1a",
                        "readQS": "1+Samuel+3:1-4:1a",
                        "audioQS": "1Sam.3"
                    },
                    {
                        "pretty": "Luke 20:20\u201326",
                        "readQS": "Luke+20:20-26",
                        "audioQS": "Luke.20"
                    }
                ],
                "readQS": "Psalm+139%3B+1+Samuel+3:1-4:1a%3B+Luke+20:20-26",
                "audioQS": "Ps.139,1Sam.3,Luke.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 130",
                        "readQS": "Psalm+130",
                        "audioQS": "Ps.130"
                    },
                    {
                        "pretty": "Esther 2",
                        "readQS": "Esther+2",
                        "audioQS": "Esth.2"
                    },
                    {
                        "pretty": "2 Corinthians 4",
                        "readQS": "2+Corinthians+4",
                        "audioQS": "2Cor.4"
                    }
                ],
                "readQS": "Psalm+130%3B+Esther+2%3B+2+Corinthians+4",
                "audioQS": "Ps.130,Esth.2,2Cor.4",
                "note": null
            }
        ]
    },
    "2026/07/11": {
        "datePretty": "Saturday, July 11, 2026",
        "calendar": "Week of 14th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 121",
                        "readQS": "Psalm+121",
                        "audioQS": "Ps.121"
                    },
                    {
                        "pretty": "1 Samuel 4:1b\u2013end",
                        "readQS": "1+Samuel+4:1b-",
                        "audioQS": "1Sam.4"
                    },
                    {
                        "pretty": "Luke 20:27\u201340",
                        "readQS": "Luke+20:27-40",
                        "audioQS": "Luke.20"
                    }
                ],
                "readQS": "Psalm+121%3B+1+Samuel+4:1b-%3B+Luke+20:27-40",
                "audioQS": "Ps.121,1Sam.4,Luke.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Esther 3",
                        "readQS": "Esther+3",
                        "audioQS": "Esth.3"
                    },
                    {
                        "pretty": "2 Corinthians 5",
                        "readQS": "2+Corinthians+5",
                        "audioQS": "2Cor.5"
                    }
                ],
                "readQS": "Psalm+118%3B+Esther+3%3B+2+Corinthians+5",
                "audioQS": "Ps.118,Esth.3,2Cor.5",
                "note": null
            }
        ]
    },
    "2026/07/12": {
        "datePretty": "Sunday, July 12, 2026",
        "calendar": "15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 65:(1\u20137),8\u201313",
                        "readQS": "Psalm+65:%281-7%29,8-13",
                        "audioQS": "Ps.65"
                    },
                    {
                        "pretty": "Isaiah 55:10\u201313",
                        "readQS": "Isaiah+55:10-13",
                        "audioQS": "Isa.55"
                    },
                    {
                        "pretty": "Romans 8:1\u201311",
                        "readQS": "Romans+8:1-11",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 13:1\u20139,18\u201323",
                        "readQS": "Matthew+13:1-9,18-23",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+65:%281-7%29,8-13%3B+Isaiah+55:10-13%3B+Romans+8:1-11%3B+Matthew+13:1-9,18-23",
                "audioQS": "Ps.65,Isa.55,Rom.8,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 119:105\u2013112",
                        "readQS": "Psalm+119:105-112",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Genesis 25:19\u201334",
                        "readQS": "Genesis+25:19-34",
                        "audioQS": "Gen.25"
                    },
                    {
                        "pretty": "Romans 8:1\u201311",
                        "readQS": "Romans+8:1-11",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 13:1\u20139,18\u201323",
                        "readQS": "Matthew+13:1-9,18-23",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+119:105-112%3B+Genesis+25:19-34%3B+Romans+8:1-11%3B+Matthew+13:1-9,18-23",
                "audioQS": "Ps.119,Gen.25,Rom.8,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 64,65",
                        "readQS": "Psalm+64,65",
                        "audioQS": "Ps.64,65"
                    },
                    {
                        "pretty": "Deuteronomy 28:1\u201314",
                        "readQS": "Deuteronomy+28:1-14",
                        "audioQS": "Deut.28"
                    },
                    {
                        "pretty": "Acts 28:17\u201331",
                        "readQS": "Acts+28:17-31",
                        "audioQS": "Acts.28"
                    }
                ],
                "readQS": "Psalm+64,65%3B+Deuteronomy+28:1-14%3B+Acts+28:17-31",
                "audioQS": "Ps.64,65,Deut.28,Acts.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 60",
                        "readQS": "Psalm+60",
                        "audioQS": "Ps.60"
                    },
                    {
                        "pretty": "2 Samuel 7:18\u201329",
                        "readQS": "2+Samuel+7:18-29",
                        "audioQS": "2Sam.7"
                    },
                    {
                        "pretty": "Luke 19:41\u201320:8",
                        "readQS": "Luke+19:41-20:8",
                        "audioQS": "Luke.19"
                    }
                ],
                "readQS": "Psalm+60%3B+2+Samuel+7:18-29%3B+Luke+19:41-20:8",
                "audioQS": "Ps.60,2Sam.7,Luke.19",
                "note": null
            }
        ]
    },
    "2026/07/13": {
        "datePretty": "Monday, July 13, 2026",
        "calendar": "Week of 15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 126",
                        "readQS": "Psalm+126",
                        "audioQS": "Ps.126"
                    },
                    {
                        "pretty": "1 Samuel 5",
                        "readQS": "1+Samuel+5",
                        "audioQS": "1Sam.5"
                    },
                    {
                        "pretty": "Luke 20:41\u201321:4",
                        "readQS": "Luke+20:41-21:4",
                        "audioQS": "Luke.20"
                    }
                ],
                "readQS": "Psalm+126%3B+1+Samuel+5%3B+Luke+20:41-21:4",
                "audioQS": "Ps.126,1Sam.5,Luke.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 127",
                        "readQS": "Psalm+127",
                        "audioQS": "Ps.127"
                    },
                    {
                        "pretty": "Esther 4",
                        "readQS": "Esther+4",
                        "audioQS": "Esth.4"
                    },
                    {
                        "pretty": "2 Corinthians 6:1\u20137:1",
                        "readQS": "2+Corinthians+6:1-7:1",
                        "audioQS": "2Cor.6"
                    }
                ],
                "readQS": "Psalm+127%3B+Esther+4%3B+2+Corinthians+6:1-7:1",
                "audioQS": "Ps.127,Esth.4,2Cor.6",
                "note": null
            }
        ]
    },
    "2026/07/14": {
        "datePretty": "Tuesday, July 14, 2026",
        "calendar": "Week of 15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "1 Samuel 6:1\u201316",
                        "readQS": "1+Samuel+6:1-16",
                        "audioQS": "1Sam.6"
                    },
                    {
                        "pretty": "Luke 21:5\u201319",
                        "readQS": "Luke+21:5-19",
                        "audioQS": "Luke.21"
                    }
                ],
                "readQS": "Psalm+132%3B+1+Samuel+6:1-16%3B+Luke+21:5-19",
                "audioQS": "Ps.132,1Sam.6,Luke.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Esther 5",
                        "readQS": "Esther+5",
                        "audioQS": "Esth.5"
                    },
                    {
                        "pretty": "2 Corinthians 7:2\u2013end",
                        "readQS": "2+Corinthians+7:2-",
                        "audioQS": "2Cor.7"
                    }
                ],
                "readQS": "Psalm+135%3B+Esther+5%3B+2+Corinthians+7:2-",
                "audioQS": "Ps.135,Esth.5,2Cor.7",
                "note": null
            }
        ]
    },
    "2026/07/15": {
        "datePretty": "Wednesday, July 15, 2026",
        "calendar": "Week of 15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:153\u2013end",
                        "readQS": "Psalm+119:153-",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "1 Samuel 7",
                        "readQS": "1+Samuel+7",
                        "audioQS": "1Sam.7"
                    },
                    {
                        "pretty": "Luke 21:20\u201328",
                        "readQS": "Luke+21:20-28",
                        "audioQS": "Luke.21"
                    }
                ],
                "readQS": "Psalm+119:153-%3B+1+Samuel+7%3B+Luke+21:20-28",
                "audioQS": "Ps.119,1Sam.7,Luke.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Esther 6:1\u201313",
                        "readQS": "Esther+6:1-13",
                        "audioQS": "Esth.6"
                    },
                    {
                        "pretty": "2 Corinthians 8:1\u201315",
                        "readQS": "2+Corinthians+8:1-15",
                        "audioQS": "2Cor.8"
                    }
                ],
                "readQS": "Psalm+136%3B+Esther+6:1-13%3B+2+Corinthians+8:1-15",
                "audioQS": "Ps.136,Esth.6,2Cor.8",
                "note": null
            }
        ]
    },
    "2026/07/16": {
        "datePretty": "Thursday, July 16, 2026",
        "calendar": "Week of 15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 143",
                        "readQS": "Psalm+143",
                        "audioQS": "Ps.143"
                    },
                    {
                        "pretty": "1 Samuel 8",
                        "readQS": "1+Samuel+8",
                        "audioQS": "1Sam.8"
                    },
                    {
                        "pretty": "Luke 21:29\u2013end",
                        "readQS": "Luke+21:29-",
                        "audioQS": "Luke.21"
                    }
                ],
                "readQS": "Psalm+143%3B+1+Samuel+8%3B+Luke+21:29-",
                "audioQS": "Ps.143,1Sam.8,Luke.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "Esther 6:14\u2013end",
                        "readQS": "Esther+6:14-",
                        "audioQS": "Esth.6"
                    },
                    {
                        "pretty": "Esther 7",
                        "readQS": "Esther+7",
                        "audioQS": "Esth.7"
                    },
                    {
                        "pretty": "2 Corinthians 8:16\u20139:5",
                        "readQS": "2+Corinthians+8:16-9:5",
                        "audioQS": "2Cor.8"
                    }
                ],
                "readQS": "Psalm+138%3B+Esther+6:14-%3B+Esther+7%3B+2+Corinthians+8:16-9:5",
                "audioQS": "Ps.138,Esth.6,Esth.7,2Cor.8",
                "note": null
            }
        ]
    },
    "2026/07/17": {
        "datePretty": "Friday, July 17, 2026",
        "calendar": "Week of 15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "1 Samuel 9:1\u201314",
                        "readQS": "1+Samuel+9:1-14",
                        "audioQS": "1Sam.9"
                    },
                    {
                        "pretty": "Luke 22:1\u201313",
                        "readQS": "Luke+22:1-13",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+144%3B+1+Samuel+9:1-14%3B+Luke+22:1-13",
                "audioQS": "Ps.144,1Sam.9,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Esther 8",
                        "readQS": "Esther+8",
                        "audioQS": "Esth.8"
                    },
                    {
                        "pretty": "2 Corinthians 9:6\u2013end",
                        "readQS": "2+Corinthians+9:6-",
                        "audioQS": "2Cor.9"
                    }
                ],
                "readQS": "Psalm+145%3B+Esther+8%3B+2+Corinthians+9:6-",
                "audioQS": "Ps.145,Esth.8,2Cor.9",
                "note": null
            }
        ]
    },
    "2026/07/18": {
        "datePretty": "Saturday, July 18, 2026",
        "calendar": "Week of 15th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 147",
                        "readQS": "Psalm+147",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "1 Samuel 9:15\u201310:1",
                        "readQS": "1+Samuel+9:15-10:1",
                        "audioQS": "1Sam.9"
                    },
                    {
                        "pretty": "Luke 22:14\u201323",
                        "readQS": "Luke+22:14-23",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+147%3B+1+Samuel+9:15-10:1%3B+Luke+22:14-23",
                "audioQS": "Ps.147,1Sam.9,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Esther 9:20\u201328",
                        "readQS": "Esther+9:20-28",
                        "audioQS": "Esth.9"
                    },
                    {
                        "pretty": "2 Corinthians 10",
                        "readQS": "2+Corinthians+10",
                        "audioQS": "2Cor.10"
                    }
                ],
                "readQS": "Psalm+148%3B+Esther+9:20-28%3B+2+Corinthians+10",
                "audioQS": "Ps.148,Esth.9,2Cor.10",
                "note": null
            }
        ]
    },
    "2026/07/19": {
        "datePretty": "Sunday, July 19, 2026",
        "calendar": "16th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 86:11\u201317",
                        "readQS": "Psalm+86:11-17",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Isaiah 44:6\u20138",
                        "readQS": "Isaiah+44:6-8",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Romans 8:12\u201325",
                        "readQS": "Romans+8:12-25",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 13:24\u201330,36\u201343",
                        "readQS": "Matthew+13:24-30,36-43",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+86:11-17%3B+Isaiah+44:6-8%3B+Romans+8:12-25%3B+Matthew+13:24-30,36-43",
                "audioQS": "Ps.86,Isa.44,Rom.8,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 139:1\u201311,23\u201324",
                        "readQS": "Psalm+139:1-11,23-24",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Genesis 28:10\u201319a",
                        "readQS": "Genesis+28:10-19a",
                        "audioQS": "Gen.28"
                    },
                    {
                        "pretty": "Romans 8:12\u201325",
                        "readQS": "Romans+8:12-25",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 13:24\u201330,36\u201343",
                        "readQS": "Matthew+13:24-30,36-43",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+139:1-11,23-24%3B+Genesis+28:10-19a%3B+Romans+8:12-25%3B+Matthew+13:24-30,36-43",
                "audioQS": "Ps.139,Gen.28,Rom.8,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Deuteronomy 30:1\u201310",
                        "readQS": "Deuteronomy+30:1-10",
                        "audioQS": "Deut.30"
                    },
                    {
                        "pretty": "1 Peter 3:8\u201318",
                        "readQS": "1+Peter+3:8-18",
                        "audioQS": "1Pet.3"
                    }
                ],
                "readQS": "Psalm+71%3B+Deuteronomy+30:1-10%3B+1+Peter+3:8-18",
                "audioQS": "Ps.71,Deut.30,1Pet.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 67",
                        "readQS": "Psalm+67",
                        "audioQS": "Ps.67"
                    },
                    {
                        "pretty": "1 Kings 2:10\u201312,3:16\u201328",
                        "readQS": "1+Kings+2:10-12,3:16-28",
                        "audioQS": "1Kgs.2"
                    },
                    {
                        "pretty": "Acts 4:1\u201322",
                        "readQS": "Acts+4:1-22",
                        "audioQS": "Acts.4"
                    }
                ],
                "readQS": "Psalm+67%3B+1+Kings+2:10-12,3:16-28%3B+Acts+4:1-22",
                "audioQS": "Ps.67,1Kgs.2,Acts.4",
                "note": null
            }
        ]
    },
    "2026/07/20": {
        "datePretty": "Monday, July 20, 2026",
        "calendar": "Week of 16th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 1",
                        "readQS": "Psalm+1",
                        "audioQS": "Ps.1"
                    },
                    {
                        "pretty": "1 Samuel 10:1\u201316",
                        "readQS": "1+Samuel+10:1-16",
                        "audioQS": "1Sam.10"
                    },
                    {
                        "pretty": "Luke 22:24\u201330",
                        "readQS": "Luke+22:24-30",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+1%3B+1+Samuel+10:1-16%3B+Luke+22:24-30",
                "audioQS": "Ps.1,1Sam.10,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 4",
                        "readQS": "Psalm+4",
                        "audioQS": "Ps.4"
                    },
                    {
                        "pretty": "Jeremiah 26",
                        "readQS": "Jeremiah+26",
                        "audioQS": "Jer.26"
                    },
                    {
                        "pretty": "2 Corinthians 11:1\u201315",
                        "readQS": "2+Corinthians+11:1-15",
                        "audioQS": "2Cor.11"
                    }
                ],
                "readQS": "Psalm+4%3B+Jeremiah+26%3B+2+Corinthians+11:1-15",
                "audioQS": "Ps.4,Jer.26,2Cor.11",
                "note": null
            }
        ]
    },
    "2026/07/21": {
        "datePretty": "Tuesday, July 21, 2026",
        "calendar": "Week of 16th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "1 Samuel 10:17\u2013end",
                        "readQS": "1+Samuel+10:17-",
                        "audioQS": "1Sam.10"
                    },
                    {
                        "pretty": "Luke 22:31\u201338",
                        "readQS": "Luke+22:31-38",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+5%3B+1+Samuel+10:17-%3B+Luke+22:31-38",
                "audioQS": "Ps.5,1Sam.10,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Mary Magdalene)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Isaiah 25:1\u20139",
                        "readQS": "Isaiah+25:1-9",
                        "audioQS": "Isa.25"
                    },
                    {
                        "pretty": "2 Corinthians 1:3\u20137",
                        "readQS": "2+Corinthians+1:3-7",
                        "audioQS": "2Cor.1"
                    }
                ],
                "readQS": "Psalm+139%3B+Isaiah+25:1-9%3B+2+Corinthians+1:3-7",
                "audioQS": "Ps.139,Isa.25,2Cor.1",
                "note": null
            }
        ]
    },
    "2026/07/22": {
        "datePretty": "Wednesday, July 22, 2026",
        "calendar": "St Mary Magdalene",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30,32,150",
                        "readQS": "Psalm+30,32,150",
                        "audioQS": "Ps.30,32,150"
                    },
                    {
                        "pretty": "1 Samuel 16:14\u201323",
                        "readQS": "1+Samuel+16:14-23",
                        "audioQS": "1Sam.16"
                    },
                    {
                        "pretty": "Luke 8:1\u20133",
                        "readQS": "Luke+8:1-3",
                        "audioQS": "Luke.8"
                    }
                ],
                "readQS": "Psalm+30,32,150%3B+1+Samuel+16:14-23%3B+Luke+8:1-3",
                "audioQS": "Ps.30,32,150,1Sam.16,Luke.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 63",
                        "readQS": "Psalm+63",
                        "audioQS": "Ps.63"
                    },
                    {
                        "pretty": "Zephaniah 3:14\u201320",
                        "readQS": "Zephaniah+3:14-20",
                        "audioQS": "Zeph.3"
                    },
                    {
                        "pretty": "Mark 15:40\u2013end,16:1\u20137",
                        "readQS": "Mark+15:40-,16:1-7",
                        "audioQS": "Mark.15"
                    }
                ],
                "readQS": "Psalm+63%3B+Zephaniah+3:14-20%3B+Mark+15:40-,16:1-7",
                "audioQS": "Ps.63,Zeph.3,Mark.15",
                "note": null
            }
        ]
    },
    "2026/07/23": {
        "datePretty": "Thursday, July 23, 2026",
        "calendar": "Week of 16th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15",
                        "readQS": "Psalm+15",
                        "audioQS": "Ps.15"
                    },
                    {
                        "pretty": "1 Samuel 12",
                        "readQS": "1+Samuel+12",
                        "audioQS": "1Sam.12"
                    },
                    {
                        "pretty": "Luke 22:47\u201362",
                        "readQS": "Luke+22:47-62",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+15%3B+1+Samuel+12%3B+Luke+22:47-62",
                "audioQS": "Ps.15,1Sam.12,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 18",
                        "readQS": "Psalm+18",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "Jeremiah 30:1\u201311",
                        "readQS": "Jeremiah+30:1-11",
                        "audioQS": "Jer.30"
                    },
                    {
                        "pretty": "2 Corinthians 13",
                        "readQS": "2+Corinthians+13",
                        "audioQS": "2Cor.13"
                    }
                ],
                "readQS": "Psalm+18%3B+Jeremiah+30:1-11%3B+2+Corinthians+13",
                "audioQS": "Ps.18,Jer.30,2Cor.13",
                "note": null
            }
        ]
    },
    "2026/07/24": {
        "datePretty": "Friday, July 24, 2026",
        "calendar": "Week of 16th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "1 Samuel 13:5\u201318",
                        "readQS": "1+Samuel+13:5-18",
                        "audioQS": "1Sam.13"
                    },
                    {
                        "pretty": "Luke 22:63\u2013end",
                        "readQS": "Luke+22:63-",
                        "audioQS": "Luke.22"
                    }
                ],
                "readQS": "Psalm+19%3B+1+Samuel+13:5-18%3B+Luke+22:63-",
                "audioQS": "Ps.19,1Sam.13,Luke.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St James)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "Deuteronomy 30:11\u201320",
                        "readQS": "Deuteronomy+30:11-20",
                        "audioQS": "Deut.30"
                    },
                    {
                        "pretty": "Mark 5:21\u201343",
                        "readQS": "Mark+5:21-43",
                        "audioQS": "Mark.5"
                    }
                ],
                "readQS": "Psalm+144%3B+Deuteronomy+30:11-20%3B+Mark+5:21-43",
                "audioQS": "Ps.144,Deut.30,Mark.5",
                "note": null
            }
        ]
    },
    "2026/07/25": {
        "datePretty": "Saturday, July 25, 2026",
        "calendar": "St James the Apostle",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 7,29,117",
                        "readQS": "Psalm+7,29,117",
                        "audioQS": "Ps.7,29,117"
                    },
                    {
                        "pretty": "2 Kings 1:9\u201315",
                        "readQS": "2+Kings+1:9-15",
                        "audioQS": "2Kgs.1"
                    },
                    {
                        "pretty": "Luke 9:46\u201356",
                        "readQS": "Luke+9:46-56",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+7,29,117%3B+2+Kings+1:9-15%3B+Luke+9:46-56",
                "audioQS": "Ps.7,29,117,2Kgs.1,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 94",
                        "readQS": "Psalm+94",
                        "audioQS": "Ps.94"
                    },
                    {
                        "pretty": "Jeremiah 26:1\u201315",
                        "readQS": "Jeremiah+26:1-15",
                        "audioQS": "Jer.26"
                    },
                    {
                        "pretty": "Mark 1:14\u201320",
                        "readQS": "Mark+1:14-20",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+94%3B+Jeremiah+26:1-15%3B+Mark+1:14-20",
                "audioQS": "Ps.94,Jer.26,Mark.1",
                "note": null
            }
        ]
    },
    "2026/07/26": {
        "datePretty": "Sunday, July 26, 2026",
        "calendar": "17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 119:129\u2013136",
                        "readQS": "Psalm+119:129-136",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "1 Kings 3:5\u201312",
                        "readQS": "1+Kings+3:5-12",
                        "audioQS": "1Kgs.3"
                    },
                    {
                        "pretty": "Romans 8:26\u201339",
                        "readQS": "Romans+8:26-39",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 13:31\u201333,44\u201352",
                        "readQS": "Matthew+13:31-33,44-52",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+119:129-136%3B+1+Kings+3:5-12%3B+Romans+8:26-39%3B+Matthew+13:31-33,44-52",
                "audioQS": "Ps.119,1Kgs.3,Rom.8,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 105:1\u201311,45b",
                        "readQS": "Psalm+105:1-11,45b",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Genesis 29:15\u201328",
                        "readQS": "Genesis+29:15-28",
                        "audioQS": "Gen.29"
                    },
                    {
                        "pretty": "Romans 8:26\u201339",
                        "readQS": "Romans+8:26-39",
                        "audioQS": "Rom.8"
                    },
                    {
                        "pretty": "Matthew 13:31\u201333,44\u201352",
                        "readQS": "Matthew+13:31-33,44-52",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+105:1-11,45b%3B+Genesis+29:15-28%3B+Romans+8:26-39%3B+Matthew+13:31-33,44-52",
                "audioQS": "Ps.105,Gen.29,Rom.8,Matt.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Song of Solomon 2",
                        "readQS": "Song+of+Solomon+2",
                        "audioQS": "Song.2"
                    },
                    {
                        "pretty": "1 Peter 4:7\u201314",
                        "readQS": "1+Peter+4:7-14",
                        "audioQS": "1Pet.4"
                    }
                ],
                "readQS": "Psalm+77%3B+Song+of+Solomon+2%3B+1+Peter+4:7-14",
                "audioQS": "Ps.77,Song.2,1Pet.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 75",
                        "readQS": "Psalm+75",
                        "audioQS": "Ps.75"
                    },
                    {
                        "pretty": "1 Kings 6:11\u201314,23\u201338",
                        "readQS": "1+Kings+6:11-14,23-38",
                        "audioQS": "1Kgs.6"
                    },
                    {
                        "pretty": "Acts 12:1\u201317",
                        "readQS": "Acts+12:1-17",
                        "audioQS": "Acts.12"
                    }
                ],
                "readQS": "Psalm+75%3B+1+Kings+6:11-14,23-38%3B+Acts+12:1-17",
                "audioQS": "Ps.75,1Kgs.6,Acts.12",
                "note": null
            }
        ]
    },
    "2026/07/27": {
        "datePretty": "Monday, July 27, 2026",
        "calendar": "Week of 17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 30",
                        "readQS": "Psalm+30",
                        "audioQS": "Ps.30"
                    },
                    {
                        "pretty": "1 Samuel 14:24\u201346",
                        "readQS": "1+Samuel+14:24-46",
                        "audioQS": "1Sam.14"
                    },
                    {
                        "pretty": "Luke 23:13\u201325",
                        "readQS": "Luke+23:13-25",
                        "audioQS": "Luke.23"
                    }
                ],
                "readQS": "Psalm+30%3B+1+Samuel+14:24-46%3B+Luke+23:13-25",
                "audioQS": "Ps.30,1Sam.14,Luke.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 28",
                        "readQS": "Psalm+28",
                        "audioQS": "Ps.28"
                    },
                    {
                        "pretty": "Jeremiah 31:23\u201325,31:27\u201337",
                        "readQS": "Jeremiah+31:23-25,31:27-37",
                        "audioQS": "Jer.31"
                    },
                    {
                        "pretty": "James 2:1\u201313",
                        "readQS": "James+2:1-13",
                        "audioQS": "Jas.2"
                    }
                ],
                "readQS": "Psalm+28%3B+Jeremiah+31:23-25,31:27-37%3B+James+2:1-13",
                "audioQS": "Ps.28,Jer.31,Jas.2",
                "note": null
            }
        ]
    },
    "2026/07/28": {
        "datePretty": "Tuesday, July 28, 2026",
        "calendar": "Week of 17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "1 Samuel 15:1\u201323",
                        "readQS": "1+Samuel+15:1-23",
                        "audioQS": "1Sam.15"
                    },
                    {
                        "pretty": "Luke 23:26\u201343",
                        "readQS": "Luke+23:26-43",
                        "audioQS": "Luke.23"
                    }
                ],
                "readQS": "Psalm+36%3B+1+Samuel+15:1-23%3B+Luke+23:26-43",
                "audioQS": "Ps.36,1Sam.15,Luke.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Jeremiah 32:1\u201315",
                        "readQS": "Jeremiah+32:1-15",
                        "audioQS": "Jer.32"
                    },
                    {
                        "pretty": "James 2:14\u2013end",
                        "readQS": "James+2:14-",
                        "audioQS": "Jas.2"
                    }
                ],
                "readQS": "Psalm+33%3B+Jeremiah+32:1-15%3B+James+2:14-",
                "audioQS": "Ps.33,Jer.32,Jas.2",
                "note": null
            }
        ]
    },
    "2026/07/29": {
        "datePretty": "Wednesday, July 29, 2026",
        "calendar": "Week of 17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "1 Samuel 16",
                        "readQS": "1+Samuel+16",
                        "audioQS": "1Sam.16"
                    },
                    {
                        "pretty": "Luke 23:44\u201356a",
                        "readQS": "Luke+23:44-56a",
                        "audioQS": "Luke.23"
                    }
                ],
                "readQS": "Psalm+34%3B+1+Samuel+16%3B+Luke+23:44-56a",
                "audioQS": "Ps.34,1Sam.16,Luke.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:33\u201356",
                        "readQS": "Psalm+119:33-56",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Jeremiah 33:1\u201313",
                        "readQS": "Jeremiah+33:1-13",
                        "audioQS": "Jer.33"
                    },
                    {
                        "pretty": "James 3",
                        "readQS": "James+3",
                        "audioQS": "Jas.3"
                    }
                ],
                "readQS": "Psalm+119:33-56%3B+Jeremiah+33:1-13%3B+James+3",
                "audioQS": "Ps.119,Jer.33,Jas.3",
                "note": null
            }
        ]
    },
    "2026/07/30": {
        "datePretty": "Thursday, July 30, 2026",
        "calendar": "Week of 17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 37",
                        "readQS": "Psalm+37",
                        "audioQS": "Ps.37"
                    },
                    {
                        "pretty": "1 Samuel 17:1\u201330",
                        "readQS": "1+Samuel+17:1-30",
                        "audioQS": "1Sam.17"
                    },
                    {
                        "pretty": "Luke 23:56b\u201324:12",
                        "readQS": "Luke+23:56b-24:12",
                        "audioQS": "Luke.23"
                    }
                ],
                "readQS": "Psalm+37%3B+1+Samuel+17:1-30%3B+Luke+23:56b-24:12",
                "audioQS": "Ps.37,1Sam.17,Luke.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Jeremiah 33:14\u2013end",
                        "readQS": "Jeremiah+33:14-",
                        "audioQS": "Jer.33"
                    },
                    {
                        "pretty": "James 4:1\u201312",
                        "readQS": "James+4:1-12",
                        "audioQS": "Jas.4"
                    }
                ],
                "readQS": "Psalm+40%3B+Jeremiah+33:14-%3B+James+4:1-12",
                "audioQS": "Ps.40,Jer.33,Jas.4",
                "note": null
            }
        ]
    },
    "2026/07/31": {
        "datePretty": "Friday, July 31, 2026",
        "calendar": "Week of 17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "1 Samuel 17:31\u201354",
                        "readQS": "1+Samuel+17:31-54",
                        "audioQS": "1Sam.17"
                    },
                    {
                        "pretty": "Luke 24:13\u201335",
                        "readQS": "Luke+24:13-35",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+31%3B+1+Samuel+17:31-54%3B+Luke+24:13-35",
                "audioQS": "Ps.31,1Sam.17,Luke.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 35",
                        "readQS": "Psalm+35",
                        "audioQS": "Ps.35"
                    },
                    {
                        "pretty": "Jeremiah 35",
                        "readQS": "Jeremiah+35",
                        "audioQS": "Jer.35"
                    },
                    {
                        "pretty": "James 4:13\u20135:6",
                        "readQS": "James+4:13-5:6",
                        "audioQS": "Jas.4"
                    }
                ],
                "readQS": "Psalm+35%3B+Jeremiah+35%3B+James+4:13-5:6",
                "audioQS": "Ps.35,Jer.35,Jas.4",
                "note": null
            }
        ]
    },
    "2026/08/01": {
        "datePretty": "Saturday, August 1, 2026",
        "calendar": "Week of 17th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "1 Samuel 17:55\u201318:16",
                        "readQS": "1+Samuel+17:55-18:16",
                        "audioQS": "1Sam.17"
                    },
                    {
                        "pretty": "Luke 24:36\u2013end",
                        "readQS": "Luke+24:36-",
                        "audioQS": "Luke.24"
                    }
                ],
                "readQS": "Psalm+42%3B+1+Samuel+17:55-18:16%3B+Luke+24:36-",
                "audioQS": "Ps.42,1Sam.17,Luke.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Jeremiah 36:1\u201318",
                        "readQS": "Jeremiah+36:1-18",
                        "audioQS": "Jer.36"
                    },
                    {
                        "pretty": "James 5:7\u2013end",
                        "readQS": "James+5:7-",
                        "audioQS": "Jas.5"
                    }
                ],
                "readQS": "Psalm+46%3B+Jeremiah+36:1-18%3B+James+5:7-",
                "audioQS": "Ps.46,Jer.36,Jas.5",
                "note": null
            }
        ]
    },
    "2026/08/02": {
        "datePretty": "Sunday, August 2, 2026",
        "calendar": "18th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 145:8\u20139,15\u201322",
                        "readQS": "Psalm+145:8-9,15-22",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Isaiah 55:1\u20135",
                        "readQS": "Isaiah+55:1-5",
                        "audioQS": "Isa.55"
                    },
                    {
                        "pretty": "Romans 9:1\u20135",
                        "readQS": "Romans+9:1-5",
                        "audioQS": "Rom.9"
                    },
                    {
                        "pretty": "Matthew 14:13\u201321",
                        "readQS": "Matthew+14:13-21",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+145:8-9,15-22%3B+Isaiah+55:1-5%3B+Romans+9:1-5%3B+Matthew+14:13-21",
                "audioQS": "Ps.145,Isa.55,Rom.9,Matt.14",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 17:1\u20137,16",
                        "readQS": "Psalm+17:1-7,16",
                        "audioQS": "Ps.17"
                    },
                    {
                        "pretty": "Genesis 32:22\u201331",
                        "readQS": "Genesis+32:22-31",
                        "audioQS": "Gen.32"
                    },
                    {
                        "pretty": "Romans 9:1\u20135",
                        "readQS": "Romans+9:1-5",
                        "audioQS": "Rom.9"
                    },
                    {
                        "pretty": "Matthew 14:13\u201321",
                        "readQS": "Matthew+14:13-21",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+17:1-7,16%3B+Genesis+32:22-31%3B+Romans+9:1-5%3B+Matthew+14:13-21",
                "audioQS": "Ps.17,Gen.32,Rom.9,Matt.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Song of Solomon 5:2\u201316",
                        "readQS": "Song+of+Solomon+5:2-16",
                        "audioQS": "Song.5"
                    },
                    {
                        "pretty": "2 Peter 1:1\u201315",
                        "readQS": "2+Peter+1:1-15",
                        "audioQS": "2Pet.1"
                    }
                ],
                "readQS": "Psalm+85%3B+Song+of+Solomon+5:2-16%3B+2+Peter+1:1-15",
                "audioQS": "Ps.85,Song.5,2Pet.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "1 Kings 10:1\u201313",
                        "readQS": "1+Kings+10:1-13",
                        "audioQS": "1Kgs.10"
                    },
                    {
                        "pretty": "Acts 13:1\u201313",
                        "readQS": "Acts+13:1-13",
                        "audioQS": "Acts.13"
                    }
                ],
                "readQS": "Psalm+80%3B+1+Kings+10:1-13%3B+Acts+13:1-13",
                "audioQS": "Ps.80,1Kgs.10,Acts.13",
                "note": null
            }
        ]
    },
    "2026/08/03": {
        "datePretty": "Monday, August 3, 2026",
        "calendar": "Week of 18th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "1 Samuel 19:1\u201318",
                        "readQS": "1+Samuel+19:1-18",
                        "audioQS": "1Sam.19"
                    },
                    {
                        "pretty": "Acts 1:1\u201314",
                        "readQS": "Acts+1:1-14",
                        "audioQS": "Acts.1"
                    }
                ],
                "readQS": "Psalm+44%3B+1+Samuel+19:1-18%3B+Acts+1:1-14",
                "audioQS": "Ps.44,1Sam.19,Acts.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Jeremiah 36:19\u2013end",
                        "readQS": "Jeremiah+36:19-",
                        "audioQS": "Jer.36"
                    },
                    {
                        "pretty": "Mark 1:1\u201313",
                        "readQS": "Mark+1:1-13",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+47%3B+Jeremiah+36:19-%3B+Mark+1:1-13",
                "audioQS": "Ps.47,Jer.36,Mark.1",
                "note": null
            }
        ]
    },
    "2026/08/04": {
        "datePretty": "Tuesday, August 4, 2026",
        "calendar": "Week of 18th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "1 Samuel 20:1\u201317",
                        "readQS": "1+Samuel+20:1-17",
                        "audioQS": "1Sam.20"
                    },
                    {
                        "pretty": "Acts 1:15\u2013end",
                        "readQS": "Acts+1:15-",
                        "audioQS": "Acts.1"
                    }
                ],
                "readQS": "Psalm+48%3B+1+Samuel+20:1-17%3B+Acts+1:15-",
                "audioQS": "Ps.48,1Sam.20,Acts.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Jeremiah 37",
                        "readQS": "Jeremiah+37",
                        "audioQS": "Jer.37"
                    },
                    {
                        "pretty": "Mark 1:14\u201320",
                        "readQS": "Mark+1:14-20",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+50%3B+Jeremiah+37%3B+Mark+1:14-20",
                "audioQS": "Ps.50,Jer.37,Mark.1",
                "note": null
            }
        ]
    },
    "2026/08/05": {
        "datePretty": "Wednesday, August 5, 2026",
        "calendar": "Week of 18th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:57\u201380",
                        "readQS": "Psalm+119:57-80",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "1 Samuel 20:18\u2013end",
                        "readQS": "1+Samuel+20:18-",
                        "audioQS": "1Sam.20"
                    },
                    {
                        "pretty": "Acts 2:1\u201321",
                        "readQS": "Acts+2:1-21",
                        "audioQS": "Acts.2"
                    }
                ],
                "readQS": "Psalm+119:57-80%3B+1+Samuel+20:18-%3B+Acts+2:1-21",
                "audioQS": "Ps.119,1Sam.20,Acts.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Transfiguration)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 99,110",
                        "readQS": "Psalm+99,110",
                        "audioQS": "Ps.99,110"
                    },
                    {
                        "pretty": "Exodus 24:12\u201318",
                        "readQS": "Exodus+24:12-18",
                        "audioQS": "Exod.24"
                    },
                    {
                        "pretty": "John 12:27\u201336a",
                        "readQS": "John+12:27-36a",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+99,110%3B+Exodus+24:12-18%3B+John+12:27-36a",
                "audioQS": "Ps.99,110,Exod.24,John.12",
                "note": null
            }
        ]
    },
    "2026/08/06": {
        "datePretty": "Thursday, August 6, 2026",
        "calendar": "The Transfiguration of the Beloved Son",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 27,150",
                        "readQS": "Psalm+27,150",
                        "audioQS": "Ps.27,150"
                    },
                    {
                        "pretty": "1 Kings 19:1\u201316",
                        "readQS": "1+Kings+19:1-16",
                        "audioQS": "1Kgs.19"
                    },
                    {
                        "pretty": "1 John 3:1\u20133",
                        "readQS": "1+John+3:1-3",
                        "audioQS": "1John.3"
                    }
                ],
                "readQS": "Psalm+27,150%3B+1+Kings+19:1-16%3B+1+John+3:1-3",
                "audioQS": "Ps.27,150,1Kgs.19,1John.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Exodus 34:29\u201335",
                        "readQS": "Exodus+34:29-35",
                        "audioQS": "Exod.34"
                    },
                    {
                        "pretty": "2 Corinthians 3",
                        "readQS": "2+Corinthians+3",
                        "audioQS": "2Cor.3"
                    }
                ],
                "readQS": "Psalm+72%3B+Exodus+34:29-35%3B+2+Corinthians+3",
                "audioQS": "Ps.72,Exod.34,2Cor.3",
                "note": null
            }
        ]
    },
    "2026/08/07": {
        "datePretty": "Friday, August 7, 2026",
        "calendar": "Week of 18th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 51",
                        "readQS": "Psalm+51",
                        "audioQS": "Ps.51"
                    },
                    {
                        "pretty": "1 Samuel 22:6\u2013end",
                        "readQS": "1+Samuel+22:6-",
                        "audioQS": "1Sam.22"
                    },
                    {
                        "pretty": "Acts 2:37\u2013end",
                        "readQS": "Acts+2:37-",
                        "audioQS": "Acts.2"
                    }
                ],
                "readQS": "Psalm+51%3B+1+Samuel+22:6-%3B+Acts+2:37-",
                "audioQS": "Ps.51,1Sam.22,Acts.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 38",
                        "readQS": "Psalm+38",
                        "audioQS": "Ps.38"
                    },
                    {
                        "pretty": "Jeremiah 39",
                        "readQS": "Jeremiah+39",
                        "audioQS": "Jer.39"
                    },
                    {
                        "pretty": "Mark 2:1\u201312",
                        "readQS": "Mark+2:1-12",
                        "audioQS": "Mark.2"
                    }
                ],
                "readQS": "Psalm+38%3B+Jeremiah+39%3B+Mark+2:1-12",
                "audioQS": "Ps.38,Jer.39,Mark.2",
                "note": null
            }
        ]
    },
    "2026/08/08": {
        "datePretty": "Saturday, August 8, 2026",
        "calendar": "Week of 18th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 68",
                        "readQS": "Psalm+68",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "1 Samuel 23",
                        "readQS": "1+Samuel+23",
                        "audioQS": "1Sam.23"
                    },
                    {
                        "pretty": "Acts 3:1\u201310",
                        "readQS": "Acts+3:1-10",
                        "audioQS": "Acts.3"
                    }
                ],
                "readQS": "Psalm+68%3B+1+Samuel+23%3B+Acts+3:1-10",
                "audioQS": "Ps.68,1Sam.23,Acts.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66",
                        "readQS": "Psalm+66",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Jeremiah 40",
                        "readQS": "Jeremiah+40",
                        "audioQS": "Jer.40"
                    },
                    {
                        "pretty": "Mark 2:13\u201322",
                        "readQS": "Mark+2:13-22",
                        "audioQS": "Mark.2"
                    }
                ],
                "readQS": "Psalm+66%3B+Jeremiah+40%3B+Mark+2:13-22",
                "audioQS": "Ps.66,Jer.40,Mark.2",
                "note": null
            }
        ]
    },
    "2026/08/09": {
        "datePretty": "Sunday, August 9, 2026",
        "calendar": "19th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 85:8\u201313",
                        "readQS": "Psalm+85:8-13",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "1 Kings 19:9\u201318",
                        "readQS": "1+Kings+19:9-18",
                        "audioQS": "1Kgs.19"
                    },
                    {
                        "pretty": "Romans 10:5\u201315",
                        "readQS": "Romans+10:5-15",
                        "audioQS": "Rom.10"
                    },
                    {
                        "pretty": "Matthew 14:22\u201333",
                        "readQS": "Matthew+14:22-33",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+85:8-13%3B+1+Kings+19:9-18%3B+Romans+10:5-15%3B+Matthew+14:22-33",
                "audioQS": "Ps.85,1Kgs.19,Rom.10,Matt.14",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 105:1\u20136,16\u201322,45b",
                        "readQS": "Psalm+105:1-6,16-22,45b",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Genesis 37:1\u20134,12\u201328",
                        "readQS": "Genesis+37:1-4,12-28",
                        "audioQS": "Gen.37"
                    },
                    {
                        "pretty": "Romans 10:5\u201315",
                        "readQS": "Romans+10:5-15",
                        "audioQS": "Rom.10"
                    },
                    {
                        "pretty": "Matthew 14:22\u201333",
                        "readQS": "Matthew+14:22-33",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+105:1-6,16-22,45b%3B+Genesis+37:1-4,12-28%3B+Romans+10:5-15%3B+Matthew+14:22-33",
                "audioQS": "Ps.105,Gen.37,Rom.10,Matt.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 88",
                        "readQS": "Psalm+88",
                        "audioQS": "Ps.88"
                    },
                    {
                        "pretty": "Song of Solomon 8:5\u20137",
                        "readQS": "Song+of+Solomon+8:5-7",
                        "audioQS": "Song.8"
                    },
                    {
                        "pretty": "2 Peter 3:8\u201313",
                        "readQS": "2+Peter+3:8-13",
                        "audioQS": "2Pet.3"
                    }
                ],
                "readQS": "Psalm+88%3B+Song+of+Solomon+8:5-7%3B+2+Peter+3:8-13",
                "audioQS": "Ps.88,Song.8,2Pet.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 86",
                        "readQS": "Psalm+86",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "1 Kings 11:41\u201312:20",
                        "readQS": "1+Kings+11:41-12:20",
                        "audioQS": "1Kgs.11"
                    },
                    {
                        "pretty": "Acts 14:8\u201320",
                        "readQS": "Acts+14:8-20",
                        "audioQS": "Acts.14"
                    }
                ],
                "readQS": "Psalm+86%3B+1+Kings+11:41-12:20%3B+Acts+14:8-20",
                "audioQS": "Ps.86,1Kgs.11,Acts.14",
                "note": null
            }
        ]
    },
    "2026/08/10": {
        "datePretty": "Monday, August 10, 2026",
        "calendar": "Week of 19th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "1 Samuel 24",
                        "readQS": "1+Samuel+24",
                        "audioQS": "1Sam.24"
                    },
                    {
                        "pretty": "Acts 3:11\u2013end",
                        "readQS": "Acts+3:11-",
                        "audioQS": "Acts.3"
                    }
                ],
                "readQS": "Psalm+71%3B+1+Samuel+24%3B+Acts+3:11-",
                "audioQS": "Ps.71,1Sam.24,Acts.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Jeremiah 41",
                        "readQS": "Jeremiah+41",
                        "audioQS": "Jer.41"
                    },
                    {
                        "pretty": "Mark 2:23\u20133:6",
                        "readQS": "Mark+2:23-3:6",
                        "audioQS": "Mark.2"
                    }
                ],
                "readQS": "Psalm+72%3B+Jeremiah+41%3B+Mark+2:23-3:6",
                "audioQS": "Ps.72,Jer.41,Mark.2",
                "note": null
            }
        ]
    },
    "2026/08/11": {
        "datePretty": "Tuesday, August 11, 2026",
        "calendar": "Week of 19th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "1 Samuel 26",
                        "readQS": "1+Samuel+26",
                        "audioQS": "1Sam.26"
                    },
                    {
                        "pretty": "Acts 4:1\u201312",
                        "readQS": "Acts+4:1-12",
                        "audioQS": "Acts.4"
                    }
                ],
                "readQS": "Psalm+73%3B+1+Samuel+26%3B+Acts+4:1-12",
                "audioQS": "Ps.73,1Sam.26,Acts.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 74",
                        "readQS": "Psalm+74",
                        "audioQS": "Ps.74"
                    },
                    {
                        "pretty": "Jeremiah 42",
                        "readQS": "Jeremiah+42",
                        "audioQS": "Jer.42"
                    },
                    {
                        "pretty": "Mark 3:7\u201319a",
                        "readQS": "Mark+3:7-19a",
                        "audioQS": "Mark.3"
                    }
                ],
                "readQS": "Psalm+74%3B+Jeremiah+42%3B+Mark+3:7-19a",
                "audioQS": "Ps.74,Jer.42,Mark.3",
                "note": null
            }
        ]
    },
    "2026/08/12": {
        "datePretty": "Wednesday, August 12, 2026",
        "calendar": "Week of 19th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "1 Samuel 28:3\u2013end",
                        "readQS": "1+Samuel+28:3-",
                        "audioQS": "1Sam.28"
                    },
                    {
                        "pretty": "Acts 4:13\u201331",
                        "readQS": "Acts+4:13-31",
                        "audioQS": "Acts.4"
                    }
                ],
                "readQS": "Psalm+77%3B+1+Samuel+28:3-%3B+Acts+4:13-31",
                "audioQS": "Ps.77,1Sam.28,Acts.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:81\u2013104",
                        "readQS": "Psalm+119:81-104",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Jeremiah 43",
                        "readQS": "Jeremiah+43",
                        "audioQS": "Jer.43"
                    },
                    {
                        "pretty": "Mark 3:19b\u2013end",
                        "readQS": "Mark+3:19b-",
                        "audioQS": "Mark.3"
                    }
                ],
                "readQS": "Psalm+119:81-104%3B+Jeremiah+43%3B+Mark+3:19b-",
                "audioQS": "Ps.119,Jer.43,Mark.3",
                "note": null
            }
        ]
    },
    "2026/08/13": {
        "datePretty": "Thursday, August 13, 2026",
        "calendar": "Week of 19th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 78:1\u201339",
                        "readQS": "Psalm+78:1-39",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "1 Samuel 31",
                        "readQS": "1+Samuel+31",
                        "audioQS": "1Sam.31"
                    },
                    {
                        "pretty": "Acts 4:32\u20135:11",
                        "readQS": "Acts+4:32-5:11",
                        "audioQS": "Acts.4"
                    }
                ],
                "readQS": "Psalm+78:1-39%3B+1+Samuel+31%3B+Acts+4:32-5:11",
                "audioQS": "Ps.78,1Sam.31,Acts.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 78:40\u2013end",
                        "readQS": "Psalm+78:40-",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "Jeremiah 44:1\u201314",
                        "readQS": "Jeremiah+44:1-14",
                        "audioQS": "Jer.44"
                    },
                    {
                        "pretty": "Mark 4:1\u201320",
                        "readQS": "Mark+4:1-20",
                        "audioQS": "Mark.4"
                    }
                ],
                "readQS": "Psalm+78:40-%3B+Jeremiah+44:1-14%3B+Mark+4:1-20",
                "audioQS": "Ps.78,Jer.44,Mark.4",
                "note": null
            }
        ]
    },
    "2026/08/14": {
        "datePretty": "Friday, August 14, 2026",
        "calendar": "Week of 19th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 55",
                        "readQS": "Psalm+55",
                        "audioQS": "Ps.55"
                    },
                    {
                        "pretty": "2 Samuel 1",
                        "readQS": "2+Samuel+1",
                        "audioQS": "2Sam.1"
                    },
                    {
                        "pretty": "Acts 5:12\u201326",
                        "readQS": "Acts+5:12-26",
                        "audioQS": "Acts.5"
                    }
                ],
                "readQS": "Psalm+55%3B+2+Samuel+1%3B+Acts+5:12-26",
                "audioQS": "Ps.55,2Sam.1,Acts.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of the Blessed Virgin Mary)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 72",
                        "readQS": "Psalm+72",
                        "audioQS": "Ps.72"
                    },
                    {
                        "pretty": "Proverbs 8:22\u201331",
                        "readQS": "Proverbs+8:22-31",
                        "audioQS": "Prov.8"
                    },
                    {
                        "pretty": "John 19:23\u201327",
                        "readQS": "John+19:23-27",
                        "audioQS": "John.19"
                    }
                ],
                "readQS": "Psalm+72%3B+Proverbs+8:22-31%3B+John+19:23-27",
                "audioQS": "Ps.72,Prov.8,John.19",
                "note": null
            }
        ]
    },
    "2026/08/15": {
        "datePretty": "Saturday, August 15, 2026",
        "calendar": "The Blessed Virgin Mary",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 98,138,147:1\u201311",
                        "readQS": "Psalm+98,138,147:1-11",
                        "audioQS": "Ps.98,138,147"
                    },
                    {
                        "pretty": "Isaiah 7:10\u201315",
                        "readQS": "Isaiah+7:10-15",
                        "audioQS": "Isa.7"
                    },
                    {
                        "pretty": "Luke 11:27\u201328",
                        "readQS": "Luke+11:27-28",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+98,138,147:1-11%3B+Isaiah+7:10-15%3B+Luke+11:27-28",
                "audioQS": "Ps.98,138,147,Isa.7,Luke.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "Song of Solomon 2:1\u20137",
                        "readQS": "Song+of+Solomon+2:1-7",
                        "audioQS": "Song.2"
                    },
                    {
                        "pretty": "Acts 1:6\u201314",
                        "readQS": "Acts+1:6-14",
                        "audioQS": "Acts.1"
                    }
                ],
                "readQS": "Psalm+132%3B+Song+of+Solomon+2:1-7%3B+Acts+1:6-14",
                "audioQS": "Ps.132,Song.2,Acts.1",
                "note": null
            }
        ]
    },
    "2026/08/16": {
        "datePretty": "Sunday, August 16, 2026",
        "calendar": "20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 67",
                        "readQS": "Psalm+67",
                        "audioQS": "Ps.67"
                    },
                    {
                        "pretty": "Isaiah 56:1,6\u20138",
                        "readQS": "Isaiah+56:1,6-8",
                        "audioQS": "Isa.56"
                    },
                    {
                        "pretty": "Romans 11:1\u20132a,29\u201332",
                        "readQS": "Romans+11:1-2a,29-32",
                        "audioQS": "Rom.11"
                    },
                    {
                        "pretty": "Matthew 15:(10\u201320),21\u201328",
                        "readQS": "Matthew+15:%2810-20%29,21-28",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+67%3B+Isaiah+56:1,6-8%3B+Romans+11:1-2a,29-32%3B+Matthew+15:%2810-20%29,21-28",
                "audioQS": "Ps.67,Isa.56,Rom.11,Matt.15",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 133",
                        "readQS": "Psalm+133",
                        "audioQS": "Ps.133"
                    },
                    {
                        "pretty": "Genesis 45:1\u201315",
                        "readQS": "Genesis+45:1-15",
                        "audioQS": "Gen.45"
                    },
                    {
                        "pretty": "Romans 11:1\u20132a,29\u201332",
                        "readQS": "Romans+11:1-2a,29-32",
                        "audioQS": "Rom.11"
                    },
                    {
                        "pretty": "Matthew 15:(10\u201320),21\u201328",
                        "readQS": "Matthew+15:%2810-20%29,21-28",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+133%3B+Genesis+45:1-15%3B+Romans+11:1-2a,29-32%3B+Matthew+15:%2810-20%29,21-28",
                "audioQS": "Ps.133,Gen.45,Rom.11,Matt.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 92",
                        "readQS": "Psalm+92",
                        "audioQS": "Ps.92"
                    },
                    {
                        "pretty": "Jonah 1",
                        "readQS": "Jonah+1",
                        "audioQS": "Jonah.1"
                    },
                    {
                        "pretty": "2 Peter 3:14\u201318",
                        "readQS": "2+Peter+3:14-18",
                        "audioQS": "2Pet.3"
                    }
                ],
                "readQS": "Psalm+92%3B+Jonah+1%3B+2+Peter+3:14-18",
                "audioQS": "Ps.92,Jonah.1,2Pet.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 90",
                        "readQS": "Psalm+90",
                        "audioQS": "Ps.90"
                    },
                    {
                        "pretty": "2 Kings 4:1\u201337",
                        "readQS": "2+Kings+4:1-37",
                        "audioQS": "2Kgs.4"
                    },
                    {
                        "pretty": "Acts 16:1\u201315",
                        "readQS": "Acts+16:1-15",
                        "audioQS": "Acts.16"
                    }
                ],
                "readQS": "Psalm+90%3B+2+Kings+4:1-37%3B+Acts+16:1-15",
                "audioQS": "Ps.90,2Kgs.4,Acts.16",
                "note": null
            }
        ]
    },
    "2026/08/17": {
        "datePretty": "Monday, August 17, 2026",
        "calendar": "Week of 20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "2 Samuel 3:12\u2013end",
                        "readQS": "2+Samuel+3:12-",
                        "audioQS": "2Sam.3"
                    },
                    {
                        "pretty": "Acts 6",
                        "readQS": "Acts+6",
                        "audioQS": "Acts.6"
                    }
                ],
                "readQS": "Psalm+80%3B+2+Samuel+3:12-%3B+Acts+6",
                "audioQS": "Ps.80,2Sam.3,Acts.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Micah 1:1\u20139",
                        "readQS": "Micah+1:1-9",
                        "audioQS": "Mic.1"
                    },
                    {
                        "pretty": "Mark 5:1\u201320",
                        "readQS": "Mark+5:1-20",
                        "audioQS": "Mark.5"
                    }
                ],
                "readQS": "Psalm+85%3B+Micah+1:1-9%3B+Mark+5:1-20",
                "audioQS": "Ps.85,Mic.1,Mark.5",
                "note": null
            }
        ]
    },
    "2026/08/18": {
        "datePretty": "Tuesday, August 18, 2026",
        "calendar": "Week of 20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 89:1\u201318",
                        "readQS": "Psalm+89:1-18",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "2 Samuel 5:1\u201312",
                        "readQS": "2+Samuel+5:1-12",
                        "audioQS": "2Sam.5"
                    },
                    {
                        "pretty": "Acts 7:1\u201316",
                        "readQS": "Acts+7:1-16",
                        "audioQS": "Acts.7"
                    }
                ],
                "readQS": "Psalm+89:1-18%3B+2+Samuel+5:1-12%3B+Acts+7:1-16",
                "audioQS": "Ps.89,2Sam.5,Acts.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 89:19\u2013end",
                        "readQS": "Psalm+89:19-",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Micah 2",
                        "readQS": "Micah+2",
                        "audioQS": "Mic.2"
                    },
                    {
                        "pretty": "Mark 5:21\u201334",
                        "readQS": "Mark+5:21-34",
                        "audioQS": "Mark.5"
                    }
                ],
                "readQS": "Psalm+89:19-%3B+Micah+2%3B+Mark+5:21-34",
                "audioQS": "Ps.89,Mic.2,Mark.5",
                "note": null
            }
        ]
    },
    "2026/08/19": {
        "datePretty": "Wednesday, August 19, 2026",
        "calendar": "Week of 20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:105\u2013128",
                        "readQS": "Psalm+119:105-128",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "2 Samuel 6:1\u201319",
                        "readQS": "2+Samuel+6:1-19",
                        "audioQS": "2Sam.6"
                    },
                    {
                        "pretty": "Acts 7:17\u201343",
                        "readQS": "Acts+7:17-43",
                        "audioQS": "Acts.7"
                    }
                ],
                "readQS": "Psalm+119:105-128%3B+2+Samuel+6:1-19%3B+Acts+7:17-43",
                "audioQS": "Ps.119,2Sam.6,Acts.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 91",
                        "readQS": "Psalm+91",
                        "audioQS": "Ps.91"
                    },
                    {
                        "pretty": "Micah 3",
                        "readQS": "Micah+3",
                        "audioQS": "Mic.3"
                    },
                    {
                        "pretty": "Mark 5:35\u2013end",
                        "readQS": "Mark+5:35-",
                        "audioQS": "Mark.5"
                    }
                ],
                "readQS": "Psalm+91%3B+Micah+3%3B+Mark+5:35-",
                "audioQS": "Ps.91,Mic.3,Mark.5",
                "note": null
            }
        ]
    },
    "2026/08/20": {
        "datePretty": "Thursday, August 20, 2026",
        "calendar": "Week of 20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 92",
                        "readQS": "Psalm+92",
                        "audioQS": "Ps.92"
                    },
                    {
                        "pretty": "2 Samuel 7:1\u201317",
                        "readQS": "2+Samuel+7:1-17",
                        "audioQS": "2Sam.7"
                    },
                    {
                        "pretty": "Acts 7:44\u201353",
                        "readQS": "Acts+7:44-53",
                        "audioQS": "Acts.7"
                    }
                ],
                "readQS": "Psalm+92%3B+2+Samuel+7:1-17%3B+Acts+7:44-53",
                "audioQS": "Ps.92,2Sam.7,Acts.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 94",
                        "readQS": "Psalm+94",
                        "audioQS": "Ps.94"
                    },
                    {
                        "pretty": "Micah 4:1\u20135:1",
                        "readQS": "Micah+4:1-5:1",
                        "audioQS": "Mic.4"
                    },
                    {
                        "pretty": "Mark 6:1\u201313",
                        "readQS": "Mark+6:1-13",
                        "audioQS": "Mark.6"
                    }
                ],
                "readQS": "Psalm+94%3B+Micah+4:1-5:1%3B+Mark+6:1-13",
                "audioQS": "Ps.94,Mic.4,Mark.6",
                "note": null
            }
        ]
    },
    "2026/08/21": {
        "datePretty": "Friday, August 21, 2026",
        "calendar": "Week of 20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 88",
                        "readQS": "Psalm+88",
                        "audioQS": "Ps.88"
                    },
                    {
                        "pretty": "2 Samuel 7:18\u2013end",
                        "readQS": "2+Samuel+7:18-",
                        "audioQS": "2Sam.7"
                    },
                    {
                        "pretty": "Acts 7:54\u20138:3",
                        "readQS": "Acts+7:54-8:3",
                        "audioQS": "Acts.7"
                    }
                ],
                "readQS": "Psalm+88%3B+2+Samuel+7:18-%3B+Acts+7:54-8:3",
                "audioQS": "Ps.88,2Sam.7,Acts.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 102",
                        "readQS": "Psalm+102",
                        "audioQS": "Ps.102"
                    },
                    {
                        "pretty": "Micah 5:2\u2013end",
                        "readQS": "Micah+5:2-",
                        "audioQS": "Mic.5"
                    },
                    {
                        "pretty": "Mark 6:14\u201329",
                        "readQS": "Mark+6:14-29",
                        "audioQS": "Mark.6"
                    }
                ],
                "readQS": "Psalm+102%3B+Micah+5:2-%3B+Mark+6:14-29",
                "audioQS": "Ps.102,Mic.5,Mark.6",
                "note": null
            }
        ]
    },
    "2026/08/22": {
        "datePretty": "Saturday, August 22, 2026",
        "calendar": "Week of 20th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "2 Samuel 9",
                        "readQS": "2+Samuel+9",
                        "audioQS": "2Sam.9"
                    },
                    {
                        "pretty": "Acts 8:4\u201325",
                        "readQS": "Acts+8:4-25",
                        "audioQS": "Acts.8"
                    }
                ],
                "readQS": "Psalm+97%3B+2+Samuel+9%3B+Acts+8:4-25",
                "audioQS": "Ps.97,2Sam.9,Acts.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 104",
                        "readQS": "Psalm+104",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Micah 6",
                        "readQS": "Micah+6",
                        "audioQS": "Mic.6"
                    },
                    {
                        "pretty": "Mark 6:30\u201344",
                        "readQS": "Mark+6:30-44",
                        "audioQS": "Mark.6"
                    }
                ],
                "readQS": "Psalm+104%3B+Micah+6%3B+Mark+6:30-44",
                "audioQS": "Ps.104,Mic.6,Mark.6",
                "note": null
            }
        ]
    },
    "2026/08/23": {
        "datePretty": "Sunday, August 23, 2026",
        "calendar": "21st Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "Isaiah 51:1\u20136",
                        "readQS": "Isaiah+51:1-6",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "Romans 12:1\u20138",
                        "readQS": "Romans+12:1-8",
                        "audioQS": "Rom.12"
                    },
                    {
                        "pretty": "Matthew 16:13\u201320",
                        "readQS": "Matthew+16:13-20",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+138%3B+Isaiah+51:1-6%3B+Romans+12:1-8%3B+Matthew+16:13-20",
                "audioQS": "Ps.138,Isa.51,Rom.12,Matt.16",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 124",
                        "readQS": "Psalm+124",
                        "audioQS": "Ps.124"
                    },
                    {
                        "pretty": "Exodus 1:8\u20132:10",
                        "readQS": "Exodus+1:8-2:10",
                        "audioQS": "Exod.1"
                    },
                    {
                        "pretty": "Romans 12:1\u20138",
                        "readQS": "Romans+12:1-8",
                        "audioQS": "Rom.12"
                    },
                    {
                        "pretty": "Matthew 16:13\u201320",
                        "readQS": "Matthew+16:13-20",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+124%3B+Exodus+1:8-2:10%3B+Romans+12:1-8%3B+Matthew+16:13-20",
                "audioQS": "Ps.124,Exod.1,Rom.12,Matt.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 104:1\u201325",
                        "readQS": "Psalm+104:1-25",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Jonah 2",
                        "readQS": "Jonah+2",
                        "audioQS": "Jonah.2"
                    },
                    {
                        "pretty": "Revelation 1",
                        "readQS": "Revelation+1",
                        "audioQS": "Rev.1"
                    }
                ],
                "readQS": "Psalm+104:1-25%3B+Jonah+2%3B+Revelation+1",
                "audioQS": "Ps.104,Jonah.2,Rev.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Bartholomew)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Isaiah 61:1\u20139",
                        "readQS": "Isaiah+61:1-9",
                        "audioQS": "Isa.61"
                    },
                    {
                        "pretty": "2 Corinthians 6:1\u201310",
                        "readQS": "2+Corinthians+6:1-10",
                        "audioQS": "2Cor.6"
                    }
                ],
                "readQS": "Psalm+97%3B+Isaiah+61:1-9%3B+2+Corinthians+6:1-10",
                "audioQS": "Ps.97,Isa.61,2Cor.6",
                "note": null
            }
        ]
    },
    "2026/08/24": {
        "datePretty": "Monday, August 24, 2026",
        "calendar": "St Bartholomew the Apostle",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 86,117",
                        "readQS": "Psalm+86,117",
                        "audioQS": "Ps.86,117"
                    },
                    {
                        "pretty": "Genesis 28:10\u201317",
                        "readQS": "Genesis+28:10-17",
                        "audioQS": "Gen.28"
                    },
                    {
                        "pretty": "John 1:43\u201351",
                        "readQS": "John+1:43-51",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+86,117%3B+Genesis+28:10-17%3B+John+1:43-51",
                "audioQS": "Ps.86,117,Gen.28,John.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 91,116",
                        "readQS": "Psalm+91,116",
                        "audioQS": "Ps.91,116"
                    },
                    {
                        "pretty": "Deuteronomy 18:15\u201319",
                        "readQS": "Deuteronomy+18:15-19",
                        "audioQS": "Deut.18"
                    },
                    {
                        "pretty": "Matthew 10:1\u201322",
                        "readQS": "Matthew+10:1-22",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+91,116%3B+Deuteronomy+18:15-19%3B+Matthew+10:1-22",
                "audioQS": "Ps.91,116,Deut.18,Matt.10",
                "note": null
            }
        ]
    },
    "2026/08/25": {
        "datePretty": "Tuesday, August 25, 2026",
        "calendar": "Week of 21st Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 106",
                        "readQS": "Psalm+106",
                        "audioQS": "Ps.106"
                    },
                    {
                        "pretty": "2 Samuel 12:1\u201325",
                        "readQS": "2+Samuel+12:1-25",
                        "audioQS": "2Sam.12"
                    },
                    {
                        "pretty": "Acts 9:1\u201319a",
                        "readQS": "Acts+9:1-19a",
                        "audioQS": "Acts.9"
                    }
                ],
                "readQS": "Psalm+106%3B+2+Samuel+12:1-25%3B+Acts+9:1-19a",
                "audioQS": "Ps.106,2Sam.12,Acts.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 107",
                        "readQS": "Psalm+107",
                        "audioQS": "Ps.107"
                    },
                    {
                        "pretty": "Micah 7:8\u2013end",
                        "readQS": "Micah+7:8-",
                        "audioQS": "Mic.7"
                    },
                    {
                        "pretty": "Mark 7:1\u201313",
                        "readQS": "Mark+7:1-13",
                        "audioQS": "Mark.7"
                    }
                ],
                "readQS": "Psalm+107%3B+Micah+7:8-%3B+Mark+7:1-13",
                "audioQS": "Ps.107,Mic.7,Mark.7",
                "note": null
            }
        ]
    },
    "2026/08/26": {
        "datePretty": "Wednesday, August 26, 2026",
        "calendar": "Week of 21st Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 111",
                        "readQS": "Psalm+111",
                        "audioQS": "Ps.111"
                    },
                    {
                        "pretty": "2 Samuel 15:1\u201312",
                        "readQS": "2+Samuel+15:1-12",
                        "audioQS": "2Sam.15"
                    },
                    {
                        "pretty": "Acts 9:19b\u201331",
                        "readQS": "Acts+9:19b-31",
                        "audioQS": "Acts.9"
                    }
                ],
                "readQS": "Psalm+111%3B+2+Samuel+15:1-12%3B+Acts+9:19b-31",
                "audioQS": "Ps.111,2Sam.15,Acts.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:129\u2013152",
                        "readQS": "Psalm+119:129-152",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Habakkuk 1:1\u201311",
                        "readQS": "Habakkuk+1:1-11",
                        "audioQS": "Hab.1"
                    },
                    {
                        "pretty": "Mark 7:14\u201323",
                        "readQS": "Mark+7:14-23",
                        "audioQS": "Mark.7"
                    }
                ],
                "readQS": "Psalm+119:129-152%3B+Habakkuk+1:1-11%3B+Mark+7:14-23",
                "audioQS": "Ps.119,Hab.1,Mark.7",
                "note": null
            }
        ]
    },
    "2026/08/27": {
        "datePretty": "Thursday, August 27, 2026",
        "calendar": "Week of 21st Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 115",
                        "readQS": "Psalm+115",
                        "audioQS": "Ps.115"
                    },
                    {
                        "pretty": "2 Samuel 15:13\u2013end",
                        "readQS": "2+Samuel+15:13-",
                        "audioQS": "2Sam.15"
                    },
                    {
                        "pretty": "Acts 9:32\u2013end",
                        "readQS": "Acts+9:32-",
                        "audioQS": "Acts.9"
                    }
                ],
                "readQS": "Psalm+115%3B+2+Samuel+15:13-%3B+Acts+9:32-",
                "audioQS": "Ps.115,2Sam.15,Acts.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Habakkuk 1:12\u20132:5",
                        "readQS": "Habakkuk+1:12-2:5",
                        "audioQS": "Hab.1"
                    },
                    {
                        "pretty": "Mark 7:24\u201330",
                        "readQS": "Mark+7:24-30",
                        "audioQS": "Mark.7"
                    }
                ],
                "readQS": "Psalm+116%3B+Habakkuk+1:12-2:5%3B+Mark+7:24-30",
                "audioQS": "Ps.116,Hab.1,Mark.7",
                "note": null
            }
        ]
    },
    "2026/08/28": {
        "datePretty": "Friday, August 28, 2026",
        "calendar": "Week of 21st Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "2 Samuel 16:1\u201314",
                        "readQS": "2+Samuel+16:1-14",
                        "audioQS": "2Sam.16"
                    },
                    {
                        "pretty": "Acts 10:1\u201316",
                        "readQS": "Acts+10:1-16",
                        "audioQS": "Acts.10"
                    }
                ],
                "readQS": "Psalm+139%3B+2+Samuel+16:1-14%3B+Acts+10:1-16",
                "audioQS": "Ps.139,2Sam.16,Acts.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 130",
                        "readQS": "Psalm+130",
                        "audioQS": "Ps.130"
                    },
                    {
                        "pretty": "Habakkuk 2:6\u2013end",
                        "readQS": "Habakkuk+2:6-",
                        "audioQS": "Hab.2"
                    },
                    {
                        "pretty": "Mark 7:31\u2013end",
                        "readQS": "Mark+7:31-",
                        "audioQS": "Mark.7"
                    }
                ],
                "readQS": "Psalm+130%3B+Habakkuk+2:6-%3B+Mark+7:31-",
                "audioQS": "Ps.130,Hab.2,Mark.7",
                "note": null
            }
        ]
    },
    "2026/08/29": {
        "datePretty": "Saturday, August 29, 2026",
        "calendar": "Week of 21st Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 121",
                        "readQS": "Psalm+121",
                        "audioQS": "Ps.121"
                    },
                    {
                        "pretty": "2 Samuel 17:1\u201323",
                        "readQS": "2+Samuel+17:1-23",
                        "audioQS": "2Sam.17"
                    },
                    {
                        "pretty": "Acts 10:17\u201333",
                        "readQS": "Acts+10:17-33",
                        "audioQS": "Acts.10"
                    }
                ],
                "readQS": "Psalm+121%3B+2+Samuel+17:1-23%3B+Acts+10:17-33",
                "audioQS": "Ps.121,2Sam.17,Acts.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Habakkuk 3:2\u201319a",
                        "readQS": "Habakkuk+3:2-19a",
                        "audioQS": "Hab.3"
                    },
                    {
                        "pretty": "Mark 8:1\u201310",
                        "readQS": "Mark+8:1-10",
                        "audioQS": "Mark.8"
                    }
                ],
                "readQS": "Psalm+118%3B+Habakkuk+3:2-19a%3B+Mark+8:1-10",
                "audioQS": "Ps.118,Hab.3,Mark.8",
                "note": null
            }
        ]
    },
    "2026/08/30": {
        "datePretty": "Sunday, August 30, 2026",
        "calendar": "22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 26:1\u20138",
                        "readQS": "Psalm+26:1-8",
                        "audioQS": "Ps.26"
                    },
                    {
                        "pretty": "Jeremiah 15:15\u201321",
                        "readQS": "Jeremiah+15:15-21",
                        "audioQS": "Jer.15"
                    },
                    {
                        "pretty": "Romans 12:9\u201321",
                        "readQS": "Romans+12:9-21",
                        "audioQS": "Rom.12"
                    },
                    {
                        "pretty": "Matthew 16:21\u201328",
                        "readQS": "Matthew+16:21-28",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+26:1-8%3B+Jeremiah+15:15-21%3B+Romans+12:9-21%3B+Matthew+16:21-28",
                "audioQS": "Ps.26,Jer.15,Rom.12,Matt.16",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 105:1\u20136,23\u201326,45b",
                        "readQS": "Psalm+105:1-6,23-26,45b",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Exodus 3:1\u201315",
                        "readQS": "Exodus+3:1-15",
                        "audioQS": "Exod.3"
                    },
                    {
                        "pretty": "Romans 12:9\u201321",
                        "readQS": "Romans+12:9-21",
                        "audioQS": "Rom.12"
                    },
                    {
                        "pretty": "Matthew 16:21\u201328",
                        "readQS": "Matthew+16:21-28",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+105:1-6,23-26,45b%3B+Exodus+3:1-15%3B+Romans+12:9-21%3B+Matthew+16:21-28",
                "audioQS": "Ps.105,Exod.3,Rom.12,Matt.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 107:1\u201332",
                        "readQS": "Psalm+107:1-32",
                        "audioQS": "Ps.107"
                    },
                    {
                        "pretty": "Jonah 3:1\u20139",
                        "readQS": "Jonah+3:1-9",
                        "audioQS": "Jonah.3"
                    },
                    {
                        "pretty": "Revelation 3:14\u201322",
                        "readQS": "Revelation+3:14-22",
                        "audioQS": "Rev.3"
                    }
                ],
                "readQS": "Psalm+107:1-32%3B+Jonah+3:1-9%3B+Revelation+3:14-22",
                "audioQS": "Ps.107,Jonah.3,Rev.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 105:1\u201315",
                        "readQS": "Psalm+105:1-15",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "2 Kings 6:24\u201325,7:3\u201320",
                        "readQS": "2+Kings+6:24-25,7:3-20",
                        "audioQS": "2Kgs.6"
                    },
                    {
                        "pretty": "Acts 18:1\u201316",
                        "readQS": "Acts+18:1-16",
                        "audioQS": "Acts.18"
                    }
                ],
                "readQS": "Psalm+105:1-15%3B+2+Kings+6:24-25,7:3-20%3B+Acts+18:1-16",
                "audioQS": "Ps.105,2Kgs.6,Acts.18",
                "note": null
            }
        ]
    },
    "2026/08/31": {
        "datePretty": "Monday, August 31, 2026",
        "calendar": "Week of 22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 126",
                        "readQS": "Psalm+126",
                        "audioQS": "Ps.126"
                    },
                    {
                        "pretty": "2 Samuel 18:1\u201318",
                        "readQS": "2+Samuel+18:1-18",
                        "audioQS": "2Sam.18"
                    },
                    {
                        "pretty": "Acts 10:34\u2013end",
                        "readQS": "Acts+10:34-",
                        "audioQS": "Acts.10"
                    }
                ],
                "readQS": "Psalm+126%3B+2+Samuel+18:1-18%3B+Acts+10:34-",
                "audioQS": "Ps.126,2Sam.18,Acts.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 127",
                        "readQS": "Psalm+127",
                        "audioQS": "Ps.127"
                    },
                    {
                        "pretty": "Haggai 1:1\u201311",
                        "readQS": "Haggai+1:1-11",
                        "audioQS": "Hag.1"
                    },
                    {
                        "pretty": "Mark 8:11\u201321",
                        "readQS": "Mark+8:11-21",
                        "audioQS": "Mark.8"
                    }
                ],
                "readQS": "Psalm+127%3B+Haggai+1:1-11%3B+Mark+8:11-21",
                "audioQS": "Ps.127,Hag.1,Mark.8",
                "note": null
            }
        ]
    },
    "2026/09/01": {
        "datePretty": "Tuesday, September 1, 2026",
        "calendar": "Week of 22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "2 Samuel 18:19\u201319:8a",
                        "readQS": "2+Samuel+18:19-19:8a",
                        "audioQS": "2Sam.18"
                    },
                    {
                        "pretty": "Acts 11:1\u201318",
                        "readQS": "Acts+11:1-18",
                        "audioQS": "Acts.11"
                    }
                ],
                "readQS": "Psalm+132%3B+2+Samuel+18:19-19:8a%3B+Acts+11:1-18",
                "audioQS": "Ps.132,2Sam.18,Acts.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Haggai 1:12\u20132:9",
                        "readQS": "Haggai+1:12-2:9",
                        "audioQS": "Hag.1"
                    },
                    {
                        "pretty": "Mark 8:22\u201326",
                        "readQS": "Mark+8:22-26",
                        "audioQS": "Mark.8"
                    }
                ],
                "readQS": "Psalm+135%3B+Haggai+1:12-2:9%3B+Mark+8:22-26",
                "audioQS": "Ps.135,Hag.1,Mark.8",
                "note": null
            }
        ]
    },
    "2026/09/02": {
        "datePretty": "Wednesday, September 2, 2026",
        "calendar": "Week of 22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:153\u2013end",
                        "readQS": "Psalm+119:153-",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "2 Samuel 19:8b\u201323",
                        "readQS": "2+Samuel+19:8b-23",
                        "audioQS": "2Sam.19"
                    },
                    {
                        "pretty": "Acts 11:19\u2013end",
                        "readQS": "Acts+11:19-",
                        "audioQS": "Acts.11"
                    }
                ],
                "readQS": "Psalm+119:153-%3B+2+Samuel+19:8b-23%3B+Acts+11:19-",
                "audioQS": "Ps.119,2Sam.19,Acts.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Haggai 2:10\u2013end",
                        "readQS": "Haggai+2:10-",
                        "audioQS": "Hag.2"
                    },
                    {
                        "pretty": "Mark 8:27\u20139:1",
                        "readQS": "Mark+8:27-9:1",
                        "audioQS": "Mark.8"
                    }
                ],
                "readQS": "Psalm+136%3B+Haggai+2:10-%3B+Mark+8:27-9:1",
                "audioQS": "Ps.136,Hag.2,Mark.8",
                "note": null
            }
        ]
    },
    "2026/09/03": {
        "datePretty": "Thursday, September 3, 2026",
        "calendar": "Week of 22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 143",
                        "readQS": "Psalm+143",
                        "audioQS": "Ps.143"
                    },
                    {
                        "pretty": "2 Samuel 19:24\u2013end",
                        "readQS": "2+Samuel+19:24-",
                        "audioQS": "2Sam.19"
                    },
                    {
                        "pretty": "Acts 12:1\u201317",
                        "readQS": "Acts+12:1-17",
                        "audioQS": "Acts.12"
                    }
                ],
                "readQS": "Psalm+143%3B+2+Samuel+19:24-%3B+Acts+12:1-17",
                "audioQS": "Ps.143,2Sam.19,Acts.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "Zechariah 1:1\u201317",
                        "readQS": "Zechariah+1:1-17",
                        "audioQS": "Zech.1"
                    },
                    {
                        "pretty": "Mark 9:2\u201313",
                        "readQS": "Mark+9:2-13",
                        "audioQS": "Mark.9"
                    }
                ],
                "readQS": "Psalm+138%3B+Zechariah+1:1-17%3B+Mark+9:2-13",
                "audioQS": "Ps.138,Zech.1,Mark.9",
                "note": null
            }
        ]
    },
    "2026/09/04": {
        "datePretty": "Friday, September 4, 2026",
        "calendar": "Week of 22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "2 Samuel 23:1\u20137",
                        "readQS": "2+Samuel+23:1-7",
                        "audioQS": "2Sam.23"
                    },
                    {
                        "pretty": "Acts 12:18\u2013end",
                        "readQS": "Acts+12:18-",
                        "audioQS": "Acts.12"
                    }
                ],
                "readQS": "Psalm+144%3B+2+Samuel+23:1-7%3B+Acts+12:18-",
                "audioQS": "Ps.144,2Sam.23,Acts.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Zechariah 1:18\u2013end",
                        "readQS": "Zechariah+1:18-",
                        "audioQS": "Zech.1"
                    },
                    {
                        "pretty": "Zechariah 2",
                        "readQS": "Zechariah+2",
                        "audioQS": "Zech.2"
                    },
                    {
                        "pretty": "Mark 9:14\u201329",
                        "readQS": "Mark+9:14-29",
                        "audioQS": "Mark.9"
                    }
                ],
                "readQS": "Psalm+145%3B+Zechariah+1:18-%3B+Zechariah+2%3B+Mark+9:14-29",
                "audioQS": "Ps.145,Zech.1,Zech.2,Mark.9",
                "note": null
            }
        ]
    },
    "2026/09/05": {
        "datePretty": "Saturday, September 5, 2026",
        "calendar": "Week of 22nd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 147",
                        "readQS": "Psalm+147",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "2 Samuel 24",
                        "readQS": "2+Samuel+24",
                        "audioQS": "2Sam.24"
                    },
                    {
                        "pretty": "Acts 13:1\u201312",
                        "readQS": "Acts+13:1-12",
                        "audioQS": "Acts.13"
                    }
                ],
                "readQS": "Psalm+147%3B+2+Samuel+24%3B+Acts+13:1-12",
                "audioQS": "Ps.147,2Sam.24,Acts.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Zechariah 3",
                        "readQS": "Zechariah+3",
                        "audioQS": "Zech.3"
                    },
                    {
                        "pretty": "Mark 9:30\u201337",
                        "readQS": "Mark+9:30-37",
                        "audioQS": "Mark.9"
                    }
                ],
                "readQS": "Psalm+148%3B+Zechariah+3%3B+Mark+9:30-37",
                "audioQS": "Ps.148,Zech.3,Mark.9",
                "note": null
            }
        ]
    },
    "2026/09/06": {
        "datePretty": "Sunday, September 6, 2026",
        "calendar": "23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 119:33\u201340",
                        "readQS": "Psalm+119:33-40",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Ezekiel 33:7\u201311",
                        "readQS": "Ezekiel+33:7-11",
                        "audioQS": "Ezek.33"
                    },
                    {
                        "pretty": "Romans 13:8\u201314",
                        "readQS": "Romans+13:8-14",
                        "audioQS": "Rom.13"
                    },
                    {
                        "pretty": "Matthew 18:15\u201320",
                        "readQS": "Matthew+18:15-20",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+119:33-40%3B+Ezekiel+33:7-11%3B+Romans+13:8-14%3B+Matthew+18:15-20",
                "audioQS": "Ps.119,Ezek.33,Rom.13,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 149",
                        "readQS": "Psalm+149",
                        "audioQS": "Ps.149"
                    },
                    {
                        "pretty": "Exodus 12:1\u201314",
                        "readQS": "Exodus+12:1-14",
                        "audioQS": "Exod.12"
                    },
                    {
                        "pretty": "Romans 13:8\u201314",
                        "readQS": "Romans+13:8-14",
                        "audioQS": "Rom.13"
                    },
                    {
                        "pretty": "Matthew 18:15\u201320",
                        "readQS": "Matthew+18:15-20",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+149%3B+Exodus+12:1-14%3B+Romans+13:8-14%3B+Matthew+18:15-20",
                "audioQS": "Ps.149,Exod.12,Rom.13,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:17\u201332",
                        "readQS": "Psalm+119:17-32",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Jonah 3:10\u20134:11",
                        "readQS": "Jonah+3:10-4:11",
                        "audioQS": "Jonah.3"
                    },
                    {
                        "pretty": "Revelation 8:1\u20135",
                        "readQS": "Revelation+8:1-5",
                        "audioQS": "Rev.8"
                    }
                ],
                "readQS": "Psalm+119:17-32%3B+Jonah+3:10-4:11%3B+Revelation+8:1-5",
                "audioQS": "Ps.119,Jonah.3,Rev.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 108",
                        "readQS": "Psalm+108",
                        "audioQS": "Ps.108"
                    },
                    {
                        "pretty": "Ezekiel 12:21\u201313:16",
                        "readQS": "Ezekiel+12:21-13:16",
                        "audioQS": "Ezek.12"
                    },
                    {
                        "pretty": "Acts 19:1\u201320",
                        "readQS": "Acts+19:1-20",
                        "audioQS": "Acts.19"
                    }
                ],
                "readQS": "Psalm+108%3B+Ezekiel+12:21-13:16%3B+Acts+19:1-20",
                "audioQS": "Ps.108,Ezek.12,Acts.19",
                "note": null
            }
        ]
    },
    "2026/09/07": {
        "datePretty": "Monday, September 7, 2026",
        "calendar": "Week of 23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 1",
                        "readQS": "Psalm+1",
                        "audioQS": "Ps.1"
                    },
                    {
                        "pretty": "1 Kings 1:5\u201331",
                        "readQS": "1+Kings+1:5-31",
                        "audioQS": "1Kgs.1"
                    },
                    {
                        "pretty": "Acts 13:13\u201343",
                        "readQS": "Acts+13:13-43",
                        "audioQS": "Acts.13"
                    }
                ],
                "readQS": "Psalm+1%3B+1+Kings+1:5-31%3B+Acts+13:13-43",
                "audioQS": "Ps.1,1Kgs.1,Acts.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 4",
                        "readQS": "Psalm+4",
                        "audioQS": "Ps.4"
                    },
                    {
                        "pretty": "Zechariah 4",
                        "readQS": "Zechariah+4",
                        "audioQS": "Zech.4"
                    },
                    {
                        "pretty": "Mark 9:38\u2013end",
                        "readQS": "Mark+9:38-",
                        "audioQS": "Mark.9"
                    }
                ],
                "readQS": "Psalm+4%3B+Zechariah+4%3B+Mark+9:38-",
                "audioQS": "Ps.4,Zech.4,Mark.9",
                "note": null
            }
        ]
    },
    "2026/09/08": {
        "datePretty": "Tuesday, September 8, 2026",
        "calendar": "Week of 23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "1 Kings 1:32\u20132:4,2:10\u201312",
                        "readQS": "1+Kings+1:32-2:4,2:10-12",
                        "audioQS": "1Kgs.1"
                    },
                    {
                        "pretty": "Acts 13:44\u201314:7",
                        "readQS": "Acts+13:44-14:7",
                        "audioQS": "Acts.13"
                    }
                ],
                "readQS": "Psalm+5%3B+1+Kings+1:32-2:4,2:10-12%3B+Acts+13:44-14:7",
                "audioQS": "Ps.5,1Kgs.1,Acts.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Zechariah 6:9\u2013end",
                        "readQS": "Zechariah+6:9-",
                        "audioQS": "Zech.6"
                    },
                    {
                        "pretty": "Mark 10:1\u201316",
                        "readQS": "Mark+10:1-16",
                        "audioQS": "Mark.10"
                    }
                ],
                "readQS": "Psalm+9%3B+Zechariah+6:9-%3B+Mark+10:1-16",
                "audioQS": "Ps.9,Zech.6,Mark.10",
                "note": null
            }
        ]
    },
    "2026/09/09": {
        "datePretty": "Wednesday, September 9, 2026",
        "calendar": "Week of 23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:1\u201332",
                        "readQS": "Psalm+119:1-32",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "1 Kings 3",
                        "readQS": "1+Kings+3",
                        "audioQS": "1Kgs.3"
                    },
                    {
                        "pretty": "Acts 14:8\u2013end",
                        "readQS": "Acts+14:8-",
                        "audioQS": "Acts.14"
                    }
                ],
                "readQS": "Psalm+119:1-32%3B+1+Kings+3%3B+Acts+14:8-",
                "audioQS": "Ps.119,1Kgs.3,Acts.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "Zechariah 7",
                        "readQS": "Zechariah+7",
                        "audioQS": "Zech.7"
                    },
                    {
                        "pretty": "Mark 10:17\u201331",
                        "readQS": "Mark+10:17-31",
                        "audioQS": "Mark.10"
                    }
                ],
                "readQS": "Psalm+11%3B+Zechariah+7%3B+Mark+10:17-31",
                "audioQS": "Ps.11,Zech.7,Mark.10",
                "note": null
            }
        ]
    },
    "2026/09/10": {
        "datePretty": "Thursday, September 10, 2026",
        "calendar": "Week of 23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15",
                        "readQS": "Psalm+15",
                        "audioQS": "Ps.15"
                    },
                    {
                        "pretty": "1 Kings 4:29\u20135:12",
                        "readQS": "1+Kings+4:29-5:12",
                        "audioQS": "1Kgs.4"
                    },
                    {
                        "pretty": "Acts 15:1\u201321",
                        "readQS": "Acts+15:1-21",
                        "audioQS": "Acts.15"
                    }
                ],
                "readQS": "Psalm+15%3B+1+Kings+4:29-5:12%3B+Acts+15:1-21",
                "audioQS": "Ps.15,1Kgs.4,Acts.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 18",
                        "readQS": "Psalm+18",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "Zechariah 8:1\u20138",
                        "readQS": "Zechariah+8:1-8",
                        "audioQS": "Zech.8"
                    },
                    {
                        "pretty": "Mark 10:32\u201334",
                        "readQS": "Mark+10:32-34",
                        "audioQS": "Mark.10"
                    }
                ],
                "readQS": "Psalm+18%3B+Zechariah+8:1-8%3B+Mark+10:32-34",
                "audioQS": "Ps.18,Zech.8,Mark.10",
                "note": null
            }
        ]
    },
    "2026/09/11": {
        "datePretty": "Friday, September 11, 2026",
        "calendar": "Week of 23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "1 Kings 6:1,6:11\u201328",
                        "readQS": "1+Kings+6:1,6:11-28",
                        "audioQS": "1Kgs.6"
                    },
                    {
                        "pretty": "Acts 15:22\u201335",
                        "readQS": "Acts+15:22-35",
                        "audioQS": "Acts.15"
                    }
                ],
                "readQS": "Psalm+19%3B+1+Kings+6:1,6:11-28%3B+Acts+15:22-35",
                "audioQS": "Ps.19,1Kgs.6,Acts.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Zechariah 8:9\u2013end",
                        "readQS": "Zechariah+8:9-",
                        "audioQS": "Zech.8"
                    },
                    {
                        "pretty": "Mark 10:35\u201345",
                        "readQS": "Mark+10:35-45",
                        "audioQS": "Mark.10"
                    }
                ],
                "readQS": "Psalm+22%3B+Zechariah+8:9-%3B+Mark+10:35-45",
                "audioQS": "Ps.22,Zech.8,Mark.10",
                "note": null
            }
        ]
    },
    "2026/09/12": {
        "datePretty": "Saturday, September 12, 2026",
        "calendar": "Week of 23rd Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "1 Kings 8:1\u201330",
                        "readQS": "1+Kings+8:1-30",
                        "audioQS": "1Kgs.8"
                    },
                    {
                        "pretty": "Acts 15:36\u201316:5",
                        "readQS": "Acts+15:36-16:5",
                        "audioQS": "Acts.15"
                    }
                ],
                "readQS": "Psalm+23%3B+1+Kings+8:1-30%3B+Acts+15:36-16:5",
                "audioQS": "Ps.23,1Kgs.8,Acts.15",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 24",
                        "readQS": "Psalm+24",
                        "audioQS": "Ps.24"
                    },
                    {
                        "pretty": "Zechariah 9:1\u201312",
                        "readQS": "Zechariah+9:1-12",
                        "audioQS": "Zech.9"
                    },
                    {
                        "pretty": "Mark 10:46\u2013end",
                        "readQS": "Mark+10:46-",
                        "audioQS": "Mark.10"
                    }
                ],
                "readQS": "Psalm+24%3B+Zechariah+9:1-12%3B+Mark+10:46-",
                "audioQS": "Ps.24,Zech.9,Mark.10",
                "note": null
            }
        ]
    },
    "2026/09/13": {
        "datePretty": "Sunday, September 13, 2026",
        "calendar": "24th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 103:(1\u20137),8\u201313",
                        "readQS": "Psalm+103:%281-7%29,8-13",
                        "audioQS": "Ps.103"
                    },
                    {
                        "pretty": "Genesis 50:15\u201321",
                        "readQS": "Genesis+50:15-21",
                        "audioQS": "Gen.50"
                    },
                    {
                        "pretty": "Romans 14:1\u201312",
                        "readQS": "Romans+14:1-12",
                        "audioQS": "Rom.14"
                    },
                    {
                        "pretty": "Matthew 18:21\u201335",
                        "readQS": "Matthew+18:21-35",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+103:%281-7%29,8-13%3B+Genesis+50:15-21%3B+Romans+14:1-12%3B+Matthew+18:21-35",
                "audioQS": "Ps.103,Gen.50,Rom.14,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 114",
                        "readQS": "Psalm+114",
                        "audioQS": "Ps.114"
                    },
                    {
                        "pretty": "Canticle: Exodus 15:1b\u201311,20\u201321",
                        "readQS": "Exodus+15:1b-11,20-21",
                        "audioQS": "Exod.15"
                    },
                    {
                        "pretty": "Exodus 14:19\u201331",
                        "readQS": "Exodus+14:19-31",
                        "audioQS": "Exod.14"
                    },
                    {
                        "pretty": "Romans 14:1\u201312",
                        "readQS": "Romans+14:1-12",
                        "audioQS": "Rom.14"
                    },
                    {
                        "pretty": "Matthew 18:21\u201335",
                        "readQS": "Matthew+18:21-35",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+114%3B+Canticle:+Exodus+15:1b-11,20-21%3B+Exodus+14:19-31%3B+Romans+14:1-12%3B+Matthew+18:21-35",
                "audioQS": "Ps.114,Canticle,Exod.14,Rom.14,Matt.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:65\u201388",
                        "readQS": "Psalm+119:65-88",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Isaiah 44:24\u201345:8",
                        "readQS": "Isaiah+44:24-45:8",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 12:1\u201312",
                        "readQS": "Revelation+12:1-12",
                        "audioQS": "Rev.12"
                    }
                ],
                "readQS": "Psalm+119:65-88%3B+Isaiah+44:24-45:8%3B+Revelation+12:1-12",
                "audioQS": "Ps.119,Isa.44,Rev.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Holy Cross Day)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66",
                        "readQS": "Psalm+66",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Isaiah 52:13\u201353:12",
                        "readQS": "Isaiah+52:13-53:12",
                        "audioQS": "Isa.52"
                    },
                    {
                        "pretty": "Ephesians 2:11\u201322",
                        "readQS": "Ephesians+2:11-22",
                        "audioQS": "Eph.2"
                    }
                ],
                "readQS": "Psalm+66%3B+Isaiah+52:13-53:12%3B+Ephesians+2:11-22",
                "audioQS": "Ps.66,Isa.52,Eph.2",
                "note": null
            }
        ]
    },
    "2026/09/14": {
        "datePretty": "Monday, September 14, 2026",
        "calendar": "Holy Cross Day",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 2,8,146",
                        "readQS": "Psalm+2,8,146",
                        "audioQS": "Ps.2,8,146"
                    },
                    {
                        "pretty": "Genesis 3:1\u201315",
                        "readQS": "Genesis+3:1-15",
                        "audioQS": "Gen.3"
                    },
                    {
                        "pretty": "John 12:27\u201336a",
                        "readQS": "John+12:27-36a",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+2,8,146%3B+Genesis+3:1-15%3B+John+12:27-36a",
                "audioQS": "Ps.2,8,146,Gen.3,John.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 110,150",
                        "readQS": "Psalm+110,150",
                        "audioQS": "Ps.110,150"
                    },
                    {
                        "pretty": "Isaiah 63:1\u201316",
                        "readQS": "Isaiah+63:1-16",
                        "audioQS": "Isa.63"
                    },
                    {
                        "pretty": "1 Corinthians 1:18\u201325",
                        "readQS": "1+Corinthians+1:18-25",
                        "audioQS": "1Cor.1"
                    }
                ],
                "readQS": "Psalm+110,150%3B+Isaiah+63:1-16%3B+1+Corinthians+1:18-25",
                "audioQS": "Ps.110,150,Isa.63,1Cor.1",
                "note": null
            }
        ]
    },
    "2026/09/15": {
        "datePretty": "Tuesday, September 15, 2026",
        "calendar": "Week of 24th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 36",
                        "readQS": "Psalm+36",
                        "audioQS": "Ps.36"
                    },
                    {
                        "pretty": "1 Kings 8:63\u20139:9",
                        "readQS": "1+Kings+8:63-9:9",
                        "audioQS": "1Kgs.8"
                    },
                    {
                        "pretty": "Acts 16:25\u2013end",
                        "readQS": "Acts+16:25-",
                        "audioQS": "Acts.16"
                    }
                ],
                "readQS": "Psalm+36%3B+1+Kings+8:63-9:9%3B+Acts+16:25-",
                "audioQS": "Ps.36,1Kgs.8,Acts.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Zechariah 11:4\u2013end",
                        "readQS": "Zechariah+11:4-",
                        "audioQS": "Zech.11"
                    },
                    {
                        "pretty": "Mark 11:12\u201326",
                        "readQS": "Mark+11:12-26",
                        "audioQS": "Mark.11"
                    }
                ],
                "readQS": "Psalm+33%3B+Zechariah+11:4-%3B+Mark+11:12-26",
                "audioQS": "Ps.33,Zech.11,Mark.11",
                "note": null
            }
        ]
    },
    "2026/09/16": {
        "datePretty": "Wednesday, September 16, 2026",
        "calendar": "Week of 24th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "1 Kings 10:1\u201325",
                        "readQS": "1+Kings+10:1-25",
                        "audioQS": "1Kgs.10"
                    },
                    {
                        "pretty": "Acts 17:1\u201315",
                        "readQS": "Acts+17:1-15",
                        "audioQS": "Acts.17"
                    }
                ],
                "readQS": "Psalm+34%3B+1+Kings+10:1-25%3B+Acts+17:1-15",
                "audioQS": "Ps.34,1Kgs.10,Acts.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:33\u201356",
                        "readQS": "Psalm+119:33-56",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Zechariah 12:1\u201310",
                        "readQS": "Zechariah+12:1-10",
                        "audioQS": "Zech.12"
                    },
                    {
                        "pretty": "Mark 11:27\u2013end",
                        "readQS": "Mark+11:27-",
                        "audioQS": "Mark.11"
                    }
                ],
                "readQS": "Psalm+119:33-56%3B+Zechariah+12:1-10%3B+Mark+11:27-",
                "audioQS": "Ps.119,Zech.12,Mark.11",
                "note": null
            }
        ]
    },
    "2026/09/17": {
        "datePretty": "Thursday, September 17, 2026",
        "calendar": "Week of 24th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 37",
                        "readQS": "Psalm+37",
                        "audioQS": "Ps.37"
                    },
                    {
                        "pretty": "1 Kings 11:1\u201313",
                        "readQS": "1+Kings+11:1-13",
                        "audioQS": "1Kgs.11"
                    },
                    {
                        "pretty": "Acts 17:16\u2013end",
                        "readQS": "Acts+17:16-",
                        "audioQS": "Acts.17"
                    }
                ],
                "readQS": "Psalm+37%3B+1+Kings+11:1-13%3B+Acts+17:16-",
                "audioQS": "Ps.37,1Kgs.11,Acts.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Zechariah 13",
                        "readQS": "Zechariah+13",
                        "audioQS": "Zech.13"
                    },
                    {
                        "pretty": "Mark 12:1\u201312",
                        "readQS": "Mark+12:1-12",
                        "audioQS": "Mark.12"
                    }
                ],
                "readQS": "Psalm+40%3B+Zechariah+13%3B+Mark+12:1-12",
                "audioQS": "Ps.40,Zech.13,Mark.12",
                "note": null
            }
        ]
    },
    "2026/09/18": {
        "datePretty": "Friday, September 18, 2026",
        "calendar": "Week of 24th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "1 Kings 11:26\u2013end",
                        "readQS": "1+Kings+11:26-",
                        "audioQS": "1Kgs.11"
                    },
                    {
                        "pretty": "Acts 18:1\u201321",
                        "readQS": "Acts+18:1-21",
                        "audioQS": "Acts.18"
                    }
                ],
                "readQS": "Psalm+31%3B+1+Kings+11:26-%3B+Acts+18:1-21",
                "audioQS": "Ps.31,1Kgs.11,Acts.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 35",
                        "readQS": "Psalm+35",
                        "audioQS": "Ps.35"
                    },
                    {
                        "pretty": "Zechariah 14:1\u201311",
                        "readQS": "Zechariah+14:1-11",
                        "audioQS": "Zech.14"
                    },
                    {
                        "pretty": "Mark 12:13\u201317",
                        "readQS": "Mark+12:13-17",
                        "audioQS": "Mark.12"
                    }
                ],
                "readQS": "Psalm+35%3B+Zechariah+14:1-11%3B+Mark+12:13-17",
                "audioQS": "Ps.35,Zech.14,Mark.12",
                "note": null
            }
        ]
    },
    "2026/09/19": {
        "datePretty": "Saturday, September 19, 2026",
        "calendar": "Week of 24th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "1 Kings 12:1\u201324",
                        "readQS": "1+Kings+12:1-24",
                        "audioQS": "1Kgs.12"
                    },
                    {
                        "pretty": "Acts 18:22\u201319:7",
                        "readQS": "Acts+18:22-19:7",
                        "audioQS": "Acts.18"
                    }
                ],
                "readQS": "Psalm+42%3B+1+Kings+12:1-24%3B+Acts+18:22-19:7",
                "audioQS": "Ps.42,1Kgs.12,Acts.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 46",
                        "readQS": "Psalm+46",
                        "audioQS": "Ps.46"
                    },
                    {
                        "pretty": "Zechariah 14:12\u2013end",
                        "readQS": "Zechariah+14:12-",
                        "audioQS": "Zech.14"
                    },
                    {
                        "pretty": "Mark 12:18\u201327",
                        "readQS": "Mark+12:18-27",
                        "audioQS": "Mark.12"
                    }
                ],
                "readQS": "Psalm+46%3B+Zechariah+14:12-%3B+Mark+12:18-27",
                "audioQS": "Ps.46,Zech.14,Mark.12",
                "note": null
            }
        ]
    },
    "2026/09/20": {
        "datePretty": "Sunday, September 20, 2026",
        "calendar": "25th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 145:1\u20138",
                        "readQS": "Psalm+145:1-8",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Jonah 3:10\u20134:11",
                        "readQS": "Jonah+3:10-4:11",
                        "audioQS": "Jonah.3"
                    },
                    {
                        "pretty": "Philippians 1:21\u201330",
                        "readQS": "Philippians+1:21-30",
                        "audioQS": "Phil.1"
                    },
                    {
                        "pretty": "Matthew 20:1\u201316",
                        "readQS": "Matthew+20:1-16",
                        "audioQS": "Matt.20"
                    }
                ],
                "readQS": "Psalm+145:1-8%3B+Jonah+3:10-4:11%3B+Philippians+1:21-30%3B+Matthew+20:1-16",
                "audioQS": "Ps.145,Jonah.3,Phil.1,Matt.20",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 105:1\u20136,37\u201345",
                        "readQS": "Psalm+105:1-6,37-45",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Exodus 16:2\u201315",
                        "readQS": "Exodus+16:2-15",
                        "audioQS": "Exod.16"
                    },
                    {
                        "pretty": "Philippians 1:21\u201330",
                        "readQS": "Philippians+1:21-30",
                        "audioQS": "Phil.1"
                    },
                    {
                        "pretty": "Matthew 20:1\u201316",
                        "readQS": "Matthew+20:1-16",
                        "audioQS": "Matt.20"
                    }
                ],
                "readQS": "Psalm+105:1-6,37-45%3B+Exodus+16:2-15%3B+Philippians+1:21-30%3B+Matthew+20:1-16",
                "audioQS": "Ps.105,Exod.16,Phil.1,Matt.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:153\u2013176",
                        "readQS": "Psalm+119:153-176",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Isaiah 45:9\u201322",
                        "readQS": "Isaiah+45:9-22",
                        "audioQS": "Isa.45"
                    },
                    {
                        "pretty": "Revelation 14:1\u20135",
                        "readQS": "Revelation+14:1-5",
                        "audioQS": "Rev.14"
                    }
                ],
                "readQS": "Psalm+119:153-176%3B+Isaiah+45:9-22%3B+Revelation+14:1-5",
                "audioQS": "Ps.119,Isa.45,Rev.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Matthew)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Isaiah 33:13\u201317",
                        "readQS": "Isaiah+33:13-17",
                        "audioQS": "Isa.33"
                    },
                    {
                        "pretty": "Matthew 6:19\u201334",
                        "readQS": "Matthew+6:19-34",
                        "audioQS": "Matt.6"
                    }
                ],
                "readQS": "Psalm+34%3B+Isaiah+33:13-17%3B+Matthew+6:19-34",
                "audioQS": "Ps.34,Isa.33,Matt.6",
                "note": null
            }
        ]
    },
    "2026/09/21": {
        "datePretty": "Monday, September 21, 2026",
        "calendar": "St Matthew, Apostle and Evangelist",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 49,117",
                        "readQS": "Psalm+49,117",
                        "audioQS": "Ps.49,117"
                    },
                    {
                        "pretty": "1 Kings 19:15\u201321",
                        "readQS": "1+Kings+19:15-21",
                        "audioQS": "1Kgs.19"
                    },
                    {
                        "pretty": "2 Timothy 3:14\u201317",
                        "readQS": "2+Timothy+3:14-17",
                        "audioQS": "2Tim.3"
                    }
                ],
                "readQS": "Psalm+49,117%3B+1+Kings+19:15-21%3B+2+Timothy+3:14-17",
                "audioQS": "Ps.49,117,1Kgs.19,2Tim.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:33\u201340,119:89\u201396",
                        "readQS": "Psalm+119:33-40,119:89-96",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Ecclesiastes 5:4\u201312",
                        "readQS": "Ecclesiastes+5:4-12",
                        "audioQS": "Eccl.5"
                    },
                    {
                        "pretty": "Matthew 19:16\u201330",
                        "readQS": "Matthew+19:16-30",
                        "audioQS": "Matt.19"
                    }
                ],
                "readQS": "Psalm+119:33-40,119:89-96%3B+Ecclesiastes+5:4-12%3B+Matthew+19:16-30",
                "audioQS": "Ps.119,Eccl.5,Matt.19",
                "note": null
            }
        ]
    },
    "2026/09/22": {
        "datePretty": "Tuesday, September 22, 2026",
        "calendar": "Week of 25th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "1 Kings 13:11\u2013end",
                        "readQS": "1+Kings+13:11-",
                        "audioQS": "1Kgs.13"
                    },
                    {
                        "pretty": "Acts 19:21\u2013end",
                        "readQS": "Acts+19:21-",
                        "audioQS": "Acts.19"
                    }
                ],
                "readQS": "Psalm+48%3B+1+Kings+13:11-%3B+Acts+19:21-",
                "audioQS": "Ps.48,1Kgs.13,Acts.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Ezekiel 1:15\u20132:2",
                        "readQS": "Ezekiel+1:15-2:2",
                        "audioQS": "Ezek.1"
                    },
                    {
                        "pretty": "Mark 12:35\u2013end",
                        "readQS": "Mark+12:35-",
                        "audioQS": "Mark.12"
                    }
                ],
                "readQS": "Psalm+50%3B+Ezekiel+1:15-2:2%3B+Mark+12:35-",
                "audioQS": "Ps.50,Ezek.1,Mark.12",
                "note": null
            }
        ]
    },
    "2026/09/23": {
        "datePretty": "Wednesday, September 23, 2026",
        "calendar": "Week of 25th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:57\u201380",
                        "readQS": "Psalm+119:57-80",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "1 Kings 17",
                        "readQS": "1+Kings+17",
                        "audioQS": "1Kgs.17"
                    },
                    {
                        "pretty": "Acts 20:1\u201316",
                        "readQS": "Acts+20:1-16",
                        "audioQS": "Acts.20"
                    }
                ],
                "readQS": "Psalm+119:57-80%3B+1+Kings+17%3B+Acts+20:1-16",
                "audioQS": "Ps.119,1Kgs.17,Acts.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 59",
                        "readQS": "Psalm+59",
                        "audioQS": "Ps.59"
                    },
                    {
                        "pretty": "Ezekiel 2:3\u20133:11",
                        "readQS": "Ezekiel+2:3-3:11",
                        "audioQS": "Ezek.2"
                    },
                    {
                        "pretty": "Mark 13:1\u201313",
                        "readQS": "Mark+13:1-13",
                        "audioQS": "Mark.13"
                    }
                ],
                "readQS": "Psalm+59%3B+Ezekiel+2:3-3:11%3B+Mark+13:1-13",
                "audioQS": "Ps.59,Ezek.2,Mark.13",
                "note": null
            }
        ]
    },
    "2026/09/24": {
        "datePretty": "Thursday, September 24, 2026",
        "calendar": "Week of 25th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 57",
                        "readQS": "Psalm+57",
                        "audioQS": "Ps.57"
                    },
                    {
                        "pretty": "1 Kings 18:1\u201320",
                        "readQS": "1+Kings+18:1-20",
                        "audioQS": "1Kgs.18"
                    },
                    {
                        "pretty": "Acts 20:17\u2013end",
                        "readQS": "Acts+20:17-",
                        "audioQS": "Acts.20"
                    }
                ],
                "readQS": "Psalm+57%3B+1+Kings+18:1-20%3B+Acts+20:17-",
                "audioQS": "Ps.57,1Kgs.18,Acts.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 62",
                        "readQS": "Psalm+62",
                        "audioQS": "Ps.62"
                    },
                    {
                        "pretty": "Ezekiel 3:12\u2013end",
                        "readQS": "Ezekiel+3:12-",
                        "audioQS": "Ezek.3"
                    },
                    {
                        "pretty": "Mark 13:14\u201323",
                        "readQS": "Mark+13:14-23",
                        "audioQS": "Mark.13"
                    }
                ],
                "readQS": "Psalm+62%3B+Ezekiel+3:12-%3B+Mark+13:14-23",
                "audioQS": "Ps.62,Ezek.3,Mark.13",
                "note": null
            }
        ]
    },
    "2026/09/25": {
        "datePretty": "Friday, September 25, 2026",
        "calendar": "Week of 25th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 51",
                        "readQS": "Psalm+51",
                        "audioQS": "Ps.51"
                    },
                    {
                        "pretty": "1 Kings 18:21\u2013end",
                        "readQS": "1+Kings+18:21-",
                        "audioQS": "1Kgs.18"
                    },
                    {
                        "pretty": "Acts 21:1\u201316",
                        "readQS": "Acts+21:1-16",
                        "audioQS": "Acts.21"
                    }
                ],
                "readQS": "Psalm+51%3B+1+Kings+18:21-%3B+Acts+21:1-16",
                "audioQS": "Ps.51,1Kgs.18,Acts.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 38",
                        "readQS": "Psalm+38",
                        "audioQS": "Ps.38"
                    },
                    {
                        "pretty": "Ezekiel 8",
                        "readQS": "Ezekiel+8",
                        "audioQS": "Ezek.8"
                    },
                    {
                        "pretty": "Mark 13:24\u201331",
                        "readQS": "Mark+13:24-31",
                        "audioQS": "Mark.13"
                    }
                ],
                "readQS": "Psalm+38%3B+Ezekiel+8%3B+Mark+13:24-31",
                "audioQS": "Ps.38,Ezek.8,Mark.13",
                "note": null
            }
        ]
    },
    "2026/09/26": {
        "datePretty": "Saturday, September 26, 2026",
        "calendar": "Week of 25th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 68",
                        "readQS": "Psalm+68",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "1 Kings 19",
                        "readQS": "1+Kings+19",
                        "audioQS": "1Kgs.19"
                    },
                    {
                        "pretty": "Acts 21:17\u201336",
                        "readQS": "Acts+21:17-36",
                        "audioQS": "Acts.21"
                    }
                ],
                "readQS": "Psalm+68%3B+1+Kings+19%3B+Acts+21:17-36",
                "audioQS": "Ps.68,1Kgs.19,Acts.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 66",
                        "readQS": "Psalm+66",
                        "audioQS": "Ps.66"
                    },
                    {
                        "pretty": "Ezekiel 9",
                        "readQS": "Ezekiel+9",
                        "audioQS": "Ezek.9"
                    },
                    {
                        "pretty": "Mark 13:32\u2013end",
                        "readQS": "Mark+13:32-",
                        "audioQS": "Mark.13"
                    }
                ],
                "readQS": "Psalm+66%3B+Ezekiel+9%3B+Mark+13:32-",
                "audioQS": "Ps.66,Ezek.9,Mark.13",
                "note": null
            }
        ]
    },
    "2026/09/27": {
        "datePretty": "Sunday, September 27, 2026",
        "calendar": "26th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 25:1\u20138",
                        "readQS": "Psalm+25:1-8",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Ezekiel 18:1\u20134,25\u201332",
                        "readQS": "Ezekiel+18:1-4,25-32",
                        "audioQS": "Ezek.18"
                    },
                    {
                        "pretty": "Philippians 2:1\u201313",
                        "readQS": "Philippians+2:1-13",
                        "audioQS": "Phil.2"
                    },
                    {
                        "pretty": "Matthew 21:23\u201332",
                        "readQS": "Matthew+21:23-32",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+25:1-8%3B+Ezekiel+18:1-4,25-32%3B+Philippians+2:1-13%3B+Matthew+21:23-32",
                "audioQS": "Ps.25,Ezek.18,Phil.2,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 78:1\u20134,12\u201316",
                        "readQS": "Psalm+78:1-4,12-16",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "Exodus 17:1\u20137",
                        "readQS": "Exodus+17:1-7",
                        "audioQS": "Exod.17"
                    },
                    {
                        "pretty": "Philippians 2:1\u201313",
                        "readQS": "Philippians+2:1-13",
                        "audioQS": "Phil.2"
                    },
                    {
                        "pretty": "Matthew 21:23\u201332",
                        "readQS": "Matthew+21:23-32",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+78:1-4,12-16%3B+Exodus+17:1-7%3B+Philippians+2:1-13%3B+Matthew+21:23-32",
                "audioQS": "Ps.78,Exod.17,Phil.2,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 125,126,127",
                        "readQS": "Psalm+125,126,127",
                        "audioQS": "Ps.125,126,127"
                    },
                    {
                        "pretty": "Isaiah 48:12\u201321",
                        "readQS": "Isaiah+48:12-21",
                        "audioQS": "Isa.48"
                    },
                    {
                        "pretty": "Luke 11:37\u201354",
                        "readQS": "Luke+11:37-54",
                        "audioQS": "Luke.11"
                    }
                ],
                "readQS": "Psalm+125,126,127%3B+Isaiah+48:12-21%3B+Luke+11:37-54",
                "audioQS": "Ps.125,126,127,Isa.48,Luke.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 124",
                        "readQS": "Psalm+124",
                        "audioQS": "Ps.124"
                    },
                    {
                        "pretty": "Ezekiel 37:15\u201328",
                        "readQS": "Ezekiel+37:15-28",
                        "audioQS": "Ezek.37"
                    },
                    {
                        "pretty": "1 John 2:22\u201329",
                        "readQS": "1+John+2:22-29",
                        "audioQS": "1John.2"
                    }
                ],
                "readQS": "Psalm+124%3B+Ezekiel+37:15-28%3B+1+John+2:22-29",
                "audioQS": "Ps.124,Ezek.37,1John.2",
                "note": null
            }
        ]
    },
    "2026/09/28": {
        "datePretty": "Monday, September 28, 2026",
        "calendar": "Week of 26th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "1 Kings 21",
                        "readQS": "1+Kings+21",
                        "audioQS": "1Kgs.21"
                    },
                    {
                        "pretty": "Acts 21:37\u201322:21",
                        "readQS": "Acts+21:37-22:21",
                        "audioQS": "Acts.21"
                    }
                ],
                "readQS": "Psalm+71%3B+1+Kings+21%3B+Acts+21:37-22:21",
                "audioQS": "Ps.71,1Kgs.21,Acts.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Michaelmas)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 91",
                        "readQS": "Psalm+91",
                        "audioQS": "Ps.91"
                    },
                    {
                        "pretty": "2 Kings 6:8\u201317",
                        "readQS": "2+Kings+6:8-17",
                        "audioQS": "2Kgs.6"
                    },
                    {
                        "pretty": "Matthew 18:1\u20136,10",
                        "readQS": "Matthew+18:1-6,10",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+91%3B+2+Kings+6:8-17%3B+Matthew+18:1-6,10",
                "audioQS": "Ps.91,2Kgs.6,Matt.18",
                "note": null
            }
        ]
    },
    "2026/09/29": {
        "datePretty": "Tuesday, September 29, 2026",
        "calendar": "St Michael and All Angels / Michaelmas",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 34,150",
                        "readQS": "Psalm+34,150",
                        "audioQS": "Ps.34,150"
                    },
                    {
                        "pretty": "Daniel 12:1\u20134",
                        "readQS": "Daniel+12:1-4",
                        "audioQS": "Dan.12"
                    },
                    {
                        "pretty": "Acts 12:1\u201311",
                        "readQS": "Acts+12:1-11",
                        "audioQS": "Acts.12"
                    }
                ],
                "readQS": "Psalm+34,150%3B+Daniel+12:1-4%3B+Acts+12:1-11",
                "audioQS": "Ps.34,150,Dan.12,Acts.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 138,148",
                        "readQS": "Psalm+138,148",
                        "audioQS": "Ps.138,148"
                    },
                    {
                        "pretty": "Daniel 10:4\u201321",
                        "readQS": "Daniel+10:4-21",
                        "audioQS": "Dan.10"
                    },
                    {
                        "pretty": "Revelations 5",
                        "readQS": "Revelations+5",
                        "audioQS": "Revs.5"
                    }
                ],
                "readQS": "Psalm+138,148%3B+Daniel+10:4-21%3B+Revelations+5",
                "audioQS": "Ps.138,148,Dan.10,Revs.5",
                "note": null
            }
        ]
    },
    "2026/09/30": {
        "datePretty": "Wednesday, September 30, 2026",
        "calendar": "Week of 26th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "1 Kings 22:29\u201345",
                        "readQS": "1+Kings+22:29-45",
                        "audioQS": "1Kgs.22"
                    },
                    {
                        "pretty": "Acts 23:12\u2013end",
                        "readQS": "Acts+23:12-",
                        "audioQS": "Acts.23"
                    }
                ],
                "readQS": "Psalm+77%3B+1+Kings+22:29-45%3B+Acts+23:12-",
                "audioQS": "Ps.77,1Kgs.22,Acts.23",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:81\u2013104",
                        "readQS": "Psalm+119:81-104",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Ezekiel 12:1\u201316",
                        "readQS": "Ezekiel+12:1-16",
                        "audioQS": "Ezek.12"
                    },
                    {
                        "pretty": "Mark 14:26\u201342",
                        "readQS": "Mark+14:26-42",
                        "audioQS": "Mark.14"
                    }
                ],
                "readQS": "Psalm+119:81-104%3B+Ezekiel+12:1-16%3B+Mark+14:26-42",
                "audioQS": "Ps.119,Ezek.12,Mark.14",
                "note": null
            }
        ]
    },
    "2026/10/01": {
        "datePretty": "Thursday, October 1, 2026",
        "calendar": "Week of 26th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 78:1\u201339",
                        "readQS": "Psalm+78:1-39",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "2 Kings 1:2\u201317",
                        "readQS": "2+Kings+1:2-17",
                        "audioQS": "2Kgs.1"
                    },
                    {
                        "pretty": "Acts 24:1\u201323",
                        "readQS": "Acts+24:1-23",
                        "audioQS": "Acts.24"
                    }
                ],
                "readQS": "Psalm+78:1-39%3B+2+Kings+1:2-17%3B+Acts+24:1-23",
                "audioQS": "Ps.78,2Kgs.1,Acts.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 78:40\u2013end",
                        "readQS": "Psalm+78:40-",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "Ezekiel 12:17\u2013end",
                        "readQS": "Ezekiel+12:17-",
                        "audioQS": "Ezek.12"
                    },
                    {
                        "pretty": "Mark 14:43\u201352",
                        "readQS": "Mark+14:43-52",
                        "audioQS": "Mark.14"
                    }
                ],
                "readQS": "Psalm+78:40-%3B+Ezekiel+12:17-%3B+Mark+14:43-52",
                "audioQS": "Ps.78,Ezek.12,Mark.14",
                "note": null
            }
        ]
    },
    "2026/10/02": {
        "datePretty": "Friday, October 2, 2026",
        "calendar": "Week of 26th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 55",
                        "readQS": "Psalm+55",
                        "audioQS": "Ps.55"
                    },
                    {
                        "pretty": "2 Kings 2:1\u201318",
                        "readQS": "2+Kings+2:1-18",
                        "audioQS": "2Kgs.2"
                    },
                    {
                        "pretty": "Acts 24:24\u201325:12",
                        "readQS": "Acts+24:24-25:12",
                        "audioQS": "Acts.24"
                    }
                ],
                "readQS": "Psalm+55%3B+2+Kings+2:1-18%3B+Acts+24:24-25:12",
                "audioQS": "Ps.55,2Kgs.2,Acts.24",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 69",
                        "readQS": "Psalm+69",
                        "audioQS": "Ps.69"
                    },
                    {
                        "pretty": "Ezekiel 13:1\u201316",
                        "readQS": "Ezekiel+13:1-16",
                        "audioQS": "Ezek.13"
                    },
                    {
                        "pretty": "Mark 14:53\u201365",
                        "readQS": "Mark+14:53-65",
                        "audioQS": "Mark.14"
                    }
                ],
                "readQS": "Psalm+69%3B+Ezekiel+13:1-16%3B+Mark+14:53-65",
                "audioQS": "Ps.69,Ezek.13,Mark.14",
                "note": null
            }
        ]
    },
    "2026/10/03": {
        "datePretty": "Saturday, October 3, 2026",
        "calendar": "Week of 26th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 76",
                        "readQS": "Psalm+76",
                        "audioQS": "Ps.76"
                    },
                    {
                        "pretty": "2 Kings 4:1\u201337",
                        "readQS": "2+Kings+4:1-37",
                        "audioQS": "2Kgs.4"
                    },
                    {
                        "pretty": "Acts 25:13\u2013end",
                        "readQS": "Acts+25:13-",
                        "audioQS": "Acts.25"
                    }
                ],
                "readQS": "Psalm+76%3B+2+Kings+4:1-37%3B+Acts+25:13-",
                "audioQS": "Ps.76,2Kgs.4,Acts.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 84",
                        "readQS": "Psalm+84",
                        "audioQS": "Ps.84"
                    },
                    {
                        "pretty": "Ezekiel 14:1\u201311",
                        "readQS": "Ezekiel+14:1-11",
                        "audioQS": "Ezek.14"
                    },
                    {
                        "pretty": "Mark 14:66\u2013end",
                        "readQS": "Mark+14:66-",
                        "audioQS": "Mark.14"
                    }
                ],
                "readQS": "Psalm+84%3B+Ezekiel+14:1-11%3B+Mark+14:66-",
                "audioQS": "Ps.84,Ezek.14,Mark.14",
                "note": null
            }
        ]
    },
    "2026/10/04": {
        "datePretty": "Sunday, October 4, 2026",
        "calendar": "27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 80:9\u201317",
                        "readQS": "Psalm+80:9-17",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 5:1\u20137",
                        "readQS": "Isaiah+5:1-7",
                        "audioQS": "Isa.5"
                    },
                    {
                        "pretty": "Philippians 3:4b\u201314",
                        "readQS": "Philippians+3:4b-14",
                        "audioQS": "Phil.3"
                    },
                    {
                        "pretty": "Matthew 21:33\u201346",
                        "readQS": "Matthew+21:33-46",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+80:9-17%3B+Isaiah+5:1-7%3B+Philippians+3:4b-14%3B+Matthew+21:33-46",
                "audioQS": "Ps.80,Isa.5,Phil.3,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Exodus 20:1\u20134,7\u20139,12\u201320",
                        "readQS": "Exodus+20:1-4,7-9,12-20",
                        "audioQS": "Exod.20"
                    },
                    {
                        "pretty": "Philippians 3:4b\u201314",
                        "readQS": "Philippians+3:4b-14",
                        "audioQS": "Phil.3"
                    },
                    {
                        "pretty": "Matthew 21:33\u201346",
                        "readQS": "Matthew+21:33-46",
                        "audioQS": "Matt.21"
                    }
                ],
                "readQS": "Psalm+19%3B+Exodus+20:1-4,7-9,12-20%3B+Philippians+3:4b-14%3B+Matthew+21:33-46",
                "audioQS": "Ps.19,Exod.20,Phil.3,Matt.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 128,129,134",
                        "readQS": "Psalm+128,129,134",
                        "audioQS": "Ps.128,129,134"
                    },
                    {
                        "pretty": "Isaiah 49:13\u201323",
                        "readQS": "Isaiah+49:13-23",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "Luke 12:1\u201312",
                        "readQS": "Luke+12:1-12",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+128,129,134%3B+Isaiah+49:13-23%3B+Luke+12:1-12",
                "audioQS": "Ps.128,129,134,Isa.49,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Proverbs 2:1\u201311",
                        "readQS": "Proverbs+2:1-11",
                        "audioQS": "Prov.2"
                    },
                    {
                        "pretty": "1 John 2:1\u201317",
                        "readQS": "1+John+2:1-17",
                        "audioQS": "1John.2"
                    }
                ],
                "readQS": "Psalm+136%3B+Proverbs+2:1-11%3B+1+John+2:1-17",
                "audioQS": "Ps.136,Prov.2,1John.2",
                "note": null
            }
        ]
    },
    "2026/10/05": {
        "datePretty": "Monday, October 5, 2026",
        "calendar": "Week of 27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "2 Kings 5",
                        "readQS": "2+Kings+5",
                        "audioQS": "2Kgs.5"
                    },
                    {
                        "pretty": "Acts 26:1\u201323",
                        "readQS": "Acts+26:1-23",
                        "audioQS": "Acts.26"
                    }
                ],
                "readQS": "Psalm+80%3B+2+Kings+5%3B+Acts+26:1-23",
                "audioQS": "Ps.80,2Kgs.5,Acts.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 85",
                        "readQS": "Psalm+85",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Ezekiel 14:12\u2013end",
                        "readQS": "Ezekiel+14:12-",
                        "audioQS": "Ezek.14"
                    },
                    {
                        "pretty": "Mark 15:1\u201315",
                        "readQS": "Mark+15:1-15",
                        "audioQS": "Mark.15"
                    }
                ],
                "readQS": "Psalm+85%3B+Ezekiel+14:12-%3B+Mark+15:1-15",
                "audioQS": "Ps.85,Ezek.14,Mark.15",
                "note": null
            }
        ]
    },
    "2026/10/06": {
        "datePretty": "Tuesday, October 6, 2026",
        "calendar": "Week of 27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 89:1\u201318",
                        "readQS": "Psalm+89:1-18",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "2 Kings 6:1\u201323",
                        "readQS": "2+Kings+6:1-23",
                        "audioQS": "2Kgs.6"
                    },
                    {
                        "pretty": "Acts 26:24\u2013end",
                        "readQS": "Acts+26:24-",
                        "audioQS": "Acts.26"
                    }
                ],
                "readQS": "Psalm+89:1-18%3B+2+Kings+6:1-23%3B+Acts+26:24-",
                "audioQS": "Ps.89,2Kgs.6,Acts.26",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 89:19\u2013end",
                        "readQS": "Psalm+89:19-",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "Ezekiel 18:1\u201320",
                        "readQS": "Ezekiel+18:1-20",
                        "audioQS": "Ezek.18"
                    },
                    {
                        "pretty": "Mark 15:16\u201332",
                        "readQS": "Mark+15:16-32",
                        "audioQS": "Mark.15"
                    }
                ],
                "readQS": "Psalm+89:19-%3B+Ezekiel+18:1-20%3B+Mark+15:16-32",
                "audioQS": "Ps.89,Ezek.18,Mark.15",
                "note": null
            }
        ]
    },
    "2026/10/07": {
        "datePretty": "Wednesday, October 7, 2026",
        "calendar": "Week of 27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:105\u2013128",
                        "readQS": "Psalm+119:105-128",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "2 Kings 9:1\u201316",
                        "readQS": "2+Kings+9:1-16",
                        "audioQS": "2Kgs.9"
                    },
                    {
                        "pretty": "Acts 27:1\u201326",
                        "readQS": "Acts+27:1-26",
                        "audioQS": "Acts.27"
                    }
                ],
                "readQS": "Psalm+119:105-128%3B+2+Kings+9:1-16%3B+Acts+27:1-26",
                "audioQS": "Ps.119,2Kgs.9,Acts.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 91",
                        "readQS": "Psalm+91",
                        "audioQS": "Ps.91"
                    },
                    {
                        "pretty": "Ezekiel 18:21\u201332",
                        "readQS": "Ezekiel+18:21-32",
                        "audioQS": "Ezek.18"
                    },
                    {
                        "pretty": "Mark 15:33\u201341",
                        "readQS": "Mark+15:33-41",
                        "audioQS": "Mark.15"
                    }
                ],
                "readQS": "Psalm+91%3B+Ezekiel+18:21-32%3B+Mark+15:33-41",
                "audioQS": "Ps.91,Ezek.18,Mark.15",
                "note": null
            }
        ]
    },
    "2026/10/08": {
        "datePretty": "Thursday, October 8, 2026",
        "calendar": "Week of 27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 92",
                        "readQS": "Psalm+92",
                        "audioQS": "Ps.92"
                    },
                    {
                        "pretty": "2 Kings 9:17\u2013end",
                        "readQS": "2+Kings+9:17-",
                        "audioQS": "2Kgs.9"
                    },
                    {
                        "pretty": "Acts 27:27\u2013end",
                        "readQS": "Acts+27:27-",
                        "audioQS": "Acts.27"
                    }
                ],
                "readQS": "Psalm+92%3B+2+Kings+9:17-%3B+Acts+27:27-",
                "audioQS": "Ps.92,2Kgs.9,Acts.27",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 94",
                        "readQS": "Psalm+94",
                        "audioQS": "Ps.94"
                    },
                    {
                        "pretty": "Ezekiel 20:1\u201320",
                        "readQS": "Ezekiel+20:1-20",
                        "audioQS": "Ezek.20"
                    },
                    {
                        "pretty": "Mark 15:42\u2013end",
                        "readQS": "Mark+15:42-",
                        "audioQS": "Mark.15"
                    }
                ],
                "readQS": "Psalm+94%3B+Ezekiel+20:1-20%3B+Mark+15:42-",
                "audioQS": "Ps.94,Ezek.20,Mark.15",
                "note": null
            }
        ]
    },
    "2026/10/09": {
        "datePretty": "Friday, October 9, 2026",
        "calendar": "Week of 27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 88",
                        "readQS": "Psalm+88",
                        "audioQS": "Ps.88"
                    },
                    {
                        "pretty": "2 Kings 12:1\u201319",
                        "readQS": "2+Kings+12:1-19",
                        "audioQS": "2Kgs.12"
                    },
                    {
                        "pretty": "Acts 28:1\u201316",
                        "readQS": "Acts+28:1-16",
                        "audioQS": "Acts.28"
                    }
                ],
                "readQS": "Psalm+88%3B+2+Kings+12:1-19%3B+Acts+28:1-16",
                "audioQS": "Ps.88,2Kgs.12,Acts.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 102",
                        "readQS": "Psalm+102",
                        "audioQS": "Ps.102"
                    },
                    {
                        "pretty": "Ezekiel 20:21\u201338",
                        "readQS": "Ezekiel+20:21-38",
                        "audioQS": "Ezek.20"
                    },
                    {
                        "pretty": "Mark 16:1\u20138",
                        "readQS": "Mark+16:1-8",
                        "audioQS": "Mark.16"
                    }
                ],
                "readQS": "Psalm+102%3B+Ezekiel+20:21-38%3B+Mark+16:1-8",
                "audioQS": "Ps.102,Ezek.20,Mark.16",
                "note": null
            }
        ]
    },
    "2026/10/10": {
        "datePretty": "Saturday, October 10, 2026",
        "calendar": "Week of 27th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "2 Kings 17:1\u201323",
                        "readQS": "2+Kings+17:1-23",
                        "audioQS": "2Kgs.17"
                    },
                    {
                        "pretty": "Acts 28:17\u2013end",
                        "readQS": "Acts+28:17-",
                        "audioQS": "Acts.28"
                    }
                ],
                "readQS": "Psalm+97%3B+2+Kings+17:1-23%3B+Acts+28:17-",
                "audioQS": "Ps.97,2Kgs.17,Acts.28",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 104",
                        "readQS": "Psalm+104",
                        "audioQS": "Ps.104"
                    },
                    {
                        "pretty": "Ezekiel 24:15\u2013end",
                        "readQS": "Ezekiel+24:15-",
                        "audioQS": "Ezek.24"
                    },
                    {
                        "pretty": "Mark 16:9\u2013end",
                        "readQS": "Mark+16:9-",
                        "audioQS": "Mark.16"
                    }
                ],
                "readQS": "Psalm+104%3B+Ezekiel+24:15-%3B+Mark+16:9-",
                "audioQS": "Ps.104,Ezek.24,Mark.16",
                "note": null
            }
        ]
    },
    "2026/10/11": {
        "datePretty": "Sunday, October 11, 2026",
        "calendar": "28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Isaiah 25:1\u20139",
                        "readQS": "Isaiah+25:1-9",
                        "audioQS": "Isa.25"
                    },
                    {
                        "pretty": "Philippians 4:1\u20139",
                        "readQS": "Philippians+4:1-9",
                        "audioQS": "Phil.4"
                    },
                    {
                        "pretty": "Matthew 22:1\u201314",
                        "readQS": "Matthew+22:1-14",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+23%3B+Isaiah+25:1-9%3B+Philippians+4:1-9%3B+Matthew+22:1-14",
                "audioQS": "Ps.23,Isa.25,Phil.4,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 106:1\u20136,19\u201323",
                        "readQS": "Psalm+106:1-6,19-23",
                        "audioQS": "Ps.106"
                    },
                    {
                        "pretty": "Exodus 32:1\u201314",
                        "readQS": "Exodus+32:1-14",
                        "audioQS": "Exod.32"
                    },
                    {
                        "pretty": "Philippians 4:1\u20139",
                        "readQS": "Philippians+4:1-9",
                        "audioQS": "Phil.4"
                    },
                    {
                        "pretty": "Matthew 22:1\u201314",
                        "readQS": "Matthew+22:1-14",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+106:1-6,19-23%3B+Exodus+32:1-14%3B+Philippians+4:1-9%3B+Matthew+22:1-14",
                "audioQS": "Ps.106,Exod.32,Phil.4,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 138,141",
                        "readQS": "Psalm+138,141",
                        "audioQS": "Ps.138,141"
                    },
                    {
                        "pretty": "Isaiah 50:4\u201310",
                        "readQS": "Isaiah+50:4-10",
                        "audioQS": "Isa.50"
                    },
                    {
                        "pretty": "Luke 13:22\u201330",
                        "readQS": "Luke+13:22-30",
                        "audioQS": "Luke.13"
                    }
                ],
                "readQS": "Psalm+138,141%3B+Isaiah+50:4-10%3B+Luke+13:22-30",
                "audioQS": "Ps.138,141,Isa.50,Luke.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 139:1\u201318",
                        "readQS": "Psalm+139:1-18",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Proverbs 3:1\u201318",
                        "readQS": "Proverbs+3:1-18",
                        "audioQS": "Prov.3"
                    },
                    {
                        "pretty": "1 John 3:1\u201315",
                        "readQS": "1+John+3:1-15",
                        "audioQS": "1John.3"
                    }
                ],
                "readQS": "Psalm+139:1-18%3B+Proverbs+3:1-18%3B+1+John+3:1-15",
                "audioQS": "Ps.139,Prov.3,1John.3",
                "note": null
            }
        ]
    },
    "2026/10/12": {
        "datePretty": "Monday, October 12, 2026",
        "calendar": "Week of 28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 98",
                        "readQS": "Psalm+98",
                        "audioQS": "Ps.98"
                    },
                    {
                        "pretty": "2 Kings 17:24\u2013end",
                        "readQS": "2+Kings+17:24-",
                        "audioQS": "2Kgs.17"
                    },
                    {
                        "pretty": "Philippians 1:1\u201311",
                        "readQS": "Philippians+1:1-11",
                        "audioQS": "Phil.1"
                    }
                ],
                "readQS": "Psalm+98%3B+2+Kings+17:24-%3B+Philippians+1:1-11",
                "audioQS": "Ps.98,2Kgs.17,Phil.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 105",
                        "readQS": "Psalm+105",
                        "audioQS": "Ps.105"
                    },
                    {
                        "pretty": "Ezekiel 28:1\u201319",
                        "readQS": "Ezekiel+28:1-19",
                        "audioQS": "Ezek.28"
                    },
                    {
                        "pretty": "John 13:1\u201311",
                        "readQS": "John+13:1-11",
                        "audioQS": "John.13"
                    }
                ],
                "readQS": "Psalm+105%3B+Ezekiel+28:1-19%3B+John+13:1-11",
                "audioQS": "Ps.105,Ezek.28,John.13",
                "note": null
            }
        ]
    },
    "2026/10/13": {
        "datePretty": "Tuesday, October 13, 2026",
        "calendar": "Week of 28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 106",
                        "readQS": "Psalm+106",
                        "audioQS": "Ps.106"
                    },
                    {
                        "pretty": "2 Kings 18:1\u201312",
                        "readQS": "2+Kings+18:1-12",
                        "audioQS": "2Kgs.18"
                    },
                    {
                        "pretty": "Philippians 1:12\u2013end",
                        "readQS": "Philippians+1:12-",
                        "audioQS": "Phil.1"
                    }
                ],
                "readQS": "Psalm+106%3B+2+Kings+18:1-12%3B+Philippians+1:12-",
                "audioQS": "Ps.106,2Kgs.18,Phil.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 107",
                        "readQS": "Psalm+107",
                        "audioQS": "Ps.107"
                    },
                    {
                        "pretty": "Ezekiel 33:1\u201320",
                        "readQS": "Ezekiel+33:1-20",
                        "audioQS": "Ezek.33"
                    },
                    {
                        "pretty": "John 13:12\u201320",
                        "readQS": "John+13:12-20",
                        "audioQS": "John.13"
                    }
                ],
                "readQS": "Psalm+107%3B+Ezekiel+33:1-20%3B+John+13:12-20",
                "audioQS": "Ps.107,Ezek.33,John.13",
                "note": null
            }
        ]
    },
    "2026/10/14": {
        "datePretty": "Wednesday, October 14, 2026",
        "calendar": "Week of 28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 111",
                        "readQS": "Psalm+111",
                        "audioQS": "Ps.111"
                    },
                    {
                        "pretty": "2 Kings 18:13\u2013end",
                        "readQS": "2+Kings+18:13-",
                        "audioQS": "2Kgs.18"
                    },
                    {
                        "pretty": "Philippians 2:1\u201313",
                        "readQS": "Philippians+2:1-13",
                        "audioQS": "Phil.2"
                    }
                ],
                "readQS": "Psalm+111%3B+2+Kings+18:13-%3B+Philippians+2:1-13",
                "audioQS": "Ps.111,2Kgs.18,Phil.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:129\u2013152",
                        "readQS": "Psalm+119:129-152",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Ezekiel 33:21\u2013end",
                        "readQS": "Ezekiel+33:21-",
                        "audioQS": "Ezek.33"
                    },
                    {
                        "pretty": "John 13:21\u201330",
                        "readQS": "John+13:21-30",
                        "audioQS": "John.13"
                    }
                ],
                "readQS": "Psalm+119:129-152%3B+Ezekiel+33:21-%3B+John+13:21-30",
                "audioQS": "Ps.119,Ezek.33,John.13",
                "note": null
            }
        ]
    },
    "2026/10/15": {
        "datePretty": "Thursday, October 15, 2026",
        "calendar": "Week of 28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 115",
                        "readQS": "Psalm+115",
                        "audioQS": "Ps.115"
                    },
                    {
                        "pretty": "2 Kings 19:1\u201319",
                        "readQS": "2+Kings+19:1-19",
                        "audioQS": "2Kgs.19"
                    },
                    {
                        "pretty": "Philippians 2:14\u2013end",
                        "readQS": "Philippians+2:14-",
                        "audioQS": "Phil.2"
                    }
                ],
                "readQS": "Psalm+115%3B+2+Kings+19:1-19%3B+Philippians+2:14-",
                "audioQS": "Ps.115,2Kgs.19,Phil.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 116",
                        "readQS": "Psalm+116",
                        "audioQS": "Ps.116"
                    },
                    {
                        "pretty": "Ezekiel 34:1\u201316",
                        "readQS": "Ezekiel+34:1-16",
                        "audioQS": "Ezek.34"
                    },
                    {
                        "pretty": "John 13:31\u2013end",
                        "readQS": "John+13:31-",
                        "audioQS": "John.13"
                    }
                ],
                "readQS": "Psalm+116%3B+Ezekiel+34:1-16%3B+John+13:31-",
                "audioQS": "Ps.116,Ezek.34,John.13",
                "note": null
            }
        ]
    },
    "2026/10/16": {
        "datePretty": "Friday, October 16, 2026",
        "calendar": "Week of 28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "2 Kings 19:20\u201336",
                        "readQS": "2+Kings+19:20-36",
                        "audioQS": "2Kgs.19"
                    },
                    {
                        "pretty": "Philippians 3:1\u20134:1",
                        "readQS": "Philippians+3:1-4:1",
                        "audioQS": "Phil.3"
                    }
                ],
                "readQS": "Psalm+139%3B+2+Kings+19:20-36%3B+Philippians+3:1-4:1",
                "audioQS": "Ps.139,2Kgs.19,Phil.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 130",
                        "readQS": "Psalm+130",
                        "audioQS": "Ps.130"
                    },
                    {
                        "pretty": "Ezekiel 34:17\u2013end",
                        "readQS": "Ezekiel+34:17-",
                        "audioQS": "Ezek.34"
                    },
                    {
                        "pretty": "John 14:1\u201314",
                        "readQS": "John+14:1-14",
                        "audioQS": "John.14"
                    }
                ],
                "readQS": "Psalm+130%3B+Ezekiel+34:17-%3B+John+14:1-14",
                "audioQS": "Ps.130,Ezek.34,John.14",
                "note": null
            }
        ]
    },
    "2026/10/17": {
        "datePretty": "Saturday, October 17, 2026",
        "calendar": "Week of 28th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 121",
                        "readQS": "Psalm+121",
                        "audioQS": "Ps.121"
                    },
                    {
                        "pretty": "2 Kings 20",
                        "readQS": "2+Kings+20",
                        "audioQS": "2Kgs.20"
                    },
                    {
                        "pretty": "Philippians 4:2\u2013end",
                        "readQS": "Philippians+4:2-",
                        "audioQS": "Phil.4"
                    }
                ],
                "readQS": "Psalm+121%3B+2+Kings+20%3B+Philippians+4:2-",
                "audioQS": "Ps.121,2Kgs.20,Phil.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Luke)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Hosea 6:1\u20133",
                        "readQS": "Hosea+6:1-3",
                        "audioQS": "Hos.6"
                    },
                    {
                        "pretty": "2 Timothy 3:10\u201317",
                        "readQS": "2+Timothy+3:10-17",
                        "audioQS": "2Tim.3"
                    }
                ],
                "readQS": "Psalm+33%3B+Hosea+6:1-3%3B+2+Timothy+3:10-17",
                "audioQS": "Ps.33,Hos.6,2Tim.3",
                "note": null
            }
        ]
    },
    "2026/10/18": {
        "datePretty": "Sunday, October 18, 2026",
        "calendar": "St Luke the Evangelist",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 96:1\u20139,(10\u201313)",
                        "readQS": "Psalm+96:1-9,%2810-13%29",
                        "audioQS": "Ps.96"
                    },
                    {
                        "pretty": "Isaiah 45:1\u20137",
                        "readQS": "Isaiah+45:1-7",
                        "audioQS": "Isa.45"
                    },
                    {
                        "pretty": "1 Thessalonians 1:1\u201310",
                        "readQS": "1+Thessalonians+1:1-10",
                        "audioQS": "1Thess.1"
                    },
                    {
                        "pretty": "Matthew 22:15\u201322",
                        "readQS": "Matthew+22:15-22",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+96:1-9,%2810-13%29%3B+Isaiah+45:1-7%3B+1+Thessalonians+1:1-10%3B+Matthew+22:15-22",
                "audioQS": "Ps.96,Isa.45,1Thess.1,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 99:1\u20139",
                        "readQS": "Psalm+99:1-9",
                        "audioQS": "Ps.99"
                    },
                    {
                        "pretty": "Exodus 33:12\u201323",
                        "readQS": "Exodus+33:12-23",
                        "audioQS": "Exod.33"
                    },
                    {
                        "pretty": "1 Thessalonians 1:1\u201310",
                        "readQS": "1+Thessalonians+1:1-10",
                        "audioQS": "1Thess.1"
                    },
                    {
                        "pretty": "Matthew 22:15\u201322",
                        "readQS": "Matthew+22:15-22",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+99:1-9%3B+Exodus+33:12-23%3B+1+Thessalonians+1:1-10%3B+Matthew+22:15-22",
                "audioQS": "Ps.99,Exod.33,1Thess.1,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 145,146",
                        "readQS": "Psalm+145,146",
                        "audioQS": "Ps.145,146"
                    },
                    {
                        "pretty": "Isaiah 55",
                        "readQS": "Isaiah+55",
                        "audioQS": "Isa.55"
                    },
                    {
                        "pretty": "Luke 1:1\u20134",
                        "readQS": "Luke+1:1-4",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+145,146%3B+Isaiah+55%3B+Luke+1:1-4",
                "audioQS": "Ps.145,146,Isa.55,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 103",
                        "readQS": "Psalm+103",
                        "audioQS": "Ps.103"
                    },
                    {
                        "pretty": "Isaiah 61:1\u20136",
                        "readQS": "Isaiah+61:1-6",
                        "audioQS": "Isa.61"
                    },
                    {
                        "pretty": "Colossians 4:7\u201318",
                        "readQS": "Colossians+4:7-18",
                        "audioQS": "Col.4"
                    }
                ],
                "readQS": "Psalm+103%3B+Isaiah+61:1-6%3B+Colossians+4:7-18",
                "audioQS": "Ps.103,Isa.61,Col.4",
                "note": null
            }
        ]
    },
    "2026/10/19": {
        "datePretty": "Monday, October 19, 2026",
        "calendar": "Week of 29th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 126",
                        "readQS": "Psalm+126",
                        "audioQS": "Ps.126"
                    },
                    {
                        "pretty": "2 Kings 21:1\u201318",
                        "readQS": "2+Kings+21:1-18",
                        "audioQS": "2Kgs.21"
                    },
                    {
                        "pretty": "1 Timothy 1:1\u201317",
                        "readQS": "1+Timothy+1:1-17",
                        "audioQS": "1Tim.1"
                    }
                ],
                "readQS": "Psalm+126%3B+2+Kings+21:1-18%3B+1+Timothy+1:1-17",
                "audioQS": "Ps.126,2Kgs.21,1Tim.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 127",
                        "readQS": "Psalm+127",
                        "audioQS": "Ps.127"
                    },
                    {
                        "pretty": "Ezekiel 37:1\u201314",
                        "readQS": "Ezekiel+37:1-14",
                        "audioQS": "Ezek.37"
                    },
                    {
                        "pretty": "John 15:1\u201311",
                        "readQS": "John+15:1-11",
                        "audioQS": "John.15"
                    }
                ],
                "readQS": "Psalm+127%3B+Ezekiel+37:1-14%3B+John+15:1-11",
                "audioQS": "Ps.127,Ezek.37,John.15",
                "note": null
            }
        ]
    },
    "2026/10/20": {
        "datePretty": "Tuesday, October 20, 2026",
        "calendar": "Week of 29th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 132",
                        "readQS": "Psalm+132",
                        "audioQS": "Ps.132"
                    },
                    {
                        "pretty": "2 Kings 22:1\u201323:3",
                        "readQS": "2+Kings+22:1-23:3",
                        "audioQS": "2Kgs.22"
                    },
                    {
                        "pretty": "1 Timothy 1:18\u2013end",
                        "readQS": "1+Timothy+1:18-",
                        "audioQS": "1Tim.1"
                    },
                    {
                        "pretty": "1 Timothy 2",
                        "readQS": "1+Timothy+2",
                        "audioQS": "1Tim.2"
                    }
                ],
                "readQS": "Psalm+132%3B+2+Kings+22:1-23:3%3B+1+Timothy+1:18-%3B+1+Timothy+2",
                "audioQS": "Ps.132,2Kgs.22,1Tim.1,1Tim.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 135",
                        "readQS": "Psalm+135",
                        "audioQS": "Ps.135"
                    },
                    {
                        "pretty": "Ezekiel 37:15\u2013end",
                        "readQS": "Ezekiel+37:15-",
                        "audioQS": "Ezek.37"
                    },
                    {
                        "pretty": "John 15:12\u201317",
                        "readQS": "John+15:12-17",
                        "audioQS": "John.15"
                    }
                ],
                "readQS": "Psalm+135%3B+Ezekiel+37:15-%3B+John+15:12-17",
                "audioQS": "Ps.135,Ezek.37,John.15",
                "note": null
            }
        ]
    },
    "2026/10/21": {
        "datePretty": "Wednesday, October 21, 2026",
        "calendar": "Week of 29th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:153\u2013end",
                        "readQS": "Psalm+119:153-",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "2 Kings 23:4\u201325",
                        "readQS": "2+Kings+23:4-25",
                        "audioQS": "2Kgs.23"
                    },
                    {
                        "pretty": "1 Timothy 3",
                        "readQS": "1+Timothy+3",
                        "audioQS": "1Tim.3"
                    }
                ],
                "readQS": "Psalm+119:153-%3B+2+Kings+23:4-25%3B+1+Timothy+3",
                "audioQS": "Ps.119,2Kgs.23,1Tim.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 136",
                        "readQS": "Psalm+136",
                        "audioQS": "Ps.136"
                    },
                    {
                        "pretty": "Ezekiel 39:21\u2013end",
                        "readQS": "Ezekiel+39:21-",
                        "audioQS": "Ezek.39"
                    },
                    {
                        "pretty": "John 15:18\u2013end",
                        "readQS": "John+15:18-",
                        "audioQS": "John.15"
                    }
                ],
                "readQS": "Psalm+136%3B+Ezekiel+39:21-%3B+John+15:18-",
                "audioQS": "Ps.136,Ezek.39,John.15",
                "note": null
            }
        ]
    },
    "2026/10/22": {
        "datePretty": "Thursday, October 22, 2026",
        "calendar": "Week of 29th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 143",
                        "readQS": "Psalm+143",
                        "audioQS": "Ps.143"
                    },
                    {
                        "pretty": "2 Kings 23:36\u201324:17",
                        "readQS": "2+Kings+23:36-24:17",
                        "audioQS": "2Kgs.23"
                    },
                    {
                        "pretty": "1 Timothy 4",
                        "readQS": "1+Timothy+4",
                        "audioQS": "1Tim.4"
                    }
                ],
                "readQS": "Psalm+143%3B+2+Kings+23:36-24:17%3B+1+Timothy+4",
                "audioQS": "Ps.143,2Kgs.23,1Tim.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 138",
                        "readQS": "Psalm+138",
                        "audioQS": "Ps.138"
                    },
                    {
                        "pretty": "Ezekiel 43:1\u201312",
                        "readQS": "Ezekiel+43:1-12",
                        "audioQS": "Ezek.43"
                    },
                    {
                        "pretty": "John 16:1\u201315",
                        "readQS": "John+16:1-15",
                        "audioQS": "John.16"
                    }
                ],
                "readQS": "Psalm+138%3B+Ezekiel+43:1-12%3B+John+16:1-15",
                "audioQS": "Ps.138,Ezek.43,John.16",
                "note": null
            }
        ]
    },
    "2026/10/23": {
        "datePretty": "Friday, October 23, 2026",
        "calendar": "Week of 29th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "2 Kings 24:18\u201325:12",
                        "readQS": "2+Kings+24:18-25:12",
                        "audioQS": "2Kgs.24"
                    },
                    {
                        "pretty": "1 Timothy 5:1\u201316",
                        "readQS": "1+Timothy+5:1-16",
                        "audioQS": "1Tim.5"
                    }
                ],
                "readQS": "Psalm+144%3B+2+Kings+24:18-25:12%3B+1+Timothy+5:1-16",
                "audioQS": "Ps.144,2Kgs.24,1Tim.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Ezekiel 44:4\u201316",
                        "readQS": "Ezekiel+44:4-16",
                        "audioQS": "Ezek.44"
                    },
                    {
                        "pretty": "John 16:16\u201322",
                        "readQS": "John+16:16-22",
                        "audioQS": "John.16"
                    }
                ],
                "readQS": "Psalm+145%3B+Ezekiel+44:4-16%3B+John+16:16-22",
                "audioQS": "Ps.145,Ezek.44,John.16",
                "note": null
            }
        ]
    },
    "2026/10/24": {
        "datePretty": "Saturday, October 24, 2026",
        "calendar": "Week of 29th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 147",
                        "readQS": "Psalm+147",
                        "audioQS": "Ps.147"
                    },
                    {
                        "pretty": "2 Kings 25:22\u2013end",
                        "readQS": "2+Kings+25:22-",
                        "audioQS": "2Kgs.25"
                    },
                    {
                        "pretty": "1 Timothy 5:17\u2013end",
                        "readQS": "1+Timothy+5:17-",
                        "audioQS": "1Tim.5"
                    }
                ],
                "readQS": "Psalm+147%3B+2+Kings+25:22-%3B+1+Timothy+5:17-",
                "audioQS": "Ps.147,2Kgs.25,1Tim.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 148",
                        "readQS": "Psalm+148",
                        "audioQS": "Ps.148"
                    },
                    {
                        "pretty": "Ezekiel 47:1\u201312",
                        "readQS": "Ezekiel+47:1-12",
                        "audioQS": "Ezek.47"
                    },
                    {
                        "pretty": "John 16:23\u2013end",
                        "readQS": "John+16:23-",
                        "audioQS": "John.16"
                    }
                ],
                "readQS": "Psalm+148%3B+Ezekiel+47:1-12%3B+John+16:23-",
                "audioQS": "Ps.148,Ezek.47,John.16",
                "note": null
            }
        ]
    },
    "2026/10/25": {
        "datePretty": "Sunday, October 25, 2026",
        "calendar": "30th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 1",
                        "readQS": "Psalm+1",
                        "audioQS": "Ps.1"
                    },
                    {
                        "pretty": "Leviticus 19:1\u20132,15\u201318",
                        "readQS": "Leviticus+19:1-2,15-18",
                        "audioQS": "Lev.19"
                    },
                    {
                        "pretty": "1 Thessalonians 2:1\u20138",
                        "readQS": "1+Thessalonians+2:1-8",
                        "audioQS": "1Thess.2"
                    },
                    {
                        "pretty": "Matthew 22:34\u201346",
                        "readQS": "Matthew+22:34-46",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+1%3B+Leviticus+19:1-2,15-18%3B+1+Thessalonians+2:1-8%3B+Matthew+22:34-46",
                "audioQS": "Ps.1,Lev.19,1Thess.2,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 90:1\u20136,13\u201317",
                        "readQS": "Psalm+90:1-6,13-17",
                        "audioQS": "Ps.90"
                    },
                    {
                        "pretty": "Deuteronomy 34:1\u201312",
                        "readQS": "Deuteronomy+34:1-12",
                        "audioQS": "Deut.34"
                    },
                    {
                        "pretty": "1 Thessalonians 2:1\u20138",
                        "readQS": "1+Thessalonians+2:1-8",
                        "audioQS": "1Thess.2"
                    },
                    {
                        "pretty": "Matthew 22:34\u201346",
                        "readQS": "Matthew+22:34-46",
                        "audioQS": "Matt.22"
                    }
                ],
                "readQS": "Psalm+90:1-6,13-17%3B+Deuteronomy+34:1-12%3B+1+Thessalonians+2:1-8%3B+Matthew+22:34-46",
                "audioQS": "Ps.90,Deut.34,1Thess.2,Matt.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 119:137\u2013152",
                        "readQS": "Psalm+119:137-152",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Isaiah 59:9\u201320",
                        "readQS": "Isaiah+59:9-20",
                        "audioQS": "Isa.59"
                    },
                    {
                        "pretty": "Luke 14:1\u201314",
                        "readQS": "Luke+14:1-14",
                        "audioQS": "Luke.14"
                    }
                ],
                "readQS": "Psalm+119:137-152%3B+Isaiah+59:9-20%3B+Luke+14:1-14",
                "audioQS": "Ps.119,Isa.59,Luke.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:89\u2013104",
                        "readQS": "Psalm+119:89-104",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Ecclesiastes 11,12",
                        "readQS": "Ecclesiastes+11,12",
                        "audioQS": "Eccl.11,12"
                    },
                    {
                        "pretty": "2 Timothy 2:1\u20137",
                        "readQS": "2+Timothy+2:1-7",
                        "audioQS": "2Tim.2"
                    }
                ],
                "readQS": "Psalm+119:89-104%3B+Ecclesiastes+11,12%3B+2+Timothy+2:1-7",
                "audioQS": "Ps.119,Eccl.11,12,2Tim.2",
                "note": null
            }
        ]
    },
    "2026/10/26": {
        "datePretty": "Monday, October 26, 2026",
        "calendar": "Week of 30th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 1",
                        "readQS": "Psalm+1",
                        "audioQS": "Ps.1"
                    },
                    {
                        "pretty": "Exodus 22:21\u201327,23:1\u201317",
                        "readQS": "Exodus+22:21-27,23:1-17",
                        "audioQS": "Exod.22"
                    },
                    {
                        "pretty": "1 Timothy 6:1\u201310",
                        "readQS": "1+Timothy+6:1-10",
                        "audioQS": "1Tim.6"
                    }
                ],
                "readQS": "Psalm+1%3B+Exodus+22:21-27,23:1-17%3B+1+Timothy+6:1-10",
                "audioQS": "Ps.1,Exod.22,1Tim.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 4",
                        "readQS": "Psalm+4",
                        "audioQS": "Ps.4"
                    },
                    {
                        "pretty": "Ecclesiastes 1",
                        "readQS": "Ecclesiastes+1",
                        "audioQS": "Eccl.1"
                    },
                    {
                        "pretty": "John 17:1\u20135",
                        "readQS": "John+17:1-5",
                        "audioQS": "John.17"
                    }
                ],
                "readQS": "Psalm+4%3B+Ecclesiastes+1%3B+John+17:1-5",
                "audioQS": "Ps.4,Eccl.1,John.17",
                "note": null
            }
        ]
    },
    "2026/10/27": {
        "datePretty": "Tuesday, October 27, 2026",
        "calendar": "Week of 30th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "Exodus 29:38\u201330:16",
                        "readQS": "Exodus+29:38-30:16",
                        "audioQS": "Exod.29"
                    },
                    {
                        "pretty": "1 Timothy 6:11\u2013end",
                        "readQS": "1+Timothy+6:11-",
                        "audioQS": "1Tim.6"
                    }
                ],
                "readQS": "Psalm+5%3B+Exodus+29:38-30:16%3B+1+Timothy+6:11-",
                "audioQS": "Ps.5,Exod.29,1Tim.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Simon and St Jude)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 124,125,126",
                        "readQS": "Psalm+124,125,126",
                        "audioQS": "Ps.124,125,126"
                    },
                    {
                        "pretty": "Deuteronomy 32:1\u20134",
                        "readQS": "Deuteronomy+32:1-4",
                        "audioQS": "Deut.32"
                    },
                    {
                        "pretty": "John 14:15\u201326",
                        "readQS": "John+14:15-26",
                        "audioQS": "John.14"
                    }
                ],
                "readQS": "Psalm+124,125,126%3B+Deuteronomy+32:1-4%3B+John+14:15-26",
                "audioQS": "Ps.124,125,126,Deut.32,John.14",
                "note": null
            }
        ]
    },
    "2026/10/28": {
        "datePretty": "Wednesday, October 28, 2026",
        "calendar": "St Simon and St Jude, Apostles",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 116,117",
                        "readQS": "Psalm+116,117",
                        "audioQS": "Ps.116,117"
                    },
                    {
                        "pretty": "Isaiah 45:18\u201326",
                        "readQS": "Isaiah+45:18-26",
                        "audioQS": "Isa.45"
                    },
                    {
                        "pretty": "Luke 6:12\u201316",
                        "readQS": "Luke+6:12-16",
                        "audioQS": "Luke.6"
                    }
                ],
                "readQS": "Psalm+116,117%3B+Isaiah+45:18-26%3B+Luke+6:12-16",
                "audioQS": "Ps.116,117,Isa.45,Luke.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 119:1\u201316",
                        "readQS": "Psalm+119:1-16",
                        "audioQS": "Ps.119"
                    },
                    {
                        "pretty": "Jeremiah 3:11\u201318",
                        "readQS": "Jeremiah+3:11-18",
                        "audioQS": "Jer.3"
                    },
                    {
                        "pretty": "Jude 1\u20134,17\u201325",
                        "readQS": "Jude+1-4,17-25",
                        "audioQS": "Jude.1\u20134,17\u201325"
                    }
                ],
                "readQS": "Psalm+119:1-16%3B+Jeremiah+3:11-18%3B+Jude+1-4,17-25",
                "audioQS": "Ps.119,Jer.3,Jude.1\u20134,17\u201325",
                "note": null
            }
        ]
    },
    "2026/10/29": {
        "datePretty": "Thursday, October 29, 2026",
        "calendar": "Week of 30th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15",
                        "readQS": "Psalm+15",
                        "audioQS": "Ps.15"
                    },
                    {
                        "pretty": "Leviticus 9",
                        "readQS": "Leviticus+9",
                        "audioQS": "Lev.9"
                    },
                    {
                        "pretty": "2 Timothy 1:15\u20132:13",
                        "readQS": "2+Timothy+1:15-2:13",
                        "audioQS": "2Tim.1"
                    }
                ],
                "readQS": "Psalm+15%3B+Leviticus+9%3B+2+Timothy+1:15-2:13",
                "audioQS": "Ps.15,Lev.9,2Tim.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 18",
                        "readQS": "Psalm+18",
                        "audioQS": "Ps.18"
                    },
                    {
                        "pretty": "Ecclesiastes 3:16\u2013end",
                        "readQS": "Ecclesiastes+3:16-",
                        "audioQS": "Eccl.3"
                    },
                    {
                        "pretty": "Ecclesiastes 4",
                        "readQS": "Ecclesiastes+4",
                        "audioQS": "Eccl.4"
                    },
                    {
                        "pretty": "John 18:1\u201311",
                        "readQS": "John+18:1-11",
                        "audioQS": "John.18"
                    }
                ],
                "readQS": "Psalm+18%3B+Ecclesiastes+3:16-%3B+Ecclesiastes+4%3B+John+18:1-11",
                "audioQS": "Ps.18,Eccl.3,Eccl.4,John.18",
                "note": null
            }
        ]
    },
    "2026/10/30": {
        "datePretty": "Friday, October 30, 2026",
        "calendar": "Week of 30th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 19",
                        "readQS": "Psalm+19",
                        "audioQS": "Ps.19"
                    },
                    {
                        "pretty": "Leviticus 16:2\u201324",
                        "readQS": "Leviticus+16:2-24",
                        "audioQS": "Lev.16"
                    },
                    {
                        "pretty": "2 Timothy 2:14\u2013end",
                        "readQS": "2+Timothy+2:14-",
                        "audioQS": "2Tim.2"
                    }
                ],
                "readQS": "Psalm+19%3B+Leviticus+16:2-24%3B+2+Timothy+2:14-",
                "audioQS": "Ps.19,Lev.16,2Tim.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 22",
                        "readQS": "Psalm+22",
                        "audioQS": "Ps.22"
                    },
                    {
                        "pretty": "Ecclesiastes 5",
                        "readQS": "Ecclesiastes+5",
                        "audioQS": "Eccl.5"
                    },
                    {
                        "pretty": "John 18:12\u201327",
                        "readQS": "John+18:12-27",
                        "audioQS": "John.18"
                    }
                ],
                "readQS": "Psalm+22%3B+Ecclesiastes+5%3B+John+18:12-27",
                "audioQS": "Ps.22,Eccl.5,John.18",
                "note": null
            }
        ]
    },
    "2026/10/31": {
        "datePretty": "Saturday, October 31, 2026",
        "calendar": "Week of 30th Sunday in Ordinary Time",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Leviticus 17",
                        "readQS": "Leviticus+17",
                        "audioQS": "Lev.17"
                    },
                    {
                        "pretty": "2 Timothy 3",
                        "readQS": "2+Timothy+3",
                        "audioQS": "2Tim.3"
                    }
                ],
                "readQS": "Psalm+23%3B+Leviticus+17%3B+2+Timothy+3",
                "audioQS": "Ps.23,Lev.17,2Tim.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of All Saints' Day)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 1,5",
                        "readQS": "Psalm+1,5",
                        "audioQS": "Ps.1,5"
                    },
                    {
                        "pretty": "Isaiah 40:27\u2013end",
                        "readQS": "Isaiah+40:27-",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "Revelations 19:6\u201310",
                        "readQS": "Revelations+19:6-10",
                        "audioQS": "Revs.19"
                    }
                ],
                "readQS": "Psalm+1,5%3B+Isaiah+40:27-%3B+Revelations+19:6-10",
                "audioQS": "Ps.1,5,Isa.40,Revs.19",
                "note": null
            }
        ]
    },
    "2026/11/01": {
        "datePretty": "Sunday, November 1, 2026",
        "calendar": "All Saints' Day",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 34:1\u201310",
                        "readQS": "Psalm+34:1-10",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Revelation 7:9\u201317",
                        "readQS": "Revelation+7:9-17",
                        "audioQS": "Rev.7"
                    },
                    {
                        "pretty": "1 John 3:1\u20133",
                        "readQS": "1+John+3:1-3",
                        "audioQS": "1John.3"
                    },
                    {
                        "pretty": "Matthew 5:1\u201312",
                        "readQS": "Matthew+5:1-12",
                        "audioQS": "Matt.5"
                    }
                ],
                "readQS": "Psalm+34:1-10%3B+Revelation+7:9-17%3B+1+John+3:1-3%3B+Matthew+5:1-12",
                "audioQS": "Ps.34,Rev.7,1John.3,Matt.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15,84,149",
                        "readQS": "Psalm+15,84,149",
                        "audioQS": "Ps.15,84,149"
                    },
                    {
                        "pretty": "Isaiah 35",
                        "readQS": "Isaiah+35",
                        "audioQS": "Isa.35"
                    },
                    {
                        "pretty": "Luke 9:18\u201327",
                        "readQS": "Luke+9:18-27",
                        "audioQS": "Luke.9"
                    }
                ],
                "readQS": "Psalm+15,84,149%3B+Isaiah+35%3B+Luke+9:18-27",
                "audioQS": "Ps.15,84,149,Isa.35,Luke.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 148,150",
                        "readQS": "Psalm+148,150",
                        "audioQS": "Ps.148,150"
                    },
                    {
                        "pretty": "Isaiah 65:17\u201325",
                        "readQS": "Isaiah+65:17-25",
                        "audioQS": "Isa.65"
                    },
                    {
                        "pretty": "Hebrews 11:32\u201312:2",
                        "readQS": "Hebrews+11:32-12:2",
                        "audioQS": "Heb.11"
                    }
                ],
                "readQS": "Psalm+148,150%3B+Isaiah+65:17-25%3B+Hebrews+11:32-12:2",
                "audioQS": "Ps.148,150,Isa.65,Heb.11",
                "note": null
            }
        ]
    },
    "2026/11/02": {
        "datePretty": "Monday, November 2, 2026",
        "calendar": "All Souls' Day",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 2",
                        "readQS": "Psalm+2",
                        "audioQS": "Ps.2"
                    },
                    {
                        "pretty": "Daniel 1",
                        "readQS": "Daniel+1",
                        "audioQS": "Dan.1"
                    },
                    {
                        "pretty": "Revelation 1",
                        "readQS": "Revelation+1",
                        "audioQS": "Rev.1"
                    }
                ],
                "readQS": "Psalm+2%3B+Daniel+1%3B+Revelation+1",
                "audioQS": "Ps.2,Dan.1,Rev.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 92",
                        "readQS": "Psalm+92",
                        "audioQS": "Ps.92"
                    },
                    {
                        "pretty": "Isaiah 1:1\u201320",
                        "readQS": "Isaiah+1:1-20",
                        "audioQS": "Isa.1"
                    },
                    {
                        "pretty": "Matthew 1:18\u2013end",
                        "readQS": "Matthew+1:18-",
                        "audioQS": "Matt.1"
                    }
                ],
                "readQS": "Psalm+92%3B+Isaiah+1:1-20%3B+Matthew+1:18-",
                "audioQS": "Ps.92,Isa.1,Matt.1",
                "note": null
            }
        ]
    },
    "2026/11/03": {
        "datePretty": "Tuesday, November 3, 2026",
        "calendar": "Week of 4th Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 5",
                        "readQS": "Psalm+5",
                        "audioQS": "Ps.5"
                    },
                    {
                        "pretty": "Daniel 2:1\u201324",
                        "readQS": "Daniel+2:1-24",
                        "audioQS": "Dan.2"
                    },
                    {
                        "pretty": "Revelation 2:1\u201311",
                        "readQS": "Revelation+2:1-11",
                        "audioQS": "Rev.2"
                    }
                ],
                "readQS": "Psalm+5%3B+Daniel+2:1-24%3B+Revelation+2:1-11",
                "audioQS": "Ps.5,Dan.2,Rev.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 100",
                        "readQS": "Psalm+100",
                        "audioQS": "Ps.100"
                    },
                    {
                        "pretty": "Isaiah 1:21\u2013end",
                        "readQS": "Isaiah+1:21-",
                        "audioQS": "Isa.1"
                    },
                    {
                        "pretty": "Matthew 2:1\u201315",
                        "readQS": "Matthew+2:1-15",
                        "audioQS": "Matt.2"
                    }
                ],
                "readQS": "Psalm+100%3B+Isaiah+1:21-%3B+Matthew+2:1-15",
                "audioQS": "Ps.100,Isa.1,Matt.2",
                "note": null
            }
        ]
    },
    "2026/11/04": {
        "datePretty": "Wednesday, November 4, 2026",
        "calendar": "Week of 4th Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Daniel 2:25\u2013end",
                        "readQS": "Daniel+2:25-",
                        "audioQS": "Dan.2"
                    },
                    {
                        "pretty": "Revelation 2:12\u2013end",
                        "readQS": "Revelation+2:12-",
                        "audioQS": "Rev.2"
                    }
                ],
                "readQS": "Psalm+9%3B+Daniel+2:25-%3B+Revelation+2:12-",
                "audioQS": "Ps.9,Dan.2,Rev.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 112",
                        "readQS": "Psalm+112",
                        "audioQS": "Ps.112"
                    },
                    {
                        "pretty": "Isaiah 2:1\u201311",
                        "readQS": "Isaiah+2:1-11",
                        "audioQS": "Isa.2"
                    },
                    {
                        "pretty": "Matthew 2:16\u2013end",
                        "readQS": "Matthew+2:16-",
                        "audioQS": "Matt.2"
                    }
                ],
                "readQS": "Psalm+112%3B+Isaiah+2:1-11%3B+Matthew+2:16-",
                "audioQS": "Ps.112,Isa.2,Matt.2",
                "note": null
            }
        ]
    },
    "2026/11/05": {
        "datePretty": "Thursday, November 5, 2026",
        "calendar": "Week of 4th Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 15",
                        "readQS": "Psalm+15",
                        "audioQS": "Ps.15"
                    },
                    {
                        "pretty": "Daniel 3:1\u201318",
                        "readQS": "Daniel+3:1-18",
                        "audioQS": "Dan.3"
                    },
                    {
                        "pretty": "Revelation 3:1\u201313",
                        "readQS": "Revelation+3:1-13",
                        "audioQS": "Rev.3"
                    }
                ],
                "readQS": "Psalm+15%3B+Daniel+3:1-18%3B+Revelation+3:1-13",
                "audioQS": "Ps.15,Dan.3,Rev.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 118",
                        "readQS": "Psalm+118",
                        "audioQS": "Ps.118"
                    },
                    {
                        "pretty": "Isaiah 2:12\u2013end",
                        "readQS": "Isaiah+2:12-",
                        "audioQS": "Isa.2"
                    },
                    {
                        "pretty": "Matthew 3",
                        "readQS": "Matthew+3",
                        "audioQS": "Matt.3"
                    }
                ],
                "readQS": "Psalm+118%3B+Isaiah+2:12-%3B+Matthew+3",
                "audioQS": "Ps.118,Isa.2,Matt.3",
                "note": null
            }
        ]
    },
    "2026/11/06": {
        "datePretty": "Friday, November 6, 2026",
        "calendar": "Week of 4th Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 16",
                        "readQS": "Psalm+16",
                        "audioQS": "Ps.16"
                    },
                    {
                        "pretty": "Daniel 3:19\u2013end",
                        "readQS": "Daniel+3:19-",
                        "audioQS": "Dan.3"
                    },
                    {
                        "pretty": "Revelation 3:14\u2013end",
                        "readQS": "Revelation+3:14-",
                        "audioQS": "Rev.3"
                    }
                ],
                "readQS": "Psalm+16%3B+Daniel+3:19-%3B+Revelation+3:14-",
                "audioQS": "Ps.16,Dan.3,Rev.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 143",
                        "readQS": "Psalm+143",
                        "audioQS": "Ps.143"
                    },
                    {
                        "pretty": "Isaiah 3:1\u201315",
                        "readQS": "Isaiah+3:1-15",
                        "audioQS": "Isa.3"
                    },
                    {
                        "pretty": "Matthew 4:1\u201311",
                        "readQS": "Matthew+4:1-11",
                        "audioQS": "Matt.4"
                    }
                ],
                "readQS": "Psalm+143%3B+Isaiah+3:1-15%3B+Matthew+4:1-11",
                "audioQS": "Ps.143,Isa.3,Matt.4",
                "note": null
            }
        ]
    },
    "2026/11/07": {
        "datePretty": "Saturday, November 7, 2026",
        "calendar": "Week of 4th Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 18.31\u2013end",
                        "readQS": "Psalm+18.31-",
                        "audioQS": "Ps.18.31\u2013end"
                    },
                    {
                        "pretty": "Daniel 4:1\u201318",
                        "readQS": "Daniel+4:1-18",
                        "audioQS": "Dan.4"
                    },
                    {
                        "pretty": "Revelation 4",
                        "readQS": "Revelation+4",
                        "audioQS": "Rev.4"
                    }
                ],
                "readQS": "Psalm+18.31-%3B+Daniel+4:1-18%3B+Revelation+4",
                "audioQS": "Ps.18.31\u2013end,Dan.4,Rev.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Isaiah 4:2\u20135:7",
                        "readQS": "Isaiah+4:2-5:7",
                        "audioQS": "Isa.4"
                    },
                    {
                        "pretty": "Matthew 4:12\u201322",
                        "readQS": "Matthew+4:12-22",
                        "audioQS": "Matt.4"
                    }
                ],
                "readQS": "Psalm+145%3B+Isaiah+4:2-5:7%3B+Matthew+4:12-22",
                "audioQS": "Ps.145,Isa.4,Matt.4",
                "note": null
            }
        ]
    },
    "2026/11/08": {
        "datePretty": "Sunday, November 8, 2026",
        "calendar": "3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 70",
                        "readQS": "Psalm+70",
                        "audioQS": "Ps.70"
                    },
                    {
                        "pretty": "Amos 5:18\u201324",
                        "readQS": "Amos+5:18-24",
                        "audioQS": "Amos.5"
                    },
                    {
                        "pretty": "1 Thessalonians 4:13\u201318",
                        "readQS": "1+Thessalonians+4:13-18",
                        "audioQS": "1Thess.4"
                    },
                    {
                        "pretty": "Matthew 25:1\u201313",
                        "readQS": "Matthew+25:1-13",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+70%3B+Amos+5:18-24%3B+1+Thessalonians+4:13-18%3B+Matthew+25:1-13",
                "audioQS": "Ps.70,Amos.5,1Thess.4,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 78:1\u20137",
                        "readQS": "Psalm+78:1-7",
                        "audioQS": "Ps.78"
                    },
                    {
                        "pretty": "Joshua 24:1\u20133a,14\u201325",
                        "readQS": "Joshua+24:1-3a,14-25",
                        "audioQS": "Josh.24"
                    },
                    {
                        "pretty": "1 Thessalonians 4:13\u201318",
                        "readQS": "1+Thessalonians+4:13-18",
                        "audioQS": "1Thess.4"
                    },
                    {
                        "pretty": "Matthew 25:1\u201313",
                        "readQS": "Matthew+25:1-13",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+78:1-7%3B+Joshua+24:1-3a,14-25%3B+1+Thessalonians+4:13-18%3B+Matthew+25:1-13",
                "audioQS": "Ps.78,Josh.24,1Thess.4,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 91",
                        "readQS": "Psalm+91",
                        "audioQS": "Ps.91"
                    },
                    {
                        "pretty": "Deuteronomy 17:14\u201320",
                        "readQS": "Deuteronomy+17:14-20",
                        "audioQS": "Deut.17"
                    },
                    {
                        "pretty": "1 Timothy 2:1\u20137",
                        "readQS": "1+Timothy+2:1-7",
                        "audioQS": "1Tim.2"
                    }
                ],
                "readQS": "Psalm+91%3B+Deuteronomy+17:14-20%3B+1+Timothy+2:1-7",
                "audioQS": "Ps.91,Deut.17,1Tim.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 82",
                        "readQS": "Psalm+82",
                        "audioQS": "Ps.82"
                    },
                    {
                        "pretty": "Judges 7:2\u201322",
                        "readQS": "Judges+7:2-22",
                        "audioQS": "Judg.7"
                    },
                    {
                        "pretty": "John 15:9\u201317",
                        "readQS": "John+15:9-17",
                        "audioQS": "John.15"
                    }
                ],
                "readQS": "Psalm+82%3B+Judges+7:2-22%3B+John+15:9-17",
                "audioQS": "Ps.82,Judg.7,John.15",
                "note": null
            }
        ]
    },
    "2026/11/09": {
        "datePretty": "Monday, November 9, 2026",
        "calendar": "Week of 3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 20",
                        "readQS": "Psalm+20",
                        "audioQS": "Ps.20"
                    },
                    {
                        "pretty": "Daniel 4:19\u2013end",
                        "readQS": "Daniel+4:19-",
                        "audioQS": "Dan.4"
                    },
                    {
                        "pretty": "Revelation 5",
                        "readQS": "Revelation+5",
                        "audioQS": "Rev.5"
                    }
                ],
                "readQS": "Psalm+20%3B+Daniel+4:19-%3B+Revelation+5",
                "audioQS": "Ps.20,Dan.4,Rev.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 34",
                        "readQS": "Psalm+34",
                        "audioQS": "Ps.34"
                    },
                    {
                        "pretty": "Isaiah 5:8\u201324",
                        "readQS": "Isaiah+5:8-24",
                        "audioQS": "Isa.5"
                    },
                    {
                        "pretty": "Matthew 4:23\u20135:12",
                        "readQS": "Matthew+4:23-5:12",
                        "audioQS": "Matt.4"
                    }
                ],
                "readQS": "Psalm+34%3B+Isaiah+5:8-24%3B+Matthew+4:23-5:12",
                "audioQS": "Ps.34,Isa.5,Matt.4",
                "note": null
            }
        ]
    },
    "2026/11/10": {
        "datePretty": "Tuesday, November 10, 2026",
        "calendar": "Week of 3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 21",
                        "readQS": "Psalm+21",
                        "audioQS": "Ps.21"
                    },
                    {
                        "pretty": "Daniel 5:1\u201312",
                        "readQS": "Daniel+5:1-12",
                        "audioQS": "Dan.5"
                    },
                    {
                        "pretty": "Revelation 6",
                        "readQS": "Revelation+6",
                        "audioQS": "Rev.6"
                    }
                ],
                "readQS": "Psalm+21%3B+Daniel+5:1-12%3B+Revelation+6",
                "audioQS": "Ps.21,Dan.5,Rev.6",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 5:25\u2013end",
                        "readQS": "Isaiah+5:25-",
                        "audioQS": "Isa.5"
                    },
                    {
                        "pretty": "Matthew 5:13\u201320",
                        "readQS": "Matthew+5:13-20",
                        "audioQS": "Matt.5"
                    }
                ],
                "readQS": "Psalm+40%3B+Isaiah+5:25-%3B+Matthew+5:13-20",
                "audioQS": "Ps.40,Isa.5,Matt.5",
                "note": null
            }
        ]
    },
    "2026/11/11": {
        "datePretty": "Wednesday, November 11, 2026",
        "calendar": "Week of 3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 23",
                        "readQS": "Psalm+23",
                        "audioQS": "Ps.23"
                    },
                    {
                        "pretty": "Daniel 5:13\u2013end",
                        "readQS": "Daniel+5:13-",
                        "audioQS": "Dan.5"
                    },
                    {
                        "pretty": "Revelation 7:1\u20134,9\u2013end",
                        "readQS": "Revelation+7:1-4,9-",
                        "audioQS": "Rev.7"
                    }
                ],
                "readQS": "Psalm+23%3B+Daniel+5:13-%3B+Revelation+7:1-4,9-",
                "audioQS": "Ps.23,Dan.5,Rev.7",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 37",
                        "readQS": "Psalm+37",
                        "audioQS": "Ps.37"
                    },
                    {
                        "pretty": "Isaiah 6",
                        "readQS": "Isaiah+6",
                        "audioQS": "Isa.6"
                    },
                    {
                        "pretty": "Matthew 5:21\u201337",
                        "readQS": "Matthew+5:21-37",
                        "audioQS": "Matt.5"
                    }
                ],
                "readQS": "Psalm+37%3B+Isaiah+6%3B+Matthew+5:21-37",
                "audioQS": "Ps.37,Isa.6,Matt.5",
                "note": null
            }
        ]
    },
    "2026/11/12": {
        "datePretty": "Thursday, November 12, 2026",
        "calendar": "Week of 3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 26",
                        "readQS": "Psalm+26",
                        "audioQS": "Ps.26"
                    },
                    {
                        "pretty": "Daniel 6",
                        "readQS": "Daniel+6",
                        "audioQS": "Dan.6"
                    },
                    {
                        "pretty": "Revelation 8",
                        "readQS": "Revelation+8",
                        "audioQS": "Rev.8"
                    }
                ],
                "readQS": "Psalm+26%3B+Daniel+6%3B+Revelation+8",
                "audioQS": "Ps.26,Dan.6,Rev.8",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 43",
                        "readQS": "Psalm+43",
                        "audioQS": "Ps.43"
                    },
                    {
                        "pretty": "Isaiah 7:1\u201317",
                        "readQS": "Isaiah+7:1-17",
                        "audioQS": "Isa.7"
                    },
                    {
                        "pretty": "Matthew 5:38\u2013end",
                        "readQS": "Matthew+5:38-",
                        "audioQS": "Matt.5"
                    }
                ],
                "readQS": "Psalm+43%3B+Isaiah+7:1-17%3B+Matthew+5:38-",
                "audioQS": "Ps.43,Isa.7,Matt.5",
                "note": null
            }
        ]
    },
    "2026/11/13": {
        "datePretty": "Friday, November 13, 2026",
        "calendar": "Week of 3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 32",
                        "readQS": "Psalm+32",
                        "audioQS": "Ps.32"
                    },
                    {
                        "pretty": "Daniel 7:1\u201314",
                        "readQS": "Daniel+7:1-14",
                        "audioQS": "Dan.7"
                    },
                    {
                        "pretty": "Revelation 9:1\u201312",
                        "readQS": "Revelation+9:1-12",
                        "audioQS": "Rev.9"
                    }
                ],
                "readQS": "Psalm+32%3B+Daniel+7:1-14%3B+Revelation+9:1-12",
                "audioQS": "Ps.32,Dan.7,Rev.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 31",
                        "readQS": "Psalm+31",
                        "audioQS": "Ps.31"
                    },
                    {
                        "pretty": "Isaiah 8:1\u201315",
                        "readQS": "Isaiah+8:1-15",
                        "audioQS": "Isa.8"
                    },
                    {
                        "pretty": "Matthew 6:1\u201318",
                        "readQS": "Matthew+6:1-18",
                        "audioQS": "Matt.6"
                    }
                ],
                "readQS": "Psalm+31%3B+Isaiah+8:1-15%3B+Matthew+6:1-18",
                "audioQS": "Ps.31,Isa.8,Matt.6",
                "note": null
            }
        ]
    },
    "2026/11/14": {
        "datePretty": "Saturday, November 14, 2026",
        "calendar": "Week of 3rd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 33",
                        "readQS": "Psalm+33",
                        "audioQS": "Ps.33"
                    },
                    {
                        "pretty": "Daniel 7:15\u2013end",
                        "readQS": "Daniel+7:15-",
                        "audioQS": "Dan.7"
                    },
                    {
                        "pretty": "Revelation 9:13\u2013end",
                        "readQS": "Revelation+9:13-",
                        "audioQS": "Rev.9"
                    }
                ],
                "readQS": "Psalm+33%3B+Daniel+7:15-%3B+Revelation+9:13-",
                "audioQS": "Ps.33,Dan.7,Rev.9",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 86",
                        "readQS": "Psalm+86",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Isaiah 8:16\u20139:7",
                        "readQS": "Isaiah+8:16-9:7",
                        "audioQS": "Isa.8"
                    },
                    {
                        "pretty": "Matthew 6:19\u2013end",
                        "readQS": "Matthew+6:19-",
                        "audioQS": "Matt.6"
                    }
                ],
                "readQS": "Psalm+86%3B+Isaiah+8:16-9:7%3B+Matthew+6:19-",
                "audioQS": "Ps.86,Isa.8,Matt.6",
                "note": null
            }
        ]
    },
    "2026/11/15": {
        "datePretty": "Sunday, November 15, 2026",
        "calendar": "2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 90:1\u20138,(9\u201311),12",
                        "readQS": "Psalm+90:1-8,%289-11%29,12",
                        "audioQS": "Ps.90"
                    },
                    {
                        "pretty": "Zephaniah 1:7,12\u201318",
                        "readQS": "Zephaniah+1:7,12-18",
                        "audioQS": "Zeph.1"
                    },
                    {
                        "pretty": "1 Thessalonians 5:1\u201311",
                        "readQS": "1+Thessalonians+5:1-11",
                        "audioQS": "1Thess.5"
                    },
                    {
                        "pretty": "Matthew 25:14\u201330",
                        "readQS": "Matthew+25:14-30",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+90:1-8,%289-11%29,12%3B+Zephaniah+1:7,12-18%3B+1+Thessalonians+5:1-11%3B+Matthew+25:14-30",
                "audioQS": "Ps.90,Zeph.1,1Thess.5,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "rclTrack2",
                "readingSetTabName": "RCL (Co.)",
                "readingSetSubtitle": "Revised Common Lectionary (Continuous)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 123",
                        "readQS": "Psalm+123",
                        "audioQS": "Ps.123"
                    },
                    {
                        "pretty": "Judges 4:1\u20137",
                        "readQS": "Judges+4:1-7",
                        "audioQS": "Judg.4"
                    },
                    {
                        "pretty": "1 Thessalonians 5:1\u201311",
                        "readQS": "1+Thessalonians+5:1-11",
                        "audioQS": "1Thess.5"
                    },
                    {
                        "pretty": "Matthew 25:14\u201330",
                        "readQS": "Matthew+25:14-30",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+123%3B+Judges+4:1-7%3B+1+Thessalonians+5:1-11%3B+Matthew+25:14-30",
                "audioQS": "Ps.123,Judg.4,1Thess.5,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 98",
                        "readQS": "Psalm+98",
                        "audioQS": "Ps.98"
                    },
                    {
                        "pretty": "Daniel 10:19\u201321",
                        "readQS": "Daniel+10:19-21",
                        "audioQS": "Dan.10"
                    },
                    {
                        "pretty": "Revelation 4",
                        "readQS": "Revelation+4",
                        "audioQS": "Rev.4"
                    }
                ],
                "readQS": "Psalm+98%3B+Daniel+10:19-21%3B+Revelation+4",
                "audioQS": "Ps.98,Dan.10,Rev.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 89:19\u201337",
                        "readQS": "Psalm+89:19-37",
                        "audioQS": "Ps.89"
                    },
                    {
                        "pretty": "1 Kings 1:(1\u201314),15\u201340",
                        "readQS": "1+Kings+1:%281-14%29,15-40",
                        "audioQS": "1Kgs.1"
                    },
                    {
                        "pretty": "Revelation 1:4\u201318",
                        "readQS": "Revelation+1:4-18",
                        "audioQS": "Rev.1"
                    }
                ],
                "readQS": "Psalm+89:19-37%3B+1+Kings+1:%281-14%29,15-40%3B+Revelation+1:4-18",
                "audioQS": "Ps.89,1Kgs.1,Rev.1",
                "note": null
            }
        ]
    },
    "2026/11/16": {
        "datePretty": "Monday, November 16, 2026",
        "calendar": "Week of 2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 47",
                        "readQS": "Psalm+47",
                        "audioQS": "Ps.47"
                    },
                    {
                        "pretty": "Daniel 8:1\u201314",
                        "readQS": "Daniel+8:1-14",
                        "audioQS": "Dan.8"
                    },
                    {
                        "pretty": "Revelation 10",
                        "readQS": "Revelation+10",
                        "audioQS": "Rev.10"
                    }
                ],
                "readQS": "Psalm+47%3B+Daniel+8:1-14%3B+Revelation+10",
                "audioQS": "Ps.47,Dan.8,Rev.10",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 71",
                        "readQS": "Psalm+71",
                        "audioQS": "Ps.71"
                    },
                    {
                        "pretty": "Isaiah 9:8\u201310:4",
                        "readQS": "Isaiah+9:8-10:4",
                        "audioQS": "Isa.9"
                    },
                    {
                        "pretty": "Matthew 7:1\u201312",
                        "readQS": "Matthew+7:1-12",
                        "audioQS": "Matt.7"
                    }
                ],
                "readQS": "Psalm+71%3B+Isaiah+9:8-10:4%3B+Matthew+7:1-12",
                "audioQS": "Ps.71,Isa.9,Matt.7",
                "note": null
            }
        ]
    },
    "2026/11/17": {
        "datePretty": "Tuesday, November 17, 2026",
        "calendar": "Week of 2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 52",
                        "readQS": "Psalm+52",
                        "audioQS": "Ps.52"
                    },
                    {
                        "pretty": "Daniel 8:15\u2013end",
                        "readQS": "Daniel+8:15-",
                        "audioQS": "Dan.8"
                    },
                    {
                        "pretty": "Revelation 11:1\u201314",
                        "readQS": "Revelation+11:1-14",
                        "audioQS": "Rev.11"
                    }
                ],
                "readQS": "Psalm+52%3B+Daniel+8:15-%3B+Revelation+11:1-14",
                "audioQS": "Ps.52,Dan.8,Rev.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 67",
                        "readQS": "Psalm+67",
                        "audioQS": "Ps.67"
                    },
                    {
                        "pretty": "Isaiah 10:5\u201319",
                        "readQS": "Isaiah+10:5-19",
                        "audioQS": "Isa.10"
                    },
                    {
                        "pretty": "Matthew 7:13\u2013end",
                        "readQS": "Matthew+7:13-",
                        "audioQS": "Matt.7"
                    }
                ],
                "readQS": "Psalm+67%3B+Isaiah+10:5-19%3B+Matthew+7:13-",
                "audioQS": "Ps.67,Isa.10,Matt.7",
                "note": null
            }
        ]
    },
    "2026/11/18": {
        "datePretty": "Wednesday, November 18, 2026",
        "calendar": "Week of 2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 56",
                        "readQS": "Psalm+56",
                        "audioQS": "Ps.56"
                    },
                    {
                        "pretty": "Daniel 9:1\u201319",
                        "readQS": "Daniel+9:1-19",
                        "audioQS": "Dan.9"
                    },
                    {
                        "pretty": "Revelation 11:15\u2013end",
                        "readQS": "Revelation+11:15-",
                        "audioQS": "Rev.11"
                    }
                ],
                "readQS": "Psalm+56%3B+Daniel+9:1-19%3B+Revelation+11:15-",
                "audioQS": "Ps.56,Dan.9,Rev.11",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Isaiah 10:20\u201332",
                        "readQS": "Isaiah+10:20-32",
                        "audioQS": "Isa.10"
                    },
                    {
                        "pretty": "Matthew 8:1\u201313",
                        "readQS": "Matthew+8:1-13",
                        "audioQS": "Matt.8"
                    }
                ],
                "readQS": "Psalm+73%3B+Isaiah+10:20-32%3B+Matthew+8:1-13",
                "audioQS": "Ps.73,Isa.10,Matt.8",
                "note": null
            }
        ]
    },
    "2026/11/19": {
        "datePretty": "Thursday, November 19, 2026",
        "calendar": "Week of 2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 62",
                        "readQS": "Psalm+62",
                        "audioQS": "Ps.62"
                    },
                    {
                        "pretty": "Daniel 9:20\u2013end",
                        "readQS": "Daniel+9:20-",
                        "audioQS": "Dan.9"
                    },
                    {
                        "pretty": "Revelation 12",
                        "readQS": "Revelation+12",
                        "audioQS": "Rev.12"
                    }
                ],
                "readQS": "Psalm+62%3B+Daniel+9:20-%3B+Revelation+12",
                "audioQS": "Ps.62,Dan.9,Rev.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 76",
                        "readQS": "Psalm+76",
                        "audioQS": "Ps.76"
                    },
                    {
                        "pretty": "Isaiah 10:33\u201311:9",
                        "readQS": "Isaiah+10:33-11:9",
                        "audioQS": "Isa.10"
                    },
                    {
                        "pretty": "Matthew 8:14\u201322",
                        "readQS": "Matthew+8:14-22",
                        "audioQS": "Matt.8"
                    }
                ],
                "readQS": "Psalm+76%3B+Isaiah+10:33-11:9%3B+Matthew+8:14-22",
                "audioQS": "Ps.76,Isa.10,Matt.8",
                "note": null
            }
        ]
    },
    "2026/11/20": {
        "datePretty": "Friday, November 20, 2026",
        "calendar": "Week of 2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 63",
                        "readQS": "Psalm+63",
                        "audioQS": "Ps.63"
                    },
                    {
                        "pretty": "Daniel 10:1\u201311:1",
                        "readQS": "Daniel+10:1-11:1",
                        "audioQS": "Dan.10"
                    },
                    {
                        "pretty": "Revelation 13:1\u201310",
                        "readQS": "Revelation+13:1-10",
                        "audioQS": "Rev.13"
                    }
                ],
                "readQS": "Psalm+63%3B+Daniel+10:1-11:1%3B+Revelation+13:1-10",
                "audioQS": "Ps.63,Dan.10,Rev.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Isaiah 11:10\u2013end of 12",
                        "readQS": "Isaiah+11:10-+of+12",
                        "audioQS": "Isa.11"
                    },
                    {
                        "pretty": "Matthew 8:23\u2013end",
                        "readQS": "Matthew+8:23-",
                        "audioQS": "Matt.8"
                    }
                ],
                "readQS": "Psalm+77%3B+Isaiah+11:10-+of+12%3B+Matthew+8:23-",
                "audioQS": "Ps.77,Isa.11,Matt.8",
                "note": null
            }
        ]
    },
    "2026/11/21": {
        "datePretty": "Saturday, November 21, 2026",
        "calendar": "Week of 2nd Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 78.1\u201339",
                        "readQS": "Psalm+78.1-39",
                        "audioQS": "Ps.78.1\u201339"
                    },
                    {
                        "pretty": "Daniel 12",
                        "readQS": "Daniel+12",
                        "audioQS": "Dan.12"
                    },
                    {
                        "pretty": "Revelation 13:11\u2013end",
                        "readQS": "Revelation+13:11-",
                        "audioQS": "Rev.13"
                    }
                ],
                "readQS": "Psalm+78.1-39%3B+Daniel+12%3B+Revelation+13:11-",
                "audioQS": "Ps.78.1\u201339,Dan.12,Rev.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of Christ the King)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 99,100",
                        "readQS": "Psalm+99,100",
                        "audioQS": "Ps.99,100"
                    },
                    {
                        "pretty": "Isaiah 10:33\u201311:9",
                        "readQS": "Isaiah+10:33-11:9",
                        "audioQS": "Isa.10"
                    },
                    {
                        "pretty": "1 Timothy 6:11\u201316",
                        "readQS": "1+Timothy+6:11-16",
                        "audioQS": "1Tim.6"
                    }
                ],
                "readQS": "Psalm+99,100%3B+Isaiah+10:33-11:9%3B+1+Timothy+6:11-16",
                "audioQS": "Ps.99,100,Isa.10,1Tim.6",
                "note": null
            }
        ]
    },
    "2026/11/22": {
        "datePretty": "Sunday, November 22, 2026",
        "calendar": "Christ the King Sunday",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 95:1\u20137",
                        "readQS": "Psalm+95:1-7",
                        "audioQS": "Ps.95"
                    },
                    {
                        "pretty": "Ezekiel 34:11\u201316,20\u201324",
                        "readQS": "Ezekiel+34:11-16,20-24",
                        "audioQS": "Ezek.34"
                    },
                    {
                        "pretty": "Ephesians 1:15\u201323",
                        "readQS": "Ephesians+1:15-23",
                        "audioQS": "Eph.1"
                    },
                    {
                        "pretty": "Matthew 25:31\u201346",
                        "readQS": "Matthew+25:31-46",
                        "audioQS": "Matt.25"
                    }
                ],
                "readQS": "Psalm+95:1-7%3B+Ezekiel+34:11-16,20-24%3B+Ephesians+1:15-23%3B+Matthew+25:31-46",
                "audioQS": "Ps.95,Ezek.34,Eph.1,Matt.25",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 29,110",
                        "readQS": "Psalm+29,110",
                        "audioQS": "Ps.29,110"
                    },
                    {
                        "pretty": "Isaiah 4:2\u20135:7",
                        "readQS": "Isaiah+4:2-5:7",
                        "audioQS": "Isa.4"
                    },
                    {
                        "pretty": "Luke 19:29\u201338",
                        "readQS": "Luke+19:29-38",
                        "audioQS": "Luke.19"
                    }
                ],
                "readQS": "Psalm+29,110%3B+Isaiah+4:2-5:7%3B+Luke+19:29-38",
                "audioQS": "Ps.29,110,Isa.4,Luke.19",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 93",
                        "readQS": "Psalm+93",
                        "audioQS": "Ps.93"
                    },
                    {
                        "pretty": "2 Samuel 23:1\u20137",
                        "readQS": "2+Samuel+23:1-7",
                        "audioQS": "2Sam.23"
                    },
                    {
                        "pretty": "Matthew 28:16\u201320",
                        "readQS": "Matthew+28:16-20",
                        "audioQS": "Matt.28"
                    }
                ],
                "readQS": "Psalm+93%3B+2+Samuel+23:1-7%3B+Matthew+28:16-20",
                "audioQS": "Ps.93,2Sam.23,Matt.28",
                "note": null
            }
        ]
    },
    "2026/11/23": {
        "datePretty": "Monday, November 23, 2026",
        "calendar": "Week of 1st Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 96",
                        "readQS": "Psalm+96",
                        "audioQS": "Ps.96"
                    },
                    {
                        "pretty": "Isaiah 40:1\u201311",
                        "readQS": "Isaiah+40:1-11",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "Revelation 14:1\u201313",
                        "readQS": "Revelation+14:1-13",
                        "audioQS": "Rev.14"
                    }
                ],
                "readQS": "Psalm+96%3B+Isaiah+40:1-11%3B+Revelation+14:1-13",
                "audioQS": "Ps.96,Isa.40,Rev.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 14:3\u201320",
                        "readQS": "Isaiah+14:3-20",
                        "audioQS": "Isa.14"
                    },
                    {
                        "pretty": "Matthew 9:18\u201334",
                        "readQS": "Matthew+9:18-34",
                        "audioQS": "Matt.9"
                    }
                ],
                "readQS": "Psalm+80%3B+Isaiah+14:3-20%3B+Matthew+9:18-34",
                "audioQS": "Ps.80,Isa.14,Matt.9",
                "note": null
            }
        ]
    },
    "2026/11/24": {
        "datePretty": "Tuesday, November 24, 2026",
        "calendar": "Week of 1st Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 97",
                        "readQS": "Psalm+97",
                        "audioQS": "Ps.97"
                    },
                    {
                        "pretty": "Isaiah 40:12\u201326",
                        "readQS": "Isaiah+40:12-26",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "Revelation 14:14\u2013end,15:1\u2013end",
                        "readQS": "Revelation+14:14-,15:1-",
                        "audioQS": "Rev.14"
                    }
                ],
                "readQS": "Psalm+97%3B+Isaiah+40:12-26%3B+Revelation+14:14-,15:1-",
                "audioQS": "Ps.97,Isa.40,Rev.14",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 101",
                        "readQS": "Psalm+101",
                        "audioQS": "Ps.101"
                    },
                    {
                        "pretty": "Isaiah 17",
                        "readQS": "Isaiah+17",
                        "audioQS": "Isa.17"
                    },
                    {
                        "pretty": "Matthew 9:35\u201310:15",
                        "readQS": "Matthew+9:35-10:15",
                        "audioQS": "Matt.9"
                    }
                ],
                "readQS": "Psalm+101%3B+Isaiah+17%3B+Matthew+9:35-10:15",
                "audioQS": "Ps.101,Isa.17,Matt.9",
                "note": null
            }
        ]
    },
    "2026/11/25": {
        "datePretty": "Wednesday, November 25, 2026",
        "calendar": "Week of 1st Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 112",
                        "readQS": "Psalm+112",
                        "audioQS": "Ps.112"
                    },
                    {
                        "pretty": "Isaiah 40:27\u201341:7",
                        "readQS": "Isaiah+40:27-41:7",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "Revelation 16:1\u201311",
                        "readQS": "Revelation+16:1-11",
                        "audioQS": "Rev.16"
                    }
                ],
                "readQS": "Psalm+112%3B+Isaiah+40:27-41:7%3B+Revelation+16:1-11",
                "audioQS": "Ps.112,Isa.40,Rev.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 122",
                        "readQS": "Psalm+122",
                        "audioQS": "Ps.122"
                    },
                    {
                        "pretty": "Isaiah 19",
                        "readQS": "Isaiah+19",
                        "audioQS": "Isa.19"
                    },
                    {
                        "pretty": "Matthew 10:16\u201333",
                        "readQS": "Matthew+10:16-33",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+122%3B+Isaiah+19%3B+Matthew+10:16-33",
                "audioQS": "Ps.122,Isa.19,Matt.10",
                "note": null
            }
        ]
    },
    "2026/11/26": {
        "datePretty": "Thursday, November 26, 2026",
        "calendar": "Week of 1st Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 125",
                        "readQS": "Psalm+125",
                        "audioQS": "Ps.125"
                    },
                    {
                        "pretty": "Isaiah 41:8\u201320",
                        "readQS": "Isaiah+41:8-20",
                        "audioQS": "Isa.41"
                    },
                    {
                        "pretty": "Revelation 16:12\u2013end",
                        "readQS": "Revelation+16:12-",
                        "audioQS": "Rev.16"
                    }
                ],
                "readQS": "Psalm+125%3B+Isaiah+41:8-20%3B+Revelation+16:12-",
                "audioQS": "Ps.125,Isa.41,Rev.16",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 133",
                        "readQS": "Psalm+133",
                        "audioQS": "Ps.133"
                    },
                    {
                        "pretty": "Isaiah 21:1\u201312",
                        "readQS": "Isaiah+21:1-12",
                        "audioQS": "Isa.21"
                    },
                    {
                        "pretty": "Matthew 10:34\u201311:1",
                        "readQS": "Matthew+10:34-11:1",
                        "audioQS": "Matt.10"
                    }
                ],
                "readQS": "Psalm+133%3B+Isaiah+21:1-12%3B+Matthew+10:34-11:1",
                "audioQS": "Ps.133,Isa.21,Matt.10",
                "note": null
            }
        ]
    },
    "2026/11/27": {
        "datePretty": "Friday, November 27, 2026",
        "calendar": "Week of 1st Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 139",
                        "readQS": "Psalm+139",
                        "audioQS": "Ps.139"
                    },
                    {
                        "pretty": "Isaiah 41:21\u201342:9",
                        "readQS": "Isaiah+41:21-42:9",
                        "audioQS": "Isa.41"
                    },
                    {
                        "pretty": "Revelation 17",
                        "readQS": "Revelation+17",
                        "audioQS": "Rev.17"
                    }
                ],
                "readQS": "Psalm+139%3B+Isaiah+41:21-42:9%3B+Revelation+17",
                "audioQS": "Ps.139,Isa.41,Rev.17",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 146",
                        "readQS": "Psalm+146",
                        "audioQS": "Ps.146"
                    },
                    {
                        "pretty": "Isaiah 22:1\u201314",
                        "readQS": "Isaiah+22:1-14",
                        "audioQS": "Isa.22"
                    },
                    {
                        "pretty": "Matthew 11:2\u201319",
                        "readQS": "Matthew+11:2-19",
                        "audioQS": "Matt.11"
                    }
                ],
                "readQS": "Psalm+146%3B+Isaiah+22:1-14%3B+Matthew+11:2-19",
                "audioQS": "Ps.146,Isa.22,Matt.11",
                "note": null
            }
        ]
    },
    "2026/11/28": {
        "datePretty": "Saturday, November 28, 2026",
        "calendar": "Week of 1st Sunday before Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Isaiah 42:10\u201317",
                        "readQS": "Isaiah+42:10-17",
                        "audioQS": "Isa.42"
                    },
                    {
                        "pretty": "Revelation 18",
                        "readQS": "Revelation+18",
                        "audioQS": "Rev.18"
                    }
                ],
                "readQS": "Psalm+145%3B+Isaiah+42:10-17%3B+Revelation+18",
                "audioQS": "Ps.145,Isa.42,Rev.18",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 150",
                        "readQS": "Psalm+150",
                        "audioQS": "Ps.150"
                    },
                    {
                        "pretty": "Isaiah 24",
                        "readQS": "Isaiah+24",
                        "audioQS": "Isa.24"
                    },
                    {
                        "pretty": "Matthew 11:20\u2013end",
                        "readQS": "Matthew+11:20-",
                        "audioQS": "Matt.11"
                    }
                ],
                "readQS": "Psalm+150%3B+Isaiah+24%3B+Matthew+11:20-",
                "audioQS": "Ps.150,Isa.24,Matt.11",
                "note": null
            }
        ]
    },
    "2026/11/29": {
        "datePretty": "Sunday, November 29, 2026",
        "calendar": "1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 80:1\u20138,18\u201320",
                        "readQS": "Psalm+80:1-8,18-20",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 64:1\u20139",
                        "readQS": "Isaiah+64:1-9",
                        "audioQS": "Isa.64"
                    },
                    {
                        "pretty": "1 Corinthians 1:3\u20139",
                        "readQS": "1+Corinthians+1:3-9",
                        "audioQS": "1Cor.1"
                    },
                    {
                        "pretty": "Mark 13:24\u201337",
                        "readQS": "Mark+13:24-37",
                        "audioQS": "Mark.13"
                    }
                ],
                "readQS": "Psalm+80:1-8,18-20%3B+Isaiah+64:1-9%3B+1+Corinthians+1:3-9%3B+Mark+13:24-37",
                "audioQS": "Ps.80,Isa.64,1Cor.1,Mark.13",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Isaiah 2:1\u20135",
                        "readQS": "Isaiah+2:1-5",
                        "audioQS": "Isa.2"
                    },
                    {
                        "pretty": "Luke 12:35\u201348",
                        "readQS": "Luke+12:35-48",
                        "audioQS": "Luke.12"
                    }
                ],
                "readQS": "Psalm+44%3B+Isaiah+2:1-5%3B+Luke+12:35-48",
                "audioQS": "Ps.44,Isa.2,Luke.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers (Eve of St Andrew)",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 48",
                        "readQS": "Psalm+48",
                        "audioQS": "Ps.48"
                    },
                    {
                        "pretty": "Isaiah 49:1\u20139a",
                        "readQS": "Isaiah+49:1-9a",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Corinthians 4:9\u201316",
                        "readQS": "1+Corinthians+4:9-16",
                        "audioQS": "1Cor.4"
                    }
                ],
                "readQS": "Psalm+48%3B+Isaiah+49:1-9a%3B+1+Corinthians+4:9-16",
                "audioQS": "Ps.48,Isa.49,1Cor.4",
                "note": null
            }
        ]
    },
    "2026/11/30": {
        "datePretty": "Monday, November 30, 2026",
        "calendar": "St Andrew the Apostle",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 47,147:1\u201311",
                        "readQS": "Psalm+47,147:1-11",
                        "audioQS": "Ps.47,147"
                    },
                    {
                        "pretty": "Ezekiel 47:1\u201312",
                        "readQS": "Ezekiel+47:1-12",
                        "audioQS": "Ezek.47"
                    },
                    {
                        "pretty": "John 12:20\u201332",
                        "readQS": "John+12:20-32",
                        "audioQS": "John.12"
                    }
                ],
                "readQS": "Psalm+47,147:1-11%3B+Ezekiel+47:1-12%3B+John+12:20-32",
                "audioQS": "Ps.47,147,Ezek.47,John.12",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 87,96",
                        "readQS": "Psalm+87,96",
                        "audioQS": "Ps.87,96"
                    },
                    {
                        "pretty": "Zechariah 8:20\u201323",
                        "readQS": "Zechariah+8:20-23",
                        "audioQS": "Zech.8"
                    },
                    {
                        "pretty": "John 1:35\u201342",
                        "readQS": "John+1:35-42",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+87,96%3B+Zechariah+8:20-23%3B+John+1:35-42",
                "audioQS": "Ps.87,96,Zech.8,John.1",
                "note": null
            }
        ]
    },
    "2026/12/01": {
        "datePretty": "Tuesday, December 1, 2026",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Isaiah 43:1\u201313",
                        "readQS": "Isaiah+43:1-13",
                        "audioQS": "Isa.43"
                    },
                    {
                        "pretty": "Revelation 20",
                        "readQS": "Revelation+20",
                        "audioQS": "Rev.20"
                    }
                ],
                "readQS": "Psalm+80%3B+Isaiah+43:1-13%3B+Revelation+20",
                "audioQS": "Ps.80,Isa.43,Rev.20",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 74",
                        "readQS": "Psalm+74",
                        "audioQS": "Ps.74"
                    },
                    {
                        "pretty": "Isaiah 26:1\u201313",
                        "readQS": "Isaiah+26:1-13",
                        "audioQS": "Isa.26"
                    },
                    {
                        "pretty": "Matthew 12:22\u201337",
                        "readQS": "Matthew+12:22-37",
                        "audioQS": "Matt.12"
                    }
                ],
                "readQS": "Psalm+74%3B+Isaiah+26:1-13%3B+Matthew+12:22-37",
                "audioQS": "Ps.74,Isa.26,Matt.12",
                "note": null
            }
        ]
    },
    "2026/12/02": {
        "datePretty": "Wednesday, December 2, 2026",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 7",
                        "readQS": "Psalm+7",
                        "audioQS": "Ps.7"
                    },
                    {
                        "pretty": "Isaiah 43:14\u2013end",
                        "readQS": "Isaiah+43:14-",
                        "audioQS": "Isa.43"
                    },
                    {
                        "pretty": "Revelation 21:1\u20138",
                        "readQS": "Revelation+21:1-8",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+7%3B+Isaiah+43:14-%3B+Revelation+21:1-8",
                "audioQS": "Ps.7,Isa.43,Rev.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 77",
                        "readQS": "Psalm+77",
                        "audioQS": "Ps.77"
                    },
                    {
                        "pretty": "Isaiah 28:1\u201313",
                        "readQS": "Isaiah+28:1-13",
                        "audioQS": "Isa.28"
                    },
                    {
                        "pretty": "Matthew 12:38\u2013end",
                        "readQS": "Matthew+12:38-",
                        "audioQS": "Matt.12"
                    }
                ],
                "readQS": "Psalm+77%3B+Isaiah+28:1-13%3B+Matthew+12:38-",
                "audioQS": "Ps.77,Isa.28,Matt.12",
                "note": null
            }
        ]
    },
    "2026/12/03": {
        "datePretty": "Thursday, December 3, 2026",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 42",
                        "readQS": "Psalm+42",
                        "audioQS": "Ps.42"
                    },
                    {
                        "pretty": "Isaiah 44:1\u20138",
                        "readQS": "Isaiah+44:1-8",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 21:9\u201321",
                        "readQS": "Revelation+21:9-21",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+42%3B+Isaiah+44:1-8%3B+Revelation+21:9-21",
                "audioQS": "Ps.42,Isa.44,Rev.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 28:14\u2013end",
                        "readQS": "Isaiah+28:14-",
                        "audioQS": "Isa.28"
                    },
                    {
                        "pretty": "Matthew 13:1\u201323",
                        "readQS": "Matthew+13:1-23",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+40%3B+Isaiah+28:14-%3B+Matthew+13:1-23",
                "audioQS": "Ps.40,Isa.28,Matt.13",
                "note": null
            }
        ]
    },
    "2026/12/04": {
        "datePretty": "Friday, December 4, 2026",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 25",
                        "readQS": "Psalm+25",
                        "audioQS": "Ps.25"
                    },
                    {
                        "pretty": "Isaiah 44:9\u201323",
                        "readQS": "Isaiah+44:9-23",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 21:22\u201322:5",
                        "readQS": "Revelation+21:22-22:5",
                        "audioQS": "Rev.21"
                    }
                ],
                "readQS": "Psalm+25%3B+Isaiah+44:9-23%3B+Revelation+21:22-22:5",
                "audioQS": "Ps.25,Isa.44,Rev.21",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 17",
                        "readQS": "Psalm+17",
                        "audioQS": "Ps.17"
                    },
                    {
                        "pretty": "Isaiah 29:1\u201314",
                        "readQS": "Isaiah+29:1-14",
                        "audioQS": "Isa.29"
                    },
                    {
                        "pretty": "Matthew 13:24\u201343",
                        "readQS": "Matthew+13:24-43",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+17%3B+Isaiah+29:1-14%3B+Matthew+13:24-43",
                "audioQS": "Ps.17,Isa.29,Matt.13",
                "note": null
            }
        ]
    },
    "2026/12/05": {
        "datePretty": "Saturday, December 5, 2026",
        "calendar": "Week of 1st Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 9",
                        "readQS": "Psalm+9",
                        "audioQS": "Ps.9"
                    },
                    {
                        "pretty": "Isaiah 44:24\u201345:13",
                        "readQS": "Isaiah+44:24-45:13",
                        "audioQS": "Isa.44"
                    },
                    {
                        "pretty": "Revelation 22:6\u2013end",
                        "readQS": "Revelation+22:6-",
                        "audioQS": "Rev.22"
                    }
                ],
                "readQS": "Psalm+9%3B+Isaiah+44:24-45:13%3B+Revelation+22:6-",
                "audioQS": "Ps.9,Isa.44,Rev.22",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 27",
                        "readQS": "Psalm+27",
                        "audioQS": "Ps.27"
                    },
                    {
                        "pretty": "Isaiah 29:15\u2013end",
                        "readQS": "Isaiah+29:15-",
                        "audioQS": "Isa.29"
                    },
                    {
                        "pretty": "Matthew 13:44\u2013end",
                        "readQS": "Matthew+13:44-",
                        "audioQS": "Matt.13"
                    }
                ],
                "readQS": "Psalm+27%3B+Isaiah+29:15-%3B+Matthew+13:44-",
                "audioQS": "Ps.27,Isa.29,Matt.13",
                "note": null
            }
        ]
    },
    "2026/12/06": {
        "datePretty": "Sunday, December 6, 2026",
        "calendar": "2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 85:1\u20132,8\u201313",
                        "readQS": "Psalm+85:1-2,8-13",
                        "audioQS": "Ps.85"
                    },
                    {
                        "pretty": "Isaiah 40:1\u201311",
                        "readQS": "Isaiah+40:1-11",
                        "audioQS": "Isa.40"
                    },
                    {
                        "pretty": "2 Peter 3:8\u201315a",
                        "readQS": "2+Peter+3:8-15a",
                        "audioQS": "2Pet.3"
                    },
                    {
                        "pretty": "Mark 1:1\u20138",
                        "readQS": "Mark+1:1-8",
                        "audioQS": "Mark.1"
                    }
                ],
                "readQS": "Psalm+85:1-2,8-13%3B+Isaiah+40:1-11%3B+2+Peter+3:8-15a%3B+Mark+1:1-8",
                "audioQS": "Ps.85,Isa.40,2Pet.3,Mark.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 80",
                        "readQS": "Psalm+80",
                        "audioQS": "Ps.80"
                    },
                    {
                        "pretty": "Zephaniah 3:14\u201320",
                        "readQS": "Zephaniah+3:14-20",
                        "audioQS": "Zeph.3"
                    },
                    {
                        "pretty": "Luke 1:5\u201320",
                        "readQS": "Luke+1:5-20",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+80%3B+Zephaniah+3:14-20%3B+Luke+1:5-20",
                "audioQS": "Ps.80,Zeph.3,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "1 Kings 22:1\u201328",
                        "readQS": "1+Kings+22:1-28",
                        "audioQS": "1Kgs.22"
                    },
                    {
                        "pretty": "Romans 15:4\u201313",
                        "readQS": "Romans+15:4-13",
                        "audioQS": "Rom.15"
                    }
                ],
                "readQS": "Psalm+40%3B+1+Kings+22:1-28%3B+Romans+15:4-13",
                "audioQS": "Ps.40,1Kgs.22,Rom.15",
                "note": null
            }
        ]
    },
    "2026/12/07": {
        "datePretty": "Monday, December 7, 2026",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Isaiah 45:14\u2013end",
                        "readQS": "Isaiah+45:14-",
                        "audioQS": "Isa.45"
                    },
                    {
                        "pretty": "1 Thessalonians 1",
                        "readQS": "1+Thessalonians+1",
                        "audioQS": "1Thess.1"
                    }
                ],
                "readQS": "Psalm+44%3B+Isaiah+45:14-%3B+1+Thessalonians+1",
                "audioQS": "Ps.44,Isa.45,1Thess.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 144",
                        "readQS": "Psalm+144",
                        "audioQS": "Ps.144"
                    },
                    {
                        "pretty": "Isaiah 30:1\u201318",
                        "readQS": "Isaiah+30:1-18",
                        "audioQS": "Isa.30"
                    },
                    {
                        "pretty": "Matthew 14:1\u201312",
                        "readQS": "Matthew+14:1-12",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+144%3B+Isaiah+30:1-18%3B+Matthew+14:1-12",
                "audioQS": "Ps.144,Isa.30,Matt.14",
                "note": null
            }
        ]
    },
    "2026/12/08": {
        "datePretty": "Tuesday, December 8, 2026",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 56",
                        "readQS": "Psalm+56",
                        "audioQS": "Ps.56"
                    },
                    {
                        "pretty": "Isaiah 46",
                        "readQS": "Isaiah+46",
                        "audioQS": "Isa.46"
                    },
                    {
                        "pretty": "1 Thessalonians 2:1\u201312",
                        "readQS": "1+Thessalonians+2:1-12",
                        "audioQS": "1Thess.2"
                    }
                ],
                "readQS": "Psalm+56%3B+Isaiah+46%3B+1+Thessalonians+2:1-12",
                "audioQS": "Ps.56,Isa.46,1Thess.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 11",
                        "readQS": "Psalm+11",
                        "audioQS": "Ps.11"
                    },
                    {
                        "pretty": "Isaiah 30:19\u2013end",
                        "readQS": "Isaiah+30:19-",
                        "audioQS": "Isa.30"
                    },
                    {
                        "pretty": "Matthew 14:13\u2013end",
                        "readQS": "Matthew+14:13-",
                        "audioQS": "Matt.14"
                    }
                ],
                "readQS": "Psalm+11%3B+Isaiah+30:19-%3B+Matthew+14:13-",
                "audioQS": "Ps.11,Isa.30,Matt.14",
                "note": null
            }
        ]
    },
    "2026/12/09": {
        "datePretty": "Wednesday, December 9, 2026",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 62",
                        "readQS": "Psalm+62",
                        "audioQS": "Ps.62"
                    },
                    {
                        "pretty": "Isaiah 47",
                        "readQS": "Isaiah+47",
                        "audioQS": "Isa.47"
                    },
                    {
                        "pretty": "1 Thessalonians 2:13\u2013end",
                        "readQS": "1+Thessalonians+2:13-",
                        "audioQS": "1Thess.2"
                    }
                ],
                "readQS": "Psalm+62%3B+Isaiah+47%3B+1+Thessalonians+2:13-",
                "audioQS": "Ps.62,Isa.47,1Thess.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 10",
                        "readQS": "Psalm+10",
                        "audioQS": "Ps.10"
                    },
                    {
                        "pretty": "Isaiah 31",
                        "readQS": "Isaiah+31",
                        "audioQS": "Isa.31"
                    },
                    {
                        "pretty": "Matthew 15:1\u201320",
                        "readQS": "Matthew+15:1-20",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+10%3B+Isaiah+31%3B+Matthew+15:1-20",
                "audioQS": "Ps.10,Isa.31,Matt.15",
                "note": null
            }
        ]
    },
    "2026/12/10": {
        "datePretty": "Thursday, December 10, 2026",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 54",
                        "readQS": "Psalm+54",
                        "audioQS": "Ps.54"
                    },
                    {
                        "pretty": "Isaiah 48:1\u201311",
                        "readQS": "Isaiah+48:1-11",
                        "audioQS": "Isa.48"
                    },
                    {
                        "pretty": "1 Thessalonians 3",
                        "readQS": "1+Thessalonians+3",
                        "audioQS": "1Thess.3"
                    }
                ],
                "readQS": "Psalm+54%3B+Isaiah+48:1-11%3B+1+Thessalonians+3",
                "audioQS": "Ps.54,Isa.48,1Thess.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 73",
                        "readQS": "Psalm+73",
                        "audioQS": "Ps.73"
                    },
                    {
                        "pretty": "Isaiah 32",
                        "readQS": "Isaiah+32",
                        "audioQS": "Isa.32"
                    },
                    {
                        "pretty": "Matthew 15:21\u201328",
                        "readQS": "Matthew+15:21-28",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+73%3B+Isaiah+32%3B+Matthew+15:21-28",
                "audioQS": "Ps.73,Isa.32,Matt.15",
                "note": null
            }
        ]
    },
    "2026/12/11": {
        "datePretty": "Friday, December 11, 2026",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 86",
                        "readQS": "Psalm+86",
                        "audioQS": "Ps.86"
                    },
                    {
                        "pretty": "Isaiah 48:12\u2013end",
                        "readQS": "Isaiah+48:12-",
                        "audioQS": "Isa.48"
                    },
                    {
                        "pretty": "1 Thessalonians 4:1\u201312",
                        "readQS": "1+Thessalonians+4:1-12",
                        "audioQS": "1Thess.4"
                    }
                ],
                "readQS": "Psalm+86%3B+Isaiah+48:12-%3B+1+Thessalonians+4:1-12",
                "audioQS": "Ps.86,Isa.48,1Thess.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 90",
                        "readQS": "Psalm+90",
                        "audioQS": "Ps.90"
                    },
                    {
                        "pretty": "Isaiah 33:1\u201322",
                        "readQS": "Isaiah+33:1-22",
                        "audioQS": "Isa.33"
                    },
                    {
                        "pretty": "Matthew 15:29\u2013end",
                        "readQS": "Matthew+15:29-",
                        "audioQS": "Matt.15"
                    }
                ],
                "readQS": "Psalm+90%3B+Isaiah+33:1-22%3B+Matthew+15:29-",
                "audioQS": "Ps.90,Isa.33,Matt.15",
                "note": null
            }
        ]
    },
    "2026/12/12": {
        "datePretty": "Saturday, December 12, 2026",
        "calendar": "Week of 2nd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 145",
                        "readQS": "Psalm+145",
                        "audioQS": "Ps.145"
                    },
                    {
                        "pretty": "Isaiah 49:1\u201313",
                        "readQS": "Isaiah+49:1-13",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Thessalonians 4:13\u2013end",
                        "readQS": "1+Thessalonians+4:13-",
                        "audioQS": "1Thess.4"
                    }
                ],
                "readQS": "Psalm+145%3B+Isaiah+49:1-13%3B+1+Thessalonians+4:13-",
                "audioQS": "Ps.145,Isa.49,1Thess.4",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 94",
                        "readQS": "Psalm+94",
                        "audioQS": "Ps.94"
                    },
                    {
                        "pretty": "Isaiah 35",
                        "readQS": "Isaiah+35",
                        "audioQS": "Isa.35"
                    },
                    {
                        "pretty": "Matthew 16:1\u201312",
                        "readQS": "Matthew+16:1-12",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+94%3B+Isaiah+35%3B+Matthew+16:1-12",
                "audioQS": "Ps.94,Isa.35,Matt.16",
                "note": null
            }
        ]
    },
    "2026/12/13": {
        "datePretty": "Sunday, December 13, 2026",
        "calendar": "3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "rclTrack1",
                "readingSetTabName": "RCL (Re.)",
                "readingSetSubtitle": "Revised Common Lectionary (Related)",
                "timeOfDay": null,
                "readings": [
                    {
                        "pretty": "Psalm 126",
                        "readQS": "Psalm+126",
                        "audioQS": "Ps.126"
                    },
                    {
                        "pretty": "Canticle: Luke 1:46\u201355 (Magnificat)",
                        "readQS": "Luke+1:46-55",
                        "audioQS": "Luke.1"
                    },
                    {
                        "pretty": "Isaiah 61:1\u20134,8\u201311",
                        "readQS": "Isaiah+61:1-4,8-11",
                        "audioQS": "Isa.61"
                    },
                    {
                        "pretty": "1 Thessalonians 5:16\u201324",
                        "readQS": "1+Thessalonians+5:16-24",
                        "audioQS": "1Thess.5"
                    },
                    {
                        "pretty": "John 1:6\u20138,19\u201328",
                        "readQS": "John+1:6-8,19-28",
                        "audioQS": "John.1"
                    }
                ],
                "readQS": "Psalm+126%3B+Canticle:+Luke+1:46-55+%28Magnificat%29%3B+Isaiah+61:1-4,8-11%3B+1+Thessalonians+5:16-24%3B+John+1:6-8,19-28",
                "audioQS": "Ps.126,Canticle,Isa.61,1Thess.5,John.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 50:1\u20136,62",
                        "readQS": "Psalm+50:1-6,62",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Isaiah 12",
                        "readQS": "Isaiah+12",
                        "audioQS": "Isa.12"
                    },
                    {
                        "pretty": "Luke 1:57\u201366",
                        "readQS": "Luke+1:57-66",
                        "audioQS": "Luke.1"
                    }
                ],
                "readQS": "Psalm+50:1-6,62%3B+Isaiah+12%3B+Luke+1:57-66",
                "audioQS": "Ps.50,Isa.12,Luke.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 68:1\u201319",
                        "readQS": "Psalm+68:1-19",
                        "audioQS": "Ps.68"
                    },
                    {
                        "pretty": "Malachi 3:1\u20134,4:1\u2013end",
                        "readQS": "Malachi+3:1-4,4:1-",
                        "audioQS": "Mal.3"
                    },
                    {
                        "pretty": "Philippians 4:4\u20137",
                        "readQS": "Philippians+4:4-7",
                        "audioQS": "Phil.4"
                    }
                ],
                "readQS": "Psalm+68:1-19%3B+Malachi+3:1-4,4:1-%3B+Philippians+4:4-7",
                "audioQS": "Ps.68,Mal.3,Phil.4",
                "note": null
            }
        ]
    },
    "2026/12/14": {
        "datePretty": "Monday, December 14, 2026",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 40",
                        "readQS": "Psalm+40",
                        "audioQS": "Ps.40"
                    },
                    {
                        "pretty": "Isaiah 49:14\u201325",
                        "readQS": "Isaiah+49:14-25",
                        "audioQS": "Isa.49"
                    },
                    {
                        "pretty": "1 Thessalonians 5:1\u201311",
                        "readQS": "1+Thessalonians+5:1-11",
                        "audioQS": "1Thess.5"
                    }
                ],
                "readQS": "Psalm+40%3B+Isaiah+49:14-25%3B+1+Thessalonians+5:1-11",
                "audioQS": "Ps.40,Isa.49,1Thess.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 26",
                        "readQS": "Psalm+26",
                        "audioQS": "Ps.26"
                    },
                    {
                        "pretty": "Isaiah 38:1\u20138,38:21\u201322",
                        "readQS": "Isaiah+38:1-8,38:21-22",
                        "audioQS": "Isa.38"
                    },
                    {
                        "pretty": "Matthew 16:13\u2013end",
                        "readQS": "Matthew+16:13-",
                        "audioQS": "Matt.16"
                    }
                ],
                "readQS": "Psalm+26%3B+Isaiah+38:1-8,38:21-22%3B+Matthew+16:13-",
                "audioQS": "Ps.26,Isa.38,Matt.16",
                "note": null
            }
        ]
    },
    "2026/12/15": {
        "datePretty": "Tuesday, December 15, 2026",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 70",
                        "readQS": "Psalm+70",
                        "audioQS": "Ps.70"
                    },
                    {
                        "pretty": "Isaiah 50",
                        "readQS": "Isaiah+50",
                        "audioQS": "Isa.50"
                    },
                    {
                        "pretty": "1 Thessalonians 5:12\u2013end",
                        "readQS": "1+Thessalonians+5:12-",
                        "audioQS": "1Thess.5"
                    }
                ],
                "readQS": "Psalm+70%3B+Isaiah+50%3B+1+Thessalonians+5:12-",
                "audioQS": "Ps.70,Isa.50,1Thess.5",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 50",
                        "readQS": "Psalm+50",
                        "audioQS": "Ps.50"
                    },
                    {
                        "pretty": "Isaiah 38:9\u201320",
                        "readQS": "Isaiah+38:9-20",
                        "audioQS": "Isa.38"
                    },
                    {
                        "pretty": "Matthew 17:1\u201313",
                        "readQS": "Matthew+17:1-13",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+50%3B+Isaiah+38:9-20%3B+Matthew+17:1-13",
                "audioQS": "Ps.50,Isa.38,Matt.17",
                "note": null
            }
        ]
    },
    "2026/12/16": {
        "datePretty": "Wednesday, December 16, 2026",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 75",
                        "readQS": "Psalm+75",
                        "audioQS": "Ps.75"
                    },
                    {
                        "pretty": "Isaiah 51:1\u20138",
                        "readQS": "Isaiah+51:1-8",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "2 Thessalonians 1",
                        "readQS": "2+Thessalonians+1",
                        "audioQS": "2Thess.1"
                    }
                ],
                "readQS": "Psalm+75%3B+Isaiah+51:1-8%3B+2+Thessalonians+1",
                "audioQS": "Ps.75,Isa.51,2Thess.1",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 82",
                        "readQS": "Psalm+82",
                        "audioQS": "Ps.82"
                    },
                    {
                        "pretty": "Isaiah 39",
                        "readQS": "Isaiah+39",
                        "audioQS": "Isa.39"
                    },
                    {
                        "pretty": "Matthew 17:14\u201321",
                        "readQS": "Matthew+17:14-21",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+82%3B+Isaiah+39%3B+Matthew+17:14-21",
                "audioQS": "Ps.82,Isa.39,Matt.17",
                "note": null
            }
        ]
    },
    "2026/12/17": {
        "datePretty": "Thursday, December 17, 2026",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 76",
                        "readQS": "Psalm+76",
                        "audioQS": "Ps.76"
                    },
                    {
                        "pretty": "Isaiah 51:9\u201316",
                        "readQS": "Isaiah+51:9-16",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "2 Thessalonians 2",
                        "readQS": "2+Thessalonians+2",
                        "audioQS": "2Thess.2"
                    }
                ],
                "readQS": "Psalm+76%3B+Isaiah+51:9-16%3B+2+Thessalonians+2",
                "audioQS": "Ps.76,Isa.51,2Thess.2",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 44",
                        "readQS": "Psalm+44",
                        "audioQS": "Ps.44"
                    },
                    {
                        "pretty": "Zephaniah 1:1\u20132:3",
                        "readQS": "Zephaniah+1:1-2:3",
                        "audioQS": "Zeph.1"
                    },
                    {
                        "pretty": "Matthew 17:22\u2013end",
                        "readQS": "Matthew+17:22-",
                        "audioQS": "Matt.17"
                    }
                ],
                "readQS": "Psalm+44%3B+Zephaniah+1:1-2:3%3B+Matthew+17:22-",
                "audioQS": "Ps.44,Zeph.1,Matt.17",
                "note": null
            }
        ]
    },
    "2026/12/18": {
        "datePretty": "Friday, December 18, 2026",
        "calendar": "Week of 3rd Sunday of Advent",
        "readingSets": [
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Morning Prayers",
                "timeOfDay": "morning",
                "readings": [
                    {
                        "pretty": "Psalm 98",
                        "readQS": "Psalm+98",
                        "audioQS": "Ps.98"
                    },
                    {
                        "pretty": "Isaiah 51:17\u2013end",
                        "readQS": "Isaiah+51:17-",
                        "audioQS": "Isa.51"
                    },
                    {
                        "pretty": "2 Thessalonians 3",
                        "readQS": "2+Thessalonians+3",
                        "audioQS": "2Thess.3"
                    }
                ],
                "readQS": "Psalm+98%3B+Isaiah+51:17-%3B+2+Thessalonians+3",
                "audioQS": "Ps.98,Isa.51,2Thess.3",
                "note": null
            },
            {
                "readingSetTab": "prayers",
                "readingSetTabName": "Prayers",
                "readingSetSubtitle": "Evening Prayers",
                "timeOfDay": "evening",
                "readings": [
                    {
                        "pretty": "Psalm 49",
                        "readQS": "Psalm+49",
                        "audioQS": "Ps.49"
                    },
                    {
                        "pretty": "Zephaniah 3:1\u201313",
                        "readQS": "Zephaniah+3:1-13",
                        "audioQS": "Zeph.3"
                    },
                    {
                        "pretty": "Matthew 18:1\u201320",
                        "readQS": "Matthew+18:1-20",
                        "audioQS": "Matt.18"
                    }
                ],
                "readQS": "Psalm+49%3B+Zephaniah+3:1-13%3B+Matthew+18:1-20",
                "audioQS": "Ps.49,Zeph.3,Matt.18",
                "note": null
            }
        ]
    }
};export default Data;